webpackJsonp([0],[
/* 0 */,
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var _class = function () {
    function _class() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, _class);

        this.apiToken = '$2y$10$fqnlA9HkTRJS7aqwAK/7CuAfeHCXpDWclotaaVmn611gfVGHH0/1a';
        this.market_app_name = "stanelworld";
        this.app_url = "https://lookbookgallery.com";
        this.app_name = "Stanel World";
        this.sp_url = "https://wspk.herokuapp.com";
        this.siteUrl = 'http://share.sellpoints.com.ng/';
        this.video_exts = ['mp4', 'mp3'];
        this.general_banner_image = "/static/assets/images/banner-general.jpg";
        this.upload_wait_period = 60000;
        this.max_media_upload = "7MB";
        this.baseURL = 'https://spattle.afiahub.com/api/';

        this.imageSellpointsURL = '';
        this.imageProductsURL = '';
        this.imageUsersURL = '';

        this.udb_name = "udbase";
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(_class, [{
        key: "getStates",
        value: function getStates(context, id) {
            return context.$http.get(this.baseURL + 'states', {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getCities",
        value: function getCities(context, id) {
            return context.$http.get(this.baseURL + 'cities/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "regUser",
        value: function regUser(context, data) {
            return context.$http.post(this.baseURL + 'users', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "loginUser",
        value: function loginUser(context, data) {
            return context.$http.post(this.baseURL + 'users/login', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "activateUserToken",
        value: function activateUserToken(context, id) {
            return context.$http.get(this.baseURL + 'settings/activate/user/token/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "forgotPassword",
        value: function forgotPassword(context, data) {
            return context.$http.post(this.baseURL + 'settings/password/forgot', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "verifyResetPasswordToken",
        value: function verifyResetPasswordToken(context, id) {
            return context.$http.get(this.baseURL + 'settings/verify/reset/token/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "resetForgotPassword",
        value: function resetForgotPassword(context, data) {
            return context.$http.post(this.baseURL + 'settings/password/forgot/reset', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "resetPassword",
        value: function resetPassword(context, data) {
            return context.$http.post(this.baseURL + 'settings/password/reset', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "changeEmail",
        value: function changeEmail(context, data) {
            return context.$http.post(this.baseURL + 'settings/email/reset', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "sessionGuard",
        value: function sessionGuard(context, data) {
            return context.$http.post(this.baseURL + 'auth/sessions', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "sessionSyncSet",
        value: function sessionSyncSet(context, id) {
            return context.$http.get(this.baseURL + 'auth/sessions/sync/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "sessionSync",
        value: function sessionSync(context, data) {
            return context.$http.post(this.baseURL + 'auth/sessions/sync', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "checkUserDetails",
        value: function checkUserDetails(context, data) {
            return context.$http.post(this.baseURL + 'users/checks', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "editProfileDetails",
        value: function editProfileDetails(context, data) {
            return context.$http.put(this.baseURL + 'users', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "makeAppSubscriptionOrder",
        value: function makeAppSubscriptionOrder(context, data) {
            return context.$http.post(this.baseURL + 'app/businesses/subscription/orders', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "updateAppSubscriptionOrder",
        value: function updateAppSubscriptionOrder(context, data) {
            return context.$http.post(this.baseURL + 'app/businesses/subscription/orders/updates', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "can_edit",
        value: function can_edit(context, data) {
            return context.$http.post(this.baseURL + 'auth/validate/ownership', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getBusinessMarket",
        value: function getBusinessMarket(context, id) {
            return context.$http.get(this.baseURL + 'businesses/markets/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getBusinesses",
        value: function getBusinesses(context, id) {
            return context.$http.get(this.baseURL + 'businesses/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getAppBusinesses",
        value: function getAppBusinesses(context, id) {
            return context.$http.get(this.baseURL + 'app/businesses/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getBusinessByUserName",
        value: function getBusinessByUserName(context, id) {
            return context.$http.get(this.baseURL + 'businesses/usernames/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getAppBusinessByUserName",
        value: function getAppBusinessByUserName(context, id) {
            return context.$http.get(this.baseURL + 'app/businesses/usernames/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getBusinessProducts",
        value: function getBusinessProducts(context, id) {
            return context.$http.get(this.baseURL + 'products/businesses/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getAppProducts",
        value: function getAppProducts(context, id, limit) {
            return context.$http.get(this.baseURL + 'products/markets/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getAppBusinessProducts",
        value: function getAppBusinessProducts(context, id, limit) {
            return context.$http.get(this.baseURL + 'products/app/businesses/' + id + '/' + limit, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "addNewBusiness",
        value: function addNewBusiness(context, data) {
            return context.$http.post(this.baseURL + 'businesses/new', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "addExistingBusiness",
        value: function addExistingBusiness(context, data) {
            return context.$http.post(this.baseURL + 'businesses/existing', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "validateBusinessUserName",
        value: function validateBusinessUserName(context, data) {
            return context.$http.post(this.baseURL + 'businesses/validate/username', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getBusinessMarketUpgradeDetails",
        value: function getBusinessMarketUpgradeDetails(context, id) {
            return context.$http.get(this.baseURL + 'app/businesses/markets/upgrades/' + id, {
                headers: {
                    'Origin-Host': this.apiToken

                }
            });
        }
    }, {
        key: "upgradeBusinessMarketSubscription",
        value: function upgradeBusinessMarketSubscription(context, data) {
            return context.$http.post(this.baseURL + 'app/businesses/markets/upgrades', data, {
                headers: {
                    'Origin-Host': this.apiToken

                }
            });
        }
    }, {
        key: "getCategories",
        value: function getCategories(context) {
            return context.$http.get(this.baseURL + 'categories', {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getMainCategories",
        value: function getMainCategories(context, id) {
            return context.$http.get(this.baseURL + 'categories/main/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getBusinessSubCategories",
        value: function getBusinessSubCategories(context, id) {
            return context.$http.get(this.baseURL + 'categories/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getBusinessCategories",
        value: function getBusinessCategories(context, id) {
            return context.$http.get(this.baseURL + 'businesses/categories/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "addGallery",
        value: function addGallery(context, data) {
            return context.$http.post(this.baseURL + 'posts/gallery', data, {
                headers: {
                    'Origin-Host': this.apiToken

                }
            });
        }
    }, {
        key: "getPointGalleryPosts",
        value: function getPointGalleryPosts(context, id, offset, limit, posts_offset, posts_limit) {
            return context.$http.get(this.baseURL + 'posts/gallery/points/' + id + '/' + offset + '/' + limit + '/' + posts_offset + '/' + posts_limit, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getGallerySearch",
        value: function getGallerySearch(context, id) {
            return context.$http.get(this.baseURL + 'posts/gallery/url/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "editBusinessDetails",
        value: function editBusinessDetails(context, data) {
            return context.$http.put(this.baseURL + 'businesses/details', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "setShippingFeeStatus",
        value: function setShippingFeeStatus(context, data) {
            return context.$http.put(this.baseURL + 'businesses/setshippingfeestatus', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "addDeliveryOption",
        value: function addDeliveryOption(context, data) {
            return context.$http.post(this.baseURL + 'businesses/deliveryoptions', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "editDeliveryOption",
        value: function editDeliveryOption(context, data) {
            return context.$http.put(this.baseURL + 'businesses/deliveryoptions', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "deleteDeliveryOption",
        value: function deleteDeliveryOption(context, id, data) {
            return context.$http.put(this.baseURL + 'businesses/deliveryoptions/' + id, data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "switchProcessingFeePay",
        value: function switchProcessingFeePay(context, data) {
            return context.$http.put(this.baseURL + 'businesses/processingfees', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "postBusinessProcessingFeeTransactions",
        value: function postBusinessProcessingFeeTransactions(context, data) {
            return context.$http.post(this.baseURL + 'businesses/processingfees/transactions', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getBusinessProcessingFeesTransactions",
        value: function getBusinessProcessingFeesTransactions(context, id, offset, limit) {
            return context.$http.get(this.baseURL + 'businesses/processingfees/transactions/' + id + '/' + offset, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getBusinessDiscountsAndCoupons",
        value: function getBusinessDiscountsAndCoupons(context, id) {
            return context.$http.get(this.baseURL + 'businesses/discounts/coupons/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "setDiscountsAndCoupons",
        value: function setDiscountsAndCoupons(context, data) {
            return context.$http.post(this.baseURL + 'businesses/discounts/coupons', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "editDiscountsAndCoupons",
        value: function editDiscountsAndCoupons(context, data) {
            return context.$http.put(this.baseURL + 'businesses/discounts/coupons', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "deactivateDiscountsAndCoupons",
        value: function deactivateDiscountsAndCoupons(context, data) {
            return context.$http.put(this.baseURL + 'businesses/discounts/coupons/deactivate', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getProductImages",
        value: function getProductImages(context, id) {
            return context.$http.get(this.baseURL + 'products/images/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "deleteProductImage",
        value: function deleteProductImage(context, id) {
            return context.$http.delete(this.baseURL + 'products/images/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "uploadDataPhoto",
        value: function uploadDataPhoto(context, data) {
            return context.$http.post(this.baseURL + 'uploads', data, {
                headers: {
                    'Origin-Host': this.apiToken,
                    'Content-Type': 'multipart/form-data'
                }
            });
        }
    }, {
        key: "uploadBusinessDataPhoto",
        value: function uploadBusinessDataPhoto(context, data) {
            return context.$http.post(this.baseURL + 'businesses/uploads', data, {
                headers: {
                    'Origin-Host': this.apiToken,
                    'Content-Type': 'multipart/form-data'
                }
            });
        }
    }, {
        key: "getUser",
        value: function getUser(context, id) {
            return context.$http.get(this.baseURL + 'users/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getProductsInBusinessCategories",
        value: function getProductsInBusinessCategories(context, id) {
            return context.$http.get(this.baseURL + 'products/businesses/categories/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getMarketCategories",
        value: function getMarketCategories(context) {
            return context.$http.get(this.baseURL + 'market/categories', {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getFilters",
        value: function getFilters(context) {
            return context.$http.get(this.baseURL + 'filters', {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "addBusiness",
        value: function addBusiness(context, data) {
            return context.$http.post(this.baseURL + 'businesses', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getBusinessNotifications",
        value: function getBusinessNotifications(context, id) {
            return context.$http.get(this.baseURL + 'notifications/businesses/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getBusinessMessages",
        value: function getBusinessMessages(context, id) {
            return context.$http.get(this.baseURL + 'messages/businesses/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getBusinessOrders",
        value: function getBusinessOrders(context, id) {
            return context.$http.get(this.baseURL + 'orders/businesses/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "readNotifications",
        value: function readNotifications(context, data) {
            return context.$http.post(this.baseURL + 'notifications/general/updates', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "addCategory",
        value: function addCategory(context, data) {
            return context.$http.post(this.baseURL + 'businesses/categories', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "editCategory",
        value: function editCategory(context, data) {
            return context.$http.put(this.baseURL + 'businesses/categories', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getProducts",
        value: function getProducts(context, offset, limit) {
            return context.$http.get(this.baseURL + 'products/all/' + offset + '/' + limit, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getMarketProducts",
        value: function getMarketProducts(context, id) {
            return context.$http.get(this.baseURL + 'products/markets/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getMarketActivityProducts",
        value: function getMarketActivityProducts(context, id, offset, limit) {
            return context.$http.get(this.baseURL + 'products/markets/activities/' + id + '/' + offset + '/' + limit, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getBusinessMarket",
        value: function getBusinessMarket(context, id) {
            return context.$http.get(this.baseURL + 'businesses/markets/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getCategoryProducts",
        value: function getCategoryProducts(context, id) {
            return context.$http.get(this.baseURL + 'products/categories/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getBusinessesOpenAgentsCategoryProducts",
        value: function getBusinessesOpenAgentsCategoryProducts(context, data) {
            return context.$http.post(this.baseURL + 'products/businesses/agents/categories', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getBusinessesOpenAgentsProducts",
        value: function getBusinessesOpenAgentsProducts(context) {
            return context.$http.get(this.baseURL + 'products/agents/businesses', {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getAgentsBusinessCategoryProducts",
        value: function getAgentsBusinessCategoryProducts(context, id) {
            return context.$http.get(this.baseURL + 'products/agents/business/categories/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "searchCategoryProducts",
        value: function searchCategoryProducts(context, name, type) {
            return context.$http.get(this.baseURL + 'products/search/categories/' + name + '/' + type, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "searchProducts",
        value: function searchProducts(context, search) {
            return context.$http.get(this.baseURL + 'products/search/' + search, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "searchBusinessProducts",
        value: function searchBusinessProducts(context, search) {
            return context.$http.get(this.baseURL + 'products/search/businesses/' + search, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getProductSearch",
        value: function getProductSearch(context, id) {
            return context.$http.get(this.baseURL + 'products/product/url/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "setRelatedProducts",
        value: function setRelatedProducts(context, data) {
            return context.$http.post(this.baseURL + 'products/related', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "addProduct",
        value: function addProduct(context, data) {
            return context.$http.post(this.baseURL + 'products', data, {
                headers: {
                    'Origin-Host': this.apiToken

                }
            });
        }
    }, {
        key: "addProductItem",
        value: function addProductItem(context, data) {
            return context.$http.post(this.baseURL + 'products/items', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "addAgentProduct",
        value: function addAgentProduct(context, data) {
            return context.$http.post(this.baseURL + 'products/agents', data, {
                headers: {
                    'Origin-Host': this.apiToken

                }
            });
        }
    }, {
        key: "addProductDetail",
        value: function addProductDetail(context, data) {
            return context.$http.post(this.baseURL + 'products/details', data, {
                headers: {
                    'Origin-Host': this.apiToken

                }
            });
        }
    }, {
        key: "addProductReview",
        value: function addProductReview(context, data) {
            return context.$http.post(this.baseURL + 'products/reviews', data, {
                headers: {
                    'Origin-Host': this.apiToken

                }
            });
        }
    }, {
        key: "editProduct",
        value: function editProduct(context, id, data) {
            return context.$http.put(this.baseURL + 'products/' + id, data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "editProductSettings",
        value: function editProductSettings(context, id, data) {
            return context.$http.put(this.baseURL + 'products/settings/' + id, data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "editProductItemSingle",
        value: function editProductItemSingle(context, id, data) {
            return context.$http.put(this.baseURL + 'products/items/singles/' + id, data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "editProductItem",
        value: function editProductItem(context, id, data) {
            return context.$http.put(this.baseURL + 'products/items/' + id, data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "removeProductItem",
        value: function removeProductItem(context, id, data) {
            return context.$http.put(this.baseURL + 'products/items/remove/' + id, data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "editProductItemGroup",
        value: function editProductItemGroup(context, id, data) {
            return context.$http.put(this.baseURL + 'products/itemgroups/' + id, data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "removeProductItemGroup",
        value: function removeProductItemGroup(context, id, data) {
            return context.$http.put(this.baseURL + 'products/itemgroups/remove/' + id, data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "removeProduct",
        value: function removeProduct(context, id, data) {
            return context.$http.put(this.baseURL + 'products/remove/' + id, data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "editProductDetail",
        value: function editProductDetail(context, id, data) {
            return context.$http.put(this.baseURL + 'products/details/' + id, data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "deleteProductDetail",
        value: function deleteProductDetail(context, id, data) {
            return context.$http.delete(this.baseURL + 'products/details/' + id, data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getProductDeliveryOptions",
        value: function getProductDeliveryOptions(context, id) {
            return context.$http.get(this.baseURL + 'products/delivery/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "setProductDelivery",
        value: function setProductDelivery(context, id, data) {
            return context.$http.put(this.baseURL + 'products/delivery/' + id, data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "setProductShippingFeeStatus",
        value: function setProductShippingFeeStatus(context, data) {
            return context.$http.put(this.baseURL + 'products/set/shippingfeestatus', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "setProductDeliveryOption",
        value: function setProductDeliveryOption(context, data) {
            return context.$http.post(this.baseURL + 'products/delivery/fees', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getProductInformation",
        value: function getProductInformation(context, id) {
            return context.$http.get(this.baseURL + 'products/information/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "addProductInformation",
        value: function addProductInformation(context, data) {
            return context.$http.post(this.baseURL + 'products/information', data, {
                headers: {
                    'Origin-Host': this.apiToken

                }
            });
        }
    }, {
        key: "editProductInformation",
        value: function editProductInformation(context, id, data) {
            return context.$http.put(this.baseURL + 'products/information/' + id, data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "deleteProductInformation",
        value: function deleteProductInformation(context, id, data) {
            return context.$http.delete(this.baseURL + 'products/information/' + id, data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "editGallery",
        value: function editGallery(context, id, data) {
            return context.$http.put(this.baseURL + 'posts/gallery/' + id, data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "deleteGallery",
        value: function deleteGallery(context, id) {
            return context.$http.delete(this.baseURL + 'posts/gallery/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "editGalleryPost",
        value: function editGalleryPost(context, id, data) {
            return context.$http.put(this.baseURL + 'posts/gallery/posts/' + id, data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "deleteGalleryPost",
        value: function deleteGalleryPost(context, id) {
            return context.$http.delete(this.baseURL + 'posts/gallery/posts/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "resetData",
        value: function resetData(context, type, id) {
            return context.$http.get(this.baseURL + 'data/reset/' + type + '/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "deleteImages",
        value: function deleteImages(context, id, data) {
            return context.$http.put(this.baseURL + 'data/images/' + id, data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "checkout",
        value: function checkout(context, data) {
            return context.$http.post(this.baseURL + 'orders', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getCheckoutOrder",
        value: function getCheckoutOrder(context, url) {
            return context.$http.get(this.baseURL + 'orders/url/' + url, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getCheckoutOrders",
        value: function getCheckoutOrders(context, id) {
            return context.$http.get(this.baseURL + 'orders/topays/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getUserDeliveryDetails",
        value: function getUserDeliveryDetails(context, id) {
            return context.$http.get(this.baseURL + 'users/deliverydetails/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "updatePayment",
        value: function updatePayment(context, data) {
            return context.$http.post(this.baseURL + 'payments', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getOrders",
        value: function getOrders(context, id) {
            return context.$http.get(this.baseURL + 'orders/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "addService",
        value: function addService(context, data) {
            return context.$http.post(this.baseURL + 'businesses/services', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "editService",
        value: function editService(context, data) {
            return context.$http.put(this.baseURL + 'businesses/services', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getBusinessDeliveryOptions",
        value: function getBusinessDeliveryOptions(context, id) {
            return context.$http.get(this.baseURL + 'businesses/deliveryoptions/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "checkBusinessPayOnDelivery",
        value: function checkBusinessPayOnDelivery(context, id) {
            return context.$http.get(this.baseURL + 'businesses/checkdeliveryoptions/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "sendBusinessContactForm",
        value: function sendBusinessContactForm(context, data) {
            return context.$http.post(this.baseURL + 'businesses/contacts', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "setBusinessFilterOptions",
        value: function setBusinessFilterOptions(context, data) {
            return context.$http.put(this.baseURL + 'businesses/filters', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "removeBusinessFilterOption",
        value: function removeBusinessFilterOption(context, data) {
            return context.$http.post(this.baseURL + 'businesses/filters', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "setBusinessBankDetails",
        value: function setBusinessBankDetails(context, data) {
            return context.$http.put(this.baseURL + 'businesses/bankdetails', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "postBusinessGeneralOrders",
        value: function postBusinessGeneralOrders(context, data) {
            return context.$http.post(this.baseURL + 'orders/generalorders', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }]);

    return _class;
}();

/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(210)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(117),
  /* template */
  __webpack_require__(271),
  /* scopeId */
  "data-v-8d2a89aa",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(211)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(118),
  /* template */
  __webpack_require__(272),
  /* scopeId */
  "data-v-90aa3cc6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ALL_SELLPOINTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ALL_SELLPOINTS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ALL_PRODUCTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ALL_PRODUCTS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return PRODUCT_BY_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return PRODUCT_BY_ID_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return VIEW_CART; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return ADD_TO_CART; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return REMOVE_FROM_CART; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ERROR_MSG; });
/* unused harmony export SUCCESS_MSG */
var ALL_SELLPOINTS = 'ALL_SELLPOINTS';
var ALL_SELLPOINTS_SUCCESS = 'ALL_SELLPOINTS_SUCCESS';

var ALL_PRODUCTS = 'ALL_PRODUCTS';
var ALL_PRODUCTS_SUCCESS = 'ALL_PRODUCTS_SUCCESS';

var PRODUCT_BY_ID = 'PRODUCT_BY_ID';
var PRODUCT_BY_ID_SUCCESS = 'PRODUCT_BY_ID_SUCCESS';

var VIEW_CART = 'VIEW_CART';
var ADD_TO_CART = 'ADD_TO_CART';
var REMOVE_FROM_CART = 'REMOVE_FROM_CART';

var ERROR_MSG = 'ERROR_MSG';
var SUCCESS_MSG = 'SUCCESS_MSG';

/***/ }),
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(103),
  /* template */
  __webpack_require__(278),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(105),
  /* template */
  __webpack_require__(280),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(107),
  /* template */
  __webpack_require__(263),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Orderpoint_Template__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Orderpoint_Template___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_Orderpoint_Template__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_Orderpoint_Cart__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_Orderpoint_Cart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__pages_Orderpoint_Cart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_Orderpoint_Checkout__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_Orderpoint_Checkout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__pages_Orderpoint_Checkout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_Orderpoint_Orders__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_Orderpoint_Orders___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__pages_Orderpoint_Orders__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_Orderpoint_Order__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_Orderpoint_Order___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__pages_Orderpoint_Order__);





/* harmony default export */ __webpack_exports__["a"] = ({
    path: '',
    component: __WEBPACK_IMPORTED_MODULE_0__pages_Orderpoint_Template___default.a,
    children: [{
        path: '/cart',
        name: 'Cart',
        component: __WEBPACK_IMPORTED_MODULE_1__pages_Orderpoint_Cart___default.a
    }, {
        path: '/checkout',
        name: 'Checkout',
        component: __WEBPACK_IMPORTED_MODULE_2__pages_Orderpoint_Checkout___default.a
    }, {
        path: '/checkout/:ckid',
        name: 'CheckoutOrderURL',
        component: __WEBPACK_IMPORTED_MODULE_2__pages_Orderpoint_Checkout___default.a
    }, {
        path: '/orders',
        name: 'Orders',
        component: __WEBPACK_IMPORTED_MODULE_3__pages_Orderpoint_Orders___default.a
    }, {
        path: '/order',
        name: 'Order',
        component: __WEBPACK_IMPORTED_MODULE_4__pages_Orderpoint_Order___default.a
    }]
});

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var _class = function () {
    function _class() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, _class);
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(_class, [{
        key: "validate_array",
        value: function validate_array(str_array, error_msg) {
            var process_errors = [];

            var reg_num = /^[0-9]+$/;
            var reg_name = /^[\w\-\s]+$/;
            var reg_email = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            var reg_phone = /^\d{4}\d{3}\d{4}$/;

            for (var i = 0; i < str_array.length; i++) {
                var arr_in_str_array = str_array[i];
                if (arr_in_str_array[1] == undefined || arr_in_str_array[1] == "") {
                    process_errors.push(error_msg + arr_in_str_array[0]);

                    if (arr_in_str_array[2] == "alpha") {
                        if (!reg_name.test(arr_in_str_array[1])) {
                            process_errors.push(arr_in_str_array[0] + " is not valid");
                        }
                    }

                    if (arr_in_str_array[2] == "num") {
                        if (!reg_num.test(arr_in_str_array[1])) {
                            process_errors.push(arr_in_str_array[0] + " is not valid");
                        }
                    }

                    if (arr_in_str_array[2] == "email") {
                        if (!reg_email.test(String(arr_in_str_array[1]).toLowerCase())) {
                            process_errors.push(arr_in_str_array[0] + " is not valid");
                        }
                    }

                    if (arr_in_str_array[2] == "phone") {
                        if (!reg_phone.test(arr_in_str_array[1])) {
                            process_errors.push(arr_in_str_array[0] + " is not valid");
                        }
                    }
                }
            }

            return process_errors;
        }
    }, {
        key: "validateEmail",
        value: function validateEmail(email) {
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(String(email).toLowerCase());
        }
    }, {
        key: "validateName",
        value: function validateName(name) {
            var re = /^[\w\-\s]+$/;
            return re.test(name);
        }
    }, {
        key: "validatePhoneNumber",
        value: function validatePhoneNumber(phone) {
            var re = /^\d{4}\d{3}\d{4}$/;
            return re.test(phone);
        }
    }, {
        key: "validateWebsite",
        value: function validateWebsite(url) {
            var re = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/;
            return re.test(url);
        }
    }]);

    return _class;
}();

/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(197)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(96),
  /* template */
  __webpack_require__(255),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(207)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(97),
  /* template */
  __webpack_require__(268),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(200)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(100),
  /* template */
  __webpack_require__(258),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(196)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(101),
  /* template */
  __webpack_require__(254),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(104),
  /* template */
  __webpack_require__(266),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(106),
  /* template */
  __webpack_require__(279),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(201)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(120),
  /* template */
  __webpack_require__(259),
  /* scopeId */
  "data-v-4b072ad0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__home__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__timeline__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__search__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__register__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__login__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__manage__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__account__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__sellpoint__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__purchase__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__demos__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__create__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__buypoint__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__orderpoint__ = __webpack_require__(44);



















__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    mode: 'history',
    routes: [__WEBPACK_IMPORTED_MODULE_2__home__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__timeline__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__search__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__register__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__login__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__manage__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__purchase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11__demos__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__account__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12__create__["a" /* default */], __WEBPACK_IMPORTED_MODULE_13__buypoint__["a" /* default */], __WEBPACK_IMPORTED_MODULE_14__orderpoint__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__sellpoint__["a" /* default */]]
}));

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex_persist__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex_persist___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuex_persist__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getters__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mutations__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions__ = __webpack_require__(146);








__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */]);
var vuexLocalStorage = new __WEBPACK_IMPORTED_MODULE_3_vuex_persist___default.a({
    key: 'vuex',
    storage: window.localStorage,
    reducer: function reducer(state) {
        return {
            cart: state.cart
        };
    }
});

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */].Store({
    strict: true,
    plugins: [vuexLocalStorage.plugin],
    state: {
        sellpoints: [],

        sellpoint: {},

        products: [],

        product: {},

        cart: [],

        showLoader: false
    },

    getters: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_4__getters__["a" /* productGetters */], __WEBPACK_IMPORTED_MODULE_4__getters__["b" /* sellpointGetters */], __WEBPACK_IMPORTED_MODULE_4__getters__["c" /* cartGetters */]),
    mutations: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_5__mutations__["a" /* productMutations */], __WEBPACK_IMPORTED_MODULE_5__mutations__["b" /* sellpointMutations */], __WEBPACK_IMPORTED_MODULE_5__mutations__["c" /* cartMutations */]),
    actions: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_6__actions__["a" /* productActions */], __WEBPACK_IMPORTED_MODULE_6__actions__["b" /* sellpointActions */])
}));

/***/ }),
/* 73 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);



var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'ProductForm',
    data: function data() {
        return {
            user: {},
            sellpoint: {},
            sellpoint_categories: {},
            sub_categories: {},
            products: {},
            post: {},
            gallery: {},
            product_item: {},
            disable_btn: false,
            loading: true,
            action_loading: false,
            imageForm: "",
            product_info: false,
            product_url: "",
            category_type_1: false,
            category_type_2: false,
            category_type_3: false,
            file_info: {},
            data_success_message: "",
            data_error_message: ""
        };
    },

    components: {},
    methods: {
        setComponent: function setComponent(attr1, attr2) {},
        activate_processing: function activate_processing() {
            this.disable_btn = true;
            this.action_loading = true;
        },
        deactivate_processing: function deactivate_processing() {
            this.disable_btn = false;
            this.action_loading = false;
        },
        trackevent: function trackevent(e) {
            if (e == "category-type-1" && this.product.product_category != 0 && this.product.product_category != undefined) {
                this.category_type_2 = true;
                this.category_type_3 = true;
            } else if (e == "category-type-2" && this.product.product_sub_category != 0 && this.product.product_sub_category != undefined) {
                this.category_type_1 = true;
                this.category_type_3 = true;
            } else if (e == "category-type-3" && this.product.product_listed_category != "" && this.product.product_listed_category != undefined) {
                this.category_type_1 = true;
                this.category_type_2 = true;
            } else {
                this.category_type_1 = false;
                this.category_type_2 = false;
                this.category_type_3 = false;
            }
        },
        preset: function preset() {
            var _this = this;

            var credentials = {
                session_key: localStorage.getItem("sp_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.user.user_id = element.user_id;
                        }, _this);

                        _this.getSellpointCategories();
                    } else {
                        _this.$router.push('login');
                    }
                }).catch(function (err) {
                    if (err) {
                        _this.$router.push('login');
                    }
                });
            } else {
                this.$router.push('login');
            }
        },
        getSellpointCategories: function getSellpointCategories() {
            var _this2 = this;

            service.getBusinessByUserName(this, this.$route.params.id).then(function (response) {
                if (response.body.status == 200) {
                    _this2.sellpoint = response.body.data;
                    _this2.loading = false;
                }
            }).catch(function (err) {
                _this2.getSellpointCategories();
            });
        },
        getSubCategories: function getSubCategories(category) {
            var _this3 = this;

            service.getBusinessSubCategories(this, category).then(function (response) {
                if (response.body.status == 200) {
                    _this3.sub_categories = response.body.data;
                }
            }).catch(function (err) {});
        },
        getSellpointProducts: function getSellpointProducts() {
            var _this4 = this;

            service.getBusinessProducts(this, this.sellpoint.business_id).then(function (response) {
                if (response.body.status == 200) {
                    _this4.products = response.body.data;
                }
            }).catch(function (err) {});
        },
        addGallery: function addGallery() {
            var _this6 = this;

            this.activate_processing();
            var credentials = {
                gallery_new_group: true,
                gallery_group_type: 1,
                gallery_group_point: this.sellpoint.business_id,
                gallery_group_name: this.gallery.gallery_name,
                gallery_group_description: this.gallery.gallery_description,
                gallery_post_group: 0,
                gallery_post_caption: this.post.post_caption || "nill",
                gallery_post_details: this.post.post_details || "nill",
                gallery_post_products: []
            };

            var navi = this.$router;
            if (credentials.gallery_post_details != undefined) {
                service.addGallery(this, credentials).then(function (data) {
                    var _this5 = this;

                    if (data.body.status == 201) {
                        this.data_success_message = "processing, please wait.. ..";

                        this.post = data.body.data;

                        this.imageForm.append("data_id", this.post.post_id);
                        this.imageForm.append("data_type", "gallery_media");
                        service.uploadDataPhoto(this, this.imageForm).then(function (data) {
                            if (data.body.status == 200) {
                                location.reload(true);
                            }
                        }).catch(function (err) {
                            if (err) {}

                            _this5.data_error_message = "Something went wrong..";
                        });

                        var self = this;
                        setTimeout(function () {
                            location.reload(true);
                        }, 2000);
                    }
                }).catch(function (err) {
                    if (err) {
                        toastr.warning("Something went wrong", 'Warning!');

                        _this6.deactivate_processing();
                    }
                });
            } else {
                toastr.error('Kindly fill all fields', 'Warning!');
                this.disable_btn = false;
            }
        },
        onFileChange: function onFileChange(e) {
            var files = e.target.files || e.dataTransfer.files;
            if (files.length) {
                this.file_info = files;
                var formData = new FormData();
                formData.append('photo', files[0]);
                this.imageForm = formData;
            }
        }
    },
    created: function created() {
        this.preset();
    }
});

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);



var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'ProductForm',
    data: function data() {
        return {
            open_request: true,
            user: {},
            sellpoint: {},
            sellpoint_categories: {},
            categories: {},
            main_category: {},
            sub_categories: [],
            products: {},
            product: {},
            post: {},
            gallery: {},
            selected_produts: [],
            product_item: {},
            disable_btn: false,
            imageForm: "",
            product_info: false,
            product_url: "",
            category_type_1: false,
            category_type_2: false,
            category_type_3: false,
            file_info: {},
            addProductPost: false,
            showGalleryForm: true,
            showProductForm: false,
            canAddGallery: false,
            is_product_service: "product",
            data_success_message: "",
            data_error_message: "",
            loading: true,
            action_loading: false,
            executed_kipper: false,
            pinched_products: []
        };
    },

    components: {},
    methods: {
        activate_processing: function activate_processing() {
            this.disable_btn = true;
            this.action_loading = true;
        },
        deactivate_processing: function deactivate_processing() {
            this.disable_btn = false;
            this.action_loading = false;
        },
        setComponent: function setComponent(attr1, attr2) {
            if (attr1 == "add-to-gallery-product") {
                var if_index = this.selected_produts.indexOf(attr2.product_id);
                if (if_index != -1) {
                    attr2.product_checked = false;

                    this.selected_produts.splice(if_index, 1);
                    document.getElementById(attr2.product_id + "PRD").style.border = "none";
                } else {
                    this.selected_produts.push(attr2.product_id);
                    attr2.product_checked = true;
                    document.getElementById(attr2.product_id + "PRD").style.border = "1px solid #0000CC";
                }
            }
            if (attr1 == "show-add-product-form") {
                this.showProductForm = true;
                this.canAddGallery = false;
            }
        },
        close_request: function close_request() {
            this.open_request = false;
        },
        reset: function reset() {
            this.showProductForm = false;
            this.canAddGallery = true;
        },
        trackevent: function trackevent(e) {
            if (e == "category-type-1" && this.product.product_category != 0 && this.product.product_category != undefined) {
                this.category_type_2 = true;
                this.category_type_3 = true;
            } else if (e == "category-type-2" && this.product.product_sub_category != 0 && this.product.product_sub_category != undefined) {
                this.category_type_1 = true;
                this.category_type_3 = true;
            } else if (e == "category-type-3" && this.product.product_listed_category != "" && this.product.product_listed_category != undefined) {
                this.category_type_1 = true;
                this.category_type_2 = true;
            } else {
                this.category_type_1 = false;
                this.category_type_2 = false;
                this.category_type_3 = false;
            }
        },
        preset: function preset() {
            var _this = this;

            this.loading = true;
            var credentials = {
                session_key: localStorage.getItem("sp_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.user.user_id = element.user_id;
                        }, _this);

                        _this.getSellpointCategories();
                    } else {
                        _this.$router.push('login');
                    }
                }).catch(function (err) {
                    if (err) {
                        _this.$router.push('login');
                    }
                });
            } else {
                this.$router.push('login');
            }
        },
        getSellpointCategories: function getSellpointCategories() {
            var _this2 = this;

            service.getBusinessByUserName(this, this.$route.params.id).then(function (response) {
                if (response.body.status == 200) {
                    _this2.sellpoint = response.body.data;

                    service.getBusinessCategories(_this2, _this2.sellpoint.business_id).then(function (response) {
                        if (response.body.status == 200) {
                            _this2.sellpoint_categories = response.body.data;
                        }
                    }).catch(function (err) {});

                    _this2.getCategories(_this2.sellpoint.business_category_id);
                    _this2.getSellpointProducts();
                }
            }).catch(function (err) {});
        },
        getCategories: function getCategories(category) {
            var _this3 = this;

            service.getMainCategories(this, category).then(function (response) {
                if (response.body.status == 200) {
                    _this3.categories = response.body.data;
                }
            }).catch(function (err) {});
        },
        getSubCategories: function getSubCategories(category) {
            if (category != undefined) {
                this.sub_categories = category.sub_categories;
            } else {
                this.sub_categories = [];
            }
        },
        getSellpointProducts: function getSellpointProducts() {
            var _this4 = this;

            service.getBusinessProducts(this, this.sellpoint.business_id).then(function (response) {
                if (response.body.status == 200) {
                    _this4.products = response.body.data;
                    _this4.loading = false;

                    if (_this4.products.length > 0) {
                        _this4.canAddGallery = true;
                    }
                } else {
                    _this4.loading = false;
                }
            }).catch(function (err) {
                _this4.loading = false;
            });
        },
        addGallery: function addGallery() {
            var _this5 = this;

            this.activate_processing();
            this.loading = true;

            var credentials = {
                gallery_new_group: true,
                gallery_group_type: 2,
                gallery_group_point: this.sellpoint.business_id,
                gallery_group_name: this.gallery.gallery_name,
                gallery_group_description: this.gallery.gallery_description,
                gallery_post_group: 0,
                gallery_post_caption: this.post.post_caption || "nill",
                gallery_post_details: this.post.post_details || "nill",
                gallery_post_products: this.selected_produts || []
            };

            var navi = this.$router;
            if (credentials.gallery_post_details != undefined) {
                service.addGallery(this, credentials).then(function (data) {
                    if (data.body.status == 201) {
                        this.data_success_message = "Processing, please wait ...";

                        this.gallery = data.body.data;

                        location.reload("/" + this.$route.params.id);

                        this.open_request = false;

                        this.deactivate_processing();
                    }
                }).catch(function (err) {
                    if (err) {
                        _this5.data_error_message = "Something went wrong, preparing report ...";

                        _this5.deactivate_processing();
                    }
                });
            } else {
                this.data_error_message = "Kindly fill all fields ..";
                this.deactivate_processing();
            }
        },
        addProduct: function addProduct() {
            var _this7 = this;

            this.activate_processing();

            var credentials = {
                product_name: this.product.product_name,
                product_is_product_or_service: this.is_product_service,
                product_category: this.product.product_category || 0,
                product_sub_category: this.product.product_sub_category || 0,
                product_listed_category: this.product.product_listed_category || "nill",
                product_business: this.sellpoint.business_id,
                product_description: this.product.product_description || "nill",
                product_item_price: this.product.product_item_price,
                product_item_weight: this.product.product_item_weight || 1,
                product_item_quantity: this.product.product_item_quantity || 1
            };

            var navi = this.$router;
            if (credentials.product_name != undefined) {
                service.addProduct(this, credentials).then(function (data) {
                    var _this6 = this;

                    if (data.body.status == 201) {
                        this.data_success_message = "Processing, please wait ...";

                        this.product = data.body.data;

                        this.imageForm.append("data_id", this.product.product_id);

                        this.imageForm.append("data_type", "products");
                        service.uploadDataPhoto(this, this.imageForm).then(function (data) {
                            if (data.body.status == 200) {
                                if (!_this6.executed_kipper) {
                                    _this6.addProductKipper();
                                }
                            }
                        }).catch(function (err) {
                            if (err) {}

                            _this6.data_error_message = "Something went wrong, preparing report ...";

                            _this6.deactivate_processing();
                        });

                        var self = this;
                        setTimeout(function () {
                            self.addProductKipper();
                        }, 2000);
                    }
                }).catch(function (err) {
                    if (err) {
                        _this7.data_error_message = "Something went wrong, preparing report ...";

                        _this7.deactivate_processing();
                    }
                });
            } else {
                this.data_error_message = "Kindly fill all fields ...";

                this.deactivate_processing();
            }
        },
        addProductKipper: function addProductKipper() {
            this.executed_kipper = true;

            this.selected_produts.push(this.product.product_id);

            if (this.addProductPost) {
                this.addProductPostGallery();
            } else {
                this.addGallery();
            }
        },
        addProductPostGallery: function addProductPostGallery() {
            var _this8 = this;

            this.disable_btn = true;
            this.loading = true;

            var set_gallery = 0;
            if (this.$route.params.id1 != undefined) {
                set_gallery = this.gallery.gallery_posts_group_id;
            }

            var credentials = {
                gallery_new_group: false,
                gallery_post_group: set_gallery,
                gallery_post_caption: this.post.post_caption || "nill",
                gallery_post_details: this.post.post_details || "nill",
                gallery_post_products: this.selected_produts || []
            };

            var navi = this.$router;
            if (credentials.gallery_post_details != undefined) {
                service.addGallery(this, credentials).then(function (data) {
                    if (data.body.status == 201) {
                        this.data_success_message = "Processing, please wait ...";

                        this.gallery = data.body.data;
                        location.reload("/" + this.$route.params.id);


                        this.open_request = false;
                    }
                }).catch(function (err) {
                    if (err) {
                        _this8.data_error_message = "Something went wrong, preparing report ...";

                        _this8.disable_btn = false;
                        _this8.loading = false;
                    }
                });
            } else {
                this.data_error_message = "Kindly fill all fields ..";
                this.disable_btn = false;
                this.loading = false;
            }
        },
        setGallery: function setGallery() {
            var _this9 = this;

            service.getGallerySearch(this, this.$route.params.id1).then(function (response) {
                if (response.body.status == 200) {
                    _this9.gallery = response.body.data;
                }
            }).catch(function (err) {});
        },
        onFileChange: function onFileChange(e) {
            var files = e.target.files || e.dataTransfer.files;
            if (files.length) {
                this.file_info = files;
                var formData = new FormData();
                formData.append('photo', files[0]);
                this.imageForm = formData;
            }
        }
    },
    created: function created() {
        if (this.$route.params.id1 != undefined) {
            this.setGallery();

            this.showGalleryForm = false;
            this.addProductPost = true;
        }
        this.preset();
    }
});

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_mutation_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_service__ = __webpack_require__(1);




var service = new __WEBPACK_IMPORTED_MODULE_1__services_service__["a" /* default */]();
/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['productMain', 'productItemGroup', 'productItem', 'productMainView'],
  data: function data() {
    return {
      user: {},
      cart: this.$store.state.cart
    };
  },

  computed: {
    canAdd: function canAdd() {
      var _this = this;

      var index = this.cart.findIndex(function (p) {
        return p.product_item_id === _this.productItem.product_item_id;
      });
      if (index < 0) {
        return true;
      }
    }
  },
  methods: {
    addToCart: function addToCart() {
      this.productItem.active_order = true;
      this.productItem._id = this.productItem.product_item_id;

      if (this.productItem.product_item_order_quantity == undefined) {
        this.productItem.product_item_order_quantity = 1;
      }
      this.productItem.product_main_id = this.productMain.product_id;
      this.productItem.product_business_name = this.productMain.product_business_name;
      this.productItem.product_business = this.productMain.product_business_ownername;
      this.productItem.product_name = this.productMain.product_name;
      this.productItem.product_order_url = this.productMain.product_business_ownername + "-" + this.productMain.product_url_name;
      this.productItem.product_url = this.productMain.product_business_ownername + "/" + this.productMain.product_url_name;
      this.productItem.product_item_quantity = this.productItem.product_item_quantity;

      if (this.productItemGroup.product_item_group_is_color_image == 'IMG' && this.productItemGroup.product_item_group_image != 'error') {
        this.productItem.product_item_image = this.productItemGroup.product_item_group_image;
      } else {
        this.productItem.product_item_image = '';
      }

      this.productItem.product_shipping_calculation_method = this.productMain.product_set_shipping_fee_status;


      this.$store.commit(__WEBPACK_IMPORTED_MODULE_0__store_mutation_types__["i" /* ADD_TO_CART */], this.productItem);

      this.redir('order');
    },
    removeFromCart: function removeFromCart(payload) {
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_0__store_mutation_types__["j" /* REMOVE_FROM_CART */], payload);
    },
    redir: function redir(rlink) {
      location.replace("/" + rlink);
    },
    configureCTAButton: function configureCTAButton() {}
  }
});

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_mutation_types__ = __webpack_require__(8);



/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['productMain', 'productItemGroup', 'productItem', 'productMainView'],
  data: function data() {
    return {
      cart: this.$store.state.cart
    };
  },

  computed: {
    canAdd: function canAdd() {
      var _this = this;

      var index = this.cart.findIndex(function (p) {
        return p.product_item_id === _this.productItem.product_item_id;
      });
      if (index < 0) {
        return true;
      }
    }
  },
  methods: {
    addToCart: function addToCart() {
      this.productItem._id = this.productItem.product_item_id;

      if (this.productItem.product_item_order_quantity == undefined) {
        this.productItem.product_item_order_quantity = 1;
      }
      this.productItem.product_main_id = this.productMain.product_id;
      this.productItem.product_business_name = this.productMain.product_business_name;
      this.productItem.product_business = this.productMain.product_business_ownername;
      this.productItem.product_name = this.productMain.product_name;
      this.productItem.product_url = this.productMain.product_business_ownername + "/" + this.productMain.product_url_name;
      this.productItem.product_item_quantity = this.productItem.product_item_quantity;

      if (this.productItemGroup.product_item_group_is_color_image == 'IMG' && this.productItemGroup.product_item_group_image != 'error') {
        this.productItem.product_item_image = this.productItemGroup.product_item_group_image;
      } else {
        this.productItem.product_item_image = '';
      }

      this.productItem.product_shipping_calculation_method = this.productMain.product_set_shipping_fee_status;

      this.productItem.can_remove = true;

      this.$store.commit(__WEBPACK_IMPORTED_MODULE_0__store_mutation_types__["i" /* ADD_TO_CART */], this.productItem);
    },
    removeFromCart: function removeFromCart(payload) {
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_0__store_mutation_types__["j" /* REMOVE_FROM_CART */], payload);
    },
    redir: function redir(rlink) {
      location.replace("/" + rlink);
    }
  }
});

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);



var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'ProductForm',
    data: function data() {
        return {
            user: {},
            sellpoint: {},
            sellpoint_categories: {},
            sub_categories: {},
            product: {},
            product_item: {},
            disable_btn: false,
            imageForm: "",
            product_info: false,
            product_url: "",
            category_type_1: false,
            category_type_2: false,
            category_type_3: false,
            file_info: {}
        };
    },

    components: {},
    methods: {
        setComponent: function setComponent(attr1, attr2) {
            this.setPanel = true;
            if (attr1 == 'create-sellpoint') {
                this.createSellpointPanel = true;
                this.addProductPanel = false;
                this.addProductItemPanel = false;
            }
            if (attr1 == 'add-product') {
                this.addProductPanel = true;
                this.addProductItemPanel = false;
                this.createSellpointPanel = false;
            }
            if (attr1 == 'add-product-item') {
                this.addProductItemPanel = true;
                this.addProductPanel = false;
                this.createSellpointPanel = false;
            }
        },
        trackevent: function trackevent(e) {
            if (e == "category-type-1" && this.product.product_category != 0 && this.product.product_category != undefined) {
                this.category_type_2 = true;
                this.category_type_3 = true;
            } else if (e == "category-type-2" && this.product.product_sub_category != 0 && this.product.product_sub_category != undefined) {
                this.category_type_1 = true;
                this.category_type_3 = true;
            } else if (e == "category-type-3" && this.product.product_listed_category != "" && this.product.product_listed_category != undefined) {
                this.category_type_1 = true;
                this.category_type_2 = true;
            } else {
                this.category_type_1 = false;
                this.category_type_2 = false;
                this.category_type_3 = false;
            }
        },
        preset: function preset() {
            var _this = this;

            var credentials = {
                session_key: localStorage.getItem("sp_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.user.user_id = element.user_id;
                        }, _this);

                        _this.getSellpointCategories();
                    } else {}
                }).catch(function (err) {
                    if (err) {}
                });
            } else {}
        },
        getSellpointCategories: function getSellpointCategories() {
            var _this2 = this;

            service.getBusinessByUserName(this, this.$route.params.id).then(function (response) {
                if (response.body.status == 200) {
                    _this2.sellpoint = response.body.data;

                    service.getBusinessCategories(_this2, _this2.sellpoint.business_id).then(function (response) {
                        if (response.body.status == 200) {
                            _this2.sellpoint_categories = response.body.data;
                        }
                    }).catch(function (err) {});
                    _this2.getSubCategories(_this2.sellpoint.business_category_id);
                }
            }).catch(function (err) {
                console.log(err);
            });
        },
        getSubCategories: function getSubCategories(category) {
            var _this3 = this;

            service.getBusinessSubCategories(this, category).then(function (response) {
                if (response.body.status == 200) {
                    _this3.sub_categories = response.body.data;
                }
            }).catch(function (err) {});
        },
        addProduct: function addProduct() {
            var _this5 = this;

            this.disable_btn = true;

            var credentials = {
                product_name: this.product.product_name,
                product_category: this.product.product_category || 0,
                product_sub_category: this.product.product_sub_category || 0,
                product_listed_category: this.product.product_listed_category || "nill",
                product_business: this.sellpoint.business_id,
                product_description: this.product.product_description || "nill",
                product_item_price: this.product.product_item_price,
                product_item_weight: this.product.product_item_weight || 1,
                product_item_quantity: this.product.product_item_quantity || 1
            };

            var navi = this.$router;
            if (credentials.product_name != undefined) {
                service.addProduct(this, credentials).then(function (data) {
                    var _this4 = this;

                    if (data.body.status == 201) {
                        toastr.success("Product Added Successfully", 'Success!');

                        this.product = data.body.data;

                        this.imageForm.append("data_id", this.product.product_item_id);
                        this.imageForm.append("data_type", "product_items");
                        service.uploadDataPhoto(this, this.imageForm).then(function (data) {
                            if (data.body.status == 200) {
                                _this4.product_info = true;
                                _this4.product_url = "/" + _this4.$route.params.id + "/" + _this4.product.product_url_name;
                            }
                        }).catch(function (err) {
                            if (err) {}
                            toastr.warning("Something went wrong.", 'Warning!');
                        });
                    }
                }).catch(function (err) {
                    if (err) {
                        toastr.warning("Something went wrong", 'Warning!');

                        _this5.disable_btn = false;
                    }
                });
            } else {
                toastr.error('Kindly fill all fields', 'Warning!');
                this.disable_btn = false;
            }
        },
        onFileChange: function onFileChange(e) {
            var files = e.target.files || e.dataTransfer.files;
            if (files.length) {
                this.file_info = files;
                var formData = new FormData();
                formData.append('photo', files[0]);
                this.imageForm = formData;
            }
        }
    },
    created: function created() {
        this.preset();
    }
});

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);



var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'ProductItemForm',
    data: function data() {
        return {
            user: {},
            sellpoint: {},
            product: {},
            product_items: {},
            disable_btn: false,
            imageForm: "",
            addProductItemPanel: false
        };
    },

    components: {},
    methods: {
        setComponent: function setComponent(attr1, attr2) {
            if (attr1 == 'add-product-item') {
                this.addProductItemPanel = true;
            }
            if (attr1 == 'reset-edit') {}
        },
        preset: function preset() {
            var _this = this;

            var credentials = {
                session_key: localStorage.getItem("sp_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.user.user_id = element.user_id;
                        }, _this);

                        _this.setProduct();
                    } else {
                        _this.$router.push('login');
                    }
                }).catch(function (err) {
                    if (err) {
                        _this.$router.push('login');
                    }
                });
            } else {
                this.$router.push('login');
            }
        },
        setProduct: function setProduct() {
            var _this2 = this;

            service.getProductSearch(this, this.$route.params.id).then(function (response) {
                if (response.body.status == 200) {
                    _this2.product = response.body.data;
                }
            }).catch(function (err) {
                _this2.$router.push("/");
            });
        },
        addProductItem: function addProductItem() {
            var _this3 = this;

            this.disable_btn = true;

            var credentials = {
                product_id: this.product.product_id,
                product_item_price: this.product.product_item_price,
                product_item_weight: this.product.product_item_weight || 1,
                product_item_quantity: this.product.product_item_quantity || 1
            };

            var navi = this.$router;
            if (credentials.product_item_price != undefined) {
                service.addProductItem(this, credentials).then(function (data) {
                    if (data.body.status == 201) {
                        var result = data.body.data;
                        this.imageForm.append("data_id", result.product_item_id);
                        this.imageForm.append("data_type", "product_items");
                        service.uploadDataPhoto(this, this.imageForm).then(function (data) {
                            if (data.body.status == 200) {
                                location.reload(true);
                            }
                        }).catch(function (err) {
                            if (err) {}
                        });
                    }
                }).catch(function (err) {
                    if (err) {
                        console.log(err);
                        _this3.disable_btn = false;
                    }
                });
            } else {
                toastr.error('Kindly fill all fields', 'Warning!');
                this.disable_btn = false;
            }
        },
        onFileChange: function onFileChange(e) {
            var files = e.target.files || e.dataTransfer.files;
            if (files.length) {
                var formData = new FormData();
                formData.append('photo', files[0]);


                this.imageForm = formData;
            }
        }
    },
    created: function created() {
        this.imageForm = new FormData();
        this.setProduct();
    }
});

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'product-list',
  created: function created() {
    if (this.products.length === 0) {
      this.$store.dispatch('allProducts');
    }
  },

  computed: {
    products: function products() {
      return this.$store.getters.allProducts;
    }
  },
  data: function data() {
    return {};
  }
});

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);



var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'LeftSidebar',
  data: function data() {
    return {
      user: {},
      loggedIn: false
    };
  },


  methods: {
    checkLoggedIn: function checkLoggedIn() {
      if (localStorage.getItem("sp_token") != null) {
        this.loggedIn = true;
        this.user.user_name = localStorage.getItem("sp_user");
      }
    }
  },
  created: function created() {
    this.checkLoggedIn();
  }
});

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);



var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'MenuBottom',
    data: function data() {
        return {};
    }
});

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);



var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'RightSidebar',
  data: function data() {
    return {
      user: {},
      loggedIn: false
    };
  },


  methods: {
    checkLoggedIn: function checkLoggedIn() {
      if (localStorage.getItem("sp_token") != null) {
        this.loggedIn = true;
        this.user.user_name = localStorage.getItem("sp_user");
      }
    }
  },
  created: function created() {
    this.checkLoggedIn();
  }
});

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);



var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'SearchBox',
    data: function data() {
        return {
            search_words: "",
            search_type: "business"
        };
    },


    methods: {
        search: function search() {
            location.replace("search?search=" + this.search_type + "&k=" + this.search_words);
        }
    }
});

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Settings',
    data: function data() {
        return {};
    },


    methods: {
        mountid: function mountid() {
            'use strict';
        }
    },

    created: function created() {
        window.addEventListener('load', this.mountid);
    },
    destroyed: function destroyed() {
        window.removeEventListener('load', this.mountid);
    }
});

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);



var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'SearchBox',
    data: function data() {
        return {
            products: {}
        };
    },


    methods: {
        getMarketActivityProducts: function getMarketActivityProducts() {
            var _this = this;

            var offset = 0;var limit = 20;
            service.getMarketActivityProducts(this, service.market_app_name, offset, limit).then(function (response) {
                if (response.body.status == 200) {
                    _this.products = response.body.data;
                    _this.loading = false;
                }
            }).catch(function (err) {});
        }
    },
    created: function created() {
        this.getMarketActivityProducts();
    }
});

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return API_BASE; });
/* unused harmony export imageURL */
var API_BASE = 'http://localhost/kokoeco/dev/koko/v1/api/';
var imageURL = 'http://localhost/kokoeco/dev/koko/v1/api/server/x52rs6c/pr.im.ti.ny.8/';

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_resource__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vee_validate__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vee_validate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vee_validate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_v_clipboard__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_v_clipboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_v_clipboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_awesome_swiper__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_awesome_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_swiper_dist_css_swiper_css__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_swiper_dist_css_swiper_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_swiper_dist_css_swiper_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__router__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store__ = __webpack_require__(72);














__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vee_validate___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_v_clipboard___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_awesome_swiper___default.a);

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  router: __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */],
  template: '\n    <div id="app">\n      <router-view></router-view>\n    </div>\n    '
}).$mount('#app');

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_validation__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_product_ProductItemForm_vue__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_product_ProductItemForm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_product_ProductItemForm_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_util__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_util__);






var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();
var validator = new __WEBPACK_IMPORTED_MODULE_1__services_validation__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Account',
    data: function data() {
        return {
            user: {},

            menu_view: {},
            menu_tab_view: {},
            is_view: "",

            states: {},
            cities: {},

            max_upload: service.max_media_upload,
            file_info: {},

            app_orders: {},
            processing_fee: {},

            payment_gateways: {}
        };
    },

    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue___default.a,
        'product-item-form': __WEBPACK_IMPORTED_MODULE_4__components_product_ProductItemForm_vue___default.a
    },

    methods: {
        resetAll: function resetAll() {
            this.discount_coupon = {};
            this.business_details = {};
            this.product_details = {};
            this.data_success_message = "";
            this.data_error_message = "";
            this.data_processing_message = "";
        },
        activate_processing: function activate_processing() {
            this.disable_btn = true;
            this.action_loading = true;
        },
        deactivate_processing: function deactivate_processing() {
            this.disable_btn = false;
            this.action_loading = false;
        },
        checkIfVideo: function checkIfVideo(url) {
            if (url != undefined) {
                var ext = url.split('.').pop();
                if (service.video_exts.includes(ext)) {
                    return true;
                } else {
                    return false;
                }
            }
        },
        reset: function reset() {
            this.setPanel = false;
            this.managePanel = false;
        },
        getStates: function getStates() {
            var _this = this;

            service.getStates(this).then(function (response) {
                if (response.body.status == 200) {
                    _this.states = response.body.data;
                }
            }).catch(function (err) {});
        },
        getCities: function getCities(state, option) {
            var _this2 = this;

            this.activate_processing();
            if (option == "edit") {
                this.edit_city = true;
            } else {
                this.edit_city = false;
            }
            service.getCities(this, state).then(function (response) {
                if (response.body.status == 200) {
                    _this2.cities = response.body.data;
                    _this2.deactivate_processing();
                } else {
                    _this2.deactivate_processing();
                }
            }).catch(function (err) {
                _this2.deactivate_processing();
            });
        },
        preset_xtra: function preset_xtra() {
            var _this3 = this;

            var credentials = {
                session_key: localStorage.getItem("sp_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        _this3.server_query_done = true;
                        var data = response.body.data;
                        data.forEach(function (element) {
                            var _this4 = this;

                            this.user.user_id = element.user_id;

                            service.getUser(this, element.user_id).then(function (data) {
                                if (data.body.status == 200) {
                                    var user_data = data.body.data;
                                    _this4.user.user_email = user_data.user_email;
                                    _this4.user.user_member_id = user_data.user_member_id;
                                    _this4.user.user_name = user_data.user_name;
                                    _this4.user.user_phone = user_data.user_phone;
                                    _this4.user.user_token = user_data.user_token;

                                    _this4.getSellpoints(element.user_id);
                                }
                            }).catch(function (err) {
                                if (err) {}
                            });
                        }, _this3);
                    } else {
                        _this3.$router.push('/login/');
                    }
                }).catch(function (err) {
                    if (err) {}
                });
            } else {}
        },
        preset: function preset() {
            var self = this;
            localforage.getItem(service.udb_name, function (err, value) {
                if (value != undefined) {
                    self.user.user_id = value.user_id;
                    self.loggedIn = true;
                    self.server_query_done = true;
                    service.getUser(self, element.user_id).then(function (data) {
                        if (data.body.status == 200) {
                            var user_data = data.body.data;
                            self.user.user_email = user_data.user_email;
                            self.user.user_member_id = user_data.user_member_id;
                            self.user.user_name = user_data.user_name;
                            self.user.user_phone = user_data.user_phone;
                            self.user.user_token = user_data.user_token;
                        }
                    }).catch(function (err) {
                        if (err) {}
                    });
                    self.loading = false;
                } else {}
            });
        },
        editProfileDetails: function editProfileDetails() {
            var _this5 = this;

            this.activate_processing();
            var payload = {
                user_name: this.user.user_name,
                user_phone: this.user.user_phone,
                user_email: this.user.user_email
            };

            var data_test = false;
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            var email_test = re.test(String(this.user.user_email).toLowerCase());
            var re_phone = /^\d{4}\d{3}\d{4}$/;
            var phone_test = re_phone.test(String(this.user.user_phone).toLowerCase());
            if (email_test == false || this.user.user_name == " " || phone_test == false) {
                data_test = false;
                this.data_processing_message = "Some errors were found in your form, please fill correctly";
                this.deactivate_processing();
            } else {
                data_test = true;
                this.data_processing_message = "";
            }
            if (data_test) {
                if (payload.user_name != null && payload.user_phone != null) {
                    service.editProfileDetails(this, payload).then(function (data) {
                        if (data.body.status == 200) {
                            this.data_processing_message = "Profile Updated";
                            this.user = data.body.data;
                            this.deactivate_processing();
                            this.setSettings = false;
                            this.setting_details = {};
                        } else {
                            this.data_processing_message = "Could not edit details, something went wrong, please try again";
                            this.deactivate_processing();
                            this.setSettings = false;
                            this.setting_details = {};
                        }
                    }).catch(function (err) {
                        _this5.data_processing_message = "Could not edit details, something went wrong, please try again";
                        _this5.deactivate_processing();
                        _this5.setSettings = false;
                        _this5.setting_details = {};
                    });
                }
            }
        }
    },
    created: function created() {
        document.title = "Account" + " | " + service.app_name;;
        this.getStates();
        this.preset();
    }
});

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__);




var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();
/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Buypoint',
    data: function data() {
        return {
            child_route_view: false,
            loading: false,
            loggedIn: false,
            user: {},
            sellpoint: {},
            set_gallery_banner_image: ""
        };
    },

    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue___default.a
    },
    methods: {
        setSellpoint: function setSellpoint() {
            var _this = this;

            this.loading = true;
            service.getAppBusinessByUserName(this, service.business_app_name).then(function (response) {
                if (response.body.status == 200) {
                    _this.sellpoint = response.body.data;
                    document.title = _this.sellpoint.business_name + " | SP";

                    if (_this.sellpoint.business_banner_image == _this.default_banner_image || _this.sellpoint.business_banner_image == 'error') {
                        _this.set_gallery_banner_image = service.general_banner_image;
                    } else {
                        _this.set_gallery_banner_image = _this.sellpoint.business_banner_image;
                    }

                    if (_this.sellpoint.business_market_subscription_name == 'Bird Plan') {
                        _this.max_plan_lookbooks = 2;
                        _this.max_plan_lookbook_posts = 5;
                    }
                    if (_this.sellpoint.business_market_subscription_name == 'Mid Bird Plan') {
                        _this.max_plan_lookbooks = 10;
                        _this.max_plan_lookbook_posts = 50;
                    }
                    if (_this.sellpoint.business_market_subscription_name == 'Max Bird Plan') {
                        _this.max_plan_lookbooks = 50;
                        _this.max_plan_lookbook_posts = 50;
                        _this.can_add_product_lookbook = true;
                    }

                    _this.preset();
                    _this.loading = false;
                } else {
                    _this.business_load_error_msg = "Sorry, this Business Information could not be found.";
                }
            }).catch(function (err) {
                _this.loading = false;
            });
        }
    },

    created: function created() {
        this.setSellpoint();
    }
});

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__);



var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'CreateSellpoint',
    data: function data() {
        return {
            users: {},
            user: {},
            business: {},
            sellpoints: {},
            categories: {},
            market_categories: {},
            states: {},
            cities: {},
            disable_btn: false,
            validate_user_name_error: false,
            validate_user_name_message: "",
            group_isset: false,
            add_sellpoint: false,
            add_business: false,
            get_flag: false,
            loading: false
        };
    },

    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue___default.a
    },
    methods: {
        validateUserName: function validateUserName() {
            var _this = this;

            service.validateBusinessUserName(this, this.business).then(function (response) {
                if (response.body.status == 200) {
                    _this.validate_user_name_error = false;
                    _this.validate_user_name_message = "This sellpoint does not exist";
                } else {
                    _this.validate_user_name_error = true;
                    _this.validate_user_name_message = "This username already exist";
                }
            }).catch(function (err) {
                _this.validate_user_name_error = true;
                _this.validate_user_name_message = "This username already exist";
            });
        },
        preset: function preset() {
            var _this2 = this;

            this.loading = true;
            var credentials = {
                session_key: localStorage.getItem("sp_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.user.user_id = element.user_id;
                        }, _this2);

                        _this2.getBusinessCategories();
                        _this2.getMarketCategories();
                        _this2.getSellpoints(_this2.user.user_id);

                        _this2.loading = false;
                    } else {
                        _this2.$router.push('login');
                    }
                }).catch(function (err) {
                    if (err) {
                        _this2.$router.push('login');
                    }
                });
            } else {
                this.$router.push('login');
            }
        },
        getStates: function getStates() {
            service.getStates(this).then(function (data) {
                this.states = data.body;
            });
        },
        getCities: function getCities(state) {
            service.getCities(this, state).then(function (data) {
                this.cities = data.body;
            });
        },
        getBusinessCategories: function getBusinessCategories() {
            service.getCategories(this).then(function (data) {
                this.categories = data.body.data;
            });
        },
        getMarketCategories: function getMarketCategories() {
            service.getMarketCategories(this).then(function (data) {
                this.market_categories = data.body.data;
            });
        },
        getSellpoints: function getSellpoints(user) {
            var _this3 = this;

            service.getBusinesses(this, user).then(function (data) {
                if (data.body.status == 200) {
                    var result = data.body.data;
                    var arr = [];
                    result.forEach(function (element) {
                        if (element.business_type == 1) {
                            arr.push(element);
                        }
                    });
                    _this3.sellpoints = arr;
                }
            }).catch(function (err) {
                if (err) {
                    console.log(err);
                }
            });
        },
        createSellpoint: function createSellpoint() {
            var _this4 = this;

            this.disable_btn = true;
            this.business.agree = true;
            var credentials = {
                business_name: this.business.business_name,
                business_user_name: this.business.business_user_name,
                business_category: this.business.business_category || 1,
                business_market_category: this.business.market_category || 0,
                business_owner: this.user.user_id
            };
            var navi = this.$router;
            if (this.validate_user_name_error) {
                toastr.error('This Username already exists', 'Warning!');
            } else {
                if (credentials.business_name != undefined && credentials.business_category != undefined) {
                    if (this.business.agree) {
                        service.addBusiness(this, credentials).then(function (data) {
                            if (data.body.status == 201) {
                                toastr.success("Sellpoint Creation Successfull", 'Success!');

                                this.business = data.body.data;
                                navi.push('/' + this.business.business_user_name);
                            }
                        }).catch(function (err) {
                            if (err) {
                                toastr.warning("Something went wrong", 'Warning!');
                                _this4.disable_btn = false;
                            }
                        });
                    } else {
                        toastr.error('Please agree to Terms', 'Warning!');
                        this.disable_btn = false;
                    }
                } else {
                    toastr.error('Kindly fill all fields', 'Warning!');
                    this.disable_btn = false;
                }
            }
        },
        addSelectedExistingSellpoint: function addSelectedExistingSellpoint() {
            var _this5 = this;

            this.disable_btn = true;
            this.business.agree = true;
            var credentials = {
                business_user_name: this.business.business_user_name,
                business_group: localStorage.getItem("sp_#_sellpoint") || "nill"
            };
            var navi = this.$router;
            if (credentials.business_user_name != undefined) {
                service.addExistingBusiness(this, credentials).then(function (data) {
                    if (data.body.status == 201) {
                        toastr.success("Sellpoint Added Successfull", 'Success!');

                        navi.push('/' + localStorage.getItem("sp_#_sellpoint"));
                    }
                }).catch(function (err) {
                    if (err) {
                        toastr.warning("Something went wrong", 'Warning!');
                        _this5.disable_btn = false;
                    }
                });
            } else {
                toastr.error('Kindly fill all fields', 'Warning!');
                this.disable_btn = false;
            }
        },
        addExistingSellpoint: function addExistingSellpoint() {
            var _this6 = this;

            this.disable_btn = true;
            this.business.agree = true;
            var credentials = {
                business_user_name: this.business.business_user_name,
                business_group: localStorage.getItem("sp_#_sellpoint") || "nill"
            };
            var navi = this.$router;
            if (!this.validate_user_name_error) {
                toastr.error('This Sellpoint does not exist', 'Warning!');
            } else {
                if (credentials.business_user_name != undefined) {
                    service.addExistingBusiness(this, credentials).then(function (data) {
                        if (data.body.status == 201) {
                            toastr.success("Sellpoint Added Successfull", 'Success!');

                            navi.push('/' + localStorage.getItem("sp_#_sellpoint"));
                        }
                    }).catch(function (err) {
                        if (err) {
                            toastr.warning("Something went wrong", 'Warning!');
                            _this6.disable_btn = false;
                        }
                    });
                } else {
                    toastr.error('Kindly fill all fields', 'Warning!');
                    this.disable_btn = false;
                }
            }
        },
        addNewSellpoint: function addNewSellpoint() {
            var _this7 = this;

            this.disable_btn = true;
            this.business.agree = true;
            var credentials = {
                business_name: this.business.business_name,
                business_user_name: this.business.business_user_name,
                business_category: this.business.business_category || 1,
                business_owner: this.user.user_id,
                business_group: localStorage.getItem("sp_#_sellpoint") || "nill"
            };
            var navi = this.$router;
            if (this.validate_user_name_error) {
                toastr.error('This Username already exists', 'Warning!');
            } else {
                if (credentials.business_name != undefined && credentials.business_category != undefined) {
                    if (this.business.agree) {
                        service.addNewBusiness(this, credentials).then(function (data) {
                            if (data.body.status == 201) {
                                toastr.success("Sellpoint Creation Successfull", 'Success!');

                                navi.push('/' + localStorage.getItem("sp_#_sellpoint"));
                            }
                        }).catch(function (err) {
                            if (err) {
                                toastr.warning("Something went wrong", 'Warning!');
                                _this7.disable_btn = false;
                            }
                        });
                    } else {
                        toastr.error('Please agree to Terms', 'Warning!');
                        this.disable_btn = false;
                    }
                } else {
                    toastr.error('Kindly fill all fields', 'Warning!');
                    this.disable_btn = false;
                }
            }
        }
    },
    created: function created() {
        this.preset();
        if (this.$route.query.create == "new") {
            this.add_sellpoint = true;
        }
        if (this.$route.query.create == "add") {
            this.add_sellpoint = true;
            this.add_business = true;
        }
    }
});

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_posts_newgallery_vue__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_posts_newgallery_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_posts_newgallery_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_posts_newproductgallery_vue__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_posts_newproductgallery_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_posts_newproductgallery_vue__);






var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Sellpoint',
    data: function data() {
        return {
            user: {},
            market: {},
            sellpoint: {},
            categories: {},
            galleria: {},
            gallery: {},
            gallery_post: {},
            gallery_post_set_image: {},
            post: {},
            products: {},
            product: {},
            productMain: {},
            productItem: {},
            img_sellpoint_url: service.imageSellpointsURL,
            img_product_url: service.imageProductsURL,
            loggedIn: false,
            edit_mode: false,
            loading: true,
            online: false,
            place_order: false,
            ordered_product: {},
            ordered_product_item: {},
            swipe_index: 0,

            data_error_message: "",
            data_success_message: "",
            payment_successful: false,
            payment_successful_message: "",
            payment_payer_name: "",
            payment_payer_email: "",
            payment_payer_phone: "",
            payment_service: "",

            addPanel: false,
            business_load_error_msg: "",
            newLookbookForm: false,
            newProductLookbookForm: false,
            max_plan_lookbooks: 0,
            max_plan_lookbook_posts: 0,
            total_lookbooks_added: 0,
            can_add_more_lookbook: false,
            can_add_product_lookbook: false,
            addNewPost: false,
            file_info: {},
            refresh_button: false,
            disable_btn: false,
            action_loading: false,
            default_banner_image: "https://res.cloudinary.com/diprbfy7s/image/upload/v1550754799/businesses_files/sp-default-banner.jpg"

        };
    },


    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue___default.a,
        'add-lookbook': __WEBPACK_IMPORTED_MODULE_3__components_posts_newgallery_vue___default.a,
        'add-product-lookbook': __WEBPACK_IMPORTED_MODULE_4__components_posts_newproductgallery_vue___default.a
    },
    computed: {
        total: function total() {
            var total = 0;
            for (var i = 0; i < this.items.length; i++) {
                total += this.items[i].product_price;
            }
            return total;
        }
    },
    methods: {
        mobileSideNavToggle: function mobileSideNavToggle(action) {
            if (action == "open") {
                var isMobile = window.matchMedia("only screen and (max-width: 760px)").matches;

                if (isMobile) {
                    document.getElementById("mobileSideNav").style.width = "100%";
                } else {
                    document.getElementById("mobileSideNav").style.width = "50%";
                }
            }
            if (action == "close") {
                document.getElementById("mobileSideNav").style.width = "0";
            }
        },
        activate_processing: function activate_processing() {
            this.disable_btn = true;
            this.action_loading = true;
        },
        deactivate_processing: function deactivate_processing() {
            this.disable_btn = false;
            this.action_loading = false;
        },
        checkIfVideo: function checkIfVideo(url) {
            if (url != undefined) {
                var ext = url.split('.').pop();
                if (service.video_exts.includes(ext)) {
                    return true;
                } else {
                    return false;
                }
            }
        },
        addComponent: function addComponent(attr1, attr2) {
            this.addPanel = true;

            if (attr1 == "add-new-lookbook") {
                this.newLookbookForm = true;
            }
            if (attr1 == "add-new-product-lookbook") {
                this.newProductLookbookForm = true;
            }
            if (attr1 == "add-new-product-post") {
                this.$router.push("/" + this.$route.params.id + "/" + this.gallery.gallery_posts_group_url_name);
                $('#quickviewModal').modal('hide');

                this.newProductLookbookForm = true;
            }
            if (attr1 == "add-new-post") {
                this.addNewPost = true;
                $('#quickviewModal').modal('hide');
                this.gallery = attr2;
            }

            var top = document.getElementById("addPanelView").offsetTop;
            window.scrollTo(0, top);
        },
        setComponent: function setComponent(attr1, attr2) {
            if (attr1 == "refresh-store") {
                this.getGalleryPosts();
            }
        },
        reset: function reset() {
            this.addPanel = false, this.addNewPost = false;
            this.newLookbookForm = false;
            this.newProductLookbookForm = false;
            this.data_error_message = "";
            this.data_success_message = "";
        },
        preset: function preset() {
            var _this = this;

            this.loading = true;
            var credentials = {
                session_key: localStorage.getItem("sp_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.user.user_id = element.user_id;
                            this.user.user_name = localStorage.getItem("sp_user");
                            this.loggedIn = true;
                            this.is_editing();
                        }, _this);
                    } else {}
                }).catch(function (err) {
                    if (err) {}
                });
            } else {}
        },
        is_editing: function is_editing() {
            var _this2 = this;

            if (this.user.user_id != "") {
                var payload = {
                    validate_user: this.user.user_id,
                    validate_business: this.sellpoint.business_id
                };
                service.can_edit(this, payload).then(function (response) {
                    if (response.body.status == 200) {
                        _this2.edit_mode = true;
                    } else {
                        _this2.edit_mode = false;
                    }
                }).catch(function (err) {
                    if (err) {}
                });
            }
        },
        setGallery: function setGallery() {
            var _this3 = this;

            this.loading = true;
            service.getGallerySearch(this, this.$route.params.id).then(function (response) {
                if (response.body.status == 200) {
                    _this3.gallery = response.body.data;

                    _this3.loading = false;
                }
            }).catch(function (err) {
                console.log(err);
            });
        },
        setSellpoint: function setSellpoint() {
            var _this4 = this;

            this.loading = true;
            service.getAppBusinessByUserName(this, this.$route.params.id).then(function (response) {
                if (response.body.status == 200) {
                    _this4.sellpoint = response.body.data;

                    if (_this4.sellpoint.business_market_subscription_name == 'Bird Plan') {
                        _this4.max_plan_lookbooks = 2;
                        _this4.max_plan_lookbook_posts = 5;
                    }
                    if (_this4.sellpoint.business_market_subscription_name == 'Mid Bird Plan') {
                        _this4.max_plan_lookbooks = 10;
                        _this4.max_plan_lookbook_posts = 50;
                    }
                    if (_this4.sellpoint.business_market_subscription_name == 'Max Bird Plan') {
                        _this4.max_plan_lookbooks = 50;
                        _this4.max_plan_lookbook_posts = 50;
                        _this4.can_add_product_lookbook = true;
                    }

                    var self = _this4;
                    setTimeout(function () {
                        self.getGalleryPosts();
                    }, 3000);
                    _this4.preset();
                    _this4.loading = false;
                } else {
                    _this4.business_load_error_msg = "Sorry, we could not load this Business Information";
                }
            }).catch(function (err) {
                _this4.loading = false;
            });
        },
        getProductsInBusinessCategories: function getProductsInBusinessCategories() {
            var _this5 = this;

            this.loading = true;
            service.getProductsInBusinessCategories(this, this.sellpoint.business_id).then(function (response) {
                if (response.body.status == 200) {
                    _this5.categories = response.body.data;
                }
                _this5.loading = false;
            }).catch(function (err) {
                _this5.loading = false;
            });
        },
        getGalleryPosts: function getGalleryPosts() {
            var _this6 = this;

            this.loading = true;
            service.getPointGalleryPosts(this, this.sellpoint.business_id, 0, this.max_plan_lookbooks, 0, this.max_plan_lookbook_posts).then(function (response) {
                _this6.galleria = response.body.data;

                _this6.total_lookbooks_added = response.body.total_data;

                if (_this6.total_lookbooks_added < _this6.max_plan_lookbooks) {
                    _this6.can_add_more_lookbook = true;
                }

                _this6.loading = false;
            }).catch(function (err) {
                _this6.loading = false;
            });
        },
        getSellpointProducts: function getSellpointProducts() {
            var _this7 = this;

            this.loading = true;
            service.getBusinessProducts(this, this.sellpoint.business_id).then(function (response) {
                if (response.body.status == 200) {

                    _this7.products = response.body.data;
                    _this7.loading = false;
                }
            }).catch(function (err) {});
        },
        getPostsInGallery: function getPostsInGallery(gallery) {
            this.gallery = gallery;
            this.gallery_post = gallery.gallery_posts_group_posts[0];

            this.gallery_post_set_image = this.gallery_post.gallery_post_media[0];
            $('#quickviewModal').modal('show');
        },
        getCategoryProducts: function getCategoryProducts(category) {
            this.loading = true;
            this.product = category.business_category_products[0];
            this.products = category.business_category_products;
            $('#quickviewModal').modal('show');
            this.loading = false;
        },
        getCategoryProductsXX: function getCategoryProductsXX(category) {
            var _this8 = this;

            this.loading = true;
            var self = this;
            service.getCategoryProducts(this, category).then(function (response) {
                if (response.body.status == 200) {
                    _this8.products = response.body.data;

                    var count = 0;
                    _this8.products.forEach(function (element) {
                        count++;
                        if (count == 1) {
                            _this8.product = element;
                            $('#quickviewModal').modal('show');
                        }
                    });
                    _this8.loading = false;
                }
            }).catch(function (err) {
                _this8.loading = false;
            });
        },
        showPost: function showPost(post) {
            this.gallery_post = post;

            this.gallery_post_set_image = post.gallery_post_media[0];
        },
        showPostImage: function showPostImage(post_image) {
            this.gallery_post_set_image = post_image;
        },
        showProduct: function showProduct(product) {
            this.product = product;
        },
        addPostToGallery: function addPostToGallery() {
            var _this10 = this;

            this.disable_btn = true;

            var credentials = {
                gallery_new_group: false,
                gallery_post_group: this.gallery.gallery_posts_group_id,
                gallery_post_caption: this.post.post_caption || "nill",
                gallery_post_details: this.post.post_details
            };

            var navi = this.$router;
            if (credentials.gallery_post_details != undefined) {
                service.addGallery(this, credentials).then(function (data) {
                    var _this9 = this;

                    if (data.body.status == 201) {
                        this.data_success_message = "Post Created";

                        this.post = data.body.data;

                        this.imageForm.append("data_id", this.post.post_id);
                        this.imageForm.append("data_type", "gallery_media");
                        service.uploadDataPhoto(this, this.imageForm).then(function (data) {
                            if (data.body.status == 200) {
                                location.reload(true);

                                _this9.gallery = data.body.data_gallery;
                                _this9.addNewPost = false;
                            }
                        }).catch(function (err) {
                            if (err) {}

                            _this9.data_error_message = "Something went wrong";
                        });
                    }
                }).catch(function (err) {
                    if (err) {
                        _this10.data_error_message = "Something went wrong";

                        _this10.disable_btn = false;
                    }
                });
            } else {
                toastr.error('Kindly fill all fields', 'Warning!');
                this.disable_btn = false;
            }
        },
        onFileChange: function onFileChange(e) {
            var files = e.target.files || e.dataTransfer.files;
            if (files.length) {
                this.file_info = files;
                var formData = new FormData();
                formData.append('photo', files[0]);
                this.imageForm = formData;
            }
        },
        manageLookbook: function manageLookbook() {
            var _this11 = this;

            this.disable_btn = true;

            var credentials = {
                session_key: localStorage.getItem("sp_token"),
                request_url: service.app_url,
                request_from: service.app_name,
                request_status: "REQUESTING...",
                request: this.sellpoint.business_username + '/g/' + this.gallery.gallery_posts_group_url_name
            };
            if (credentials.session_key != null) {
                service.sessionSync(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var ref = response.body.data;
                        window.location.href = service.sp_url + '/manage/' + ref;
                    } else {
                        _this11.disable_btn = false;
                    }
                }).catch(function (err) {
                    if (err) {
                        console.log(err);
                        _this11.disable_btn = false;
                    }
                });
            }
        },
        addToCart: function addToCart(productMain, productItem) {
            this.productItem = {};
            var cart_index = this.cart.findIndex(function (c) {
                return c.product_item_id === productItem.product_item_id;
            });
            if (cart_index < 0) {
                this.productMain = productMain;
                this.productItem = productItem;
                this.productItem._id = this.productItem.product_item_id;
                this.productItem.is_product_in_cart = true;

                if (this.productItem.product_item_order_quantity == undefined) {
                    this.productItem.product_item_order_quantity = 1;
                }
                this.productItem.product_main_id = this.productMain.product_id;
                this.productItem.product_business = this.productMain.product_business_ownername;
                this.productItem.product_name = this.productMain.product_name;
                this.productItem.product_url_name = this.productMain.product_url_name;
                this.productItem.product_url = this.productMain.product_business_ownername + "/" + this.productMain.product_url_name;
                this.$store.commit(ADD_TO_CART, this.productItem);
            } else {}
        },
        removeFromCart: function removeFromCart(payload) {
            this.$store.commit(REMOVE_FROM_CART, payload);
        },
        placeOrder: function placeOrder(product, product_item) {
            this.ordered_product = product;
            this.ordered_product_item = product_item;
            this.place_order = true;
        },
        resetOptions: function resetOptions() {
            this.ordered_product = {};
            this.ordered_product_item = {};
            this.total_price = 0;
            this.place_order = false;
        },
        processPayment: function processPayment() {
            var data_test = false;
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            var email_test = re.test(String(this.payment_payer_email).toLowerCase());
            var re_phone = /^\d{4}\d{3}\d{4}$/;
            var phone_test = re_phone.test(String(this.payment_payer_phone).toLowerCase());
            if (email_test == false || this.payment_payer_name == " " || phone_test == false) {
                data_test = false;
                this.data_error_message = "Some errors were found in your form, please fill correctly";
            } else {
                data_test = true;
                this.data_error_message = "";
            }
            if (data_test) {
                this.payment_service = "HungrillvilleKitchen Order - " + this.ordered_product.product_name + "(" + this.ordered_product_item.product_item_price + ")";
                var obj = this;

                var handler = PaystackPop.setup({
                    key: 'pk_test_1b578e2fe82975a4ec8a79e5d1a387c953fd2c3e',
                    Name: this.payment_payer_name,

                    email: this.payment_payer_email,
                    amount: Math.round(this.ordered_product_item.product_item_price * 100),
                    ref: "HUNGLOG" + Math.random(),
                    metadata: {
                        custom_fields: [{
                            display_name: "HungrillvilleKitchen Order",
                            variable_name: "",
                            value: this.payment_payer_name + " - " + this.payment_payer_phone + " - ORDER - " + this.ordered_product.product_name
                        }, {
                            display_name: "Service",
                            variable_name: "service_type",
                            value: this.ordered_product.product_name
                        }]
                    },

                    callback: function callback(response) {
                        obj.updatePayment(response.trxref);
                    },
                    onClose: function onClose() {
                        alert('window closed');
                    }
                });
                handler.openIframe();
            }
        },
        updatePayment: function updatePayment(payment_ref) {
            var navi = this.$router;

            var payer_name = this.payment_payer_name;
            this.data = {};

            this.payment_successful = true;
            this.payment_successful_message = "Hi " + payer_name + ", Your Payment was successful, we would proceed to prepare your order. Thank You.";
        }
    },
    mounted: function mounted() {
        this.preset();
    },

    created: function created() {
        if (this.$route.params.idg) {
            this.$router.push('/' + this.$route.params.id);
        }
        if (this.addPanel) {
            this.refresh_button = true;
        }
        this.reset();
        this.setSellpoint();
    }
});

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_templates_menubottom_vue__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_templates_menubottom_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_templates_menubottom_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_tools_settings_vue__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_tools_settings_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_tools_settings_vue__);






var service = new __WEBPACK_IMPORTED_MODULE_1__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Home',
    data: function data() {
        return {
            user: {},
            market: {},
            business: {},
            categories: {},
            subscriptions: {},
            plan1: {},
            plan2: {},
            plan3: {},
            selected_plan: {},
            place_order: false,

            data_boarding_message: "",
            set_up_with_existing_account: false,
            set_up_with_new_account: false,
            set_up_business: false,
            validate_user_name_error: false,
            data_error_message: "",
            payment_successful: false,
            payment_successful_message: "",
            payment_payer_name: "",
            payment_payer_email: "",
            payment_payer_phone: "",
            payment_service: "",
            img_sellpoint_url: service.imageSellpointsURL,
            img_product_url: service.imageProductsURL,
            loggedIn: false,
            loading: true,
            disable_btn: false
        };
    },


    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue___default.a,
        'component-menu-bottom': __WEBPACK_IMPORTED_MODULE_4__components_templates_menubottom_vue___default.a,
        'c-settings': __WEBPACK_IMPORTED_MODULE_5__components_tools_settings_vue___default.a
    },
    computed: {},
    methods: {
        preset: function preset() {
            var _this = this;

            var credentials = {
                session_key: localStorage.getItem("sp_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.user.user_id = element.user_id;
                            this.user.user_name = localStorage.getItem("sp_user");
                            this.loggedIn = true;
                            this.$router.push('/timeline');
                        }, _this);
                    } else {}
                }).catch(function (err) {
                    if (err) {}
                });
            } else {}
        },
        setComponent: function setComponent(attr1, attr2) {
            if (attr1 == 'setup-existing') {
                this.set_up_with_existing_account = true;
            }
        },
        toggleFAQComponent: function toggleFAQComponent(action, show, hide, head, body) {
            if (action == 'show') {
                document.getElementById(show).style.display = "none";
                document.getElementById(hide).style.display = "block";
                document.getElementById(head).style.color = "#ff0000";
                document.getElementById(body).style.display = "block";
            }
            if (action == 'hide') {
                document.getElementById(show).style.display = "block";
                document.getElementById(hide).style.display = "==none";
                document.getElementById(head).style.color = "#777b92";
                document.getElementById(body).style.display = "none";
            }
        },
        getSellpointMarket: function getSellpointMarket() {
            var _this2 = this;

            service.getBusinessByUserName(this, service.market_app_name).then(function (response) {
                if (response.body.status == 200) {
                    _this2.market = response.body.data;

                    _this2.getMarketMainProductsAsSubscriptions();

                    _this2.loading = false;
                }
            }).catch(function (err) {});
        },
        getMarketMainProductsAsSubscriptions: function getMarketMainProductsAsSubscriptions() {
            var _this3 = this;

            service.getBusinessProducts(this, this.market.business_id).then(function (response) {
                if (response.body.status == 200) {
                    _this3.subscriptions = response.body.data;
                    _this3.plan1 = _this3.subscriptions[2];
                    _this3.plan2 = _this3.subscriptions[1];
                    _this3.plan3 = _this3.subscriptions[0];
                }
            }).catch(function (err) {});
        },
        purchase_plan: function purchase_plan(plan, plan_product_service_item_index) {
            this.loading = true;
            this.selected_plan = plan;
            this.place_order = true;

            this.$router.push('/purchase/?purchase=' + plan.product_url_name + '&item=' + plan_product_service_item_index);
        },
        resetOptions: function resetOptions() {
            this.selected_plan = {};
            this.total_price = 0;
            this.place_order = false;
        },
        resetMessages: function resetMessages() {
            this.data_error_message = "";
            this.data_boarding_message = "";
            this.payment_successful_message = "";
            this.validate_user_name_error = "";
        },
        proceedNewAccount: function proceedNewAccount() {
            this.resetMessages();
            this.set_up_with_new_account = true;

            if (this.selected_plan.product_items[0].product_item_price == 0) {
                this.updatePayment("gw-free-account");
            } else {
                this.processPayment();
            }
        },
        proceedWithAccount: function proceedWithAccount() {
            this.resetMessages();
            var payload = {
                user_email: this.user.user_email,
                user_password: this.user.user_password,
                user_business: this.user.user_business
            };
            service.checkUserDetails(this, payload).then(function (data) {
                if (data.body.status == 200) {
                    if (data.body.status_2 != 200) {
                        this.data_error_message = "Sorry, Sellpoint does not exist on this account";
                    } else {
                        this.payment_payer_name = data.body.data.user_name;
                        this.payment_payer_email = data.body.data.user_email;
                        this.payment_payer_phone = data.body.data.user_phone;

                        if (this.selected_plan.product_items[0].product_item_price == 0) {
                            this.updatePayment("gw-free-account");
                        } else {
                            this.processPayment();
                        }
                    }
                } else {
                    this.data_error_message = "Sorry, Account does not exist";
                }
            }).catch(function (err) {});
        },
        processPayment: function processPayment() {
            var data_test = false;
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            var email_test = re.test(String(this.payment_payer_email).toLowerCase());
            var re_phone = /^\d{4}\d{3}\d{4}$/;
            var phone_test = re_phone.test(String(this.payment_payer_phone).toLowerCase());
            if (email_test == false || this.payment_payer_name == " " || phone_test == false) {
                data_test = false;
                this.data_error_message = "Some errors were found in your form, please fill correctly";
            } else {
                data_test = true;
                this.data_error_message = "";
            }
            if (data_test) {
                this.payment_service = "Gallery Website Order - " + this.selected_plan.product_name + "(" + this.selected_plan.product_items[0].product_item_price + ")";
                var obj = this;

                var handler = PaystackPop.setup({
                    key: 'pk_test_1b578e2fe82975a4ec8a79e5d1a387c953fd2c3e',
                    Name: this.payment_payer_name,

                    email: this.payment_payer_email,
                    amount: Math.round(this.selected_plan.product_items[0].product_item_price * 100),
                    ref: "GWLOG" + Math.random(),
                    metadata: {
                        custom_fields: [{
                            display_name: "GalleryWebsite Order",
                            variable_name: "",
                            value: this.payment_payer_name + " - " + this.payment_payer_phone + " - ORDER - " + this.selected_plan.product_name
                        }, {
                            display_name: "Service",
                            variable_name: "service_type",
                            value: this.selected_plan.product_name
                        }]
                    },

                    callback: function callback(response) {
                        obj.updatePayment(response.trxref);
                    },
                    onClose: function onClose() {
                        alert('window closed');
                    }
                });
                handler.openIframe();
            }
        },
        updatePayment: function updatePayment(payment_ref) {

            var navi = this.$router;
            this.payment_successful = true;
            this.payment_successful_message = "Payment Successful...";

            if (this.set_up_with_existing_account) {
                this.setUpExistingAccount();
            }
            if (this.set_up_with_new_account) {
                this.setUpNewAccount();
            }
        },
        setUpExistingAccount: function setUpExistingAccount() {
            var _this5 = this;

            this.disable_btn = true;
            var credentials = {
                business_user_name: this.user.user_business,
                business_group: service.market_app_name,
                business_subscription: this.selected_plan.product_id
            };

            var navi = this.$router;
            service.addExistingBusiness(this, credentials).then(function (data) {
                var _this4 = this;

                if (data.body.status == 201) {
                    this.boarding_messages.push("Sellpoint Setup Successful...");

                    var credentials = {
                        user_email: this.user.user_email,
                        user_password: this.user.user_password
                    };
                    service.loginUser(this, credentials).then(function (response) {
                        if (response.body.status == 200) {
                            var _data = response.body.data;
                            localStorage.setItem("sp_user", _data.user_name);
                            localStorage.setItem("sp_token", _data.user_session_key);
                            localStorage.setItem("sp_token_key", _data.user_token_key);

                            $('#purchaseModal').modal('hide');
                            navi.push('/' + _this4.user.user_business);
                        }
                    }).catch(function (err) {
                        if (err.status == 404) {
                            toastr.warning("invalid login credentials", 'Warning!');
                            _this4.disable_btn = false;
                        }
                    });
                }
            }).catch(function (err) {
                if (err) {
                    toastr.warning("Something went wrong", 'Warning!');
                    _this5.disable_btn = false;
                }
            });
        },
        setUpNewAccount: function setUpNewAccount() {
            this.disable_btn = true;
            this.loading = true;
            var credentials = {
                user_name: this.payment_payer_name,
                user_phone: this.payment_payer_phone,
                user_email: this.payment_payer_email,
                user_address: '',
                user_state: '',
                user_city: '',
                user_password: this.user.user_password
            };

            var navi = this.$router;

            var data_test = false;
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            var email_test = re.test(String(this.payment_payer_email).toLowerCase());
            var re_phone = /^\d{4}\d{3}\d{4}$/;
            var phone_test = re_phone.test(String(this.payment_payer_phone).toLowerCase());
            if (email_test == false || this.payment_payer_name == " " || phone_test == false) {
                data_test = false;
                this.data_error_message = "Some errors were found in your form, please fill correctly";
            } else {
                data_test = true;
                this.data_error_message = "";
            }
            if (data_test) {
                if (credentials.user_name != undefined && credentials.user_address != undefined && credentials.user_phone != null && credentials.user_email != null && credentials.user_password != null) {
                    service.regUser(this, credentials).then(function (data) {
                        var _this6 = this;

                        if (data.body.status == 201) {
                            this.data_boarding_message = "Registration Successful...";

                            var credentials = {
                                user_email: data.body.data.user_email,
                                user_password: data.body.data.user_password
                            };
                            service.loginUser(this, credentials).then(function (response) {
                                if (response.body.status == 200) {
                                    var _data2 = response.body.data;
                                    localStorage.setItem("sp_user", _data2.user_name);
                                    localStorage.setItem("sp_token", _data2.user_session_key);
                                    localStorage.setItem("sp_token_key", _data2.user_token_key);

                                    _this6.preset();

                                    setTimeout(function () {
                                        this.set_up_business = true;
                                        $('#purchaseModal').modal('hide');
                                        $('#newBusinessModal').modal('show');
                                    }, 3000);
                                }
                            }).catch(function (err) {
                                if (err.status == 404) {
                                    _this6.data_error_message = "invalid login credentials..";
                                    _this6.disable_btn = false;
                                }
                            });
                        } else if (data.body.status == 409) {
                            this.data_error_message = "This User is already registered..";
                            this.disable_btn = false;
                        }
                    });
                } else {
                    this.data_error_message = "Kindly fill all fields...";
                    this.disable_btn = false;
                }
            }
        },
        validateUserName: function validateUserName() {
            var _this7 = this;

            service.validateBusinessUserName(this, this.business).then(function (response) {
                if (response.body.status != 200) {
                    _this7.validate_user_name_error = true;
                    _this7.validate_user_name_message = "This username already exist";
                }
            }).catch(function (err) {
                _this7.validate_user_name_error = true;
                _this7.validate_user_name_message = "This username already exist";
            });
        },
        setUpNewAccountBusiness: function setUpNewAccountBusiness() {
            var _this8 = this;

            this.resetMessages();
            this.disable_btn = true;
            var credentials = {
                business_name: this.business.business_name,
                business_user_name: this.business.business_user_name,
                business_category: this.business.business_category || 1,
                business_owner: this.user.user_id,
                business_group: service.market_app_name,
                business_layout: this.business.business_view_layout || 3,
                business_subscription: this.selected_plan.product_id
            };
            var navi = this.$router;
            if (this.validate_user_name_error) {
                this.data_error_message = "This Username already exists..";
            } else {
                if (credentials.business_name != undefined && credentials.business_category != undefined) {
                    service.addNewBusiness(this, credentials).then(function (data) {
                        if (data.body.status == 201) {
                            this.data_boarding_message = "Sellpoint Creation Successful.";

                            $('#newBusinessModal').modal('hide');
                            navi.push('/' + this.business.business_user_name);
                        } else {
                            this.data_error_message = "This Username already exists";
                        }
                    }).catch(function (err) {
                        if (err) {
                            _this8.data_error_message = "Something went wrong";
                            _this8.disable_btn = false;
                        }
                    });
                } else {
                    this.data_error_message = "Kindly fill all fields";
                    this.disable_btn = false;
                }
            }
        },
        getBusinessCategories: function getBusinessCategories() {
            service.getCategories(this).then(function (data) {
                this.categories = data.body.data;
            });
        },
        creation_thread: function creation_thread() {
            var promises = [];
            for (var i = 0; i < 9; ++i) {
                if (i == 1) {
                    promises.push(this.preset());
                }
                if (i == 2) {
                    promises.push(this.getSellpointMarket());
                }
            }

            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(promises).then(function () {
                var result = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
                promises.forEach(function (promise) {
                    result.then(function () {});
                });
            }).catch(function (e) {});
        }
    },

    created: function created() {
        var self = this;
        setTimeout(function () {
            var menu = self.$route.params.menu;
            if (menu == "features") {
                var top = document.getElementById("features").offsetTop;
                window.scrollTo(0, top);
            }
            if (menu == "pricing") {
                var top = document.getElementById("pricing").offsetTop;
                window.scrollTo(0, top);
            }
            if (menu == "blog") {
                var top = document.getElementById("blog").offsetTop;
                window.scrollTo(0, top);
            }
        }, 1500);
        this.creation_thread();
    }
});

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue__);




var service = new __WEBPACK_IMPORTED_MODULE_1__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Register',
    data: function data() {
        var _ref;

        return _ref = {
            users: {},
            user: {},
            states: {},
            cities: {},
            disable_btn: false,
            data_error_message: ""
        }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'disable_btn', false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'action_loading', false), _ref;
    },

    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue___default.a
    },
    methods: {
        reset: function reset() {
            localStorage.removeItem("sp_user");
            localStorage.removeItem("sp_token");
            localStorage.removeItem("sp_token_key");
            localStorage.removeItem("sp_#_sellpoint");
        },
        activate_processing: function activate_processing() {
            this.disable_btn = true;
            this.action_loading = true;
        },
        deactivate_processing: function deactivate_processing() {
            this.disable_btn = false;
            this.action_loading = false;
        },
        login: function login() {
            var _this = this;

            this.activate_processing();
            this.data_error_message = "";
            var credentials = {
                user_email: this.user.email,
                user_password: this.user.password
            };

            var navi = this.$router;
            if (credentials.user_email != null && credentials.user_password != null) {
                service.loginUser(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        localStorage.setItem("sp_user", data.user_name);

                        var user_data = {
                            "user_name": data.user_name,
                            "sp_token": data.user_session_key,
                            "sp_token_key": data.user_token_key
                        };
                        var credentials = {
                            session_key: data.user_session_key
                        };

                        service.sessionGuard(_this, credentials).then(function (response) {
                            if (response.body.status == 200) {
                                var _data = response.body.data;
                                _data.forEach(function (element) {
                                    user_data.user_id = element.user_id;
                                }, _this);
                                localforage.setItem(service.udb_name, user_data).then(function (value) {}).catch(function (err) {});
                            } else {
                                navi.push('/timeline');
                            }
                            navi.push('/timeline');
                            _this.loading = false;
                        }).catch(function (err) {
                            if (err) {}
                        });
                    } else {
                        _this.data_error_message = "invalid login credentials";

                        _this.deactivate_processing();
                    }
                }).catch(function (err) {
                    _this.data_error_message = "Sorry, could not process request";

                    _this.deactivate_processing();
                });
            } else {
                this.data_error_message = "Kindly fill all fields";
                this.disable_btn = false;
            }
        }
    },
    created: function created() {
        this.reset();
    }
});

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_templates_menubottom_vue__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_templates_menubottom_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_templates_menubottom_vue__);


var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: "MainFooter",
    data: function data() {
        return {
            user: {},
            user_slug: {}
        };
    },

    components: {
        'component-menu-bottom': __WEBPACK_IMPORTED_MODULE_1__components_templates_menubottom_vue___default.a
    }

});

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_tools_settings_vue__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_tools_settings_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_tools_settings_vue__);


var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: "MainHeader",
    data: function data() {
        return {
            path: this.$route.path.replace('/', ''),
            user: {},
            user_slug: {},
            market: {},
            products: {},
            product: {},
            items: [],
            checked_out_items: [],
            img_url: service.imageURL,
            loggedIn: false,
            server_query_done: false,
            navw: false
        };
    },


    components: {
        'c-settings': __WEBPACK_IMPORTED_MODULE_1__components_tools_settings_vue___default.a

    },
    methods: {
        back: function back() {
            window.history.back();
        },
        show_nav: function show_nav() {
            document.getElementById("main-nav-bar").style.display = "block";
            this.navw = true;
        },
        hide_nav: function hide_nav() {
            document.getElementById("main-nav-bar").style.display = "none";
            this.navw = false;
        },
        navggle: function navggle() {
            var status = document.getElementById("main-nav-bar").style.display;
            if (status == "none") {
                document.getElementById("main-nav-bar").style.display = "block";
            } else {
                document.getElementById("main-nav-bar").style.display = "none";
            }
        },
        display_menu: function display_menu() {
            var status = document.getElementById("main-nav-bar").style.display;
            if (status == "none") {
                document.getElementById("main-nav-bar").style.display = "block";
            } else {
                document.getElementById("main-nav-bar").style.display = "none";
            }
        },
        checkLoggedIn: function checkLoggedIn() {
            if (localStorage.getItem("sp_token") != null) {
                this.loggedIn = true;
                this.user = localStorage.getItem("sp_user");
            }
        },
        preset: function preset() {
            var _this = this;

            var credentials = {
                session_key: localStorage.getItem("sp_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        _this.server_query_done = true;
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.user.user_id = element.user_id;
                            this.user.user_name = localStorage.getItem("sp_user");
                            this.loggedIn = true;
                        }, _this);
                    } else {}
                    _this.server_query_done = true;
                }).catch(function (err) {
                    if (err) {
                        _this.server_query_done = true;
                    }
                });
            } else {
                this.server_query_done = true;
            }
        },
        setMarketRemote: function setMarketRemote() {
            var _this2 = this;

            service.getBusinessByUserName(this, "").then(function (response) {
                if (response.body.status == 200) {
                    _this2.market = response.body.data;
                }
            }).catch(function (err) {});
        },
        setMarketLocal: function setMarketLocal() {}
    },
    created: function created() {
        this.checkLoggedIn();
    }
});

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__);



var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Account',
    data: function data() {
        return {
            user: {},
            sellpoints: {},
            img_url: service.imageURL,
            user_business_interests: {}
        };
    },

    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue___default.a
    },
    methods: {
        syncset: function syncset() {
            var navi = this.$router;
            service.sessionSyncSet(this, this.$route.params.id).then(function (response) {
                if (response.body.status == 200) {
                    var data = response.body.data;

                    localStorage.setItem("sp_user", data.user_name);
                    localStorage.setItem("sp_token", data.user_session_key);
                    localStorage.setItem("sp_token_key", data.user_token_key);

                    navi.push('/' + data.request);
                }
            }).catch(function (err) {
                if (err) {
                    console.log(err);
                }
            });
        }
    },
    created: function created() {
        document.title = "Account" + " | SP";
        this.syncset();
    }
});

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_mutation_types__ = __webpack_require__(8);





var _methods;



var service = new __WEBPACK_IMPORTED_MODULE_4__services_service__["a" /* default */]();



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Cart',
    props: ['userprop'],
    data: function data() {
        var _ref;

        return _ref = {
            loading: false,
            user: {},
            group_products: {},
            item_product: {},
            checked_out: [],
            processed_checkout_orders: [],
            sorted_cart: [],
            orders: [],
            cart: this.$store.state.cart,
            img_product_url: service.imageProductsURL,
            coupon_code: [],
            product_delivery_fee: "",
            sellpoint_delivery_fee: "",
            payment_option: "",
            total_order_amt: 0.0,
            total_delivery_fee: 0.0,
            processed_groups: 0,
            process_count: 0,
            loggedIn: false
        }, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'loading', true), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'buy_now_order', false), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'data_processing_message', ""), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'action_loading', false), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'shipping_fee_key', 0), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'total_orders_key', 0), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'shipping_fee_key_options', 0), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'order_delivery_main_location', {}), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'states', []), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'cities', []), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'componentDeliveryLocationsKey', 0), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'componentProductDeliveryLocationsKey', 0), _ref;
    },

    components: {},
    computed: {},
    methods: (_methods = {
        setComponent: function setComponent(attr1, attr2) {},
        forceRerender: function forceRerender() {
            this.shipping_fee_key += 1;
            this.total_orders_key += 1;
            this.shipping_fee_key_options += 1;
        },
        toggleSingleDisplay: function toggleSingleDisplay(attr, id) {
            if (attr == true) {
                document.getElementById(id).style = "display:block";
            } else {
                document.getElementById(id).style = "display:none";
            }
        },
        toggleDoubleMultiDisplay: function toggleDoubleMultiDisplay(show_arr, hide_arr) {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(show_arr), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var show = _step.value;

                    document.getElementById(show).style = "display:block";
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(hide_arr), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var hide = _step2.value;

                    document.getElementById(hide).style = "display:none";
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }
        },
        toggleProductDelivery: function toggleProductDelivery(attr1, i, product_index) {
            if (attr1 == 'item-delivery-options') {
                this.sorted_cart[i][1][product_index].display_delivery_details = true;
            }
            if (attr1 == 'hide-item-delivery-options') {
                this.sorted_cart[i][1][product_index].display_delivery_details = false;
            }
        },
        toggleSellpointDelivery: function toggleSellpointDelivery(attr1, i) {
            if (attr1 == 'group-delivery-options') {
                this.sorted_cart[i].display_delivery_details++;
            }
            if (attr1 == 'hide-group-delivery-options') {
                this.sorted_cart[i].display_delivery_details = false;
            }
        },
        activate_processing: function activate_processing() {
            this.disable_btn = true;
            this.action_loading = true;
        },
        deactivate_processing: function deactivate_processing() {
            this.disable_btn = false;
            this.action_loading = false;
        },
        checkOrderQuantity: function checkOrderQuantity(group_index, item_index, item_qty, qty) {
            if (Number(qty) > item_qty) {
                this.sorted_cart[group_index][1][item_index].quantity_check_pass = false;
                document.getElementById("qty_c" + item_index).innerHTML = "The quantity you entered is above Item Quantity";
                document.getElementById("qty_t" + item_index).style = "display:none";
                return false;
            } else {
                this.sorted_cart[group_index][1][item_index].quantity_check_pass = true;
                document.getElementById("qty_c" + item_index).innerHTML = "";

                document.getElementById("qty_t" + item_index).style = "display:block";
                return true;
            }
        },
        removeFromCart: function removeFromCart(item_id, group_index, item) {
            this.removeFromSortedCart(group_index, item);
            this.$store.commit(__WEBPACK_IMPORTED_MODULE_5__store_mutation_types__["j" /* REMOVE_FROM_CART */], item_id);

            this.prepCart();
        },
        removeFromSortedCart: function removeFromSortedCart(group_index, item) {
            var index = this.sorted_cart[group_index][1].findIndex(function (p) {
                return p._id === item._id;
            });
            this.sorted_cart[group_index][1].splice(index, 1);
        },
        prepCart: function prepCart() {
            this.activate_processing();
            var sorted_cart = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(this.cart.reduce(function (result, obj) {
                (result[obj.product_business] || (result[obj.product_business] = [])).push(obj);
                return result;
            }, {}));


            var count = 0;var sorted_cart_array = [];
            sorted_cart.forEach(function (element) {
                var _this = this;

                var pre_sort = [];

                pre_sort.products_with_delivery_details_count = 0;
                pre_sort.products_without_delivery_details_count = 0;
                pre_sort.products_with_delivery_details_checked = [];
                pre_sort.products_without_delivery_details_checked = [];

                element.forEach(function (item) {
                    item.can_remove = true;
                    item.display_delivery_details = false;
                    item.actual_product_item_price = item.product_item_price;
                    item.total_item_order_coupons_amount = 0;

                    item.has_delivery = false;
                    if (item.product_checked) {
                        item.product_checked = false;
                    }

                    service.getProductDeliveryOptions(this, item.product_main_id).then(function (response) {
                        if (response.body.status == 200) {
                            item.has_delivery = true;
                            item.delivery_option = 0;
                            pre_sort.products_with_delivery_details_count += 1;
                        } else {
                            pre_sort.products_without_delivery_details_count += 1;
                        }
                    }).catch(function (err) {
                        pre_sort.products_without_delivery_details_count += 1;
                    });
                }, this);
                pre_sort.display_delivery_details = 0;
                pre_sort.business_name = element[0].product_business_name;
                pre_sort[0] = element[0].product_business;
                pre_sort[1] = element;
                pre_sort.items_in_checkout = 0;
                pre_sort.total_order_amt = 0.0;
                pre_sort.delivery_option_fee = 0.0;
                pre_sort.total_delivery_charge = 0.0;
                pre_sort.delivery_states = [];
                pre_sort.selected_delivery_state_locations = [];
                pre_sort.total_order_coupons_amount = 0.0;
                pre_sort.order_coupons_discounts = [];
                var promises = [];
                for (var i = 0; i < 5; ++i) {
                    if (i == 1) {
                        promises.push(service.getBusinessDiscountsAndCoupons(this, element[0].product_business).then(function (response) {
                            if (response.body.status == 200) {
                                pre_sort[4] = response.body.data;
                            }
                        }).catch(function (err) {}));
                    }

                    if (i == 2) {
                        promises.push(service.getBusinessDeliveryOptions(this, element[0].product_business).then(function (response) {
                            if (response.body.status == 200) {
                                var delivery_options = response.body.data;
                                pre_sort.delivery_states = response.body.data_states;

                                var last_or_only_item_in_array = element[element.length - 1];
                                if (last_or_only_item_in_array) {
                                    delivery_options.forEach(function (item) {
                                        var fees = item.business_products_delivery_fees;

                                        if (fees.length != 0) {
                                            fees.forEach(function (fee) {
                                                if (last_or_only_item_in_array.product_main_id == fee.product_delivery_product) {
                                                    item.has_product_delivery_fee = true;
                                                    item.business_product_delivery_fee = fee.product_delivery_fee;
                                                }
                                            }, this);
                                        } else {
                                            pre_sort[2] = delivery_options;
                                            this.deactivate_processing();
                                        }
                                    }, _this);
                                } else {
                                    _this.deactivate_processing();
                                }

                                pre_sort[2] = delivery_options;
                                if (pre_sort.delivery_states.length == 1) {
                                    pre_sort.selected_delivery_state_locations = delivery_options;
                                }

                                pre_sort.business_shipping_calculation_method = response.body.data_business_set_shipping_fee_status;
                                _this.deactivate_processing();
                            } else {
                                pre_sort.delivery_option = "Free Delivery";
                                pre_sort.delivery_general_set_option = {};
                                _this.deactivate_processing();
                            }

                            pre_sort.business_min_delivery_fee = response.body.data_min_delivery_fee;
                            pre_sort.business_max_delivery_fee = response.body.data_max_delivery_fee;
                        }).catch(function (err) {}));
                    }

                    if (i == 3) {
                        promises.push(service.checkBusinessPayOnDelivery(this, element[0].product_business).then(function (response) {
                            if (response.body.status == 200) {
                                pre_sort[3] = response.body.data;
                            }
                        }).catch(function (err) {}));
                    }
                }

                __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(promises).then(function () {
                    sorted_cart_array.push(pre_sort);
                }).catch(function (e) {});
            }, this);

            this.sorted_cart = sorted_cart_array;
            this.loading = false;

            return this.sorted_cart;
        },
        preset_xtra: function preset_xtra() {
            var _this2 = this;

            this.loading = true;
            var credentials = {
                session_key: localStorage.getItem("sp_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.user.user_id = element.user_id;

                            this.prepCart();
                        }, _this2);
                        _this2.loggedIn = true;
                    } else {}
                    _this2.loading = false;
                }).catch(function (err) {
                    if (err) {}
                });
            } else {
                this.$router.push('login');
            }
        },
        preset: function preset() {
            this.loading = true;
            var self = this;
            localforage.getItem(service.udb_name, function (err, value) {
                if (value != undefined) {
                    self.user.user_id = value.user_id;
                    self.loggedIn = true;
                    self.loading = false;
                } else {}
                self.prepCart();
            });
        },
        canUseCoupon: function canUseCoupon(coupon) {
            if (coupon.discount_type == 4 || coupon.discount_type == 5) {
                if (coupon.discount_type == 4) {
                    var sorted = this.checked_out.filter(function (item) {
                        return item.product_main_id == coupon.discount_product;
                    });
                    if (sorted.length != 0) {
                        return true;
                    }
                }
                if (coupon.discount_type == 5) {
                    var _sorted = this.checked_out.filter(function (item) {
                        return item.product_item_id == coupon.discount_product_item;
                    });
                    if (_sorted.length != 0) {
                        return true;
                    }
                }
            } else {
                return true;
            }
        },
        set_coupons: function set_coupons(i, i2, coupon, coupon_percentage) {
            var calc = 0;
            if (this.sorted_cart[i].total_order_amt != 0) {
                if (!coupon.added) {
                    if (coupon.discount_type == 4 || coupon.discount_type == 5) {
                        calc = coupon_percentage / 100 * this.sorted_cart[i][1][i2].actual_product_item_price;
                        this.sorted_cart[i][1][i2].item_order_coupons_discounts.push(coupon);
                        this.sorted_cart[i][1][i2].total_item_order_coupons_amount += calc;
                        this.sorted_cart[i][1][i2].product_item_price -= calc;

                        this.sorted_cart[i].total_order_amt -= calc;
                    } else {
                        calc = coupon_percentage / 100 * this.sorted_cart[i].total_order_amt;

                        this.sorted_cart[i].order_coupons_discounts.push(coupon);
                        this.sorted_cart[i].total_order_coupons_amount += calc;
                        this.sorted_cart[i].total_order_amt -= calc;
                    }

                    coupon.added = true;
                    coupon.value = calc;
                    this.total_order_amt -= calc;
                } else {
                    calc = coupon.value;

                    if (coupon.discount_type == 4 || coupon.discount_type == 5) {

                        var index = this.sorted_cart[i][1][i2].item_order_coupons_discounts.findIndex(function (c) {
                            return c.discount_id === coupon.discount_id;
                        });
                        this.sorted_cart[i][1][i2].item_order_coupons_discounts.splice(index, 1);
                        this.sorted_cart[i][1][i2].total_item_order_coupons_amount -= calc;
                        this.sorted_cart[i][1][i2].product_item_price += calc;

                        this.sorted_cart[i].total_order_amt += calc;
                    } else {
                        var _index = this.sorted_cart[i].order_coupons_discounts.findIndex(function (c) {
                            return c.discount_id === coupon.discount_id;
                        });
                        this.sorted_cart[i].order_coupons_discounts.splice(_index, 1);
                        this.sorted_cart[i].total_order_coupons_amount -= calc;
                        this.sorted_cart[i].total_order_amt += calc;
                    }

                    coupon.added = false;
                    this.total_order_amt += calc;
                    coupon.value = 0;
                }
            } else {
                toastr.warning("Select an Order", 'Warning!');
                this.coupon_code.checked = false;
            }
            this.forceRerender();
        },
        getDeliveryLocations: function getDeliveryLocations(i, delivery_selected_state) {
            this.activate_processing();
            if (delivery_selected_state != undefined) {
                var sorted_options = [];
                this.sorted_cart[i].selected_business_delivery_option = false;var _iteratorNormalCompletion3 = true;
                var _didIteratorError3 = false;
                var _iteratorError3 = undefined;

                try {
                    for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(this.sorted_cart[i][2]), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                        var option = _step3.value;

                        if (option.business_delivery_state_id == delivery_selected_state.state_id) {
                            sorted_options.push(option);
                        }
                    }
                } catch (err) {
                    _didIteratorError3 = true;
                    _iteratorError3 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion3 && _iterator3.return) {
                            _iterator3.return();
                        }
                    } finally {
                        if (_didIteratorError3) {
                            throw _iteratorError3;
                        }
                    }
                }

                this.sorted_cart[i].selected_delivery_state_locations = sorted_options;
                document.getElementById(i + "BDLS").style = "display:block;";
                this.componentDeliveryLocationsKey++;
            }
        },
        getStates: function getStates() {
            var _this3 = this;

            service.getStates(this).then(function (response) {
                if (response.body.status == 200) {
                    _this3.states = response.body.data;
                }
            }).catch(function (err) {});
        },
        getCities: function getCities(state) {
            var _this4 = this;

            this.activate_processing();
            if (state != undefined) {
                service.getCities(this, state.state_id).then(function (response) {
                    if (response.body.status == 200) {
                        _this4.cities = response.body.data;
                        _this4.deactivate_processing();
                    }
                }).catch(function (err) {
                    _this4.deactivate_processing();
                });
            }
        },
        setOrderLocations: function setOrderLocations(location) {
            if (location.city != undefined) {
                var i = 0;
                var _iteratorNormalCompletion4 = true;
                var _didIteratorError4 = false;
                var _iteratorError4 = undefined;

                try {
                    for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(this.sorted_cart), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                        var group = _step4.value;

                        if (group[2] && group[2].length != 0) {
                            var _iteratorNormalCompletion5 = true;
                            var _didIteratorError5 = false;
                            var _iteratorError5 = undefined;

                            try {
                                for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(group[2]), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                                    var option = _step5.value;

                                    if (option.business_delivery_state_id == location.state.state_id) {
                                        if (option.business_delivery_city == location.city.city_id || option.business_delivery_other_option == location.city.city_name || option.business_delivery_city == 0 && option.business_delivery_other_option == 'nill') {
                                            this.calc_sellpoint_delivery_fee(i, option);
                                        }
                                    }
                                }
                            } catch (err) {
                                _didIteratorError5 = true;
                                _iteratorError5 = err;
                            } finally {
                                try {
                                    if (!_iteratorNormalCompletion5 && _iterator5.return) {
                                        _iterator5.return();
                                    }
                                } finally {
                                    if (_didIteratorError5) {
                                        throw _iteratorError5;
                                    }
                                }
                            }
                        } else {
                            this.sorted_cart[i].delivery_general_set_option = location;
                        }
                        i++;
                    }
                } catch (err) {
                    _didIteratorError4 = true;
                    _iteratorError4 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion4 && _iterator4.return) {
                            _iterator4.return();
                        }
                    } finally {
                        if (_didIteratorError4) {
                            throw _iteratorError4;
                        }
                    }
                }
            }
        },
        calc_product_delivery_fee: function calc_product_delivery_fee(i, option, product_index) {
            if (this.sorted_cart[i][1][product_index].delivery_option_fee != undefined) {
                if (this.sorted_cart[i][1][product_index].delivery_option_fee != 0.0) {
                    this.total_delivery_fee -= this.sorted_cart[i][1][product_index].delivery_option_fee;
                    this.sorted_cart[i].total_delivery_charge -= this.sorted_cart[i][1][product_index].delivery_option_fee;
                }
            }

            this.sorted_cart[i][1][product_index].selected_product_delivery_option = option;

            this.sorted_cart[i][1][product_index].delivery_option = option.business_delivery_option_id;
            this.sorted_cart[i][1][product_index].delivery_option_fee = Number(option.business_delivery_option_price);

            this.sorted_cart[i].total_delivery_charge += Number(option.business_delivery_option_price);
            this.total_delivery_fee += Number(option.business_delivery_option_price);
        },
        calc_sellpoint_delivery_fee_XXX: function calc_sellpoint_delivery_fee_XXX(i, option) {
            if (this.sorted_cart[i].delivery_option_fee != 0.0) {
                this.total_delivery_fee -= this.sorted_cart[i].delivery_option_fee;
                this.sorted_cart[i].total_delivery_charge -= this.sorted_cart[i].delivery_option_fee;
            }

            this.sorted_cart[i].selected_business_delivery_option = option;

            this.sorted_cart[i].delivery_option = option.business_delivery_option_id;
            this.sorted_cart[i].delivery_option_fee = Number(option.business_delivery_option_price);

            this.sorted_cart[i].total_delivery_charge += Number(option.business_delivery_option_price);

            this.total_delivery_fee += Number(option.business_delivery_option_price);
        },
        calc_sellpoint_delivery_fee: function calc_sellpoint_delivery_fee(i, option) {
            if (this.sorted_cart[i].delivery_option_fee != 0.0) {
                this.total_delivery_fee -= this.sorted_cart[i].delivery_option_fee;
                this.sorted_cart[i].total_delivery_charge -= this.sorted_cart[i].delivery_option_fee;
            }

            this.sorted_cart[i].selected_business_delivery_option = option;
            this.sorted_cart[i].delivery_option = option.business_delivery_option_id;

            this.sorted_cart[i].delivery_option_total_delivery_fee = 0;

            var fees = option.business_products_delivery_fees;
            if (fees.length == 0) {
                if (this.sorted_cart[i].business_shipping_calculation_method == 9) {
                    this.sorted_cart[i].delivery_option_total_delivery_fee += Number(option.business_delivery_option_price);
                } else {
                    var items_to_checkout = this.sorted_cart[i][1].filter(function (item) {
                        return item.product_checked == true;
                    });
                    var _iteratorNormalCompletion6 = true;
                    var _didIteratorError6 = false;
                    var _iteratorError6 = undefined;

                    try {
                        for (var _iterator6 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(items_to_checkout), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                            var item = _step6.value;

                            if (this.sorted_cart[i].business_shipping_calculation_method == 10) {
                                this.sorted_cart[i].delivery_option_total_delivery_fee += Number(option.business_delivery_option_price);
                            }
                            if (this.sorted_cart[i].business_shipping_calculation_method == 11) {
                                this.sorted_cart[i].delivery_option_total_delivery_fee += Number(item.product_item_order_quantity * option.business_delivery_option_price);
                            }
                        }
                    } catch (err) {
                        _didIteratorError6 = true;
                        _iteratorError6 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion6 && _iterator6.return) {
                                _iterator6.return();
                            }
                        } finally {
                            if (_didIteratorError6) {
                                throw _iteratorError6;
                            }
                        }
                    }
                }
            } else {
                var _items_to_checkout = this.sorted_cart[i][1].filter(function (item) {
                    return item.product_checked == true;
                });

                var _iteratorNormalCompletion7 = true;
                var _didIteratorError7 = false;
                var _iteratorError7 = undefined;

                try {
                    for (var _iterator7 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(_items_to_checkout), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
                        var _item = _step7.value;

                        if (_item.has_calculated_product_delivery_fee == true) {
                            _item.product_delivery_fee = 0;
                            _item.has_calculated_product_delivery_fee = false;
                            _item.calculated_product_delivery_fee = 0;
                        };
                        var _iteratorNormalCompletion9 = true;
                        var _didIteratorError9 = false;
                        var _iteratorError9 = undefined;

                        try {
                            for (var _iterator9 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(fees), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
                                var fee = _step9.value;

                                _item.product_delivery_fee = Number(fee.product_delivery_fee);
                                if (_item.product_main_id == fee.product_delivery_product) {
                                    if (_item.product_shipping_calculation_method == 13) {
                                        this.sorted_cart[i].delivery_option_total_delivery_fee += Number(_item.product_item_order_quantity * fee.product_delivery_fee);
                                        _item.calculated_product_delivery_fee = Number(_item.product_item_order_quantity * fee.product_delivery_fee);
                                    }
                                    if (_item.product_shipping_calculation_method == 12) {
                                        this.sorted_cart[i].delivery_option_total_delivery_fee += Number(fee.product_delivery_fee);
                                        _item.calculated_product_delivery_fee = Number(fee.product_delivery_fee);
                                    }

                                    _item.has_calculated_product_delivery_fee = true;
                                }
                            }
                        } catch (err) {
                            _didIteratorError9 = true;
                            _iteratorError9 = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion9 && _iterator9.return) {
                                    _iterator9.return();
                                }
                            } finally {
                                if (_didIteratorError9) {
                                    throw _iteratorError9;
                                }
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError7 = true;
                    _iteratorError7 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion7 && _iterator7.return) {
                            _iterator7.return();
                        }
                    } finally {
                        if (_didIteratorError7) {
                            throw _iteratorError7;
                        }
                    }
                }

                var sorted_fees = _items_to_checkout.filter(function (item) {
                    return item.has_calculated_product_delivery_fee == true;
                });

                if (sorted_fees.length < _items_to_checkout.length) {
                    if (this.sorted_cart[i].business_shipping_calculation_method == 9) {
                        this.sorted_cart[i].delivery_option_total_delivery_fee += Number(option.business_delivery_option_price);
                    } else {
                        var _iteratorNormalCompletion8 = true;
                        var _didIteratorError8 = false;
                        var _iteratorError8 = undefined;

                        try {
                            for (var _iterator8 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(_items_to_checkout), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
                                var _item2 = _step8.value;

                                if (!_item2.has_calculated_product_delivery_fee) {
                                    if (this.sorted_cart[i].business_shipping_calculation_method == 10) {
                                        this.sorted_cart[i].delivery_option_total_delivery_fee += Number(option.business_delivery_option_price);
                                    }
                                    if (this.sorted_cart[i].business_shipping_calculation_method == 11) {
                                        this.sorted_cart[i].delivery_option_total_delivery_fee += Number(_item2.product_item_order_quantity * option.business_delivery_option_price);
                                    }
                                }
                            }
                        } catch (err) {
                            _didIteratorError8 = true;
                            _iteratorError8 = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion8 && _iterator8.return) {
                                    _iterator8.return();
                                }
                            } finally {
                                if (_didIteratorError8) {
                                    throw _iteratorError8;
                                }
                            }
                        }
                    }
                }
            }

            this.sorted_cart[i].delivery_option_fee = Number(this.sorted_cart[i].delivery_option_total_delivery_fee);

            this.sorted_cart[i].total_delivery_charge += Number(this.sorted_cart[i].delivery_option_total_delivery_fee);

            this.total_delivery_fee += Number(this.sorted_cart[i].delivery_option_total_delivery_fee);

            this.forceRerender();
        },
        setPaymentOption: function setPaymentOption(i, option) {
            this.sorted_cart[i].payment_mode = option;
        },
        pre_checkout: function pre_checkout() {
            this.preset();
        },
        addRefreshCheckout: function addRefreshCheckout(it, group_index, item_index) {
            it.product_item_order_quantity++;
            this.refreshCheckout(it, group_index, item_index);
        },
        removeRefreshCheckout: function removeRefreshCheckout(it, group_index, item_index) {
            if (it.product_item_order_quantity > 1) {
                it.product_item_order_quantity--;
                this.refreshCheckout(it, group_index, item_index);
            }
        },
        refreshCheckout: function refreshCheckout(it, group_index, item_index) {
            if (it.product_item_order_quantity > 1) {
                if (this.checkOrderQuantity(group_index, item_index, it.product_item_quantity, it.product_item_order_quantity)) {
                    this.sorted_cart[group_index].total_order_amt = 0.0;
                    this.total_order_amt = 0.0;
                    this.checked_out.forEach(function (item) {
                        this.sorted_cart[group_index].total_order_amt += item.product_item_order_quantity * item.product_item_price;

                        this.total_order_amt += item.product_item_order_quantity * item.product_item_price;
                    }, this);

                    if (this.sorted_cart[group_index].order_coupons_discounts.length > 0) {
                        this.sorted_cart[group_index].order_coupons_discounts.forEach(function (coupon) {
                            coupon.added = false;
                            var index = this.sorted_cart[group_index].order_coupons_discounts.findIndex(function (c) {
                                return c.discount_id === coupon.discount_id;
                            });
                            this.sorted_cart[group_index].order_coupons_discounts.splice(index, 1);
                            this.sorted_cart[group_index].total_order_coupons_amount -= coupon.value;
                            this.set_coupons(group_index, item_index, coupon, coupon.discount_percentage);
                        }, this);
                    }

                    if (this.sorted_cart[group_index].selected_business_delivery_option) {
                        this.calc_sellpoint_delivery_fee(group_index, this.sorted_cart[group_index].selected_business_delivery_option);
                    }
                }

                this.forceRerender();
            }
        },
        addToCheckout: function addToCheckout(item, group_index, item_index) {
            if (item.product_item_order_quantity == 0) {
                item.product_item_order_quantity = 1;
            }

            this.sorted_cart[group_index][1][item_index].can_remove = false;
            this.sorted_cart[group_index].products_in_checkout = true;
            if (this.sorted_cart[group_index][1][item_index].has_delivery) {
                this.sorted_cart[group_index].products_with_delivery_details_checked.push(item);
            } else {
                this.sorted_cart[group_index].products_without_delivery_details_checked.push(item);
            }

            this.checked_out.push(item);
            this.sorted_cart[group_index][1][item_index].product_checked = true;
            this.sorted_cart[group_index].total_order_amt += item.product_item_order_quantity * item.product_item_price;

            this.total_order_amt += item.product_item_order_quantity * item.product_item_price;
            this.sorted_cart[group_index].items_in_checkout++;

            if (this.sorted_cart[group_index][1][item_index].has_delivery) {
                this.sorted_cart[group_index][1][item_index].display_delivery_details = true;
            }

            if (this.sorted_cart[group_index].selected_business_delivery_option) {
                this.calc_sellpoint_delivery_fee(group_index, this.sorted_cart[group_index].selected_business_delivery_option);
            }

            if (this.buy_now_order) {
                document.getElementById(item.item_index + "PRT_CART").style = "display:block;";
            }
        },
        removeFromCheckout: function removeFromCheckout(item, group_index, item_index) {
            var index = this.checked_out.findIndex(function (p) {
                return p._id === item._id;
            });
            this.checked_out.splice(index, 1);
            this.sorted_cart[group_index][1][item_index].product_checked = false;

            if (this.sorted_cart[group_index][1][item_index].item_order_coupons_discounts && this.sorted_cart[group_index][1][item_index].item_order_coupons_discounts.length > 1) {
                this.sorted_cart[group_index][1][item_index].item_order_coupons_discounts.forEach(function (coupon) {
                    var index = this.sorted_cart[group_index][1][item_index].item_order_coupons_discounts.findIndex(function (c) {
                        return c.discount_id === coupon.discount_id;
                    });
                    this.sorted_cart[group_index][1][item_index].item_order_coupons_discounts.splice(index, 1);
                    this.sorted_cart[group_index][1][item_index].total_item_order_coupons_amount -= coupon.value;
                }, this);
            }

            if (this.sorted_cart[group_index][1][item_index].has_delivery) {
                var _index2 = this.sorted_cart[group_index].products_with_delivery_details_checked.findIndex(function (p) {
                    return p._id === item._id;
                });
                this.sorted_cart[group_index].products_with_delivery_details_checked.splice(_index2, 1);;
            } else {
                var _index3 = this.sorted_cart[group_index].products_without_delivery_details_checked.findIndex(function (p) {
                    return p._id === item._id;
                });
                this.sorted_cart[group_index].products_without_delivery_details_checked.splice(_index3, 1);;
            }

            this.sorted_cart[group_index].total_order_amt -= item.product_item_order_quantity * item.product_item_price;

            this.total_order_amt -= item.product_item_order_quantity * item.product_item_price;
            this.sorted_cart[group_index].items_in_checkout--;

            this.sorted_cart[group_index][1][item_index].can_remove = true;
            if (this.sorted_cart[group_index].items_in_checkout == 0 && this.sorted_cart[group_index].delivery_option != "Free Delivery") {
                this.total_delivery_fee -= this.sorted_cart[group_index].delivery_option_fee;
                this.sorted_cart[group_index].delivery_option_fee = 0;
                this.sorted_cart[group_index].delivery_option = 0;
                this.sorted_cart[group_index].total_delivery_charge = 0;
            }

            if (this.sorted_cart[group_index].selected_business_delivery_option) {
                this.calc_sellpoint_delivery_fee(group_index, this.sorted_cart[group_index].selected_business_delivery_option);
            }
        },
        process_checkout: function process_checkout(group) {
            if (this.checked_out.length > 0) {
                var processed_checkout = {};

                processed_checkout.order_user_id = this.user.user_id || 0;

                processed_checkout.order_business = group[0];
                var order_url = group[0] + new Date().getTime();
                processed_checkout.order_url = order_url, processed_checkout.order_total_amount = group.total_order_amt;
                processed_checkout.order_delivery_option = group.delivery_option;
                processed_checkout.order_total_delivery_charge = group.total_delivery_charge;
                processed_checkout.order_payment_mode = group.payment_mode || 1;
                processed_checkout.order_coupons_discounts = group.order_coupons_discounts;
                processed_checkout.total_order_coupons_amount = group.total_order_coupons_amount;
                processed_checkout.order_items = [];
                this.checked_out.forEach(function (element) {
                    if (element.product_business == group[0]) {
                        processed_checkout.order_items.push(element);
                    }
                    processed_checkout.status = "processed";
                }, this);
                if (processed_checkout.status == "processed") {
                    if (this.loggedIn) {
                        processed_checkout.order_mode = 1;
                        service.checkout(this, processed_checkout).then(function (data) {
                            if (data.body.status == 201) {
                                this.process_count++;

                                processed_checkout.order_items.forEach(function (item) {
                                    this.$store.commit(__WEBPACK_IMPORTED_MODULE_5__store_mutation_types__["j" /* REMOVE_FROM_CART */], item._id);
                                    var index = this.checked_out.findIndex(function (p) {
                                        return p._id === item._id;
                                    });
                                    this.checked_out.splice(index, 1);
                                }, this);
                            }

                            if (this.process_count == this.processed_groups) {
                                this.total_delivery_fee = 0;
                                this.total_order_amt = 0;

                                this.data_processing_message = 'Processing......';
                                location.replace("/checkout/");
                            }
                        }).catch(function (err) {
                            if (err) {}
                        });
                    } else {
                        processed_checkout.order_mode = 0;
                        this.process_count++;

                        processed_checkout.order_items.forEach(function (item) {
                            this.$store.commit(__WEBPACK_IMPORTED_MODULE_5__store_mutation_types__["j" /* REMOVE_FROM_CART */], item._id);
                            var index = this.checked_out.findIndex(function (p) {
                                return p._id === item._id;
                            });
                            this.checked_out.splice(index, 1);
                        }, this);

                        if (this.process_count == this.processed_groups) {
                            this.total_delivery_fee = 0;
                            this.total_order_amt = 0;
                        }

                        return processed_checkout;
                    }
                }
            }
        },
        process_orders: function process_orders() {
            this.data_processing_message = '';
            if (this.checked_out.length == 0) {
                this.data_processing_message = 'Select Items to process';
            } else {

                var processed = [];
                var process_errors = 0;
                var process_error_list = [];

                this.checked_out.forEach(function (item) {
                    if (Number(item.product_item_order_quantity) > item.product_item_quantity) {
                        var err = "The quantity you entered for " + item.product_name + " is above Item Quantity";
                        process_errors++;
                        process_error_list.push(err);
                    }
                }, this);

                this.sorted_cart.forEach(function (group) {
                    if (group.items_in_checkout) {
                        if (group.delivery_option != 0 && group.delivery_option != undefined) {
                            processed.push(group);
                        } else {
                            var err = "";
                            if (this.buy_now_order) {
                                err = "Please select a delivery option";
                            } else {
                                err = "Please select a delivery option for " + group.business_name;
                            }
                            process_errors++;
                            process_error_list.push(err);
                        }
                    }
                }, this);

                if (process_errors > 0) {
                    process_error_list.forEach(function (error) {
                        toastr.error(error, 'Warning!');
                        this.data_processing_message = this.data_processing_message + " . " + error;
                    }, this);
                } else {
                    if (this.loggedIn) {
                        if (processed.length != 0 && process_errors == 0) {
                            this.processed_groups = processed.length;
                            processed.forEach(function (group) {
                                this.process_checkout(group);
                            }, this);
                        }
                    } else {
                        var processed_to_store_in_forage = [];
                        if (processed.length != 0 && process_errors == 0) {
                            this.processed_groups = processed.length;
                            processed.forEach(function (group) {
                                processed_to_store_in_forage.push(this.process_checkout(group));
                            }, this);
                            localforage.setItem('not_loggedin_processed_orders', processed_to_store_in_forage).then(function (value) {}).catch(function (err) {});
                        }

                        this.data_processing_message = 'Processing Orders......';
                        this.$router.push("checkout");
                    }
                }
            }
        }
    }, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_methods, 'getStates', function getStates() {
        var _this5 = this;

        service.getStates(this).then(function (response) {
            if (response.body.status == 200) {
                _this5.states = response.body.data;
            }
        }).catch(function (err) {});
    }), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_methods, 'getCities', function getCities(state) {
        var _this6 = this;

        this.activate_processing();
        if (state != undefined) {
            service.getCities(this, state.state_id).then(function (response) {
                if (response.body.status == 200) {
                    _this6.cities = response.body.data;
                    _this6.deactivate_processing();
                }
            }).catch(function (err) {
                _this6.deactivate_processing();
            });
        }
    }), _methods),
    created: function created() {
        if (this.$route.path == '/order') {
            this.buy_now_order = true;
        }
        document.title = "Cart" + " | " + service.app_name;
        this.preset();

        this.getStates();
    }
});

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CartWidget_index_vue__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CartWidget_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__CartWidget_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_mutation_types__ = __webpack_require__(8);



var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Cart',
    data: function data() {
        return {
            loading: false,
            user: {},
            cart: this.$store.state.cart,
            img_product_url: service.imageProductsURL,
            loggedIn: false
        };
    },

    components: {
        'cart-widget': __WEBPACK_IMPORTED_MODULE_1__CartWidget_index_vue___default.a
    },
    computed: {},
    methods: {},
    created: function created() {
        document.title = "Cart" + " | SP";
    }
});

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_mutation_types__ = __webpack_require__(8);




var service = new __WEBPACK_IMPORTED_MODULE_2__services_service__["a" /* default */]();



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Checkout',
    data: function data() {
        return {
            user: {},
            selected_order: [],
            checkout_orders: {},
            delivery_details: [],
            payment_details: {},
            payment_mode: "",
            request_page: "orders",
            checked_out: [],
            processed_checkout_orders: [],
            sorted_cart: [],
            orders: [],
            cart: this.$store.state.cart,
            img_product_url: service.imageProductsURL,
            item_delivery_fee: "",
            delivery_fee: "",
            payment_option: "",
            total_order_items_total: 0.0,
            total_orders_amount: 0.0,
            total_order_coupon_amount: 0.0,
            total_shipping_fee: 0.0,
            states: {},
            cities: [],
            set_cities: [],
            loggedIn: false,
            new_account: true,
            process_count: 0,
            checkout_processed: false,
            data_error_message: "",
            data_success_message: "",
            is_logged_in_order_mode: 0,
            disable_btn: false,
            loading: true,
            action_loading: false,
            user_delivery_address: "",
            order_delivery_state: "",
            order_delivery_city: "",

            shipping_locations: {},
            order_delivery_main_location: {},
            order_delivery_sorted_locations: {},
            group_set_order_delivery_key: 0,
            data_processing_message: ""
        };
    },

    components: {},
    computed: {},
    methods: {
        setComponent: function setComponent(attr1, attr2) {
            if (attr1 == 'login') {
                this.new_account = false;
            }
            if (attr1 == 'new-account') {
                this.new_account = true;
            }
            if (attr1 == 'change-delivery-option') {
                this.checkout_orders[attr2].change_delivery_option = true;
                document.getElementById("cdl" + attr2).style = "display:block;";
                document.getElementById("cdlb" + attr2).style = "display:none;";
            }
            if (attr1 == 'cancel-change-delivery-option') {
                this.checkout_orders[attr2].change_delivery_option = false;
                document.getElementById("cdl" + attr2).style = "display:none;";
                document.getElementById("cdlb" + attr2).style = "display:block;";
            }
        },
        activate_processing: function activate_processing() {
            this.disable_btn = true;
            this.action_loading = true;
        },
        deactivate_processing: function deactivate_processing() {
            this.disable_btn = false;
            this.action_loading = false;
        },
        removeFromCheckout: function removeFromCheckout(group_index, order, item) {
            var index = this.checkout_orders[group_index].order_items.findIndex(function (ord) {
                return ord.order_item_no === item.order_item_no;
            });
            this.checkout_orders[group_index].order_items.splice(index, 1);
            if (this.checkout_orders[group_index].order_items.length == 0) {
                var index2 = this.checkout_orders.findIndex(function (o) {
                    return o.order_id === order.order_id;
                });
                this.checkout_orders.splice(index2, 1);
            }
        },
        getStates: function getStates() {
            var _this = this;

            service.getStates(this).then(function (response) {
                if (response.body.status == 200) {
                    _this.states = response.body.data;
                }
            }).catch(function (err) {});
        },
        getCities: function getCities(state) {
            var _this2 = this;

            this.activate_processing();
            service.getCities(this, state).then(function (response) {
                if (response.body.status == 200) {
                    _this2.cities = response.body.data;
                    _this2.deactivate_processing();
                }
            }).catch(function (err) {
                _this2.deactivate_processing();
            });
        },
        setCities: function setCities(state) {
            var _this3 = this;

            if (state != undefined) {
                this.activate_processing();
                service.getCities(this, state.state_id).then(function (response) {
                    if (response.body.status == 200) {
                        _this3.set_cities = response.body.data;
                        _this3.deactivate_processing();
                    }
                }).catch(function (err) {
                    _this3.deactivate_processing();
                });
            }
        },
        setOrderLocations: function setOrderLocations(location) {
            if (location.city != undefined) {
                this.order_delivery_main_location.address = '';
                var i = 0;
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.checkout_orders), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var group = _step.value;

                        if (group.order_business_delivery_options && group.order_business_delivery_options.length == 0) {
                            this.checkout_orders[i].order_delivery_city = location.city.city_name;
                            this.checkout_orders[i].order_delivery_city_id = location.city.city_id;
                            this.checkout_orders[i].order_delivery_state_id = location.state.state_id;
                            this.checkout_orders[i].order_delivery_state = location.state.name;

                            this.checkout_orders[i].order_user_delivery_address = "";
                            this.group_set_order_delivery_key++;
                        }
                        i++;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        setOrderLocationAddress: function setOrderLocationAddress(location) {
            if (location.city != undefined) {
                var i = 0;
                var _iteratorNormalCompletion2 = true;
                var _didIteratorError2 = false;
                var _iteratorError2 = undefined;

                try {
                    for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.checkout_orders), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                        var group = _step2.value;

                        if (group.order_business_delivery_options && group.order_business_delivery_options.length == 0) {
                            this.checkout_orders[i].order_user_delivery_address = location.address;
                            this.group_set_order_delivery_key++;
                        }
                        i++;
                    }
                } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion2 && _iterator2.return) {
                            _iterator2.return();
                        }
                    } finally {
                        if (_didIteratorError2) {
                            throw _iteratorError2;
                        }
                    }
                }
            }
        },
        setSortedOrderLocationAddress: function setSortedOrderLocationAddress(location) {
            if (location != undefined) {
                var i = 0;
                var _iteratorNormalCompletion3 = true;
                var _didIteratorError3 = false;
                var _iteratorError3 = undefined;

                try {
                    for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.checkout_orders), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                        var group = _step3.value;

                        if (group.order_business_delivery_options && group.order_business_delivery_options.length != 0) {
                            if (group.order_delivery_city_id == location.city_id) {
                                this.checkout_orders[i].order_user_delivery_address = location.address;
                                this.group_set_order_delivery_key++;
                            }
                        }
                        i++;
                    }
                } catch (err) {
                    _didIteratorError3 = true;
                    _iteratorError3 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion3 && _iterator3.return) {
                            _iterator3.return();
                        }
                    } finally {
                        if (_didIteratorError3) {
                            throw _iteratorError3;
                        }
                    }
                }
            }
        },
        resetDeliveryLocation: function resetDeliveryLocation(i, location) {
            if (location != undefined) {
                this.checkout_orders[i].order_delivery_city = location.city_name;
                this.checkout_orders[i].order_delivery_city_id = location.city_id;
                this.checkout_orders[i].order_delivery_state_id = this.checkout_orders[i].order_delivery_selected_state.state_id;
                this.checkout_orders[i].order_delivery_state = this.checkout_orders[i].order_delivery_selected_state.name;

                this.checkout_orders[i].order_user_delivery_address = "";
            }
        },
        resetDeliveryLocationAddress: function resetDeliveryLocationAddress(index, location) {
            if (location != undefined) {
                this.checkout_orders[index].order_user_delivery_address = location.address;
                this.group_set_order_delivery_key++;
            }
        },
        getOrderLocations: function getOrderLocations(index, state) {
            this.activate_processing();

            var order_array = this.checkout_orders[index].order_business_delivery_options;
            this.checkout_orders[index].sorted_order_business_delivery_options = order_array.filter(function (item) {
                return item.business_delivery_state_id == state.state_id;
            });

            this.deactivate_processing();
        },
        loginAndProcess: function loginAndProcess() {
            var _this4 = this;

            this.activate_processing();
            service.loginUser(this, this.user).then(function (response) {
                if (response.body.status == 200) {
                    var data = response.body.data;
                    localStorage.setItem("sp_user", data.user_name);
                    localStorage.setItem("sp_token", data.user_session_key);
                    localStorage.setItem("sp_token_key", data.user_token_key);
                    _this4.user = data;

                    _this4.is_logged_in_order_mode = 1;
                    _this4.process_checkout();
                    _this4.deactivate_processing();
                } else {
                    _this4.data_error_message = "Sorry, these login details are invalid.";
                    _this4.deactivate_processing();
                }
            }).catch(function (err) {
                _this4.deactivate_processing();
            });
        },
        preset_xtra: function preset_xtra() {
            var _this5 = this;

            var credentials = {
                session_key: localStorage.getItem("sp_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.user.user_id = element.user_id;

                            this.loggedIn = true;

                            if (this.$route.params.ckid != null) {
                                this.order_url = this.$route.params.ckid;
                                this.getCheckoutOrdersByURL();
                            } else {
                                this.getCheckoutOrders();
                            }
                            this.checkout_processed = true;
                            this.loading = false;

                            this.getUserDeliveryDetails();
                        }, _this5);
                    } else {}
                }).catch(function (err) {
                    if (err) {}
                });
            } else {}
        },
        preset: function preset() {
            var self = this;
            localforage.getItem(service.udb_name, function (err, value) {
                if (value != undefined) {
                    self.user.user_id = value.user_id;
                    self.loggedIn = true;
                    self.new_account = false;

                    if (self.$route.params.ckid != null) {
                        self.order_url = self.$route.params.ckid;
                        self.getCheckoutOrdersByURL();
                    } else {
                        console.log("43ww");
                        self.getCheckoutOrders();
                    }
                    self.checkout_processed = true;
                    self.loading = false;
                    self.getUserDeliveryDetails();
                } else {
                    self.getCheckoutLocalOrder();
                }
            });
        },
        getCheckoutLocalOrder: function getCheckoutLocalOrder() {
            this.loading = true;

            var self = this;

            setTimeout(function () {
                localforage.getItem('not_loggedin_processed_orders').then(function (value) {
                    if (value != null) {
                        self.checkout_orders = value;
                    }
                    self.loading = false;
                }).catch(function (err) {
                    this.loading = false;
                    location.replace("/orders/");
                });
            }, 500);
        },
        getCheckoutOrders: function getCheckoutOrders() {
            var _this6 = this;

            this.activate_processing();
            service.getCheckoutOrders(this, this.user.user_id).then(function (response) {
                if (response.body.status == 200) {
                    _this6.setCheckoutOrders(response);
                } else {
                    console.log("kop");
                }
            }).catch(function (err) {
                console.log(err);
                _this6.deactivate_processing();
            });
        },
        getCheckoutOrdersByURL: function getCheckoutOrdersByURL() {
            var _this7 = this;

            this.activate_processing();
            service.getCheckoutOrder(this, this.order_url).then(function (response) {
                if (response.body.status == 200) {
                    var data = response.body.data;
                    if (data[0]["order_payment_status_id"] && data[0]["order_payment_status_id"] != 2) {
                        _this7.setCheckoutOrders(response);
                    } else {
                        location.replace("/orders/");
                    }
                } else {
                    _this7.deactivate_processing();
                    location.replace("/orders/");
                }
            }).catch(function (err) {
                _this7.deactivate_processing();
                location.replace("/orders/");
            });
        },
        setCheckoutOrders: function setCheckoutOrders(response) {
            var _this8 = this;

            this.checkout_orders = response.body.data;

            var remove_orders = [];
            this.checkout_orders.forEach(function (order) {
                order.display_delivery = false;
                order.cities = {};

                if (order.order_items.length == 0) {
                    remove_orders.push(order);
                }
            }, this);

            var _loop = function _loop(order) {
                var order_index = _this8.checkout_orders.findIndex(function (o) {
                    return o.order_id === order.order_id;
                });
                _this8.checkout_orders.splice(order_index, 1);
            };

            var _iteratorNormalCompletion4 = true;
            var _didIteratorError4 = false;
            var _iteratorError4 = undefined;

            try {
                for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(remove_orders), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                    var order = _step4.value;

                    _loop(order);
                }
            } catch (err) {
                _didIteratorError4 = true;
                _iteratorError4 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion4 && _iterator4.return) {
                        _iterator4.return();
                    }
                } finally {
                    if (_didIteratorError4) {
                        throw _iteratorError4;
                    }
                }
            }

            this.total_order_items_total = response.body.data_calculated_orders_amount;
            this.total_orders_amount = response.body.data_total_orders_amount;
            this.total_order_coupon_amount = response.body.data_calculated_coupons;
            this.total_shipping_fee = response.body.data_calculated_shipping_fee;
            this.delivery_details = response.body.data_user_delivery_details;
            this.payment_details = response.body.payment_data;

            this.sortOrderLocations();

            this.checkout_processed = true;
            if (this.new_account) {
                this.loginAndProcess();
            }
            this.deactivate_processing();
        },
        sortOrderLocations: function sortOrderLocations() {
            var i = 0;
            var locations = [];
            this.order_delivery_sorted_locations.cities = [];
            var _iteratorNormalCompletion5 = true;
            var _didIteratorError5 = false;
            var _iteratorError5 = undefined;

            try {
                for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.checkout_orders), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                    var group = _step5.value;

                    if (group.order_business_delivery_options && group.order_business_delivery_options.length != 0) {
                        var delivery_arr = { city_id: group.order_delivery_city_id, city_name: group.order_delivery_city };

                        locations.push(delivery_arr);
                    }

                    i++;
                }
            } catch (err) {
                _didIteratorError5 = true;
                _iteratorError5 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion5 && _iterator5.return) {
                        _iterator5.return();
                    }
                } finally {
                    if (_didIteratorError5) {
                        throw _iteratorError5;
                    }
                }
            }

            var _iteratorNormalCompletion6 = true;
            var _didIteratorError6 = false;
            var _iteratorError6 = undefined;

            try {
                for (var _iterator6 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(locations), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                    var _location = _step6.value;

                    if (this.order_delivery_sorted_locations.cities.indexOf(_location) == -1) {
                        this.order_delivery_sorted_locations.cities.push(_location);
                    }
                }
            } catch (err) {
                _didIteratorError6 = true;
                _iteratorError6 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion6 && _iterator6.return) {
                        _iterator6.return();
                    }
                } finally {
                    if (_didIteratorError6) {
                        throw _iteratorError6;
                    }
                }
            }
        },
        getUserDeliveryDetails: function getUserDeliveryDetails() {
            var _this9 = this;

            service.getUserDeliveryDetails(this, this.user.user_id).then(function (response) {
                if (response.body.status == 200) {
                    _this9.delivery_details = response.body.data;
                }
            }).catch(function (err) {});
        },
        prep_process_checkout: function prep_process_checkout() {
            var _this10 = this;

            var data_test = false;
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            var email_test = re.test(String(this.user.user_email).toLowerCase());
            var re_phone = /^\d{4}\d{3}\d{4}$/;

            var phone_test = true;
            if (email_test == false || this.user.user_name == " " || phone_test == false) {
                data_test = false;
                this.data_error_message = "Some errors were found in your form, please fill correctly";
            } else {
                data_test = true;
                this.data_error_message = "";
            }
            if (data_test) {
                this.user.user_has_shipping_details = false;
                this.user.user_password = this.user.user_name;
                this.user.new_set_account = true;

                service.regUser(this, this.user).then(function (data) {
                    if (data.body.status == 201) {
                        this.loginAndProcess();
                    }
                }).catch(function (err) {
                    _this10.data_error_message = "Something went wrong while account was being processed";
                });
            }
        },
        process_checkout: function process_checkout() {
            this.activate_processing();

            var promises = [];
            var promise_thread_count = 0;

            if (this.process_count != this.checkout_orders.length) {
                this.checkout_orders.forEach(function (processed_checkout) {
                    this.order_url = this.checkout_orders[0].order_business + new Date().getTime();
                    processed_checkout.order_mode = this.is_logged_in_order_mode;
                    processed_checkout.order_url = this.order_url;
                    if (!this.new_account) {
                        processed_checkout.order_user_id = this.user.user_id;
                    } else {
                        processed_checkout.order_user_details = this.user;
                    }

                    processed_checkout.order_user_id = this.user.user_id;
                    processed_checkout.order_mode = 1;
                    promise_thread_count++;
                    promises.push(this.processCheckoutThread(processed_checkout));
                }, this);
            }

            if (promise_thread_count == this.checkout_orders.length) {
                console.log("qwa" + 133);

                __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(promises).then(function () {}).catch(function (e) {});
            }
        },
        processCheckoutThread: function processCheckoutThread(processed_checkout) {
            service.checkout(this, processed_checkout).then(function (data) {
                if (data.body.status == 201) {
                    this.process_count++;
                }

                if (this.process_count == this.checkout_orders.length) {
                    this.checkout_orders = [];
                    this.preset();
                }
                this.deactivate_processing();
            }).catch(function (err) {});
        },
        process_checkoutXX: function process_checkoutXX() {
            this.activate_processing();

            this.checkout_orders.forEach(function (processed_checkout) {
                var _this11 = this;

                this.order_url = this.checkout_orders[0].order_business + new Date().getTime();
                processed_checkout.order_mode = this.is_logged_in_order_mode;
                processed_checkout.order_url = this.order_url;
                if (!this.new_account) {
                    processed_checkout.order_user_id = this.user.user_id;
                } else {
                    processed_checkout.order_user_details = this.user;
                }

                service.checkout(this, processed_checkout).then(function (data) {
                    if (data.body.status == 201) {
                        this.process_count++;
                    }
                    if (this.process_count == this.checkout_orders.length) {
                        this.getCheckoutOrdersByURL();
                    }
                    this.deactivate_processing();
                }).catch(function (err) {
                    if (err) {
                        _this11.deactivate_processing();
                    }
                });
            }, this);
        },
        pre_checkout: function pre_checkout() {
            this.preset();
        },
        displayDeliveryOptions: function displayDeliveryOptions(order) {
            this.selected_order = [];
            this.selected_order = order;
            if (this.selected_order.display_delivery) {
                this.selected_order.display_delivery = false;
            } else {
                this.selected_order.display_delivery = true;
            }
        },
        calc_delivery_feeXXXX: function calc_delivery_feeXXXX(i, option) {
            if (option != undefined) {
                this.total_orders_amount -= Number(this.checkout_orders[i].order_delivery_fee);
                this.checkout_orders[i].order_total -= Number(this.checkout_orders[i].order_delivery_fee);
                this.total_shipping_fee -= Number(this.checkout_orders[i].order_delivery_fee);
                this.checkout_orders[i].order_delivery_id = option.business_delivery_option_id;
                this.checkout_orders[i].order_delivery_fee = option.business_delivery_option_price;
                this.checkout_orders[i].order_delivery_city = option.business_delivery_option;

                this.checkout_orders[i].order_delivery_id = option.business_delivery_option_id;
                this.checkout_orders[i].order_delivery_fee = Number(option.business_delivery_option_price);

                this.total_orders_amount += Number(option.business_delivery_option_price);
                this.checkout_orders[i].order_total += Number(option.business_delivery_option_price);
                this.total_shipping_fee += Number(option.business_delivery_option_price);
                this.delivery_details.forEach(function (detail) {
                    if (detail.user_delivery_city == option.business_delivery_option) {
                        this.checkout_orders[i].order_user_delivery_addresses = [];

                        this.checkout_orders[i].order_user_delivery_addresses.push(detail);
                    }
                }, this);
            }
        },
        calc_delivery_fee: function calc_delivery_fee(i, option) {
            if (option != undefined) {
                this.total_orders_amount -= Number(this.checkout_orders[i].order_delivery_fee);
                this.checkout_orders[i].order_total -= Number(this.checkout_orders[i].order_delivery_fee);
                this.total_shipping_fee -= Number(this.checkout_orders[i].order_delivery_fee);
                this.checkout_orders[i].order_delivery_fee = 0;
                this.checkout_orders[i].order_user_delivery_address = "";

                var _iteratorNormalCompletion7 = true;
                var _didIteratorError7 = false;
                var _iteratorError7 = undefined;

                try {
                    for (var _iterator7 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.checkout_orders[i].order_items), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
                        var item = _step7.value;

                        item.order_item_delivery_fee = 0;
                    }
                } catch (err) {
                    _didIteratorError7 = true;
                    _iteratorError7 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion7 && _iterator7.return) {
                            _iterator7.return();
                        }
                    } finally {
                        if (_didIteratorError7) {
                            throw _iteratorError7;
                        }
                    }
                }

                this.checkout_orders[i].order_delivery_id = option.business_delivery_option_id;
                this.checkout_orders[i].order_delivery_city = option.business_delivery_option;
                this.checkout_orders[i].order_delivery_city_id = option.business_delivery_city;
                this.checkout_orders[i].order_delivery_state_id = option.business_delivery_state_id;
                this.checkout_orders[i].order_delivery_state = option.business_delivery_state;

                var fees = option.business_products_delivery_fees;
                if (fees.length == 0) {
                    if (this.checkout_orders[i].business_shipping_calculation_method == 9) {
                        this.checkout_orders[i].order_delivery_fee += Number(option.business_delivery_option_price);
                    } else {
                        var _iteratorNormalCompletion8 = true;
                        var _didIteratorError8 = false;
                        var _iteratorError8 = undefined;

                        try {
                            for (var _iterator8 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.checkout_orders[i].order_items), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
                                var _item = _step8.value;

                                if (this.checkout_orders[i].business_shipping_calculation_method == 10) {
                                    this.checkout_orders[i].order_delivery_fee += Number(option.business_delivery_option_price);
                                }
                                if (this.checkout_orders[i].business_shipping_calculation_method == 11) {
                                    this.checkout_orders[i].order_delivery_fee += Number(_item.product_item_order_quantity * option.business_delivery_option_price);
                                }
                            }
                        } catch (err) {
                            _didIteratorError8 = true;
                            _iteratorError8 = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion8 && _iterator8.return) {
                                    _iterator8.return();
                                }
                            } finally {
                                if (_didIteratorError8) {
                                    throw _iteratorError8;
                                }
                            }
                        }
                    }
                } else {
                    var ordered_items = this.checkout_orders[i].order_items;
                    var _iteratorNormalCompletion9 = true;
                    var _didIteratorError9 = false;
                    var _iteratorError9 = undefined;

                    try {
                        for (var _iterator9 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(ordered_items), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
                            var _item2 = _step9.value;
                            var _iteratorNormalCompletion11 = true;
                            var _didIteratorError11 = false;
                            var _iteratorError11 = undefined;

                            try {
                                for (var _iterator11 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(fees), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
                                    var fee = _step11.value;

                                    if (_item2.product_id == fee.product_delivery_product) {
                                        if (_item2.product_shipping_calculation_method == 13) {
                                            this.checkout_orders[i].order_delivery_fee += Number(_item2.order_item_quantity * fee.product_delivery_fee);
                                        }
                                        if (_item2.product_shipping_calculation_method == 12) {
                                            this.checkout_orders[i].order_delivery_fee += Number(fee.product_delivery_fee);
                                        }

                                        _item2.has_calculated_product_delivery_fee = true;
                                        _item2.calculated_product_delivery_fee = Number(fee.product_delivery_fee);
                                        _item2.order_item_delivery_fee = Number(fee.product_delivery_fee);
                                    }
                                }
                            } catch (err) {
                                _didIteratorError11 = true;
                                _iteratorError11 = err;
                            } finally {
                                try {
                                    if (!_iteratorNormalCompletion11 && _iterator11.return) {
                                        _iterator11.return();
                                    }
                                } finally {
                                    if (_didIteratorError11) {
                                        throw _iteratorError11;
                                    }
                                }
                            }
                        }
                    } catch (err) {
                        _didIteratorError9 = true;
                        _iteratorError9 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion9 && _iterator9.return) {
                                _iterator9.return();
                            }
                        } finally {
                            if (_didIteratorError9) {
                                throw _iteratorError9;
                            }
                        }
                    }

                    var sorted_fees = ordered_items.filter(function (item) {
                        return item.has_calculated_product_delivery_fee == true;
                    });

                    if (sorted_fees.length < ordered_items.length) {
                        if (this.checkout_orders[i].business_shipping_calculation_method == 9) {
                            this.checkout_orders[i].order_delivery_fee += Number(option.business_delivery_option_price);
                        } else {
                            var _iteratorNormalCompletion10 = true;
                            var _didIteratorError10 = false;
                            var _iteratorError10 = undefined;

                            try {
                                for (var _iterator10 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(ordered_items), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
                                    var _item3 = _step10.value;

                                    if (this.checkout_orders[i].business_shipping_calculation_method == 10) {
                                        this.checkout_orders[i].order_delivery_fee += Number(option.business_delivery_option_price);
                                    }
                                    if (this.checkout_orders[i].business_shipping_calculation_method == 11) {
                                        this.checkout_orders[i].order_delivery_fee += Number(_item3.product_item_order_quantity * option.business_delivery_option_price);
                                    }
                                }
                            } catch (err) {
                                _didIteratorError10 = true;
                                _iteratorError10 = err;
                            } finally {
                                try {
                                    if (!_iteratorNormalCompletion10 && _iterator10.return) {
                                        _iterator10.return();
                                    }
                                } finally {
                                    if (_didIteratorError10) {
                                        throw _iteratorError10;
                                    }
                                }
                            }
                        }
                    }
                }

                this.total_orders_amount += Number(this.checkout_orders[i].order_delivery_fee);
                this.checkout_orders[i].order_total += Number(this.checkout_orders[i].order_delivery_fee);
                this.total_shipping_fee += Number(this.checkout_orders[i].order_delivery_fee);
                if (this.delivery_details.length != 0) {
                    var _iteratorNormalCompletion12 = true;
                    var _didIteratorError12 = false;
                    var _iteratorError12 = undefined;

                    try {
                        for (var _iterator12 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.delivery_details), _step12; !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
                            var detail = _step12.value;

                            if (detail.user_delivery_city == option.business_delivery_option) {
                                this.checkout_orders[i].order_user_city_delivery_addresses = [];

                                this.checkout_orders[i].order_user_city_delivery_addresses.push(detail);
                            }
                        }
                    } catch (err) {
                        _didIteratorError12 = true;
                        _iteratorError12 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion12 && _iterator12.return) {
                                _iterator12.return();
                            }
                        } finally {
                            if (_didIteratorError12) {
                                throw _iteratorError12;
                            }
                        }
                    }
                }
            }
        },
        setOrderUserCityDeliveryAddress: function setOrderUserCityDeliveryAddress(i, address) {
            if (address != undefined) {
                this.checkout_orders[i].order_user_delivery_detail = address.address_id;
            }
        },
        setUserDeliveryAddress: function setUserDeliveryAddress(i, city) {
            this.delivery_details.forEach(function (detail) {
                if (detail.user_delivery_city == city) {
                    this.checkout_orders[i].order_user_delivery_address = detail.user_delivery_address;
                }
            }, this);
        },
        setPaymentOption: function setPaymentOption(option) {
            this.payment_mode = option;
        },
        processPayment: function processPayment() {
            var process_errors = [];

            this.checkout_orders.forEach(function (order) {
                if (order.order_user_delivery_address == undefined || order.order_user_delivery_address == '') {
                    process_errors.push("Please enter delivery address for " + order.order_business);
                }

                order.order_items.forEach(function (item) {
                    if (item.order_delivery_city) {
                        if (item.order_user_delivery_address == undefined) {
                            process_errors.push("Please enter delivery address for " + item.product_name);
                        }
                    }
                }, this);
            }, this);
            if (process_errors.length != 0) {
                process_errors.forEach(function (error) {
                    this.data_error_message = error;
                    toastr.error(error);
                }, this);
            } else {
                this.checkout_orders.forEach(function (order) {
                    if (!order.order_user_delivery_detail) {
                        order.order_user_new_delivery_detail = true;
                    }
                }, this);

                this.processCardPayment(this.payment_details);
            }
        },
        processRavePayment: function processRavePayment() {
            var self = this;
            var x = getpaidSetup({
                PBFPubKey: service.raveLivePublicKey,
                customer_email: self.payment_details.payment_payer_email,
                amount: Math.round(self.total_orders_amount),
                customer_phone: self.payment_details.payment_payer_phone,
                currency: "GBP",

                payment_method: "both",
                txref: "GalleryWebsiteOrders" + self.payment_details.payment__ref,
                meta: [{
                    metaname: "GalleryWebsiteOrders",
                    metavalue: self.payment_details.payment_payer_name
                }],
                onclose: function onclose() {},
                callback: function callback(response) {
                    var txref = response.tx.txRef;
                    var tx_amount = response.tx.amount;
                    if (response.tx.chargeResponseCode == "00" || response.tx.chargeResponseCode == "0") {
                        self.processing = true;

                        this.updatePayment(txref);
                    } else {
                        self.wallet_payment_message = "Payment unsuccessfull. please try again or contact us";
                    }

                    x.close();
                }
            });
        },
        processPayStackPayment: function processPayStackPayment(data) {
            var obj = this;

            var handler = PaystackPop.setup({
                key: 'pk_test_1b578e2fe82975a4ec8a79e5d1a387c953fd2c3e',
                Name: data.payment_payer_name,

                email: "keneinfostream@gmail.com",

                amount: Math.round(this.total_orders_amount * 100),
                ref: data.payment_ref,
                metadata: {
                    custom_fields: [{
                        display_name: "",
                        variable_name: "",
                        value: data.payment_payer_name
                    }, {
                        display_name: "Service",
                        variable_name: "service_type",
                        value: data.payment_service
                    }]
                },

                callback: function callback(response) {
                    obj.updatePayment(response.trxref);
                },
                onClose: function onClose() {
                    alert('window closed');

                    location.reload();
                }
            });
            handler.openIframe();
        },
        processCardPayment: function processCardPayment(data) {
            var obj = this;

            var handler = PaystackPop.setup({
                key: 'pk_test_1b578e2fe82975a4ec8a79e5d1a387c953fd2c3e',
                Name: data.payment_payer_name,

                email: "keneinfostream@gmail.com",

                amount: Math.round(this.total_orders_amount * 100),
                ref: data.payment_ref,
                metadata: {
                    custom_fields: [{
                        display_name: "",
                        variable_name: "",
                        value: data.payment_payer_name
                    }, {
                        display_name: "Service",
                        variable_name: "service_type",
                        value: data.payment_service
                    }]
                },

                callback: function callback(response) {
                    obj.updatePayment(response.trxref);
                },
                onClose: function onClose() {
                    alert('window closed');

                    location.reload();
                }
            });
            handler.openIframe();
        },
        updatePayment: function updatePayment(payment_ref) {

            var payload = {
                payment_order_ref: payment_ref,
                payment_order_amount_paid: this.payment_details.payment_amount,
                payment_user_id: this.user.user_id,
                payment_orders: this.checkout_orders,
                payment_details: this.payment_details.payment_service
            };
            var navi = this.$router;

            if (payment_ref != "") {
                service.updatePayment(this, payload).then(function (data) {
                    if (data.body.status == 201) {
                        toastr.success("Payment Processed!", "Success!");
                        location.replace("/orders/");
                    } else {
                        toastr.error('Sorry, could not update payment', 'Warning!');
                    }
                }).catch(function (err) {
                    if (err) {
                        toastr.error('Sorry, could not process information', 'Warning!');
                    }
                });
            } else {
                toastr.error('Something went wrong', 'Warning!');
            }
        }
    },
    created: function created() {
        document.title = "Checkout" + " | " + service.app_name;
        this.preset();
        this.loading = true;

        this.getStates();
    }
});

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CartWidget_index_vue__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CartWidget_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__CartWidget_index_vue__);



var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Order',
    data: function data() {
        return {
            loading: false,
            user: {},
            cart: this.$store.state.cart,
            img_product_url: service.imageProductsURL,
            loggedIn: false
        };
    },

    components: {
        'cart-widget': __WEBPACK_IMPORTED_MODULE_1__CartWidget_index_vue___default.a
    },
    computed: {},
    methods: {},
    created: function created() {
        document.title = "Order" + " | Gallery";
    }
});

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_service__ = __webpack_require__(1);



var service = new __WEBPACK_IMPORTED_MODULE_1__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Orders',
    data: function data() {
        return {
            user: {},
            orders: {},
            order: {},
            img_product_url: service.imageProductsURL,
            loading: true,
            show_all: true,
            show_single: false,
            is_new: false
        };
    },

    components: {},

    methods: {
        setOrder: function setOrder(order) {
            this.order = order;
            this.show_all = false;
            this.show_single = true;
        },
        viewOrders: function viewOrders() {
            this.show_all = true;
            this.show_single = false;
            this.is_new = false;
        },
        preset_xtra: function preset_xtra() {
            var _this = this;

            var credentials = {
                session_key: localStorage.getItem("sp_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.user.user_id = element.user_id;
                            this.getOrders();
                            if (this.$route.params.ordid != null) {
                                this.setSingleOrder(this.$route.params.ckid);
                            }
                        }, _this);
                    } else {
                        _this.$router.push('login');
                    }
                }).catch(function (err) {
                    if (err) {
                        _this.$router.push('login');
                    }
                });
            } else {
                this.$router.push('login');
            }
        },
        preset: function preset() {
            var self = this;
            localforage.getItem(service.udb_name, function (err, value) {
                if (value != null) {
                    self.user.user_id = value.user_id;
                    self.loggedIn = true;
                    self.getOrders();
                    if (self.$route.params.ordid != null) {
                        self.setSingleOrder(self.$route.params.ckid);
                    }
                    self.loading = false;
                } else {
                    self.$router.push('login');
                }
            });
        },
        getOrders: function getOrders() {
            var _this2 = this;

            service.getOrders(this, this.user.user_id).then(function (response) {
                if (response.body.status == 200) {
                    _this2.orders = response.body.data;
                    _this2.orders.set = true;
                    _this2.loading = false;
                }
            }).catch(function (err) {});
        },
        setSingleOrder: function setSingleOrder(order_no) {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(orders), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var order = _step.value;

                    if (order.order_no == order_no) {
                        this.setOrder(order);
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    },
    created: function created() {
        document.title = "Orders" + " | " + service.app_name;

        localforage.removeItem("not_loggedin_processed_orders").then(function (value) {}).catch(function (err) {});
        if (this.$route.params.ordid != null) {
            this.show_all = false;
            this.show_single = true;
            this.is_new = true;
        }
        this.preset();
    }
});

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__);




var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();
/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Buypoint',
    data: function data() {
        return {
            child_route_view: false,
            loading: false,
            loggedIn: false,
            user: {},
            sellpoint: {},
            set_gallery_banner_image: ""
        };
    },

    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue___default.a
    },
    methods: {
        setSellpoint: function setSellpoint() {
            var _this = this;

            this.loading = true;
            service.getAppBusinessByUserName(this, service.business_app_name).then(function (response) {
                if (response.body.status == 200) {
                    _this.sellpoint = response.body.data;
                    document.title = _this.sellpoint.business_name + " | SP";

                    if (_this.sellpoint.business_banner_image == _this.default_banner_image || _this.sellpoint.business_banner_image == 'error') {
                        _this.set_gallery_banner_image = service.general_banner_image;
                    } else {
                        _this.set_gallery_banner_image = _this.sellpoint.business_banner_image;
                    }

                    if (_this.sellpoint.business_market_subscription_name == 'Bird Plan') {
                        _this.max_plan_lookbooks = 2;
                        _this.max_plan_lookbook_posts = 5;
                    }
                    if (_this.sellpoint.business_market_subscription_name == 'Mid Bird Plan') {
                        _this.max_plan_lookbooks = 10;
                        _this.max_plan_lookbook_posts = 50;
                    }
                    if (_this.sellpoint.business_market_subscription_name == 'Max Bird Plan') {
                        _this.max_plan_lookbooks = 50;
                        _this.max_plan_lookbook_posts = 50;
                        _this.can_add_product_lookbook = true;
                    }

                    _this.preset();
                    _this.loading = false;
                } else {
                    _this.business_load_error_msg = "Sorry, this Business Information could not be found.";
                }
            }).catch(function (err) {
                _this.loading = false;
            });
        }
    },

    created: function created() {
        this.setSellpoint();
    }
});

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_commons__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_product_ProductList_vue__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_product_ProductList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_product_ProductList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_templates_rightsidebar_vue__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_templates_rightsidebar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_templates_rightsidebar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_templates_leftsidebar_vue__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_templates_leftsidebar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_templates_leftsidebar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_templates_searchbox_vue__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_templates_searchbox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_templates_searchbox_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_tools_settings_vue__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_tools_settings_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_tools_settings_vue__);









var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();
var set = new __WEBPACK_IMPORTED_MODULE_1__services_commons__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Home',
    data: function data() {
        return {
            user: {},
            market: {},
            business: {},
            categories: {},
            subscriptions: {},
            business_service_categories: [],
            business_product_categories: [],
            business_category_type: 0,
            plan1: {},
            plan2: {},
            plan3: {},
            selected_plan: {},
            selected_plan_product_service_item: {},
            upgradable_plans: {},
            upgrade_business: "",
            set_upgrade_plans: false,
            place_order: false,

            data_boarding_message: "",
            set_up_with_existing_account: false,
            set_up_with_new_account: false,
            set_up_business: false,
            validate_user_name_error: false,
            data_error_message: "",
            payment_successful: false,
            payment_successful_message: "",
            payment_payer_name: "",
            payment_payer_email: "",
            payment_payer_phone: "",
            payment_service: "",
            img_sellpoint_url: service.imageSellpointsURL,
            img_product_url: service.imageProductsURL,
            loggedIn: false,
            loading: true,
            action_loading: false,
            disable_btn: false,
            setup_error_message: "",
            newBusinessForm: false,
            product_service_items_select: "",
            set_upgrade_plan_process: false
        };
    },


    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue___default.a,
        'right-sidebar': __WEBPACK_IMPORTED_MODULE_5__components_templates_rightsidebar_vue___default.a,
        'left-sidebar': __WEBPACK_IMPORTED_MODULE_6__components_templates_leftsidebar_vue___default.a,
        'search-box': __WEBPACK_IMPORTED_MODULE_7__components_templates_searchbox_vue___default.a,
        'c-settings': __WEBPACK_IMPORTED_MODULE_8__components_tools_settings_vue___default.a
    },
    computed: {},
    methods: {
        setCurrency: function setCurrency(currency) {
            return set.formatCurrency(currency);
        },
        setComponent: function setComponent(attr1, attr2) {
            if (attr1 == 'setup-existing') {
                this.set_up_with_existing_account = true;
            }
            if (attr1 == 'not-setup-existing') {
                this.set_up_with_existing_account = false;
            }
            if (attr1 == 'show-new-business-form') {
                this.newBusinessForm = true;
            }
            if (attr1 == 'display-product_service_items') {
                var x = document.getElementById("productServiceItems");
                if (x.style.display === "none") {
                    x.style.display = "block";
                } else {
                    x.style.display = "none";
                }
            }
        },
        reset: function reset() {
            this.set_upgrade_plan_process = false;
        },
        toggleDisplayFeatures: function toggleDisplayFeatures() {
            var x = document.getElementById("seeFeatures");
            if (x.style.display === "none") {
                x.style.display = "block";
            } else {
                x.style.display = "none";
            }
        },
        activate_processing: function activate_processing() {
            this.disable_btn = true;
            this.action_loading = true;
        },
        deactivate_processing: function deactivate_processing() {
            this.disable_btn = false;
            this.action_loading = false;
        },
        selectProductServiceItem: function selectProductServiceItem(item) {
            this.selected_plan_product_service_item = item;
        },
        preset: function preset() {
            var _this = this;

            var credentials = {
                session_key: localStorage.getItem("sp_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.user.user_id = element.user_id;
                            this.user.user_name = localStorage.getItem("sp_user");
                            this.loggedIn = true;

                            if (this.$route.query.upgrade) {
                                this.prepareUpgradePlans();
                            }
                        }, _this);
                    } else {}
                }).catch(function (err) {
                    if (err) {}
                });
            } else {}
        },
        setPurchase: function setPurchase() {
            var query_plan = this.$route.query.purchase;
            var query_plan_item = this.$route.query.item;
            var found = false;

            this.subscriptions.forEach(function (element) {
                if (element.product_url_name == query_plan) {
                    this.selected_plan = element;
                    if (query_plan_item != 'n') {
                        if (element.product_items[query_plan_item]) {
                            this.selected_plan_product_service_item = element.product_items[query_plan_item];
                        } else {
                            this.selected_plan_product_service_item = element.product_items[0];
                        }
                    } else {
                        this.selected_plan_product_service_item = element.product_items[0];
                    }

                    found = true;

                    this.loading = false;
                }
            }, this);

            if (!found) {
                this.setup_error_message = "Something went wrong with your selection, please pick another plan";
            }

            this.loading = false;
        },
        prepareUpgradePlans: function prepareUpgradePlans() {
            this.loading = true;

            var navi = this.$router;
            service.getBusinessMarketUpgradeDetails(this, this.$route.query.upgrade).then(function (data) {
                this.upgradable_plans = data.body.data;
                this.upgrade_business = this.$route.query.upgrade;

                this.payment_payer_name = data.body.data_user_payment_details["user_name"];
                this.payment_payer_email = data.body.data_user_payment_details["user_email"];
                this.payment_payer_phone = data.body.data_user_payment_details["user_phone"];

                this.set_upgrade_plans = true;
                this.loading = false;
            });
        },
        getSellpointMarket: function getSellpointMarket() {
            var _this2 = this;

            service.getBusinessByUserName(this, service.market_app_name).then(function (response) {
                if (response.body.status == 200) {
                    _this2.market = response.body.data;

                    _this2.getMarketMainProductsAsSubscriptions();

                    _this2.loading = false;
                }
            }).catch(function (err) {
                _this2.loading = true;
            });
        },
        getMarketMainProductsAsSubscriptions: function getMarketMainProductsAsSubscriptions() {
            var _this3 = this;

            service.getBusinessProducts(this, this.market.business_id).then(function (response) {
                if (response.body.status == 200) {
                    _this3.subscriptions = response.body.data;
                    _this3.plan1 = _this3.subscriptions[2];
                    _this3.plan2 = _this3.subscriptions[1];
                    _this3.plan3 = _this3.subscriptions[0];
                }

                if (_this3.$route.query.purchase) {
                    _this3.setPurchase();
                }
            }).catch(function (err) {});
        },
        purchase_plan_2: function purchase_plan_2(plan, plan_product_service_item_index) {
            this.loading = true;
            this.$router.push('/purchase/?purchase=' + plan.product_url_name + '&item=' + plan_product_service_item_index);
            this.setPurchase();

            var top = document.getElementById("topwrap").offsetTop;
            window.scrollTo(0, top);
        },
        purchase_plan: function purchase_plan(plan) {
            this.loading = true;
            this.selected_plan = plan;
            this.selected_plan_product_service_item = plan.product_items[0];
        },
        upgrade_plan: function upgrade_plan(plan) {
            this.loading = true;
            this.set_upgrade_plan_process = true;
            this.selected_plan = plan;
            this.selected_plan_product_service_item = plan.product_items[0];
            this.loading = false;
        },
        resetOptions: function resetOptions() {
            this.selected_plan = {};
            this.selected_plan_product_service_item = {}, this.total_price = 0;
            this.place_order = false;
        },
        resetMessages: function resetMessages() {
            this.data_error_message = "";
            this.data_boarding_message = "";
            this.payment_successful_message = "";
            this.validate_user_name_error = "";
        },
        proceedUpgradePlan: function proceedUpgradePlan() {
            var found = false;
            this.selected_plan.product_items_upgrade_details.forEach(function (element) {
                if (this.selected_plan_product_service_item.product_item_id == element.subscription_new_product_item_id) {
                    this.selected_plan_product_service_item.product_item_price = element.subscription_new_product_total_amount_to_pay;
                    found = true;
                }
            }, this);

            if (found) {
                this.processPayment();
            }
        },
        proceedNewAccount: function proceedNewAccount() {
            this.resetMessages();
            this.set_up_with_new_account = true;

            if (this.selected_plan_product_service_item.product_item_price == 0) {
                this.updatePayment("gw-free-account");
            } else {
                this.processPayment();
            }
        },
        proceedWithAccount: function proceedWithAccount() {
            this.resetMessages();
            this.activate_processing();
            var payload = {
                user_email: this.user.user_email,
                user_password: this.user.user_password,
                user_business: this.user.user_business
            };
            service.checkUserDetails(this, payload).then(function (data) {
                if (data.body.status == 200) {
                    if (data.body.status_2 != 200) {
                        this.data_error_message = "Sorry, Sellpoint does not exist on this account";
                        this.deactivate_processing();
                    } else {
                        this.data_boarding_message = "Account verified...";

                        this.payment_payer_name = data.body.data.user_name;
                        this.payment_payer_email = data.body.data.user_email;
                        this.payment_payer_phone = data.body.data.user_phone;

                        if (this.selected_plan_product_service_item.product_item_price == 0) {
                            this.updatePayment("gw-free-account");
                        } else {
                            this.processPayment();
                        }
                    }
                } else {
                    this.data_error_message = "Sorry, Account does not exist";
                    this.deactivate_processing();
                }
            }).catch(function (err) {});
        },
        processPayment: function processPayment() {
            this.data_boarding_message = "Preparing Payment Information";

            var data_test = false;
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            var email_test = re.test(String(this.payment_payer_email).toLowerCase());
            var re_phone = /^\d{4}\d{3}\d{4}$/;
            var phone_test = re_phone.test(String(this.payment_payer_phone).toLowerCase());
            if (email_test == false || this.payment_payer_name == " " || phone_test == false) {
                data_test = false;
                this.data_error_message = "Some errors were found in your form, please fill correctly";
            } else {
                data_test = true;
                this.data_error_message = "";
            }
            if (data_test) {
                this.payment_service = "Gallery Website Order - " + this.selected_plan.product_name + "(" + this.selected_plan.product_items[0].product_item_price + ")";
                var obj = this;

                var handler = PaystackPop.setup({
                    key: 'pk_test_1b578e2fe82975a4ec8a79e5d1a387c953fd2c3e',
                    Name: this.payment_payer_name,

                    email: this.payment_payer_email,
                    amount: Math.round(this.selected_plan_product_service_item.product_item_price * 100),
                    ref: "GWLOG" + new Date().getTime(),
                    metadata: {
                        custom_fields: [{
                            display_name: "GalleryWebsite Order",
                            variable_name: "",
                            value: this.payment_payer_name + " - " + this.payment_payer_phone + " - ORDER - " + this.selected_plan.product_name
                        }, {
                            display_name: "Service",
                            variable_name: "service_type",
                            value: this.selected_plan.product_name
                        }]
                    },

                    callback: function callback(response) {
                        obj.updatePayment(response.trxref);
                    },
                    onClose: function onClose() {
                        alert('window closed');
                    }
                });
                handler.openIframe();
            }
        },
        updatePayment: function updatePayment(payment_ref) {
            var navi = this.$router;

            this.payment_successful = true;
            if (this.selected_plan_product_service_item.product_item_price != 0) {
                this.payment_successful_message = "Payment Successful...";
            }

            if (this.set_up_with_existing_account) {
                this.setUpExistingAccount();
            }
            if (this.set_up_with_new_account) {
                this.setUpNewAccount();
            }

            if (this.set_upgrade_plan_process) {
                this.upgradePlan();
            }
        },
        setUpExistingAccount: function setUpExistingAccount() {
            var _this5 = this;

            this.activate_processing();
            var credentials = {
                business_user_name: this.user.user_business,
                business_group: service.market_app_name,
                business_subscription: this.selected_plan_product_service_item.product_item_id
            };

            var navi = this.$router;
            service.addExistingBusiness(this, credentials).then(function (data) {
                var _this4 = this;

                if (data.body.status == 201 || data.body.status == 200) {
                    this.data_boarding_message = "Sellpoint Setup Successful...";

                    var credentials = {
                        user_email: this.user.user_email,
                        user_password: this.user.user_password
                    };
                    service.loginUser(this, credentials).then(function (response) {
                        if (response.body.status == 200) {
                            var _data = response.body.data;
                            localStorage.setItem("sp_user", _data.user_name);
                            localStorage.setItem("sp_token", _data.user_session_key);
                            localStorage.setItem("sp_token_key", _data.user_token_key);

                            navi.push('/' + _this4.user.user_business);
                        }
                    }).catch(function (err) {
                        if (err.status == 404) {
                            toastr.warning("invalid login credentials", 'Warning!');

                            _this4.deactivate_processing();
                        }
                    });
                }
            }).catch(function (err) {
                if (err) {
                    _this5.deactivate_processing();
                }
            });
        },
        setUpNewAccount: function setUpNewAccount() {
            this.activate_processing();
            var credentials = {
                user_name: this.payment_payer_name,
                user_phone: this.payment_payer_phone,
                user_email: this.payment_payer_email,
                user_address: '',
                user_state: '',
                user_city: '',
                user_password: this.user.user_password
            };

            var navi = this.$router;

            var data_test = false;
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            var email_test = re.test(String(this.payment_payer_email).toLowerCase());
            var re_phone = /^\d{4}\d{3}\d{4}$/;
            var phone_test = re_phone.test(String(this.payment_payer_phone).toLowerCase());
            if (email_test == false || this.payment_payer_name == " " || phone_test == false) {
                data_test = false;
                this.data_error_message = "Some errors were found in your form, please fill correctly";
                this.deactivate_processing();
            } else {
                data_test = true;
                this.data_error_message = "";
            }
            if (data_test) {
                if (credentials.user_name != undefined && credentials.user_address != undefined && credentials.user_phone != null && credentials.user_email != null && credentials.user_password != null) {
                    service.regUser(this, credentials).then(function (data) {
                        var _this6 = this;

                        if (data.body.status == 201) {
                            this.data_boarding_message = "Registration Successful...";

                            var credentials = {
                                user_email: data.body.data.user_email,
                                user_password: data.body.data.user_password
                            };
                            service.loginUser(this, credentials).then(function (response) {
                                if (response.body.status == 200) {
                                    var _data2 = response.body.data;
                                    localStorage.setItem("sp_user", _data2.user_name);
                                    localStorage.setItem("sp_token", _data2.user_session_key);
                                    localStorage.setItem("sp_token_key", _data2.user_token_key);

                                    _this6.preset();

                                    var self = _this6;
                                    setTimeout(function () {
                                        self.set_up_business = true;

                                        self.data_boarding_message = " ";
                                        self.setComponent('show-new-business-form', '');
                                        self.deactivate_processing();

                                        var top = document.getElementById("banner").offsetTop;
                                        window.scrollTo(0, top);
                                    }, 3000);
                                }
                            }).catch(function (err) {
                                if (err.status == 404) {
                                    _this6.data_error_message = "invalid login credentials..";

                                    _this6.deactivate_processing();
                                }
                            });
                        } else if (data.body.status == 409) {
                            this.data_error_message = "This User is already registered..";

                            this.deactivate_processing();
                        }
                    });
                } else {
                    this.data_error_message = "Kindly fill all fields...";

                    this.deactivate_processing();
                }
            }
        },
        validateUserName: function validateUserName() {
            var _this7 = this;

            service.validateBusinessUserName(this, this.business).then(function (response) {
                if (response.body.status != 200) {
                    _this7.validate_user_name_error = true;
                    _this7.validate_user_name_message = "This username already exist";
                    _this7.deactivate_processing();
                }
            }).catch(function (err) {
                _this7.validate_user_name_error = true;
                _this7.validate_user_name_message = "This username already exist";
                _this7.deactivate_processing();
            });
        },
        setUpNewAccountBusiness: function setUpNewAccountBusiness() {
            var _this8 = this;

            this.resetMessages();

            this.activate_processing();
            var credentials = {
                business_name: this.business.business_name,
                business_user_name: this.business.business_user_name,
                business_category: this.business.business_category || 1,
                business_owner: this.user.user_id,
                business_group: service.market_app_name,
                business_layout: 3,
                business_subscription: this.selected_plan_product_service_item.product_item_id
            };
            var navi = this.$router;
            if (this.validate_user_name_error) {
                this.data_error_message = "This Username already exists..";
                this.deactivate_processing();
            } else {
                if (credentials.business_name != undefined && credentials.business_category != undefined) {
                    service.addNewBusiness(this, credentials).then(function (data) {
                        if (data.body.status == 201) {
                            this.data_boarding_message = "Sellpoint Creation Successful.";

                            navi.push('/' + this.business.business_user_name);
                        } else {
                            this.data_error_message = "This Username already exists";
                            this.deactivate_processing();
                        }
                    }).catch(function (err) {
                        if (err) {
                            _this8.data_error_message = "Something went wrong";

                            _this8.deactivate_processing();
                        }
                    });
                } else {
                    this.data_error_message = "Kindly fill all fields";

                    this.deactivate_processing();
                }
            }
        },
        upgradePlan: function upgradePlan() {
            var _this9 = this;

            this.activate_processing();
            var credentials = {
                business_user_name: this.upgrade_business,
                business_group: service.market_app_name,
                business_subscription: this.selected_plan_product_service_item.product_item_id,
                business_subscription_amount_paid: this.selected_plan_product_service_item.product_item_price
            };

            var navi = this.$router;
            service.upgradeBusinessMarketSubscription(this, credentials).then(function (data) {
                if (data.body.status == 200) {
                    navi.push('/' + this.upgrade_business);
                }
            }).catch(function (err) {
                if (err) {
                    _this9.data_error_message = "Something went wrong";
                    _this9.deactivate_processing();
                }
            });
        },
        getBusinessCategories: function getBusinessCategories() {
            service.getCategories(this).then(function (data) {
                this.categories = data.body.data;

                this.categories.forEach(function (element) {
                    if (element.category_type == 1) {
                        this.business_product_categories.push(element);
                    }
                    if (element.category_type == 2) {
                        this.business_service_categories.push(element);
                    }
                }, this);
            });
        }
    },
    mounted: function mounted() {
        var top = document.getElementById("topwrap").offsetTop;
        window.scrollTo(0, top);
    },

    created: function created() {
        if (this.$route.query.upgrade) {
            this.set_upgrade_plans = true;
        }
        this.preset();
        this.getSellpointMarket();
        this.getBusinessCategories();
    }
});

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__);



var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Register',
    data: function data() {
        return {
            users: {},
            user: {},
            states: {},
            cities: {},
            user_type: "bo",
            terms: true,
            disable_btn: false,
            loading: false,
            action_loading: false,
            data_error_message: ""
        };
    },

    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue___default.a
    },
    methods: {
        reset: function reset() {
            localStorage.removeItem("sp_user");
            localStorage.removeItem("sp_token");
            localStorage.removeItem("sp_token_key");
        },
        getStates: function getStates() {
            service.getStates(this).then(function (data) {
                this.states = data.body;
            });
        },
        getCities: function getCities(state) {
            service.getCities(this, state).then(function (data) {
                this.cities = data.body;
            });
        },
        reg: function reg() {
            this.disable_btn = true;
            this.user.agree = true;
            var credentials = {
                user_name: this.user.name,
                user_phone: this.user.phone,
                user_email: this.user.email,
                user_address: this.user.address || '',
                user_state: this.user.state || '',
                user_city: this.user.city || '',
                user_password: this.user.password
            };

            var navi = this.$router;
            if (credentials.user_name != undefined && credentials.user_address != undefined && credentials.user_phone != null && credentials.user_email != null && credentials.user_password != null) {
                if (this.terms) {
                    this.loading = true;
                    service.regUser(this, credentials).then(function (data) {
                        var _this = this;

                        if (data.body.status == 201) {
                            this.data_processing_message = "Account Created";

                            var credentials = {
                                user_email: data.body.data.user_email,
                                user_password: data.body.data.user_password
                            };
                            service.loginUser(this, credentials).then(function (response) {
                                if (response.body.status == 200) {
                                    var _data = response.body.data;
                                    localStorage.setItem("sp_user", _data.user_name);
                                    localStorage.setItem("sp_token", _data.user_session_key);
                                    localStorage.setItem("sp_token_key", _data.user_token_key);

                                    navi.push('/timeline');
                                }
                            }).catch(function (err) {
                                if (err.status == 404) {
                                    _this.data_error_message = "invalid login credentials";
                                    _this.disable_btn = false;
                                }
                            });
                        } else if (data.body.status == 409) {
                            this.data_error_message = "You already have a Sellpoint Account";
                            navi.push("login?u=connect");
                            this.disable_btn = false;
                        }
                    });
                } else {
                    this.data_error_message = 'Please agree to Terms';
                    this.disable_btn = false;
                }
            } else {
                this.data_error_message = 'Kindly fill all fields';
                this.disable_btn = false;
            }
        }
    },
    created: function created() {}
});

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_templates_rightsidebar_vue__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_templates_rightsidebar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_templates_rightsidebar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_templates_leftsidebar_vue__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_templates_leftsidebar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_templates_leftsidebar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_templates_searchbox_vue__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_templates_searchbox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_templates_searchbox_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_widgets_activeproducts_vue__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_widgets_activeproducts_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_widgets_activeproducts_vue__);








var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();
/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Search',
    data: function data() {
        return {
            user: {},
            products: {},
            product: {},
            search_data: "",
            loggedIn: false
        };
    },


    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue___default.a,
        'right-sidebar': __WEBPACK_IMPORTED_MODULE_3__components_templates_rightsidebar_vue___default.a,
        'left-sidebar': __WEBPACK_IMPORTED_MODULE_4__components_templates_leftsidebar_vue___default.a,
        'search-box': __WEBPACK_IMPORTED_MODULE_5__components_templates_searchbox_vue___default.a,
        'active-products': __WEBPACK_IMPORTED_MODULE_6__components_widgets_activeproducts_vue___default.a
    },
    methods: {
        preset: function preset() {
            var _this = this;

            var credentials = {
                session_key: localStorage.getItem("sp_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.user.user_id = element.user_id;
                            this.user.user_name = localStorage.getItem("sp_user");
                            this.loggedIn = true;
                        }, _this);
                    } else {}
                }).catch(function (err) {
                    if (err) {}
                });
            } else {}
        },
        getSearchProducts: function getSearchProducts() {
            var _this2 = this;

            service.searchProducts(this, this.$route.query.k).then(function (response) {
                if (response.body.status == 200) {
                    _this2.products = response.body.data;
                    _this2.search_data = _this2.$route.query.k;
                }
            }).catch(function (err) {});
        },
        getBusinessSearchProducts: function getBusinessSearchProducts() {
            var _this3 = this;

            service.searchBusinessProducts(this, this.$route.query.k).then(function (response) {
                if (response.body.status == 200) {
                    _this3.products = response.body.data;
                    _this3.search_data = _this3.$route.query.k;
                }
            }).catch(function (err) {});
        },
        getCategorySearchProducts: function getCategorySearchProducts() {
            var _this4 = this;

            service.searchCategoryProducts(this, this.$route.query.s, this.$route.query.k).then(function (response) {
                if (response.body.status == 200) {
                    _this4.products = response.body.data;
                    _this4.search_data = response.body.data_search;
                }
            }).catch(function (err) {});
        }
    },
    created: function created() {
        this.preset();
        if (this.$route.query.search == "business") {
            this.getBusinessSearchProducts();
        } else if (this.$route.query.search == "product") {
            this.getSearchProducts();
        } else if (this.$route.query.s) {
            this.getCategorySearchProducts();
        }
    }
});

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_product_ProductForm_vue__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_product_ProductForm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_product_ProductForm_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_product_ProductItemForm_vue__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_product_ProductItemForm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_product_ProductItemForm_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_product_ProductCartActions_vue__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_product_ProductCartActions_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_product_ProductCartActions_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_product_ProductCTAActions_vue__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_product_ProductCTAActions_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_product_ProductCTAActions_vue__);










var service = new __WEBPACK_IMPORTED_MODULE_1__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Product',
    props: ['productItem'],
    data: function data() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
            user: {},
            loggedIn: false,
            cart: this.$store.state.cart,
            sellpoint: {},
            categories: {},
            main_category: {},
            category_type_1: false,
            category_type_2: false,
            category_type_3: false,
            sub_categories: [],
            product: {},
            details: {},
            reviews: {},
            information: {},
            states: {},
            cities: {},
            related_products: {},
            delivery_option: {},
            discount_coupon: {},
            product_item_group: {},
            product_item: {},
            sellpoint_categories: {},
            seller_mode: false,
            can_edit: false,
            edit_mode: false,
            disable_btn: false,
            setPanel: false,
            other_delivery_option: false,
            edit_other_delivery_option: false,
            edit_city: false,
            editProductPanel: false,
            addProductItemPanel: false,
            editProductItemPanel: false,
            removeItemPanel: false,
            editProductItemGroupPanel: false,
            removeItemGroupPanel: false,
            removeProductPanel: false,
            product_details_descr: true,
            product_details_reviews: false,
            product_details_information: false,
            addDeliveryInformation: false,
            editDeliveryInformation: false,
            setProductDeliveryInformation: false,
            setDiscount: false,
            editDiscount: false,
            img_product_url: service.imageProductsURL,
            img_user_url: service.imageUsersURL,
            siteUrl: "",
            is_product_in_cart: false,
            loading: false,
            copied: false,
            descr_active: 'active',
            user_type: "buyer",
            new_added: false,
            product_display_image: {},
            action_loading: false,
            product_is_ready_to_cart: false,
            product_item_selected: [],
            product_item_group_selected: [],
            data_cart_message: "",
            data_cart_group_message: "",
            data_cart_item_message: "",
            product_set_shipping_fee_status: 12,
            set_shipping_fee_status_track: false,
            check_order_quantity: "",

            tab_view: {},
            product_item_quantity_key: 0,
            share_url: "",
            share_text: ""
        }, 'related_products', "");
    },

    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue___default.a,
        'product-form': __WEBPACK_IMPORTED_MODULE_4__components_product_ProductForm_vue___default.a,
        "product-item-form": __WEBPACK_IMPORTED_MODULE_5__components_product_ProductItemForm_vue___default.a,
        'add-to-cart-button': __WEBPACK_IMPORTED_MODULE_6__components_product_ProductCartActions_vue___default.a,
        'product-cta-button': __WEBPACK_IMPORTED_MODULE_7__components_product_ProductCTAActions_vue___default.a
    },
    computed: {},

    methods: {
        redir: function redir(rlink) {
            location.replace("/" + rlink);
        },
        copyLink: function copyLink() {
            this.$clipboard(this.siteUrl);
            this.copied = true;
        },
        mobileSideNavToggle: function mobileSideNavToggle(action) {
            if (action == "open") {
                document.getElementById("mobileSideNav").style.width = "300px";
            }
            if (action == "close") {
                document.getElementById("mobileSideNav").style.width = "0";
            }
        },
        activate_processing: function activate_processing() {
            this.disable_btn = true;
            this.action_loading = true;
        },
        deactivate_processing: function deactivate_processing() {
            this.disable_btn = false;
            this.action_loading = false;
        },
        addQuantity: function addQuantity(qty) {
            if (this.product_item.product_item_order_quantity == undefined) {
                this.product_item.product_item_order_quantity = 1;
            } else {
                this.product_item.product_item_order_quantity++;
            }
            this.product_item_quantity_key++;
            this.checkOrderQuantity(qty);
        },
        removeQuantity: function removeQuantity(qty) {
            if (this.product_item.product_item_order_quantity != 1) {
                this.product_item.product_item_order_quantity--;
                this.product_item_quantity_key++;
                this.checkOrderQuantity(qty);
            }
        },
        checkOrderQuantity: function checkOrderQuantity(qty) {
            if (this.product_item_selected.product_item_price > 0 && this.product_item.product_item_order_quantity != 0) {
                if (Number(qty) > this.product_item.product_item_quantity) {
                    this.check_order_quantity = "The quantity you entered is above Item Quantity";
                    this.product_is_ready_to_cart = false;
                    this.data_cart_message = "The quantity you entered is above Item Quantity";
                } else {
                    this.check_order_quantity = "";
                    this.product_is_ready_to_cart = true;
                    this.data_cart_message = "";
                }
            } else {
                this.check_order_quantity = "";
            }
        },
        trackevent: function trackevent(e) {
            if (e == "category-type-1" && this.product.product_category != 0 && this.product.product_category != undefined) {
                this.category_type_2 = true;
                this.category_type_3 = true;
            } else if (e == "category-type-2" && this.product.product_sub_category != 0 && this.product.product_sub_category != undefined) {
                this.category_type_1 = true;
                this.category_type_3 = true;
            } else if (e == "category-type-3" && this.product.product_listed_category != "" && this.product.product_listed_category != undefined) {
                this.category_type_1 = true;
                this.category_type_2 = true;
            } else {
                this.category_type_1 = false;
                this.category_type_2 = false;
                this.category_type_3 = true;
            }
        },
        setTabComponent: function setTabComponent(view) {
            this.tab_view = {};
            this.tab_view[view] = true;
        },
        setComponent: function setComponent(attr1, attr2) {
            this.setPanel = true;
            if (attr1 == 'edit-product') {
                this.editProductPanel = true;
            }
            if (attr1 == 'remove-product') {
                this.removeProductPanel = true;
            }
            if (attr1 == 'add-product-item') {
                this.addProductItemPanel = true;
            }
            if (attr1 == 'edit-product-item') {
                this.editProductItemPanel = true;
            }
            if (attr1 == 'set-edit-product-item') {
                this.product_item = attr2;
                this.editProductItemPanel = true;
            }
            if (attr1 == 'remove-product-item') {
                this.product_item = attr2;
                this.removeItemPanel = true;
            }
            if (attr1 == 'edit-product-item_group') {
                this.product_item_group = attr2;
                this.editProductItemGroupPanel = true;
            }
            if (attr1 == 'remove-product-item_group') {
                this.product_item_group = attr2;
                this.removeItemGroupPanel = true;
            }
            if (attr1 == 'set-product-item-group-image') {
                this.product_item_group.product_item_group_image = attr2;
                var imgs = document.getElementsByClassName('product-item-group-image');
                for (var i = 0; i < imgs.length; i++) {
                    imgs[i].style = "border:none;";
                }
                document.getElementById(attr2 + "PRTG").style.border = "1px solid #0000CC";
            }
            if (attr1 == 'edit-product-detail') {
                this.details.edit_product_detail = false;
                this.details = attr2;
                this.details.edit_product_detail = true;
            }
            if (attr1 == 'edit-product-delivery') {
                this.details.edit_product_delivery = false;
                this.details = {};
                this.details.edit_product_delivery = true;
            }
            if (attr1 == 'add-delivery-option') {
                this.addDeliveryInformation = true;
            }
            if (attr1 == 'set-product-delivery-option') {
                this.delivery_option.edit_set = false;
                this.setProductDeliveryInformation = true;
                this.delivery_option = attr2;
                this.delivery_option.edit_set = true;
            }
            if (attr1 == 'edit-delivery-option') {
                this.delivery_option.edit_set = false;
                this.editDeliveryInformation = true;
                this.delivery_option = attr2;
                this.delivery_option.edit_set = true;

                this.getCities(this.delivery_option.business_delivery_state, 'edit');
            }
            if (attr1 == 'set-product-item') {
                this.check_order_quantity = "";
                this.data_cart_message = '';

                this.product_item = attr2;
                this.product_item_selected = attr2;

                var itms = document.getElementsByClassName('product-item');
                for (var i = 0; i < itms.length; i++) {
                    itms[i].style = "border:none;";
                }

                if (attr2.product_item_size != "Nill" && attr2.product_item_size != "") {
                    document.getElementById(attr2.product_item_id + "PRT").style = "border:1px solid #0000CC;";
                }

                this.data_cart_item_message = '';
                this.data_cart_message = '';
                this.prep_set_product_is_ready_to_cart();
            }
            if (attr1 == 'set-product-item-group') {
                this.check_order_quantity = "";
                this.data_cart_message = '';

                this.product_item_group = attr2;
                this.product_item_group_selected = attr2;

                this.product_display_image = [];
                this.product_display_image.product_image = attr2.product_item_group_image;

                this.product_is_ready_to_cart = false;
                this.product_item_selected = [];

                var itms = document.getElementsByClassName('product-item');
                for (var i = 0; i < itms.length; i++) {
                    itms[i].style = "border:none;";
                }

                var grps = document.getElementsByClassName('product-item-group');
                for (var i = 0; i < grps.length; i++) {
                    grps[i].style.border = "none";
                }

                document.getElementById(attr2.product_item_group_id + "PRTGR").style.border = "1px solid #0000CC";

                this.data_cart_group_message = '';

                if (attr2.product_items[0].product_item_size == "Nill" || attr2.product_items[0].product_item_size == "") {
                    this.setComponent('set-product-item', attr2.product_items[0]);
                } else {
                    if (this.product.product_service == 'P') {
                        this.data_cart_item_message = "please select";
                    } else {
                        this.data_cart_item_message = "please select";
                    }
                }
            }
            if (attr1 == 'set-product-display-image') {
                this.product_display_image = attr2;
            }
            if (attr1 == 'set-descr') {
                window.location.hash = "productDetails";
                history.pushState({}, null, location.href.replace('#productDetails', ''));

                this.product_details_descr = true;
                this.product_details_reviews = false;
                this.product_details_information = false;
                window.location.hash = "";
            }
            if (attr1 == 'set-reviews') {
                window.location.hash = "productDetails";
                history.pushState({}, null, location.href.replace('#productDetails', ''));
                this.descr_active = '';
                this.product_details_reviews = true;
                this.product_details_descr = false;
                this.product_details_information = false;
            }
            if (attr1 == 'set-information') {
                this.descr_active = '';
                this.product_details_information = true;
                this.product_details_reviews = false;
                this.product_details_descr = false;
            }
            if (attr1 == 'set-discount') {
                this.setDiscount = true;
                this.editDiscount = false;
            }
            if (attr1 == 'edit-discount') {
                this.editDiscount = true;
                this.setDiscount = false;
                this.discount_coupon = attr2;
            }
            if (attr1 == 'reset-edit') {
                this.addProductItemPanel = false;
                this.editProductPanel = false;
                this.editProductItemPanel = false;
                this.removeItemPanel = false;
                this.editProductItemGroupPanel = false;
                this.removeItemGroupPanel = false;
                this.removeProductPanel = false;
                this.addDeliveryInformation = false;
                this.editDeliveryInformation = false;
                this.delivery_option.edit_set = false;
                this.setDiscounts = false;
                this.editDiscount = false;
            }
            var self = this;

            setTimeout(function () {
                self.action_loading = false;
            }, 2000);
        },
        setComponentActions: function setComponentActions(attr1, attr2) {
            if (attr1 == 'reset-edit') {
                this.details = {};
            }
        },
        preset: function preset() {
            var _this = this;

            var credentials = {
                session_key: localStorage.getItem("sp_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.user.user_id = element.user_id;
                            this.user.user_name = localStorage.getItem("sp_user");
                            this.sellpoint.business_id = this.product.product_business_id;

                            this.is_editing();

                            this.loggedIn = true;
                        }, _this);
                    } else {}
                }).catch(function (err) {
                    if (err) {}
                });
            } else {}
        },
        is_editing: function is_editing() {
            var _this2 = this;

            var payload = {
                validate_user: this.user.user_id,
                validate_business: this.sellpoint.business_id
            };
            service.can_edit(this, payload).then(function (response) {
                if (response.body.status == 200) {
                    _this2.seller_mode = true;
                    _this2.edit_mode = true;
                    _this2.can_edit = true;
                } else {
                    _this2.edit_mode = false;
                    _this2.seller_mode = false;
                }
            }).catch(function (err) {
                if (err) {}
            });
        },
        switchMode: function switchMode() {
            if (this.edit_mode == false) {
                this.is_editing();
            } else {
                this.edit_mode = false;
                this.can_edit = true;
            }
        },
        getStates: function getStates() {
            var _this3 = this;

            service.getStates(this).then(function (response) {
                if (response.body.status == 200) {
                    _this3.states = response.body.data;
                }
            }).catch(function (err) {});
        },
        getCities: function getCities(state, option) {
            var _this4 = this;

            if (option == "edit") {
                this.edit_city = true;
            } else {
                this.edit_city = false;
            }
            service.getCities(this, state).then(function (response) {
                if (response.body.status == 200) {
                    _this4.cities = response.body.data;
                }
            }).catch(function (err) {});
        },
        setOtherOptions: function setOtherOptions(v, o) {
            if (v != undefined) {
                if (v == "other") {
                    this.other_delivery_option = true;
                    if (o == "edit") {
                        this.edit_other_delivery_option = true;
                    }
                }
                if (v == "all") {
                    this.delivery_option.business_delivery_other_option = "nill";
                    if (o == "edit") {
                        this.edit_other_delivery_option = false;
                    }
                    this.other_delivery_option = false;
                }
            }
        },
        set_data_messages: function set_data_messages(data, action) {
            if (this.product.product_service == 'P') {
                if (action == 'set') {
                    if (data == 'product-item') {}
                }
                if (action == 'unset') {}
            } else {}
        },
        prep_set_product_is_ready_to_cart: function prep_set_product_is_ready_to_cart() {
            if (this.product_item_selected.length != 0) {
                this.product_is_ready_to_cart = true;
            } else {
                this.data_cart_message = "make a selection before you proceed";
                if (this.product_item_group_selected.length != 0) {
                    if (this.product.product_service == 'P') {
                        this.data_cart_item_message = "please select";
                    } else {
                        this.data_cart_item_message = "please select";
                    }
                } else {
                    if (this.product.product_service == 'P') {
                        this.data_cart_group_message = "please select";
                    } else {
                        this.data_cart_group_message = "please select";
                    }
                }
            }
        },
        isEmpty: function isEmpty(obj) {
            for (var key in obj) {
                if (obj.hasOwnProperty(key)) return false;
            }
            return true;
        },
        set_product_is_ready_to_cart: function set_product_is_ready_to_cart() {
            if (this.product.product_set_groups <= 1 && this.product.product_set_items <= 1) {
                this.product_item_selected = this.product_item;
                this.product_item_group_selected = this.product_item_group;
                this.product_is_ready_to_cart = true;
            }
        },
        setProduct: function setProduct() {
            var _this5 = this;

            this.loading = true;
            service.getProductSearch(this, this.$route.params.id1).then(function (response) {
                if (response.body.status == 200) {
                    _this5.product = response.body.data;

                    document.title = _this5.product.product_name + " | " + _this5.product.product_business_name + " | SP";

                    _this5.product_display_image = _this5.product.product_images[0];
                    _this5.product_item = _this5.product.product_items[0];
                    if (_this5.product.product_item_groups.length != 0) {
                        _this5.product_item_group = _this5.product.product_item_groups[0];
                    } else {
                        _this5.product_item_group = [];
                    }

                    _this5.product_set_shipping_fee_status = _this5.product.product_set_shipping_fee_status;

                    _this5.set_product_is_ready_to_cart();

                    _this5.siteUrl = service.siteUrl + "?p=" + _this5.product.product_url_name + "&p1=" + _this5.product.product_business_ownername + "&p2=" + _this5.product.product_url_name + "&p3=" + encodeURI(_this5.product.product_name) + "&p4=" + encodeURI(_this5.product.product_description) + "&p5=" + _this5.product_item.product_item_image + " ";

                    _this5.product.product_share_url = "http://sellpoints.com.ng/" + _this5.product.product_business_ownername + "/" + _this5.product.product_url_name;
                    _this5.loading = false;

                    _this5.preset();

                    _this5.setRelatedProducts(_this5.product.product_business_id);

                    _this5.getCategories(_this5.product.product_business_category_id);

                    _this5.getSellpointCategories();

                    _this5.check_in_cart();
                }
            }).catch(function (err) {});
        },
        getCategories: function getCategories(category) {
            var _this6 = this;

            service.getMainCategories(this, category).then(function (response) {
                if (response.body.status == 200) {
                    _this6.categories = response.body.data;
                }
            }).catch(function (err) {});
        },
        getSubCategories: function getSubCategories(category) {
            if (category != undefined) {
                this.sub_categories = category.sub_categories;
            } else {
                this.sub_categories = [];
            }
        },
        check_in_cart: function check_in_cart() {
            this.cart.forEach(function (element) {
                if (element.product_item_id == this.product_item.product_item_id) {
                    this.is_product_in_cart = true;
                }
            }, this);
        },
        setRelatedProducts: function setRelatedProducts() {
            var _this7 = this;

            var payload = {
                business: this.product.product_business_id,
                category: this.product.product_category_id,
                product: this.product.product_id,
                limit: 4,
                user_search: []
            };
            service.setRelatedProducts(this, payload).then(function (response) {
                if (response.body.status == 200) {
                    _this7.related_products = response.body.data;
                }
            }).catch(function (err) {});
        },
        getProductImages: function getProductImages() {
            var _this8 = this;

            service.getProductImages(this, this.product.product_id).then(function (response) {
                if (response.body.status == 200) {
                    _this8.product.product_images = response.body.data;
                    _this8.product_display_image = _this8.product.product_images[0];
                }
            }).catch(function (err) {});
        },
        deleteProductImage: function deleteProductImage(image) {
            service.deleteProductImage(this, image).then(function (data) {
                if (data.body.status == 200) {
                    this.getProductImages();
                }
            }).catch(function (err) {});
        },
        editProduct: function editProduct() {
            var _this9 = this;

            this.activate_processing();

            var set_product_category = this.product.product_category_id;
            if (this.product.product_sub_category != undefined || this.product.product_listed_category != undefined) {
                set_product_category = 0;
            } else {
                if (this.product.product_category != undefined) {
                    set_product_category = this.product.product_category;
                } else {
                    set_product_category = this.product.product_category_id;
                }
            }
            var credentials = {
                product_id: this.product.product_id,
                product_name: this.product.product_name,

                product_category: set_product_category,
                product_sub_category: this.product.product_sub_category || 0,
                product_listed_category: this.product.product_listed_category || "nill",


                product_url_name: this.product.product_url_name,
                product_description: this.product.product_description || "nill",
                product_business: this.product.product_business_id };

            var navi = this.$router;
            if (credentials.product_name != undefined) {
                service.editProduct(this, this.product.product_id, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        _this9.editProductPanel = false;
                        _this9.product = response.body.data;
                        navi.push("/" + _this9.product.product_business_ownername + "/" + _this9.product.product_url_name);
                    } else {
                        _this9.editProductPanel = false;
                        _this9.deactivate_processing();
                    }
                }).catch(function (err) {
                    if (err) {
                        _this9.editProductPanel = false;
                        _this9.deactivate_processing();
                    }
                });
            } else {
                this.disable_btn = false;
            }
        },
        editProductItem: function editProductItem() {
            var _this10 = this;

            this.activate_processing();
            var credentials = {
                product_item_id: this.product_item.product_item_id,
                product_item_price: this.product_item.product_item_price,
                product_item_weight: this.product_item.product_item_weight || 1,
                product_item_size: this.product_item.product_item_size || "Nill",
                product_item_service_tag: this.product_item.product_item_service_tag || "Nill",
                product_item_quantity: this.product_item.product_item_quantity || 1
            };

            var navi = this.$router;
            if (credentials.product_item_price != undefined) {
                service.editProductItem(this, this.product_item.product_item_id, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        _this10.product_item = response.body.data;
                        _this10.deactivate_processing();
                        _this10.editProductItemPanel = false;
                    }
                }).catch(function (err) {
                    if (err) {
                        _this10.deactivate_processing();
                    }
                });
            } else {
                this.deactivate_processing();
            }
        },
        editProductItemGroup: function editProductItemGroup() {
            var _this11 = this;

            this.activate_processing();
            var product_item_group_is_color_image = 'IMG';
            if (this.product_item_group.product_item_group_color == undefined) {
                product_item_group_is_color_image = 'IMG';
            } else {
                product_item_group_is_color_image = 'COL';
            }

            if (this.product_item_group.product_item_group_color_new != undefined) {
                product_item_group_is_color_image = 'COL';
                this.product_item_group.product_item_group_color = this.product_item_group.product_item_group_color_new;
                this.product_item_group.product_item_group_image = 0;
            } else {
                product_item_group_is_color_image = 'IMG';
                this.product_item_group.product_item_group_color = "Nill";
            }
            var credentials = {
                product_item_group_product: this.product.product_id,
                product_item_group_name: this.product_item_group.product_item_group_name || "Type",
                product_item_group_is_color_image: product_item_group_is_color_image,
                product_item_group_color: this.product_item_group.product_item_group_color || "Nill",
                product_item_group_image: this.product_item_group.product_item_group_image || 0
            };

            var navi = this.$router;
            if (credentials.product_item_group_name != undefined) {
                service.editProductItemGroup(this, this.product_item_group.product_item_group_id, credentials).then(function (response) {
                    if (response.body.status == 200) {

                        _this11.product.product_item_groups = response.body.data;

                        _this11.deactivate_processing();
                        _this11.editProductItemGroupPanel = false;
                    } else {
                        _this11.deactivate_processing();
                        _this11.editProductItemGroupPanel = false;
                    }
                }).catch(function (err) {
                    if (err) {
                        _this11.deactivate_processing();
                    }
                });
            } else {
                this.deactivate_processing();
            }
        },
        removeProduct: function removeProduct() {
            var _this12 = this;

            this.disable_btn = true;
            var payload = {
                product_id: this.product.product_id
            };
            var navi = this.$router;
            service.removeProduct(this, this.product.product_id, payload).then(function (response) {
                if (response.body.status == 200) {
                    _this12.redir(_this12.$route.params.id1);

                    _this12.removeProductPanel = false;
                }
            }).catch(function (err) {
                if (err) {
                    _this12.disable_btn = false;
                    _this12.redir(_this12.$route.params.id1);
                }
            });
        },
        removeProductItem: function removeProductItem() {
            var _this13 = this;

            this.activate_processing();
            var payload = {
                product_id: this.product.product_id,
                product_item_id: this.product_item.product_item_id
            };
            var navi = this.$router;
            service.removeProductItem(this, this.product_item.product_item_id, payload).then(function (response) {
                if (response.body.status == 200) {
                    if (response.body.no_product) {
                        _this13.redir(_this13.$route.params.id);
                    }
                    _this13.product.product_item_groups = response.body.data;

                    _this13.deactivate_processing();
                    _this13.removeItemPanel = false;
                }
            }).catch(function (err) {
                if (err) {
                    _this13.deactivate_processing();
                }
            });
        },
        removeProductItemGroup: function removeProductItemGroup() {
            var _this14 = this;

            this.activate_processing();
            var payload = {
                product_id: this.product.product_id,
                product_item_group_id: this.product_item_group.product_item_group_id
            };
            var navi = this.$router;
            service.removeProductItemGroup(this, this.product_item_group.product_item_group_id, payload).then(function (response) {
                if (response.body.status == 200) {
                    if (response.body.no_product) {
                        _this14.redir(_this14.$route.params.id);
                    }
                    _this14.product.product_item_groups = response.body.data;
                    _this14.deactivate_processing();
                    _this14.removeItemGroupPanel = false;
                }
            }).catch(function (err) {
                if (err) {
                    _this14.deactivate_processing();
                }
            });
        },
        addProductDetail: function addProductDetail() {
            var _this15 = this;

            this.activate_processing();
            var payload = {
                product_detail: this.details.new_product_detail || "nill",
                product_id: this.product.product_id
            };
            service.addProductDetail(this, payload).then(function (data) {
                if (data.body.status == 201) {
                    this.product.product_details = data.body.data;
                    this.details = {};
                    this.deactivate_processing();
                } else {
                    this.deactivate_processing();
                }
            }).catch(function (err) {
                _this15.details = {};
                _this15.deactivate_processing();
            });
        },
        editProductDetail: function editProductDetail() {
            var _this16 = this;

            this.details.product_id = this.product.product_id;
            service.editProductDetail(this, 1, this.details).then(function (data) {
                if (data.body.status == 200) {
                    this.product.product_details = data.body.data;
                }
            }).catch(function (err) {
                _this16.service = {};
            });
        },
        deleteProductDetail: function deleteProductDetail(details) {
            var _this17 = this;

            var payload = {
                product_detail_id: details.product_detail_id
            };
            service.deleteProductDetail(this, details.product_detail_id, payload).then(function (data) {
                if (data.body.status == 200) {
                    this.product.product_details = data.body.data;
                }
            }).catch(function (err) {
                _this17.service = {};
            });
        },
        setProductDelivery: function setProductDelivery() {
            var payload = {
                product_id: this.product.product_id,
                product_delivery_details: this.product.product_delivery_returns
            };
            service.setProductDelivery(this, 1, payload).then(function (data) {
                if (data.body.status == 200) {
                    this.details = {};

                    this.details.edit_product_delivery = false;
                }
            }).catch(function (err) {});
        },
        setProductShippingFeeStatus: function setProductShippingFeeStatus() {
            this.set_shipping_fee_status_track = true;
            this.activate_processing();
            var payload = {
                product_id: this.product.product_id,
                product_set_shipping_fee_status: this.product_set_shipping_fee_status
            };
            service.setProductShippingFeeStatus(this, payload).then(function (data) {
                if (data.body.status == 200) {
                    this.product.product_set_shipping_fee_status = this.product_set_shipping_fee_status;
                    this.set_shipping_fee_status_track = false;
                    this.deactivate_processing();
                }
            }).catch(function (err) {});
        },
        addProductReview: function addProductReview() {
            var _this18 = this;

            var payload = {
                product_reviewed_by: this.user.user_id || 1,
                product_review: this.reviews.review || "nill",
                product_id: this.product.product_id
            };
            service.addProductReview(this, payload).then(function (data) {
                if (data.body.status == 201) {
                    this.product.product_reviews = data.body.data;
                    this.reviews = {};
                }
            }).catch(function (err) {
                _this18.reviews = {};
            });
        },
        getProductInformation: function getProductInformation() {
            var _this19 = this;

            service.getProductInformation(this, this.product.product_id).then(function (response) {
                if (response.body.status == 200) {
                    _this19.product.product_information = response.body.data;
                }
            }).catch(function (err) {});
        },
        addProductInformation: function addProductInformation() {
            var _this20 = this;

            var payload = {
                product_info_detail: this.information.product_info_detail || "nill",
                product_info_type: "text",
                product_id: this.product.product_id
            };
            if (payload.product_information != "nill") {
                service.addProductInformation(this, payload).then(function (data) {
                    if (data.body.status == 201) {
                        this.product.product_information = data.body.data;
                        this.information = {};
                    }
                }).catch(function (err) {
                    _this20.details = {};
                });
            }
        },
        editProductInformation: function editProductInformation() {
            var _this21 = this;

            this.details.product_id = this.product.product_id;
            service.editProductInformation(this, 1, this.details).then(function (data) {
                if (data.body.status == 200) {
                    this.product.product_details = data.body.data;
                }
            }).catch(function (err) {
                _this21.service = {};
            });
        },
        deleteProductInformation: function deleteProductInformation(details) {
            var _this22 = this;

            var payload = {
                product_detail_id: details.product_detail_id
            };
            service.deleteProductDetail(this, details.product_detail_id, payload).then(function (data) {
                if (data.body.status == 200) {
                    this.product.product_details = data.body.data;
                }
            }).catch(function (err) {
                _this22.service = {};
            });
        },
        setProductDeliveryOption: function setProductDeliveryOption() {
            var _this23 = this;

            this.activate_processing();
            var payload = {
                business_id: this.sellpoint.business_id,
                business_product_id: this.product.product_id,
                business_product_delivery_fee: this.delivery_option.product_delivery_fee || 0,
                business_delivery_option_id: this.delivery_option.business_delivery_option_id
            };
            if (payload.business_product_delivery_option_price == 0) {
                toastr.warning("Delivery Charge not Added", 'Warning!');
            } else {
                if (payload.business_product_delivery_option != 0) {
                    service.setProductDeliveryOption(this, payload).then(function (data) {
                        if (data.body.status == 200 || data.body.status == 201) {
                            this.product.product_business_delivery_options = data.body.data;
                            this.delivery_option.edit_set = false;
                            this.setProductDeliveryInformation = false;

                            this.deactivate_processing();
                        } else {
                            this.deactivate_processing();
                        }
                    }).catch(function (err) {
                        _this23.delivery_option.edit_set = false;
                        _this23.setProductDeliveryInformation = false;
                        _this23.deactivate_processing();
                    });
                } else {
                    this.deactivate_processing();
                }
            }
        },
        deleteDeliveryFee: function deleteDeliveryFee(id) {
            var _this24 = this;

            var payload = {
                business_id: this.sellpoint.business_id,
                business_delivery_product: this.product.product_id
            };
            service.deleteDeliveryOption(this, id, payload).then(function (data) {
                if (data.body.status == 200) {
                    this.product.product_delivery_options = data.body.data;
                    this.delivery_option.edit_set = false;
                    this.delivery_option = {};
                }
            }).catch(function (err) {
                _this24.delivery_option = {};
            });
        },
        addDeliveryOption: function addDeliveryOption() {
            var _this25 = this;

            var payload = {
                business_delivery_state: this.delivery_option.state,
                business_delivery_city: this.delivery_option.city || 0,
                business_delivery_other_option: this.delivery_option.delivery_other_option || "nill",
                business_delivery_option_price: this.delivery_option.delivery_option_price || 0,
                business_delivery_product: this.product.product_id,
                business_id: this.sellpoint.business_id
            };
            if (payload.business_delivery_option_price == 0) {
                toastr.warning("Delivery Charge not Added", 'Warning!');
            } else {
                if (payload.business_delivery_option != 0 || payload.business_delivery_other_option != "nill") {
                    service.addDeliveryOption(this, payload).then(function (data) {
                        if (data.body.status == 201) {
                            this.product.product_delivery_options = data.body.data;
                            this.delivery_option = {};
                            this.addDeliveryInformation = false;
                        }
                    }).catch(function (err) {
                        _this25.delivery_option = {};
                    });
                } else {
                    toastr.warning("Select a delivery option", 'Warning!');
                }
            }
        },
        editDeliveryOption: function editDeliveryOption() {
            var _this26 = this;

            var payload = {
                business_id: this.sellpoint.business_id,
                business_delivery_product: this.product.product_id,
                business_delivery_state: this.delivery_option.business_delivery_state,
                business_delivery_city: this.delivery_option.city || 0,
                business_delivery_other_option: this.delivery_option.business_delivery_other_option || "nill",
                business_delivery_option_price: this.delivery_option.business_delivery_option_price || 0,
                business_delivery_option_id: this.delivery_option.business_delivery_option_id
            };

            if (payload.business_delivery_option_price == 0) {
                toastr.warning("Delivery Charge not Added", 'Warning!');
            } else {
                if (payload.business_delivery_option != 0 || payload.business_delivery_other_option != "nill") {
                    service.editDeliveryOption(this, payload).then(function (data) {
                        if (data.body.status == 200) {
                            this.product.product_delivery_options = data.body.data;
                            this.delivery_option.edit_set = false;
                            this.editDeliveryInformation = false;
                        }
                    }).catch(function (err) {
                        _this26.delivery_option.edit_set = false;
                        _this26.editDeliveryInformation = false;
                    });
                } else {}
            }
        },
        deleteDeliveryOption: function deleteDeliveryOption(id) {
            var _this27 = this;

            var payload = {
                business_id: this.sellpoint.business_id,
                business_delivery_product: this.product.product_id
            };
            service.deleteDeliveryOption(this, id, payload).then(function (data) {
                if (data.body.status == 200) {
                    this.product.product_delivery_options = data.body.data;
                    this.delivery_option.edit_set = false;
                    this.delivery_option = {};
                }
            }).catch(function (err) {
                _this27.delivery_option = {};
            });
        },
        setDiscountsAndCoupons: function setDiscountsAndCoupons() {
            var payload = {
                business_id: this.sellpoint.business_id,
                product_item_id: this.product_item.product_item_id,
                is_coupon_or_discount: this.discount_coupon.is_discount_coupon || 'D',
                coupon_business_category: 0,
                coupon_percentage: this.discount_coupon.discount_percentage,
                coupon_start_date: this.discount_coupon.discount_start_date,
                coupon_end_date: this.discount_coupon.discount_end_date
            };
            service.setDiscountsAndCoupons(this, payload).then(function (data) {
                if (data.body.status == 201) {
                    toastr.success("New Discount Set", 'Update!');
                    this.sellpoint.business_discounts_coupons = data.body.data;
                    this.setDiscount = false;
                }
            }).catch(function (err) {});
        },
        editDiscountsAndCoupons: function editDiscountsAndCoupons() {
            this.discount_coupon.business_id = this.sellpoint.business_id;
            service.editDiscountsAndCoupons(this, this.discount_coupon).then(function (data) {
                if (data.body.status == 200) {
                    this.editDiscount = false;
                }
            }).catch(function (err) {});
        },
        deactivateDiscountsAndCoupons: function deactivateDiscountsAndCoupons(payload) {
            payload.business_id = this.sellpoint.business_id;
            service.deactivateDiscountsAndCoupons(this, payload).then(function (data) {
                if (data.body.status == 200) {
                    payload.discount_status_id = 6;
                }
            }).catch(function (err) {});
        },
        onFileChange: function onFileChange(e, type, data_id) {
            var _this28 = this;

            var files = e.target.files || e.dataTransfer.files;
            if (files.length) {
                var formData = new FormData();
                formData.append('photo', files[0]);
                formData.append('data_id', data_id);
                formData.append('data_type', type);


                this.imageForm = formData;
                service.uploadDataPhoto(this, formData).then(function (data) {
                    if (data.body.status == 200) {
                        if (type == "products") {
                            _this28.getProductImages();
                            if (_this28.editProductItemGroupPanel) {
                                _this28.product_item_group.product_item_group_image = data.body.data_id;
                            }
                        }

                        if (type == "product_information") {
                            _this28.getProductInformation();
                        }
                    }
                }).catch(function (err) {
                    if (err) {}
                });
            }
        },
        getSellpointCategories: function getSellpointCategories() {
            var _this29 = this;

            service.getBusinessByUserName(this, this.product.product_business_ownername).then(function (response) {
                if (response.body.status == 200) {
                    var sellpoint = response.body.data;
                    service.getBusinessCategories(_this29, sellpoint.business_id).then(function (response) {
                        if (response.body.status == 200) {
                            _this29.sellpoint_categories = response.body.data;
                        }
                    }).catch(function (err) {});
                }
            }).catch(function (err) {});
        },
        handleScrollFix: function handleScrollFix(event) {
            var x = document.getElementById("menuHeader");

            var isMobile = false;
            if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4))) {
                isMobile = true;
            }
            if (isMobile) {
                if (document.documentElement.scrollTop >= 300) {
                    x.style.display = "block";
                } else {
                    x.style.display = "none";
                }
            }
        }
    },
    mounted: function mounted() {},
    created: function created() {
        if (this.$route.query.setup == "yes") {
            this.new_added = true;
        }
        this.setProduct();
        this.getStates();
        this.tab_view['descr'] = true;
    },
    destroyed: function destroyed() {}
});

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_validation__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_product_ProductForm_vue__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_product_ProductForm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_product_ProductForm_vue__);






var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();
var validator = new __WEBPACK_IMPORTED_MODULE_1__services_validation__["a" /* default */]();
/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'SellpointTemplate',
    data: function data() {
        return {
            sellpoint: {}
        };
    },

    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue___default.a,
        'product-form': __WEBPACK_IMPORTED_MODULE_4__components_product_ProductForm_vue___default.a
    },
    methods: {},
    created: function created() {}
});

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_posts_newgallery_vue__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_posts_newgallery_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_posts_newgallery_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_posts_newproductgallery_vue__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_posts_newproductgallery_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_posts_newproductgallery_vue__);






var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Sellpoint',
    data: function data() {
        return {
            user: {},
            market: {},
            sellpoint: {},
            categories: {},
            galleria: {},
            gallery: {},
            gallery_post: {},
            gallery_post_set_image: {},
            post: {},
            products: {},
            product: {},
            productMain: {},
            productItem: {},
            img_sellpoint_url: service.imageSellpointsURL,
            img_product_url: service.imageProductsURL,
            loggedIn: false,
            edit_mode: false,
            loading: true,
            online: false,
            place_order: false,
            ordered_product: {},
            ordered_product_item: {},
            swipe_index: 0,

            data_error_message: "",
            data_success_message: "",
            payment_successful: false,
            payment_successful_message: "",
            payment_payer_name: "",
            payment_payer_email: "",
            payment_payer_phone: "",
            payment_service: "",

            addPanel: false,
            business_load_error_msg: "",
            newLookbookForm: false,
            newProductLookbookForm: false,
            max_plan_lookbooks: 0,
            max_plan_lookbook_posts: 0,
            total_lookbooks_added: 0,
            can_add_more_lookbook: false,
            can_add_product_lookbook: false,
            addNewPost: false,
            file_info: {},
            refresh_button: false,
            disable_btn: false,
            action_loading: false,
            default_banner_image: "https://res.cloudinary.com/diprbfy7s/image/upload/v1550754799/businesses_files/sp-default-banner.jpg",
            set_gallery_banner_image: '',

            gallery_view: false,

            swiperOption: {
                pagination: {
                    el: '.swiper-pagination'
                }
            },
            catvw: false
        };
    },


    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue___default.a,
        'add-lookbook': __WEBPACK_IMPORTED_MODULE_3__components_posts_newgallery_vue___default.a,
        'add-product-lookbook': __WEBPACK_IMPORTED_MODULE_4__components_posts_newproductgallery_vue___default.a
    },
    computed: {
        total: function total() {
            var total = 0;
            for (var i = 0; i < this.items.length; i++) {
                total += this.items[i].product_price;
            }
            return total;
        }
    },
    methods: {
        show_cat: function show_cat() {
            document.getElementById("cat-nav").style.display = "block";
            this.catvw = true;
        },
        hide_cat: function hide_cat() {
            document.getElementById("cat-nav").style.display = "none";
            this.catvw = false;
        },
        mobileSideNavToggle: function mobileSideNavToggle(action) {
            if (action == "open") {
                var isMobile = window.matchMedia("only screen and (max-width: 760px)").matches;

                if (isMobile) {
                    document.getElementById("mobileSideNav").style.width = "100%";
                } else {
                    document.getElementById("mobileSideNav").style.width = "50%";
                }
            }
            if (action == "close") {
                document.getElementById("mobileSideNav").style.width = "0";
            }
        },
        activate_processing: function activate_processing() {
            this.disable_btn = true;
            this.action_loading = true;
        },
        deactivate_processing: function deactivate_processing() {
            this.disable_btn = false;
            this.action_loading = false;
        },
        checkIfVideo: function checkIfVideo(url) {
            if (url != undefined) {
                var ext = url.split('.').pop();
                if (service.video_exts.includes(ext)) {
                    return true;
                } else {
                    return false;
                }
            }
        },
        addComponent: function addComponent(attr1, attr2) {

            this.addPanel = true;

            if (attr1 == "add-new-lookbook") {
                this.newLookbookForm = true;
            }
            if (attr1 == "add-new-product-lookbook") {
                this.newProductLookbookForm = true;
            }
            if (attr1 == "add-new-product-post") {
                this.$router.push("/" + this.$route.params.id + "/" + this.gallery.gallery_posts_group_url_name);

                this.newProductLookbookForm = true;
            }
            if (attr1 == "add-new-post") {
                this.addNewPost = true;

                this.gallery = attr2;
            }

            if (this.gallery_view) {
                this.gallery_view = false;

                var self = this;
                setTimeout(function () {
                    self.mobileSideNavToggle("open");
                }, 150);
            }

            var top = document.getElementById("addPanelView").offsetTop;
            window.scrollTo(0, top);
        },
        setComponent: function setComponent(attr1, attr2) {
            if (attr1 == "refresh-store") {
                this.getGalleryPosts();
            }
            if (attr1 == "close-gallery-view") {
                this.gallery_view = false;
            }
        },
        reset: function reset() {
            this.addPanel = false, this.addNewPost = false;
            this.newLookbookForm = false;
            this.newProductLookbookForm = false;
            this.data_error_message = "";
            this.data_success_message = "";
        },
        preset: function preset() {
            var _this = this;

            this.loading = true;
            var credentials = {
                session_key: localStorage.getItem("sp_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.user.user_id = element.user_id;
                            this.user.user_name = localStorage.getItem("sp_user");
                            this.loggedIn = true;
                            this.is_editing();
                        }, _this);
                    } else {}
                }).catch(function (err) {
                    if (err) {}
                });
            } else {}
        },
        is_editing: function is_editing() {
            var _this2 = this;

            if (this.user.user_id != "") {
                var payload = {
                    validate_user: this.user.user_id,
                    validate_business: this.sellpoint.business_id
                };
                service.can_edit(this, payload).then(function (response) {
                    if (response.body.status == 200) {
                        _this2.edit_mode = true;
                    } else {
                        _this2.edit_mode = false;
                    }
                }).catch(function (err) {
                    if (err) {}
                });
            }
        },
        setGallery: function setGallery() {
            var _this3 = this;

            this.loading = true;
            service.getGallerySearch(this, this.$route.params.id).then(function (response) {
                if (response.body.status == 200) {
                    _this3.gallery = response.body.data;

                    _this3.loading = false;
                }
            }).catch(function (err) {});
        },
        setSellpoint: function setSellpoint() {
            var _this4 = this;

            this.loading = true;
            service.getAppBusinessByUserName(this, this.$route.params.id).then(function (response) {
                if (response.body.status == 200) {
                    _this4.sellpoint = response.body.data;
                    document.title = _this4.sellpoint.business_name + " | SP";

                    _this4.getSellpointProducts();
                    if (_this4.sellpoint.business_banner_image == _this4.default_banner_image || _this4.sellpoint.business_banner_image == 'error') {
                        _this4.set_gallery_banner_image = service.general_banner_image;
                    } else {
                        _this4.set_gallery_banner_image = _this4.sellpoint.business_banner_image;
                    }

                    if (_this4.sellpoint.business_market_subscription_name == 'Bird Plan') {
                        _this4.max_plan_lookbooks = 2;
                        _this4.max_plan_lookbook_posts = 5;
                    }
                    if (_this4.sellpoint.business_market_subscription_name == 'Mid Bird Plan') {
                        _this4.max_plan_lookbooks = 10;
                        _this4.max_plan_lookbook_posts = 50;
                    }
                    if (_this4.sellpoint.business_market_subscription_name == 'Max Bird Plan') {
                        _this4.max_plan_lookbooks = 50;
                        _this4.max_plan_lookbook_posts = 50;
                        _this4.can_add_product_lookbook = true;
                    }

                    var self = _this4;
                    setTimeout(function () {
                        self.getGalleryPosts();
                    }, 3000);
                    _this4.preset();
                    _this4.loading = false;
                } else {
                    _this4.business_load_error_msg = "Sorry, this Business Information could not be found.";
                }
            }).catch(function (err) {
                _this4.loading = false;
            });
        },
        getProductsInBusinessCategories: function getProductsInBusinessCategories() {
            var _this5 = this;

            this.loading = true;
            service.getProductsInBusinessCategories(this, this.sellpoint.business_id).then(function (response) {
                if (response.body.status == 200) {
                    _this5.categories = response.body.data;
                }
                _this5.loading = false;
            }).catch(function (err) {
                _this5.loading = false;
            });
        },
        getGalleryPosts: function getGalleryPosts() {
            var _this6 = this;

            this.loading = true;
            service.getPointGalleryPosts(this, this.sellpoint.business_id, 0, this.max_plan_lookbooks, 0, this.max_plan_lookbook_posts).then(function (response) {
                _this6.galleria = response.body.data;

                _this6.total_lookbooks_added = response.body.total_data;

                if (_this6.total_lookbooks_added < _this6.max_plan_lookbooks) {
                    _this6.can_add_more_lookbook = true;
                }

                _this6.loading = false;
            }).catch(function (err) {
                _this6.loading = false;
            });
        },
        getSellpointProducts: function getSellpointProducts() {
            var _this7 = this;

            this.loading = true;
            service.getBusinessProducts(this, this.sellpoint.business_id).then(function (response) {
                if (response.body.status == 200) {
                    _this7.products = response.body.data;
                    _this7.loading = false;
                }
            }).catch(function (err) {});
        },
        getPostsInGallery: function getPostsInGallery(gallery) {
            this.gallery = gallery;
            this.gallery_post = gallery.gallery_posts_group_posts[0];


            if (this.gallery_post.gallery_post_media[0]) {
                this.gallery_post_set_image = this.gallery_post.gallery_post_media[0];
            } else {
                this.gallery_post_set_image = {};
            }


            this.gallery_view = true;
        },
        getCategoryProducts: function getCategoryProducts(category) {
            this.loading = true;
            this.product = category.business_category_products[0];
            this.products = category.business_category_products;
            $('#quickviewModal').modal('show');
            this.loading = false;
        },
        getCategoryProductsXX: function getCategoryProductsXX(category) {
            var _this8 = this;

            this.loading = true;
            var self = this;
            service.getCategoryProducts(this, category).then(function (response) {
                if (response.body.status == 200) {
                    _this8.products = response.body.data;

                    var count = 0;
                    _this8.products.forEach(function (element) {
                        count++;
                        if (count == 1) {
                            _this8.product = element;
                            $('#quickviewModal').modal('show');
                        }
                    });
                    _this8.loading = false;
                }
            }).catch(function (err) {
                _this8.loading = false;
            });
        },
        showPost: function showPost(post) {
            this.gallery_post = post;

            if (this.gallery_post.gallery_post_media[0]) {
                this.gallery_post_set_image = this.gallery_post.gallery_post_media[0];
            } else {
                this.gallery_post_set_image = {};
            }
        },
        showPostImage: function showPostImage(post_image) {
            this.gallery_post_set_image = post_image;
        },
        showProduct: function showProduct(product) {
            this.product = product;
        },
        addPostToGallery: function addPostToGallery() {
            var _this10 = this;

            this.activate_processing();

            var credentials = {
                gallery_new_group: false,
                gallery_post_group: this.gallery.gallery_posts_group_id,
                gallery_post_caption: this.post.post_caption || "nill",
                gallery_post_details: this.post.post_details
            };

            var navi = this.$router;
            if (credentials.gallery_post_details != undefined) {
                service.addGallery(this, credentials).then(function (data) {
                    var _this9 = this;

                    if (data.body.status == 201) {
                        this.data_success_message = "Post Created";

                        this.post = data.body.data;

                        this.imageForm.append("data_id", this.post.post_id);
                        this.imageForm.append("data_type", "gallery_media");
                        service.uploadDataPhoto(this, this.imageForm).then(function (data) {
                            if (data.body.status == 200) {
                                location.reload(true);
                                _this9.gallery = data.body.data_gallery;
                                _this9.addNewPost = false;
                            }
                            _this9.deactivate_processing();
                        }).catch(function (err) {
                            if (err) {}

                            _this9.data_error_message = "Something went wrong";
                            _this9.deactivate_processing();
                        });

                        var self = this;
                        setTimeout(function () {
                            location.reload(true);
                        }, 2000);
                    }
                }).catch(function (err) {
                    if (err) {
                        _this10.data_error_message = "Something went wrong";

                        _this10.disable_btn = false;
                    }
                });
            } else {
                toastr.error('Kindly fill all fields', 'Warning!');
                this.disable_btn = false;
            }
        },
        onFileChange: function onFileChange(e) {
            var files = e.target.files || e.dataTransfer.files;
            if (files.length) {
                this.file_info = files;
                var formData = new FormData();
                formData.append('photo', files[0]);
                this.imageForm = formData;
            }
        },
        onFileChangeBannerImage: function onFileChangeBannerImage(e, type) {
            var _this11 = this;

            this.activate_processing();
            var files = e.target.files || e.dataTransfer.files;
            if (files.length) {
                var formData = new FormData();
                formData.append('photo', files[0]);
                formData.append('data_id', this.sellpoint.business_id);
                formData.append('data_type', type);
                service.uploadBusinessDataPhoto(this, formData).then(function (data) {
                    if (data.body.status == 200) {
                        if (type == "business_banner_image") {
                            _this11.sellpoint.business_banner_image = data.body.data;
                            _this11.set_gallery_banner_image = _this11.sellpoint.business_banner_image;
                        }
                        if (type == "business_brand_image") {
                            _this11.sellpoint.business_brand_image = data.body.data;
                        }

                        var self = _this11;
                        setTimeout(function () {
                            self.deactivate_processing();
                            self.mobileSideNavToggle('close');

                            self.loading = true;
                            setTimeout(function () {
                                self.loading = false;
                            }, 1200);
                        }, 1000);
                    } else {
                        _this11.data_error_message = "Could not update, something went wrong. Please try again";
                        _this11.deactivate_processing();
                    }
                }).catch(function (err) {
                    _this11.data_error_message = "Could not update, something went wrong. Please try again";
                    _this11.deactivate_processing();
                });
            }
        },
        manageLookbook: function manageLookbook() {
            var _this12 = this;

            this.disable_btn = true;

            var credentials = {
                session_key: localStorage.getItem("sp_token"),
                request_url: service.app_url,
                request_from: service.app_name,
                request_status: "REQUESTING...",
                request: this.sellpoint.business_username + '/g/' + this.gallery.gallery_posts_group_url_name
            };
            if (credentials.session_key != null) {
                service.sessionSync(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var ref = response.body.data;
                        window.location.href = service.sp_url + '/manage/' + ref;
                    } else {
                        _this12.disable_btn = false;
                    }
                }).catch(function (err) {
                    if (err) {
                        _this12.disable_btn = false;
                    }
                });
            }
        },
        addToCart: function addToCart(productMain, productItem) {
            this.productItem = {};
            var cart_index = this.cart.findIndex(function (c) {
                return c.product_item_id === productItem.product_item_id;
            });
            if (cart_index < 0) {
                this.productMain = productMain;
                this.productItem = productItem;
                this.productItem._id = this.productItem.product_item_id;
                this.productItem.is_product_in_cart = true;

                if (this.productItem.product_item_order_quantity == undefined) {
                    this.productItem.product_item_order_quantity = 1;
                }
                this.productItem.product_main_id = this.productMain.product_id;
                this.productItem.product_business = this.productMain.product_business_ownername;
                this.productItem.product_name = this.productMain.product_name;
                this.productItem.product_url_name = this.productMain.product_url_name;
                this.productItem.product_url = this.productMain.product_business_ownername + "/" + this.productMain.product_url_name;
                this.$store.commit(ADD_TO_CART, this.productItem);
            } else {}
        },
        removeFromCart: function removeFromCart(payload) {
            this.$store.commit(REMOVE_FROM_CART, payload);
        },
        placeOrder: function placeOrder(product, product_item) {
            this.ordered_product = product;
            this.ordered_product_item = product_item;
            this.place_order = true;
        },
        resetOptions: function resetOptions() {
            this.ordered_product = {};
            this.ordered_product_item = {};
            this.total_price = 0;
            this.place_order = false;
        },
        processPayment: function processPayment() {
            var data_test = false;
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            var email_test = re.test(String(this.payment_payer_email).toLowerCase());
            var re_phone = /^\d{4}\d{3}\d{4}$/;
            var phone_test = re_phone.test(String(this.payment_payer_phone).toLowerCase());
            if (email_test == false || this.payment_payer_name == " " || phone_test == false) {
                data_test = false;
                this.data_error_message = "Some errors were found in your form, please fill correctly";
            } else {
                data_test = true;
                this.data_error_message = "";
            }
            if (data_test) {
                this.payment_service = "HungrillvilleKitchen Order - " + this.ordered_product.product_name + "(" + this.ordered_product_item.product_item_price + ")";
                var obj = this;

                var handler = PaystackPop.setup({
                    key: 'pk_test_1b578e2fe82975a4ec8a79e5d1a387c953fd2c3e',
                    Name: this.payment_payer_name,

                    email: this.payment_payer_email,
                    amount: Math.round(this.ordered_product_item.product_item_price * 100),
                    ref: "HUNGLOG" + Math.random(),
                    metadata: {
                        custom_fields: [{
                            display_name: "HungrillvilleKitchen Order",
                            variable_name: "",
                            value: this.payment_payer_name + " - " + this.payment_payer_phone + " - ORDER - " + this.ordered_product.product_name
                        }, {
                            display_name: "Service",
                            variable_name: "service_type",
                            value: this.ordered_product.product_name
                        }]
                    },

                    callback: function callback(response) {
                        obj.updatePayment(response.trxref);
                    },
                    onClose: function onClose() {
                        alert('window closed');
                    }
                });
                handler.openIframe();
            }
        },
        updatePayment: function updatePayment(payment_ref) {
            var navi = this.$router;

            var payer_name = this.payment_payer_name;
            this.data = {};

            this.payment_successful = true;
            this.payment_successful_message = "Hi " + payer_name + ", Your Payment was successful, we would proceed to prepare your order. Thank You.";
        },
        handleResize: function handleResize() {
            this.$refs.swipe.reset();
        }
    },
    mounted: function mounted() {
        this.preset();
    },
    destroyed: function destroyed() {},

    created: function created() {
        if (this.$route.params.idg) {
            this.$router.push('/' + this.$route.params.id);
        }
        if (this.addPanel) {
            this.refresh_button = true;
        }
        this.reset();
        this.setSellpoint();
    }
});

/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_templates_rightsidebar_vue__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_templates_rightsidebar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_templates_rightsidebar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_templates_leftsidebar_vue__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_templates_leftsidebar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_templates_leftsidebar_vue__);






var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();
/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Home',
    data: function data() {
        return {
            user: {},
            market: {},
            products: {},
            product: {},
            img_sellpoint_url: service.imageSellpointsURL,
            img_product_url: service.imageProductsURL,
            loggedIn: false,
            loading: true
        };
    },


    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue___default.a,
        'right-sidebar': __WEBPACK_IMPORTED_MODULE_3__components_templates_rightsidebar_vue___default.a,
        'left-sidebar': __WEBPACK_IMPORTED_MODULE_4__components_templates_leftsidebar_vue___default.a
    },
    computed: {
        total: function total() {
            var total = 0;
            for (var i = 0; i < this.items.length; i++) {
                total += this.items[i].product_price;
            }
            return total;
        }
    },
    methods: {
        preset_xtra: function preset_xtra() {
            var _this = this;

            var credentials = {
                session_key: localStorage.getItem("sp_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.user.user_id = element.user_id;
                            this.user.user_name = localStorage.getItem("sp_user");
                            this.loggedIn = true;
                        }, _this);
                    } else {}
                }).catch(function (err) {
                    if (err) {}
                });
            } else {}
        },
        preset: function preset() {
            this.loading = true;
            var self = this;
            localforage.getItem(service.udb_name, function (err, value) {
                if (value != undefined) {
                    self.user.user_id = value.user_id;
                    self.loggedIn = true;
                    self.loading = false;
                } else {}
            });
        },
        setMarketRemote: function setMarketRemote() {
            var _this2 = this;

            service.getBusinessByUserName(this, service.market_app_name).then(function (response) {
                if (response.body.status == 200) {
                    _this2.market = response.body.data;
                    _this2.loading = false;
                }
            }).catch(function (err) {});
        }
    },
    created: function created() {
        this.preset();
        this.setMarketRemote();
    }
});

/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Account__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Account___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_Account__);


/* harmony default export */ __webpack_exports__["a"] = ({
  path: '/account',
  component: __WEBPACK_IMPORTED_MODULE_0__pages_Account___default.a,
  children: []
});

/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Buypoint__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Buypoint___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_Buypoint__);


/* harmony default export */ __webpack_exports__["a"] = ({
  path: '/buypoint',
  name: 'Buypoint',
  component: __WEBPACK_IMPORTED_MODULE_0__pages_Buypoint___default.a

});

/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_CreateSellpoint__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_CreateSellpoint___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_CreateSellpoint__);


/* harmony default export */ __webpack_exports__["a"] = ({
  path: '/create',
  name: 'CreateSellpoint',
  component: __WEBPACK_IMPORTED_MODULE_0__pages_CreateSellpoint___default.a
});

/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Demos__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Demos___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_Demos__);


/* harmony default export */ __webpack_exports__["a"] = ({
  path: '/demos',
  name: 'demos',
  component: __WEBPACK_IMPORTED_MODULE_0__pages_Demos___default.a
});

/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Home__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_Home__);


/* harmony default export */ __webpack_exports__["a"] = ({
  path: '/',
  name: 'Home',
  component: __WEBPACK_IMPORTED_MODULE_0__pages_Home___default.a,
  children: [{
    path: 'go/:menu',
    name: 'Home2',
    component: __WEBPACK_IMPORTED_MODULE_0__pages_Home___default.a
  }]
});

/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Login__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_Login__);


/* harmony default export */ __webpack_exports__["a"] = ({
  path: '/login',
  name: 'login',
  component: __WEBPACK_IMPORTED_MODULE_0__pages_Login___default.a
});

/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Manage__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Manage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_Manage__);


/* harmony default export */ __webpack_exports__["a"] = ({
  path: '/manage/:id',
  component: __WEBPACK_IMPORTED_MODULE_0__pages_Manage___default.a,
  children: [{
    path: '',
    name: 'Manage',
    component: __WEBPACK_IMPORTED_MODULE_0__pages_Manage___default.a
  }]
});

/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Purchase__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Purchase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_Purchase__);


/* harmony default export */ __webpack_exports__["a"] = ({
  path: '/purchase',
  name: 'purchase',
  component: __WEBPACK_IMPORTED_MODULE_0__pages_Purchase___default.a
});

/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Register__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Register___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_Register__);


/* harmony default export */ __webpack_exports__["a"] = ({
  path: '/register',
  name: 'register',
  component: __WEBPACK_IMPORTED_MODULE_0__pages_Register___default.a
});

/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Search__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Search___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_Search__);


/* harmony default export */ __webpack_exports__["a"] = ({
    path: '/search',
    name: 'Search',
    component: __WEBPACK_IMPORTED_MODULE_0__pages_Search___default.a
});

/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Sellpoint_Product__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Sellpoint_Product___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_Sellpoint_Product__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_Sellpoint_Sellpoint__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_Sellpoint_Sellpoint___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__pages_Sellpoint_Sellpoint__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_Sellpoint_SellpointTemplate__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_Sellpoint_SellpointTemplate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__pages_Sellpoint_SellpointTemplate__);





/* harmony default export */ __webpack_exports__["a"] = ({
  path: '/:id',
  component: __WEBPACK_IMPORTED_MODULE_2__pages_Sellpoint_SellpointTemplate___default.a,
  children: [{
    path: '',
    name: 'Sellpoint',
    component: __WEBPACK_IMPORTED_MODULE_1__pages_Sellpoint_Sellpoint___default.a
  }, {
    path: ':id1',
    name: 'Product',
    component: __WEBPACK_IMPORTED_MODULE_0__pages_Sellpoint_Product___default.a
  }, {
    path: 'g/:idg',
    name: 'Gallery',
    component: __WEBPACK_IMPORTED_MODULE_1__pages_Sellpoint_Sellpoint___default.a
  }]
});

/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Timeline__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Timeline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_Timeline__);


/* harmony default export */ __webpack_exports__["a"] = ({
    path: '/timeline',
    name: 'Timeline',
    component: __WEBPACK_IMPORTED_MODULE_0__pages_Timeline___default.a
});

/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var _class = function () {
    function _class() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, _class);
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(_class, [{
        key: 'formatCurrency',
        value: function formatCurrency(currency) {
            currency = Intl.NumberFormat('en-US', { style: 'currency', currency: 'NGN' }).format(currency);
            currency = currency.replace("₦", "");
            currency = currency.replace("NGN", "");
            currency = currency.replace(".00", "");
            return currency.replace(/\s/g, '');
        }
    }]);

    return _class;
}();

/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return sellpointActions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return productActions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types__ = __webpack_require__(8);





var sellpointActions = {
  allSellpoints: function allSellpoints(_ref) {
    var commit = _ref.commit;

    commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["a" /* ALL_SELLPOINTS */]);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* API_BASE */] + '/businesses', {
      headers: {
        'Api-Token': this.apiToken
      }
    }).then(function (response) {
      commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["b" /* ALL_SELLPOINTS_SUCCESS */], response.data);
    });
  }
};

var productActions = {
  allProducts: function allProducts(_ref2) {
    var commit = _ref2.commit;

    commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["c" /* ALL_PRODUCTS */]);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* API_BASE */] + '/products', {
      headers: {
        'Api-Token': this.apiToken
      }
    }).then(function (response) {
      commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["d" /* ALL_PRODUCTS_SUCCESS */], response.data);
    });
  }
};

/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return sellpointGetters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return productGetters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return cartGetters; });

var sellpointGetters = {
  allSellpoints: function allSellpoints(state, getters) {
    return state.sellpoints;
  },

  sellpointById: function sellpointById(state, getters) {
    return function (id) {
      if (getters.allSellpoints.length > 0) {
        return getters.allSellpoints.filter(function (p) {
          return p._id === id;
        })[0];
      } else {
        return state.sellpoint;
      }
    };
  }
};

var productGetters = {
  allProducts: function allProducts(state, getters) {
    return state.products;
  },

  productById: function productById(state, getters) {
    return function (id) {
      if (getters.allProducts.length > 0) {
        return getters.allProducts.filter(function (p) {
          return p._id === id;
        })[0];
      } else {
        return state.product;
      }
    };
  }
};

var cartGetters = {
  cartProducts: function cartProducts(state) {
    return state.added.map(function (_ref) {
      var id = _ref.id,
          quantity = _ref.quantity;

      var product_item = state.all.find(function (p) {
        return p._id === id;
      });

      return {
        name: product.name,
        price: product.price,
        quantity: quantity
      };
    });
  }
};

/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return sellpointMutations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return productMutations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return cartMutations; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(8);


var _sellpointMutations, _productMutations, _cartMutations;



var sellpointMutations = (_sellpointMutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_sellpointMutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* ALL_SELLPOINTS */], function (state) {
  state.showLoader = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_sellpointMutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["b" /* ALL_SELLPOINTS_SUCCESS */], function (state, payload) {
  state.showLoader = false;
  state.sellpoints = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_sellpointMutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["e" /* ERROR_MSG */], function (state, payload) {}), _sellpointMutations);

var productMutations = (_productMutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_productMutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["c" /* ALL_PRODUCTS */], function (state) {
  state.showLoader = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_productMutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["d" /* ALL_PRODUCTS_SUCCESS */], function (state, payload) {
  state.showLoader = false;
  state.products = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_productMutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["f" /* PRODUCT_BY_ID */], function (state) {
  state.showLoader = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_productMutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["g" /* PRODUCT_BY_ID_SUCCESS */], function (state, payload) {
  state.showLoader = false;
  state.product = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_productMutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["e" /* ERROR_MSG */], function (state, payload) {}), _productMutations);

var cartMutations = (_cartMutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_cartMutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["h" /* VIEW_CART */], function (state) {
  return state.cart;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_cartMutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["i" /* ADD_TO_CART */], function (state, payload) {
  state.cart.push(payload);
  state.cart = state.cart;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_cartMutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["j" /* REMOVE_FROM_CART */], function (state, payload) {
  var index = state.cart.findIndex(function (p) {
    return p._id === payload;
  });
  state.cart.splice(index, 1);
}), _cartMutations);

/***/ }),
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 190 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 191 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 192 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 193 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 194 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 195 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 196 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 197 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 198 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 199 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 200 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 201 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 202 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 203 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 204 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 205 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 206 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 207 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 208 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 209 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 210 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 211 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 212 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 213 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 214 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 215 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 216 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(212)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(98),
  /* template */
  __webpack_require__(273),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(198)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(99),
  /* template */
  __webpack_require__(256),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(102),
  /* template */
  __webpack_require__(248),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(108),
  /* template */
  __webpack_require__(265),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(206)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(111),
  /* template */
  __webpack_require__(267),
  /* scopeId */
  "data-v-7118a3a8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(204)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(112),
  /* template */
  __webpack_require__(262),
  /* scopeId */
  "data-v-59d77e7e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(195)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(113),
  /* template */
  __webpack_require__(253),
  /* scopeId */
  "data-v-1d9df4be",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(208)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(114),
  /* template */
  __webpack_require__(269),
  /* scopeId */
  "data-v-74fe042f",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(203)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(115),
  /* template */
  __webpack_require__(261),
  /* scopeId */
  "data-v-555a7296",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(205)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(116),
  /* template */
  __webpack_require__(264),
  /* scopeId */
  "data-v-68cfb168",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(191)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(119),
  /* template */
  __webpack_require__(249),
  /* scopeId */
  "data-v-1384c49c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(192)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(121),
  /* template */
  __webpack_require__(250),
  /* scopeId */
  "data-v-14c2e22c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(194)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(122),
  /* template */
  __webpack_require__(252),
  /* scopeId */
  "data-v-193c5c52",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(213)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(123),
  /* template */
  __webpack_require__(274),
  /* scopeId */
  "data-v-9b5389d0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(215)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(124),
  /* template */
  __webpack_require__(276),
  /* scopeId */
  "data-v-b6bb411e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(199)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(125),
  /* template */
  __webpack_require__(257),
  /* scopeId */
  "data-v-31852af4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(216)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(126),
  /* template */
  __webpack_require__(277),
  /* scopeId */
  "data-v-b8539b90",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(193)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(127),
  /* template */
  __webpack_require__(251),
  /* scopeId */
  "data-v-1863395a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(209)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(128),
  /* template */
  __webpack_require__(270),
  /* scopeId */
  "data-v-7a9555c2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(214)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(129),
  /* template */
  __webpack_require__(275),
  /* scopeId */
  "data-v-b29a9a06",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(189)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(130),
  /* template */
  __webpack_require__(246),
  /* scopeId */
  "data-v-05e19f26",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(202)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(131),
  /* template */
  __webpack_require__(260),
  /* scopeId */
  "data-v-51ef2fe8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(190)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(132),
  /* template */
  __webpack_require__(247),
  /* scopeId */
  "data-v-0f1bf178",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 246 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-wrap",
    attrs: {
      "id": "wrap"
    }
  }, [_c('component-header'), _vm._v(" "), _c('router-view'), _vm._v(" "), (!this.$route.params.id1) ? _c('component-footer') : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 247 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-wrap",
    attrs: {
      "id": "wrap"
    }
  }, [_c('component-header'), _vm._v(" "), _c('div', {
    staticClass: "pager"
  }, [_c('div', {
    staticClass: "container"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "loading-md"
  })]) : _c('div', [_c('div', {
    staticClass: "row grid-1"
  }, [_vm._l((_vm.market.business_markets), function(bz, index) {
    return _c('div', {
      staticClass: "card col-xs-6",
      staticStyle: {
        "height": "40vh",
        "padding": "0"
      }
    }, [_c('a', {
      staticClass: "card-link",
      staticStyle: {
        "text-decoration": "none",
        "color": "inherit"
      },
      attrs: {
        "href": '/' + bz.business_username
      }
    }, [_c('div', {
      staticStyle: {
        "height": "80%",
        "width": "100%",
        "background-position": "center",
        "background-size": "contain"
      },
      style: ({
        'background-image': 'url(' + bz.business_banner_image + ')'
      })
    }), _vm._v(" "), _c('p', [_vm._v(_vm._s(bz.business_name))])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "card col-xs-6",
    staticStyle: {
      "height": "40vh",
      "padding": "0"
    }
  }, [_c('a', {
    staticClass: "card-link",
    staticStyle: {
      "text-decoration": "none",
      "color": "inherit"
    },
    attrs: {
      "href": '#'
    }
  }, [_c('div', {
    staticStyle: {
      "height": "80%",
      "width": "100%",
      "background-position": "center",
      "background-size": "contain",
      "background-image": "url('/static/assets/images/showslive.jpg')"
    }
  }), _vm._v(" "), _c('p', [_vm._v("Events")])])])], 2)])])]), _vm._v(" "), _c('component-footer')], 1)
},staticRenderFns: []}

/***/ }),
/* 248 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "products"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._v("\n     vbvbvb " + _vm._s(_vm.products) + "bvbvbv\n    ")])])])
},staticRenderFns: []}

/***/ }),
/* 249 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    attrs: {
      "id": "wrap"
    }
  }, [_c('component-header'), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('component-footer')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('section', {
    staticClass: "shop-page padding-top-100 padding-bottom-100"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h3', [_vm._v("setting up your account....")])])])])
}]}

/***/ }),
/* 250 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pager"
  }, [_c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h3', {
    staticClass: "on-dark",
    staticStyle: {
      "margin-top": "-0.5px",
      "font-size": "18px"
    }
  }, [_vm._v("Shopping Cart")]), _vm._v(" "), (_vm.loading) ? _c('div', {
    attrs: {
      "id": "loader"
    }
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('section', {
    staticClass: "chart-page"
  }, [_c('div', {
    staticClass: "container"
  }, [(!_vm.cart.length) ? _c('div', {
    staticClass: "card-center chart-card",
    staticStyle: {
      "margin-top": "-1.4em"
    }
  }, [_vm._m(1)]) : _c('div', {
    staticClass: "col-sm-12 chart-card"
  }, [_c('cart-widget')], 1)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "position-center-center"
  }, [_c('div', {
    staticClass: "ldr"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('h5', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "center"
    }
  }, [_vm._v("Your cart is sad and empty,")]), _vm._v(" "), _c('a', {
    staticClass: "btn",
    staticStyle: {
      "padding": "0.5em",
      "background": "rgb(252, 16, 75)",
      "color": "#ffffff"
    },
    attrs: {
      "href": "/shops"
    }
  }, [_vm._v("Start Buying")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "font-size": "18px",
      "margin-top": "6px"
    }
  }, [_c('a', {
    staticStyle: {
      "color": "rgb(252, 16, 75)"
    },
    attrs: {
      "href": "login"
    }
  }, [_vm._v("Login")]), _vm._v(" to see products you added to your cart")])])
}]}

/***/ }),
/* 251 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-wrap",
    attrs: {
      "id": "wrap"
    }
  }, [_c('component-header'), _vm._v(" "), _c('div', {
    staticClass: "pager"
  }, [_c('div', {
    staticClass: "container card-box",
    staticStyle: {
      "height": "100vh",
      "padding": "2em 3em"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "login"
    }
  }, [_c('p', {
    staticClass: "text-muted"
  }, [_vm._v("create an account")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000",
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 col-xs-offset-5",
    staticStyle: {
      "text-align": "center"
    }
  }, [(_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e()]), _vm._v(" "), _c('form', {
    staticClass: "form-inline"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', {
    staticClass: "sr-only",
    attrs: {
      "for": "firstname"
    }
  }, [_vm._v("Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.name),
      expression: "user.name"
    }],
    staticClass: "form-control input-group-lg",
    attrs: {
      "id": "firstname",
      "type": "text",
      "name": "firstname",
      "title": "Enter  name",
      "placeholder": "Your Full Name"
    },
    domProps: {
      "value": (_vm.user.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', {
    staticClass: "sr-only",
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }],
    staticClass: "form-control input-group-lg",
    attrs: {
      "id": "email",
      "type": "text",
      "name": "Email",
      "title": "Enter Email",
      "placeholder": "Your Email"
    },
    domProps: {
      "value": (_vm.user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.email = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', {
    staticClass: "sr-only",
    attrs: {
      "for": "phone"
    }
  }, [_vm._v("Phone Number")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.phone),
      expression: "user.phone"
    }],
    staticClass: "form-control input-group-lg",
    attrs: {
      "id": "phone",
      "type": "text",
      "name": "Phone",
      "title": "Enter Phone Number",
      "placeholder": "Your Phone Number"
    },
    domProps: {
      "value": (_vm.user.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.phone = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', {
    staticClass: "sr-only",
    attrs: {
      "for": "password"
    }
  }, [_vm._v("Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.password),
      expression: "user.password"
    }],
    staticClass: "form-control input-group-lg",
    attrs: {
      "id": "password",
      "type": "password",
      "title": "Enter password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.user.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.password = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.terms),
      expression: "terms"
    }],
    attrs: {
      "type": "checkbox",
      "id": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.terms) ? _vm._i(_vm.terms, null) > -1 : (_vm.terms)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.terms,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.terms = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.terms = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.terms = $$c
        }
      }
    }
  }), _vm._v("I agree to "), _c('a', {
    attrs: {
      "href": "know#terms"
    }
  }, [_vm._v("Terms and Conditions")])])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#0400ff",
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "disabled": _vm.disable_btn
    },
    on: {
      "click": _vm.reg
    }
  }, [_vm._v("Register Now")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _vm._m(0)])])])])]), _vm._v(" "), _c('component-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "href": "login"
    }
  }, [_vm._v("Already have a "), _c('u', [_vm._v("Sellpoint")]), _vm._v(" account? - Login")])])
}]}

/***/ }),
/* 252 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pager",
    staticStyle: {
      "background": "#ffffff"
    }
  }, [_c('div', {
    staticClass: "section",
    staticStyle: {
      "margin-top": "1em",
      "text-align": "left"
    }
  }, [(_vm.loading) ? _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "loading-md"
  })]) : _c('div', {
    staticClass: "container"
  }, [(_vm.checkout_orders.length != 0) ? _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [(!_vm.checkout_processed) ? _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "col lg-4 md-12 xs-12",
    staticStyle: {
      "background-color": "#f7f7f7",
      "padding-top": "1em"
    }
  }, [_c('h3', {
    staticClass: "margin-bottom"
  }, [_vm._v("Billing details")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("Enter the details below to Checkout"), _c('br'), _vm._v(" "), (_vm.new_account) ? _c('span', [_vm._v("Do you have a "), _c('b', [_vm._v("Buypoint Account? ")]), _c('br'), _vm._v(" "), _c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('login', '')
      }
    }
  }, [_vm._v("You can use it to process your orders")])]) : _c('span', [_vm._v("Don't have a "), _c('b', [_vm._v("Buypoint Account? ")]), _vm._v(" "), _c('u', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('new-account', '')
      }
    }
  }, [_vm._v("Click Here")])])])]), _vm._v(" "), _c('div', {
    staticClass: "w-form"
  }, [(_vm.new_account) ? _c('form', {
    attrs: {
      "id": "email-form-4",
      "name": "email-form-4",
      "data-name": "Email Form 4"
    }
  }, [_c('div', {
    staticClass: "container container-nested is-wrapping"
  }, [_c('div', {
    staticClass: "col lg-12 no-margin-bottom"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_name),
      expression: "user.user_name"
    }],
    staticClass: "form-input-text w-input",
    attrs: {
      "type": "text",
      "maxlength": "256",
      "placeholder": "Name"
    },
    domProps: {
      "value": (_vm.user.user_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col lg-12 no-margin-bottom"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_email),
      expression: "user.user_email"
    }],
    staticClass: "form-input-text w-input",
    attrs: {
      "type": "email",
      "maxlength": "256",
      "placeholder": "Email",
      "id": "Last-name-2"
    },
    domProps: {
      "value": (_vm.user.user_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col lg-12 no-margin-bottom"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_phone),
      expression: "user.user_phone"
    }],
    staticClass: "form-input-text w-input",
    attrs: {
      "type": "number",
      "maxlength": "256",
      "placeholder": "Phone No"
    },
    domProps: {
      "value": (_vm.user.user_phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_phone = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col lg-12 no-margin-bottom"
  }, [(_vm.data_success_message) ? _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_success_message))]) : _vm._e(), _vm._v(" "), (_vm.data_error_message) ? _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))]) : _vm._e(), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "button-primary w100 w-inline-block",
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": _vm.prep_process_checkout
    }
  }, [_vm._v("Process Checkout")])])])]) : _c('form', [_c('div', {
    staticClass: "container container-nested is-wrapping"
  }, [_c('div', {
    staticClass: "col lg-12 no-margin-bottom"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_name),
      expression: "user.user_name"
    }],
    staticClass: "form-input-text w-input",
    attrs: {
      "type": "text",
      "maxlength": "256",
      "placeholder": "First name",
      "id": "First-name"
    },
    domProps: {
      "value": (_vm.user.user_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col lg-12 no-margin-bottom"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_email),
      expression: "user.user_email"
    }],
    staticClass: "form-input-text w-input",
    attrs: {
      "type": "email",
      "maxlength": "256",
      "placeholder": "Email",
      "id": "Last-name-2"
    },
    domProps: {
      "value": (_vm.user.user_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.data_success_message) ? _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_success_message))]) : _vm._e(), _vm._v(" "), (_vm.data_error_message) ? _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))]) : _vm._e(), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "background": "#000000"
    },
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.loginAndProcess()
      }
    }
  }, [_vm._v("Process Checkout")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col lg-8 md-12 xs-12"
  }, [_c('h3', {
    staticClass: "margin-bottom"
  }, [_vm._v("Items to Checkout")]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin": "1em",
      "padding": "1em"
    }
  }, _vm._l((_vm.checkout_orders), function(group, index) {
    return _c('div', {
      staticClass: "group-row",
      staticStyle: {
        "border": "#f7f7f7 solid",
        "margin-bottom": "1em",
        "height": "auto",
        "box-shadow": "0px 8px 16px 0px rgba(0,0,0,0.2)"
      }
    }, [_c('div', {
      staticClass: "col lg-12 md-12"
    }, [_vm._l((group.order_items), function(item) {
      return _c('div', {
        staticStyle: {
          "width": "100%",
          "padding-top": "1em"
        }
      }, [_c('div', [_c('div', {
        staticStyle: {
          "width": "30%",
          "float": "left"
        }
      }, [_c('a', {
        staticStyle: {
          "cursor": "pointer"
        },
        attrs: {
          "href": item.product_url
        }
      }, [((item.product_item_image && (item.product_item_image != ''))) ? _c('img', {
        staticClass: "sp-prd-img",
        attrs: {
          "src": _vm.img_product_url + item.product_item_image
        }
      }) : _c('img', {
        staticClass: "sp-prd-img",
        attrs: {
          "src": "/static/assets/images/dummy-image.png"
        }
      })])]), _vm._v(" "), _c('div', {
        staticStyle: {
          "width": "60%",
          "float": "right"
        }
      }, [_c('h5', [_vm._v(_vm._s(item.product_name))]), _vm._v(" "), _c('p', {
        staticStyle: {
          "display": "inline"
        }
      }, [_vm._v(" Qty: " + _vm._s(item.product_item_order_quantity))]), _c('br'), _vm._v(" "), _c('p', {
        staticStyle: {
          "display": "inline"
        }
      }, [_vm._v("  ₦" + _vm._s((item.product_item_price * item.product_item_order_quantity).toFixed(2)))]), _c('br'), _vm._v(" "), (group.order_items.length > 1) ? _c('div', {
        staticClass: "col-xs-9 pull-right"
      }, [(item.calculated_product_delivery_fee > 0) ? _c('p', [_vm._v("This item's Shipping Fee: " + _vm._s(item.calculated_product_delivery_fee))]) : _vm._e()]) : _vm._e()])])])
    }), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both",
        "width": "100%",
        "border-top": "#f3f0f0 solid 1px",
        "padding-top": "1em"
      }
    }, [(group.total_order_coupons_amount != 0) ? _c('div', [_vm._m(0, true), _vm._v(" "), _c('label', {
      staticStyle: {
        "float": "right"
      }
    }, [_vm._v("₦" + _vm._s((group.total_order_coupons_amount).toFixed(2)))])]) : _vm._e(), _vm._v(" "), _c('div', [_vm._m(1, true), _vm._v(" "), _c('label', {
      staticStyle: {
        "float": "right"
      }
    }, [_vm._v("₦" + _vm._s((group.order_total_amount).toFixed(2)))])]), _vm._v(" "), (group.order_total_delivery_charge > 0) ? _c('div', [_vm._m(2, true), _vm._v(" "), _c('label', {
      staticStyle: {
        "float": "right"
      }
    }, [_vm._v("₦" + _vm._s(group.order_total_delivery_charge))])]) : _vm._e()])], 2)])
  }))])]) : _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "col lg-5 md-12 xs-12"
  }, [_c('div', {
    staticClass: "c-cart-totals"
  }, [_c('h5', {
    staticStyle: {
      "text-align": "center",
      "font-size": "18px",
      "margin": "0"
    }
  }, [_vm._v("Checkout")]), _vm._v(" "), _c('div', {
    staticClass: "row cktop ck-card-row"
  }, [_c('div', {
    staticClass: "mobi-on"
  }, [_c('p', [_c('b', [_c('span', {
    staticClass: "pull-left",
    staticStyle: {
      "text-decoration": "underline"
    }
  }, [_vm._v(_vm._s(_vm.payment_details.payment_ref))]), _vm._v(" "), _c('span', {
    staticClass: "pull-right",
    staticStyle: {
      "text-decoration": "underline"
    }
  }, [_vm._v("₦" + _vm._s(_vm.total_orders_amount.toFixed(2)))])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {}, [_c('p', {
    staticClass: "bar-top"
  }, [_c('b', [_vm._v(_vm._s(_vm.payment_details.payment_payer_name))])]), _vm._v(" "), _c('p', {
    staticClass: "bar-top"
  }, [_c('b', [_vm._v(_vm._s(_vm.payment_details.payment_payer_phone))])]), _vm._v(" "), _c('p', {
    staticClass: "bar-top"
  }, [_c('b', [_vm._v(_vm._s(_vm.payment_details.payment_payer_email))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), (_vm.order_delivery_sorted_locations.cities) ? _c('div', _vm._l((_vm.order_delivery_sorted_locations.cities), function(location) {
    return _c('div', {
      staticClass: "ck-card-row-slim"
    }, [_c('label', [_vm._v("Enter Shipping Address For "), _c('b', [_vm._v(_vm._s(location.city_name))])]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (location.address),
        expression: "location.address"
      }],
      staticClass: "form-control sp-input",
      attrs: {
        "type": "text",
        "placeholder": "Shipping Address"
      },
      domProps: {
        "value": (location.address)
      },
      on: {
        "change": function($event) {
          _vm.setSortedOrderLocationAddress(location)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          location.address = $event.target.value
        }
      }
    })])
  })) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ck-card-row-slim"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "basis-200px"
  }, [_c('div', {
    staticClass: "w-form"
  }, [_c('form', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.order_delivery_main_location.state),
      expression: "order_delivery_main_location.state"
    }],
    staticClass: "sp-select",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.order_delivery_main_location.state = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.setCities(_vm.order_delivery_main_location.state)
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select...")]), _vm._v(" "), _vm._l((_vm.states), function(state) {
    return _c('option', {
      domProps: {
        "value": state
      }
    }, [_vm._v(_vm._s(state.name))])
  })], 2)])])]), _vm._v(" "), (_vm.action_loading) ? _c('div', [_c('div', {
    staticClass: "loading-sm"
  })]) : _vm._e()]), _vm._v(" "), (_vm.set_cities.length != 0) ? _c('div', {
    staticClass: "ck-card-row-slim"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "basis-200px"
  }, [_c('div', {
    staticClass: "w-form"
  }, [_c('form', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.order_delivery_main_location.city),
      expression: "order_delivery_main_location.city"
    }],
    staticClass: "sp-select",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.order_delivery_main_location.city = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.setOrderLocations(_vm.order_delivery_main_location)
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select...")]), _vm._v(" "), _vm._l((_vm.set_cities), function(city) {
    return _c('option', {
      domProps: {
        "value": city
      }
    }, [_vm._v(_vm._s(city.city_name))])
  })], 2)])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ck-card-row-slim"
  }, [_c('label', [_vm._v("Enter Shipping Address")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.order_delivery_main_location.address),
      expression: "order_delivery_main_location.address"
    }],
    staticClass: "form-control input-group-lg",
    attrs: {
      "type": "text",
      "placeholder": "Shipping Address"
    },
    domProps: {
      "value": (_vm.order_delivery_main_location.address)
    },
    on: {
      "change": function($event) {
        _vm.setOrderLocationAddress(_vm.order_delivery_main_location)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.order_delivery_main_location.address = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._l((_vm.checkout_orders), function(group, index) {
    return _c('div', {
      staticClass: "group-row",
      staticStyle: {
        "border": "#f7f7f7 solid",
        "padding": "8px",
        "margin-bottom": "1em",
        "height": "auto",
        "box-shadow": "0px 8px 8px 0px rgba(0,0,0,0.2)"
      }
    }, [_vm._l((group.order_items), function(item) {
      return _c('div', {
        staticClass: "row ck-card-row"
      }, [_c('div', {}, [_c('div', {
        staticStyle: {
          "width": "30%",
          "float": "left"
        }
      }, [_c('a', {
        staticStyle: {
          "cursor": "pointer"
        },
        attrs: {
          "href": item.product_url
        }
      }, [((item.product_item_group_image && (item.product_item_group_image != ''))) ? _c('img', {
        staticClass: "sp-prd-img",
        attrs: {
          "src": item.product_item_group_image
        }
      }) : _c('img', {
        staticClass: "sp-prd-img",
        attrs: {
          "src": "/static/assets/images/dummy-image.png"
        }
      })])]), _vm._v(" "), _c('div', {
        staticStyle: {
          "width": "60%",
          "float": "right"
        }
      }, [_c('h5', [_vm._v(_vm._s(item.product_name))]), _vm._v(" "), _c('p', [_vm._v(" QTY: " + _vm._s(item.order_item_quantity))]), _vm._v(" "), _c('p', [(item.order_item_quantity > 1) ? _c('span', {
        staticClass: "price"
      }, [_c('small', [_vm._v("₦")]), _vm._v(_vm._s(item.product_item_total_price.toFixed(2))), _c('br')]) : _vm._e(), _vm._v(" "), _c('b', [_vm._v("Total: ")]), _vm._v("₦" + _vm._s(item.order_item_total) + "\r\n                                        ")])]), _vm._v(" "), _c('div', {
        staticStyle: {
          "clear": "both",
          "width": "100%",
          "border-top": "#f3f0f0 solid 1px",
          "padding-top": "1em"
        }
      }, [_vm._m(5, true), _vm._v(" "), ((group.order_items.length > 1)) ? _c('div', {
        staticStyle: {
          "clear": "both"
        }
      }, [(item.order_item_delivery_fee != 0) ? _c('div', [_c('span', {
        staticStyle: {
          "color": "#ff0000",
          "float": "left"
        }
      }, [_vm._v("Product Shipping Fee:")]), _vm._v(" "), _c('span', {
        staticStyle: {
          "float": "right"
        }
      }, [_vm._v("₦" + _vm._s(item.order_item_delivery_fee))]), _c('br')]) : _vm._e(), _vm._v(" "), (item.order_item_delivery_fee != 0) ? _c('div', [_c('span', {
        staticStyle: {
          "color": "#ff0000",
          "float": "left"
        }
      }, [_vm._v("Total:")]), _vm._v(" "), _c('span', {
        staticStyle: {
          "float": "left"
        }
      }, [_vm._v(" ₦" + _vm._s(item.order_item_total_delivery_fee))])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
        staticStyle: {
          "float": "right",
          "margin-bottom": "5px",
          "display": "none"
        }
      }, [_c('span', [_c('a', {
        staticClass: "mobi-on",
        staticStyle: {
          "cursor": "pointer",
          "color": "#000000"
        },
        on: {
          "click": function($event) {
            _vm.removeFromCheckout(index, group, item)
          }
        }
      }, [_vm._v("Remove")]), _vm._v(" "), _c('a', {
        staticClass: "mobi-off",
        staticStyle: {
          "cursor": "pointer"
        },
        on: {
          "click": function($event) {
            _vm.removeFromCheckout(index, group, item)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-close"
      }), _vm._v("Remove")])])])])])])
    }), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    }), _vm._v(" "), _c('div', {
      staticClass: "c-cart-totals"
    }, [_c('div', {
      key: _vm.group_set_order_delivery_key,
      staticClass: "row",
      staticStyle: {
        "margin": "1em 0"
      }
    }, [(group.order_delivery_city) ? _c('p', {
      staticStyle: {
        "margin-top": "-1em",
        "font-size": "14px"
      }
    }, [_vm._v("Shipping: " + _vm._s(group.order_delivery_city))]) : _c('p', {
      staticStyle: {
        "margin-top": "-1em",
        "font-size": "14px"
      }
    }, [_vm._v("Shipping: Not set yet")]), _vm._v(" "), (group.order_user_delivery_address) ? _c('p', {
      staticStyle: {
        "margin-top": "-1em",
        "font-size": "14px"
      }
    }, [_vm._v("Address: " + _vm._s(group.order_user_delivery_address))]) : _vm._e(), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "none"
      },
      attrs: {
        "id": 'cdl' + index
      }
    }, [_c('div', {
      staticClass: "row",
      staticStyle: {
        "border": "#cccbbb dashed 1px",
        "margin": "2em 0 2em 0"
      }
    }, [((group.order_business_delivery_options && (group.order_business_delivery_options.length != 0))) ? _c('div', [((group.order_business_delivery_options_custom && (group.order_business_delivery_options_custom.length != 0))) ? _c('div', {
      staticClass: "form-group col-xs-12",
      staticStyle: {
        "margin-top": "-2em"
      }
    }, [_c('label', [_vm._v("Select Shipping Location")]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (group.order_delivery_location),
        expression: "group.order_delivery_location"
      }],
      staticClass: "form-control",
      on: {
        "click": function($event) {
          _vm.calc_delivery_fee(index, group.order_delivery_location)
        },
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          group.order_delivery_location = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }
      }
    }, [_c('option', {
      domProps: {
        "value": undefined
      }
    }, [_vm._v("Select")]), _vm._v(" "), _vm._l((group.order_business_delivery_options_custom), function(location) {
      return _c('option', {
        domProps: {
          "value": location
        }
      }, [_vm._v(_vm._s(location.business_delivery_option))])
    })], 2), _vm._v(" "), _c('button', {
      staticClass: "pull-right btn btn-default",
      on: {
        "click": function($event) {
          _vm.setComponent('cancel-change-delivery-option', index)
        }
      }
    }, [_vm._v("Done")])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "form-group col-xs-12",
      staticStyle: {
        "margin-bottom": "2em"
      }
    }, [((group.order_business_delivery_options_custom && (group.order_business_delivery_options_custom.length != 0))) ? _c('label', [_vm._v("OR Select State In Nigeria")]) : _c('label', [_vm._v("Select State")]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (group.order_delivery_selected_state),
        expression: "group.order_delivery_selected_state"
      }],
      staticClass: "form-control",
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          group.order_delivery_selected_state = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }, function($event) {
          _vm.getOrderLocations(index, group.order_delivery_selected_state)
        }]
      }
    }, [_c('option', {
      domProps: {
        "value": undefined
      }
    }, [_vm._v("Select")]), _vm._v(" "), _vm._l((group.order_business_delivery_options_states), function(state) {
      return _c('option', {
        domProps: {
          "value": state
        }
      }, [_vm._v(_vm._s(state.state_name))])
    })], 2), _vm._v(" "), (_vm.action_loading) ? _c('div', [_c('div', {
      staticClass: "loading-sm"
    })]) : _vm._e()]), _vm._v(" "), (group.sorted_order_business_delivery_options) ? _c('div', {
      staticClass: "form-group col-xs-12",
      staticStyle: {
        "margin-top": "-2em"
      }
    }, [_c('label', [_vm._v("Select Location")]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (group.order_delivery_location),
        expression: "group.order_delivery_location"
      }],
      staticClass: "form-control",
      on: {
        "click": function($event) {
          _vm.calc_delivery_fee(index, group.order_delivery_location)
        },
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          group.order_delivery_location = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }
      }
    }, [_c('option', {
      domProps: {
        "value": undefined
      }
    }, [_vm._v("Select")]), _vm._v(" "), _vm._l((group.sorted_order_business_delivery_options), function(location) {
      return _c('option', {
        domProps: {
          "value": location
        }
      }, [_vm._v(_vm._s(location.business_delivery_option))])
    })], 2)]) : _vm._e()]) : _c('div', [_c('div', {
      staticClass: "form-group col-xs-12",
      staticStyle: {
        "margin-bottom": "2em"
      }
    }, [_c('label', [_vm._v("Select State")]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (group.order_delivery_selected_state),
        expression: "group.order_delivery_selected_state"
      }],
      staticClass: "form-control",
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          group.order_delivery_selected_state = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }, function($event) {
          _vm.getCities(group.order_delivery_selected_state.state_id)
        }]
      }
    }, [_c('option', {
      domProps: {
        "value": undefined
      }
    }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.states), function(state) {
      return _c('option', {
        domProps: {
          "value": state
        }
      }, [_vm._v(_vm._s(state.name))])
    })], 2)]), _vm._v(" "), (_vm.cities.length > 0) ? _c('div', {
      staticClass: "form-group col-xs-12",
      staticStyle: {
        "margin-top": "-2em"
      }
    }, [_c('label', [_vm._v("Select Location")]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (group.order_delivery_location),
        expression: "group.order_delivery_location"
      }],
      staticClass: "form-control",
      on: {
        "click": function($event) {
          _vm.resetDeliveryLocation(index, group.order_delivery_location)
        },
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          group.order_delivery_location = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }
      }
    }, [_c('option', {
      domProps: {
        "value": undefined
      }
    }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.cities), function(city) {
      return _c('option', {
        domProps: {
          "value": city
        }
      }, [_vm._v(_vm._s(city.city_name))])
    })], 2)]) : _vm._e()]), _vm._v(" "), (group.order_delivery_city) ? _c('div', {
      staticClass: "form-group col-xs-12",
      staticStyle: {
        "margin-top": "0.3em"
      }
    }, [(group.order_user_city_delivery == group.order_delivery_city_id) ? _c('div', [(group.order_user_city_delivery_addresses.length != 0) ? _c('div', [_c('label', [_vm._v("Select from previous Shipping Address")]), _vm._v(" "), _vm._l((group.order_user_city_delivery_addresses), function(address) {
      return _c('label', [(address.address_city == group.order_delivery_city_id) ? _c('span', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (group.order_user_delivery_address),
          expression: "group.order_user_delivery_address"
        }],
        attrs: {
          "type": "radio"
        },
        domProps: {
          "value": address.address_id,
          "checked": _vm._q(group.order_user_delivery_address, address.address_id)
        },
        on: {
          "click": function($event) {
            _vm.setOrderUserCityDeliveryAddress(index, address)
          },
          "__c": function($event) {
            group.order_user_delivery_address = address.address_id
          }
        }
      }), _vm._v("\r\n                                                                " + _vm._s(address.address_address) + "\r\n                                                            ")]) : _vm._e()])
    })], 2) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('label', [_vm._v("Enter Shipping Address")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (group.order_user_delivery_address),
        expression: "group.order_user_delivery_address"
      }],
      staticClass: "form-control input-group-lg",
      attrs: {
        "type": "text",
        "placeholder": "Shipping Address"
      },
      domProps: {
        "value": (group.order_user_delivery_address)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          group.order_user_delivery_address = $event.target.value
        }
      }
    })]) : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "pull-right btn btn-default",
      on: {
        "click": function($event) {
          _vm.setComponent('cancel-change-delivery-option', index)
        }
      }
    }, [_vm._v("Done")])])]), _vm._v(" "), (group.order_delivery_city) ? _c('button', {
      staticClass: "pull-right btn btn-default",
      attrs: {
        "id": 'cdlb' + index
      },
      on: {
        "click": function($event) {
          _vm.setComponent('change-delivery-option', index)
        }
      }
    }, [_vm._v("Change Location")]) : _vm._e()])])], 2)
  }), _vm._v(" "), _c('div', {
    staticClass: "c-cart-totals",
    staticStyle: {
      "margin-bottom": "5em"
    }
  }, [_c('div', [_c('div', {
    staticClass: "pull-right order-sec",
    staticStyle: {
      "margin-bottom": "7em",
      "margin-right": "1em"
    }
  }, [_c('div', [(_vm.checkout_orders) ? _c('span', [_c('p', {
    staticClass: "tiny-part"
  }, [_vm._v("Total Orders: ₦" + _vm._s(_vm.total_order_items_total.toFixed(2)))]), _vm._v(" "), _c('p', {
    staticClass: "tiny-part"
  }, [_vm._v("Shipping Fee:  ₦" + _vm._s(_vm.total_shipping_fee.toFixed(2)))]), _vm._v(" "), _c('p', {
    staticClass: "tiny-part"
  }, [_vm._v("Total: ₦" + _vm._s(_vm.total_orders_amount.toFixed(2)))])]) : _c('span', [_vm._m(6)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "mobile-fix-nav"
  }, [_c('div', {
    staticStyle: {
      "padding": "1em"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "background": "#ffa800",
      "width": "100vw",
      "padding": "0.8em",
      "text-align": "center"
    }
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer",
      "color": "#000000",
      "text-decoration": "none"
    },
    on: {
      "click": _vm.processPayment
    }
  }, [_vm._v("Make Payment")])])])], 2)])]) : _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#ff0000",
      "margin-top": "2em"
    }
  }, [_vm._v("No Orders for Checkout")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn default",
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "href": "/"
    }
  }, [_vm._v("Shop Here")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('b', [_vm._v("Total Coupon Discount Amount:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('b', [_vm._v("Total Order Amount:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('b', [_vm._v("Total Shipping Fee:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('b', [_vm._v("State:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('b', [_vm._v("Location:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('label', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    }
  }), _vm._v("Gift/Send this Product to a different location")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tiny-part"
  }, [_c('b', [_vm._v("Shipping Details:")]), _vm._v(" {{}}")])
}]}

/***/ }),
/* 253 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-wrap",
    attrs: {
      "id": "wrap"
    }
  }, [_c('component-header'), _vm._v(" "), _c('div', {
    staticClass: "pager"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row card-box-o"
  }, [_c('div', {
    staticClass: "card",
    staticStyle: {
      "padding-top": "3em",
      "padding-bottom": "4em"
    },
    attrs: {
      "id": ""
    }
  }, [_c('div', {
    staticClass: "col-sm-6 col-sm-offset-1"
  }, [_c('div', {
    staticClass: "sp1-reg",
    staticStyle: {
      "background": "#ffffff",
      "padding": "2em",
      "border-radius": "2px"
    }
  }, [_c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane active",
    attrs: {
      "id": "register"
    }
  }, [_c('h3', [_vm._v("Create A Sellpoint")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("Set up a Store for your Business!")]), _vm._v(" "), _c('form', {
    staticClass: "form-inline",
    attrs: {
      "name": "registration_form",
      "id": "registration_form"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', {
    attrs: {
      "for": "business_name"
    }
  }, [_vm._v("Business Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business.business_name),
      expression: "business.business_name"
    }],
    staticClass: "form-control input-group-lg",
    attrs: {
      "id": "business_name",
      "type": "text",
      "name": "business_name",
      "title": "Enter  name",
      "placeholder": "Your Business Name"
    },
    domProps: {
      "value": (_vm.business.business_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.business.business_name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', {
    attrs: {
      "for": "business_user_name"
    }
  }, [_vm._v("Business Username"), (_vm.validate_user_name_error) ? _c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.validate_user_name_message))]) : _vm._e()]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business.business_user_name),
      expression: "business.business_user_name"
    }],
    staticClass: "form-control input-group-lg",
    attrs: {
      "id": "business_user_name",
      "type": "text",
      "name": "business_name",
      "title": "Enter  name",
      "placeholder": "Your unique Business User Name"
    },
    domProps: {
      "value": (_vm.business.business_user_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.business.business_user_name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Business Category")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business.business_category),
      expression: "business.business_category"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.business.business_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select a Category")]), _vm._v(" "), _vm._l((_vm.categories), function(category) {
    return _c('option', {
      domProps: {
        "value": category.category_id
      }
    }, [_vm._v(_vm._s(category.category_name))])
  })], 2)])])]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1",
    on: {
      "click": _vm.createSellpoint
    }
  }, [_vm._v("Create")])])])])])])])])]), _vm._v(" "), _c('component-footer')], 1)
},staticRenderFns: []}

/***/ }),
/* 254 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-8 contact_form add-prd-item"
  }, [_c('h6', [_vm._v("Add New Item ")]), _vm._v(" "), _c('form', {
    staticClass: "sp-forms-one"
  }, [_c('ul', {
    staticClass: "row"
  }, [_c('li', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(" *Product Price\n                        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_price),
      expression: "product.product_item_price"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "value": "",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.product.product_item_price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_price = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(" *Product Weight\n                        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_weight),
      expression: "product.product_item_weight"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "step": "any",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.product.product_item_weight)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_weight = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(" *Product Quantity\n                        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_quantity),
      expression: "product.product_item_quantity"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.product.product_item_quantity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_quantity = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(" Product Image")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.onFileChange($event)
      }
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "col-md-6"
  }, [_c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addProductItem
    }
  }, [_vm._v("Add")])])])])])
},staticRenderFns: []}

/***/ }),
/* 255 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('h6', [_vm._v("Add a New Lookbook to your Gallery")]), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.loading) ? _c('div', [(_vm.loading) ? _c('div', {
    staticClass: "loading-md"
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "13px",
      "color": "#000000"
    }
  }, [_vm._v("Preparing and Checking your Sellpoint")])]) : _c('form', {
    staticClass: "gw-form"
  }, [_c('div', [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gallery.gallery_name),
      expression: "gallery.gallery_name"
    }],
    attrs: {
      "type": "text",
      "value": "",
      "placeholder": "What's the Name of your Lookbook"
    },
    domProps: {
      "value": (_vm.gallery.gallery_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.gallery.gallery_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(2), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gallery.gallery_description),
      expression: "gallery.gallery_description"
    }],
    attrs: {
      "placeholder": "What's this Lookbook all about"
    },
    domProps: {
      "value": (_vm.gallery.gallery_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.gallery.gallery_description = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('h6', [_vm._v("Add a Post to "), _c('span', {
    staticStyle: {
      "color": "#ff0055"
    }
  }, [_vm._v(_vm._s(_vm.gallery.gallery_name))]), _vm._v(" Lookbook")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', [_c('div', [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(4), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.post.post_caption),
      expression: "post.post_caption"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Caption/Title this Post"
    },
    domProps: {
      "value": (_vm.post.post_caption)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.post.post_caption = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(5), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.post.post_details),
      expression: "post.post_details"
    }],
    attrs: {
      "placeholder": "Full Post Details"
    },
    domProps: {
      "value": (_vm.post.post_details)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.post.post_details = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {}, [_c('div', {
    staticClass: "upload-btn-wrapper"
  }, [_c('button', {
    staticClass: "upload-btn",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Add Post's media (Image/Video)")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "accept": "image/*,video/*",
      "capture": ""
    },
    on: {
      "change": function($event) {
        _vm.onFileChange($event)
      }
    }
  }), _vm._v(" "), (_vm.file_info[0]) ? _c('span', [_c('b', [_vm._v("Added " + _vm._s(_vm.file_info[0].name))])]) : _vm._e()]), _vm._v(" "), _vm._m(6)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ee87a6"
    }
  }, [_vm._v(_vm._s(_vm.data_success_message))]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn",
    staticStyle: {
      "background": "#ff0055",
      "color": "#ffffff"
    },
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": _vm.addGallery
    }
  }, [_vm._v("All Done, Add Lookbook")])])]), _vm._v(" "), _c('hr')])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "sp-form-descr"
  }, [_vm._v("(your lookbook is a collection or group of posts you want to keep together)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Lookbook Name"), _c('span', {
    staticClass: "sp-form-must"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Description"), _c('span', {
    staticClass: "sp-form-must"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "sp-form-descr"
  }, [_vm._v("(This would be the first post added to this lookbook)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Caption"), _c('span', {
    staticClass: "sp-form-must"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Details"), _c('span', {
    staticClass: "sp-form-must"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    staticClass: "sp-form-descr"
  }, [_vm._v("(You can always add more images or video on this post)")])])
}]}

/***/ }),
/* 256 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.productMainView == 'cartactions') ? _c('span', [(_vm.canAdd) ? _c('button', {
    staticClass: "cart-btn cart-btn-sm",
    on: {
      "click": _vm.addToCart
    }
  }, [_vm._v("Add to Cart")]) : _c('div', [_c('div', {
    staticClass: "hidden-sm hidden-xs"
  }, [_c('div', {
    staticClass: "cart-cta-box"
  }, [_c('button', {
    staticClass: "cart-btn cart-btn-sm",
    on: {
      "click": function($event) {
        _vm.redir('cart')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-shopping-cart"
  }), _vm._v(" View Cart")])])]), _vm._v(" "), _c('div', {
    staticClass: "hidden-md hidden-lg"
  }, [_c('button', {
    staticClass: "cart-btn cart-btn-sm",
    staticStyle: {
      "line-height": "2em"
    },
    on: {
      "click": function($event) {
        _vm.redir('cart')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-shopping-cart"
  }), _vm._v(" View Cart")])])])]) : _c('div', {
    staticStyle: {
      "clear": "right"
    }
  }, [(_vm.canAdd) ? _c('button', {
    staticClass: "cart-btn",
    staticStyle: {
      "width": "50vw"
    },
    on: {
      "click": _vm.addToCart
    }
  }, [_vm._v("Add to Cart")]) : _c('button', {
    staticClass: "cart-btn",
    staticStyle: {
      "width": "50vw",
      "font-size": "14px"
    },
    on: {
      "click": function($event) {
        _vm.redir('cart')
      }
    }
  }, [_vm._v("View Cart")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "hidden-sm hidden-xs mobi-off"
  }, [_c('ul', {
    staticClass: "cart-cta-box"
  }, [_c('li', {
    staticClass: "cart-btn btn-white remove-btn"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.removeFromCart(_vm.productItem)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  }), _vm._v(" Remove "), _c('br'), _vm._v(" from Cart")])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('li', {
    staticClass: "cart-btn btn-white btn-primary"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.redir(_vm.productMain.product_business_ownername)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-shopping-cart"
  }), _vm._v(" Continue "), _c('br'), _vm._v("  Shopping")])])])]), _vm._v(" "), _c('div', {
    staticClass: "hidden-md hidden-lg mobi-on"
  }, [_c('button', {
    staticClass: "cart-btn remove-btn",
    staticStyle: {
      "background": "#e05024"
    },
    on: {
      "click": function($event) {
        _vm.removeFromCart(_vm.productItem)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  }), _vm._v(" Remove from Cart")]), _vm._v(" "), _c('button', {
    staticClass: "cart-btn view-btn",
    staticStyle: {
      "line-height": "2em"
    },
    on: {
      "click": function($event) {
        _vm.redir('cart')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-shopping-cart"
  }), _vm._v(" View Cart")]), _vm._v(" "), _c('button', {
    staticClass: "cart-btn btn-primary",
    staticStyle: {
      "line-height": "2em"
    },
    on: {
      "click": function($event) {
        _vm.redir(_vm.productMain.product_business_ownername)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-shopping-cart"
  }), _vm._v(" Continue Shopping")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "cart-btn view-btn"
  }, [_c('a', {
    attrs: {
      "href": "/cart"
    }
  }, [_c('i', {
    staticClass: "fa fa-shopping-cart"
  }), _vm._v(" View "), _c('br'), _vm._v(" Cart")])])
}]}

/***/ }),
/* 257 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "wrap"
    }
  }, [_c('component-header'), _vm._v(" "), _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('section', {
    attrs: {
      "id": "banner"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('router-view')], 1)])]), _vm._v(" "), ((!(this.$route.path == '/order') && !(this.$route.path == '/order/') && !(this.$route.path == '/cart') && !(this.$route.path == '/cart/') && !(this.$route.path == '/checkout') && !(this.$route.path == '/checkout/'))) ? _c('component-footer') : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 258 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.product_info) ? _c('div', {
    staticClass: "margin-top-50 pretty-banner"
  }, [_c('h5', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_vm._v("Same product but different variations")]), _vm._v(" "), _c('p', [_vm._v("if this product has different colours, sizes, etc... no need filling this long form again, go to this product view and set them.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('i', {
    staticClass: "fa fa-arrow-right"
  }), _c('a', {
    attrs: {
      "href": _vm.product_url
    }
  }, [_vm._v("Proceed to this Product's View ")])])]) : _vm._e(), _vm._v(" "), (!_vm.product_info) ? _c('div', {
    staticClass: "col-sm-10 col-sm-offset-4"
  }, [_c('h6', [_vm._v("Add Product / Service")]), _vm._v(" "), _c('form', [_c('ul', {
    staticClass: "row"
  }, [_c('li', {
    staticClass: "col-sm-12"
  }, [_c('label', [_vm._v(" *Product Name\n                            "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_name),
      expression: "product.product_name"
    }],
    attrs: {
      "type": "text",
      "value": "",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.product.product_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_name = $event.target.value
      }
    }
  })])]), _vm._v(" "), (_vm.sellpoint_categories.length != 0) ? _c('li', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(" Select Product Category\n                        "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_category),
      expression: "product.product_category"
    }],
    attrs: {
      "id": "category-type-1"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.product.product_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.trackevent('category-type-1')
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "0",
      "disabled": _vm.category_type_1
    }
  }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.sellpoint_categories), function(category) {
    return _c('option', {
      key: category.business_category_id,
      attrs: {
        "disabled": _vm.category_type_1
      },
      domProps: {
        "value": category.business_category_id
      }
    }, [_vm._v(_vm._s(category.business_category))])
  })], 2)])]) : _vm._e(), _vm._v(" "), (_vm.sellpoint_categories.length != 0) ? _c('li', {
    staticClass: "col-sm-4 col-sm-offset-4"
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v("Select from related Shop Categories\n                        "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_sub_category),
      expression: "product.product_sub_category"
    }],
    staticClass: "category-type-2",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.product.product_sub_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.trackevent('category-type-2')
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "0",
      "disabled": _vm.category_type_2
    }
  }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.sub_categories), function(category) {
    return _c('option', {
      key: category.sub_category_id,
      attrs: {
        "disabled": _vm.category_type_2
      },
      domProps: {
        "value": category.sub_category_id
      }
    }, [_vm._v(_vm._s(category.sub_category_name))])
  })], 2)])]), _vm._v(" "), _c('li', {
    staticClass: "col-md-12"
  }, [_c('label', [_c('b', [_vm._v(" *Or ")]), _vm._v(" Enter a specific Category\n                            "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_listed_category),
      expression: "product.product_listed_category"
    }],
    attrs: {
      "disabled": _vm.category_type_3,
      "type": "text",
      "placeholder": "",
      "id": "category-type-3"
    },
    domProps: {
      "value": (_vm.product.product_listed_category)
    },
    on: {
      "change": function($event) {
        _vm.trackevent('category-type-3')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_listed_category = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(" *Product Description\n                            "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_description),
      expression: "product.product_description"
    }],
    domProps: {
      "value": (_vm.product.product_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_description = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(" *Product Price\n                            "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_price),
      expression: "product.product_item_price"
    }],
    attrs: {
      "type": "number",
      "placeholder": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.product.product_item_price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_price = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(" *Product Weight\n                            "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_weight),
      expression: "product.product_item_weight"
    }],
    attrs: {
      "type": "number",
      "step": "any",
      "placeholder": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.product.product_item_weight)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_weight = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(" *Product Quantity\n                            "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_quantity),
      expression: "product.product_item_quantity"
    }],
    attrs: {
      "type": "number",
      "placeholder": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.product.product_item_quantity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_quantity = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "upload-btn-wrapper",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('button', {
    staticClass: "upload-btn"
  }, [_vm._v("Add Product Image")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.onFileChange($event)
      }
    }
  }), _vm._v(" "), (_vm.file_info[0]) ? _c('span', [_c('b', [_vm._v("Added " + _vm._s(_vm.file_info[0].name))])]) : _vm._e()])]), _vm._v(" "), _c('li', {
    staticClass: "col-md-6"
  }, [_c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addProduct
    }
  }, [_vm._v("Add")])])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('b', [_vm._v(" *Or ")])])
}]}

/***/ }),
/* 259 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row",
    staticStyle: {
      "width": "100vw"
    }
  }, [(_vm.loading) ? _c('div', {
    staticClass: "col-md-6 col-md-offset-4 col-xs-12"
  }, [_c('div', {
    staticClass: "loading-md"
  })]) : _c('div', [(this.$route.path == '/cart') ? _c('div', {
    staticClass: "row cart-widget",
    staticStyle: {
      "width": "100vw",
      "margin-top": "-0.2em"
    }
  }, [_c('div', {
    staticStyle: {
      "background": "#ffffff",
      "margin": "0 1em"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "container",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.sorted_cart), function(group, index) {
    return _c('div', {
      staticClass: "group-row",
      staticStyle: {
        "margin-bottom": "2em",
        "height": "auto"
      }
    }, [_c('div', [_c('p', {
      staticStyle: {
        "float": "left"
      }
    }, [_vm._v(_vm._s(group.business_name))]), _vm._v(" "), _c('div', {
      staticStyle: {
        "float": "right",
        "margin-right": "5px"
      }
    }, [_c('div', {
      staticStyle: {
        "height": "2em"
      }
    }, [(group.selected_business_delivery_option || group.delivery_general_set_option) ? _c('div', [(group.selected_business_delivery_option) ? _c('p', {
      staticStyle: {
        "font-size": "13px"
      }
    }, [_c('b', [_vm._v("Shipping: ")]), _vm._v(_vm._s(group.selected_business_delivery_option.business_delivery_option) + " - ₦" + _vm._s(group.selected_business_delivery_option.business_delivery_option_price))]) : _vm._e(), _vm._v(" "), (group.delivery_general_set_option && (group.delivery_general_set_option.city)) ? _c('p', {
      staticStyle: {
        "font-size": "13px"
      }
    }, [_c('b', [_vm._v("Shipping: ")]), _vm._v(_vm._s(group.delivery_general_set_option.city.city_name) + "-" + _vm._s(group.delivery_option))]) : _vm._e()]) : _c('div', [(group.business_min_delivery_fee != 0 && (group.business_max_delivery_fee.length != 0)) ? _c('div', [_c('p', {
      staticStyle: {
        "font-size": "13px"
      }
    }, [_c('b', [_vm._v("Shipping: ")]), _vm._v("₦" + _vm._s(group.business_min_delivery_fee) + " - ₦" + _vm._s(group.business_max_delivery_fee))])]) : _vm._e()])]), _vm._v(" "), (group[2]) ? _c('div', {
      key: _vm.shipping_fee_key_options,
      staticStyle: {
        "margin-top": "-1em"
      }
    }, [(group.delivery_states.length == 1) ? _c('div') : _c('div', [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (group.delivery_selected_state),
        expression: "group.delivery_selected_state"
      }],
      staticClass: "sp-form-select sp-select",
      staticStyle: {
        "height": "28px",
        "padding": "0",
        "margin-bottom": "3px",
        "font-size": "12px"
      },
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          group.delivery_selected_state = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }, function($event) {
          _vm.getDeliveryLocations(index, group.delivery_selected_state)
        }]
      }
    }, [_c('option', {
      domProps: {
        "value": undefined
      }
    }, [_vm._v("Select")]), _vm._v(" "), _vm._l((group.delivery_states), function(state) {
      return _c('option', {
        domProps: {
          "value": state
        }
      }, [_vm._v(_vm._s(state.state_name))])
    })], 2)]), _vm._v(" "), (((group.delivery_states.length == 1) || (group.delivery_selected_state))) ? _c('div', {
      attrs: {
        "id": index + 'BDLS'
      }
    }, [_c('div', {
      key: _vm.componentDeliveryLocationsKey
    }, [(group.selected_delivery_state_locations.length != 0) ? _c('div', [_c('div', {
      staticClass: "dropdown"
    }, [(group.delivery_states.length == 1) ? _c('span', {
      staticStyle: {
        "font-size": "12px"
      }
    }, [_vm._v(_vm._s(group.delivery_states[0].state_name) + ":")]) : _vm._e(), _vm._v(" "), (group.selected_business_delivery_option) ? _c('button', {
      staticClass: "dropbtn"
    }, [(group.selected_business_delivery_option.has_product_delivery_fee) ? _c('span', [_vm._v("\r\n                                  " + _vm._s(group.selected_business_delivery_option.business_delivery_option) + " -  ₦" + _vm._s(group.selected_business_delivery_option.business_product_delivery_fee) + "▼\r\n                                ")]) : _c('span', [_vm._v("\r\n                                  " + _vm._s(group.selected_business_delivery_option.business_delivery_option) + " -  ₦" + _vm._s(group.selected_business_delivery_option.business_delivery_option_price) + "▼\r\n                                ")])]) : _c('button', {
      staticClass: "dropbtn"
    }, [_vm._v("Select Delivery Location ▼")]), _vm._v(" "), _c('div', {
      staticClass: "dropdown-content"
    }, _vm._l((group.selected_delivery_state_locations), function(option) {
      return _c('div', [(option.business_delivery_product == 0) ? _c('span', [_c('label', [_c('span', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.sellpoint_delivery_fee),
          expression: "sellpoint_delivery_fee"
        }],
        attrs: {
          "type": "radio"
        },
        domProps: {
          "value": option.business_delivery_option_id,
          "checked": _vm._q(_vm.sellpoint_delivery_fee, option.business_delivery_option_id)
        },
        on: {
          "click": function($event) {
            _vm.calc_sellpoint_delivery_fee(index, option)
          },
          "__c": function($event) {
            _vm.sellpoint_delivery_fee = option.business_delivery_option_id
          }
        }
      })]), _vm._v(" "), _c('span', {
        staticStyle: {
          "font-size": "12px"
        }
      }, [_vm._v("\r\n                                        " + _vm._s(option.business_delivery_option) + " -  ₦" + _vm._s(option.business_delivery_option_price) + "\r\n                                      ")])])]) : _vm._e()])
    }))])]) : _c('div', [_c('p', {
      staticStyle: {
        "color": "#ff0000",
        "font-size": "12px"
      }
    }, [_vm._v("Free Delivery")])])])]) : _vm._e()]) : _c('div', {
      staticStyle: {
        "margin-top": "-3em"
      }
    }, [_c('p', {
      staticStyle: {
        "color": "#ff0000",
        "font-size": "12px"
      }
    }, [_vm._v("Free Delivery")])])])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    }), _vm._v(" "), _vm._l((group[1]), function(item, index2) {
      return _c('ul', {
        staticClass: "row cart-details cart-item-row",
        staticStyle: {
          "margin": "0 auto"
        }
      }, [_c('li', {
        staticClass: "col-xs-4 cart-item-row-left",
        staticStyle: {
          "margin": "0",
          "padding": "0",
          "padding-left": "5px"
        }
      }, [_c('div', {
        staticStyle: {
          "float": "left",
          "width": "15%",
          "padding-top": "3em",
          "margin-right": "5px"
        }
      }, [(item.product_checked) ? _c('input', {
        staticClass: "check-select",
        attrs: {
          "type": "checkbox",
          "checked": ""
        },
        on: {
          "click": function($event) {
            _vm.removeFromCheckout(item, index, index2)
          }
        }
      }) : _c('input', {
        staticClass: "check-select",
        attrs: {
          "type": "checkbox"
        },
        on: {
          "click": function($event) {
            _vm.addToCheckout(item, index, index2)
          }
        }
      })]), _vm._v(" "), _c('div', {
        staticStyle: {
          "float": "right",
          "width": "75%",
          "margin-left": "5px"
        }
      }, [_c('div', {
        staticStyle: {
          "width": "90%",
          "padding-top": "1em"
        }
      }, [_c('a', {
        staticStyle: {
          "cursor": "pointer"
        },
        attrs: {
          "href": item.product_url
        }
      }, [((item.product_item_image && (item.product_item_image != ''))) ? _c('img', {
        attrs: {
          "src": _vm.img_product_url + item.product_item_image,
          "width": "100%;"
        }
      }) : _c('img', {
        attrs: {
          "src": "/static/assets/images/dummy-image.png",
          "width": "100%"
        }
      })])])])]), _vm._v(" "), _c('li', {
        staticClass: "col-xs-8 cart-item-row-right",
        staticStyle: {
          "margin": "0",
          "padding": "0"
        }
      }, [_c('div', {
        staticClass: "w-flow"
      }, [_c('h5', [_vm._v(_vm._s(item.product_name))])]), _vm._v(" "), _c('div', {
        staticClass: "w-flow"
      }, [_c('div', {
        staticClass: "col-xs-12",
        staticStyle: {
          "margin": "0",
          "padding": "0"
        }
      }, [_c('a', {
        staticClass: "col-xs-1 qty-btn qty-btn-sm",
        staticStyle: {
          "cursor": "pointer",
          "text-decoration": "none",
          "padding": "1px 3px",
          "width": "25px"
        },
        on: {
          "click": function($event) {
            _vm.removeRefreshCheckout(item, index, index2)
          }
        }
      }, [_vm._v("–")]), _vm._v(" "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (item.product_item_order_quantity),
          expression: "item.product_item_order_quantity"
        }],
        staticClass: "col-xs-2 qty-input qty-input-sm",
        staticStyle: {
          "width": "38px"
        },
        attrs: {
          "type": "number"
        },
        domProps: {
          "value": (item.product_item_order_quantity)
        },
        on: {
          "change": function($event) {
            _vm.refreshCheckout(item, index, index2)
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            item.product_item_order_quantity = $event.target.value
          }
        }
      }), _vm._v(" "), _c('a', {
        staticClass: "col-xs-1 qty-btn qty-btn-sm",
        staticStyle: {
          "cursor": "pointer",
          "text-decoration": "none",
          "padding": "1px 3px",
          "width": "25px"
        },
        on: {
          "click": function($event) {
            _vm.addRefreshCheckout(item, index, index2)
          }
        }
      }, [_vm._v("+")])]), _vm._v(" "), _c('p', {
        staticStyle: {
          "color": "#f73676"
        },
        attrs: {
          "id": 'qty_c' + index2
        }
      }, [_vm._v(_vm._s(item.check_order_quantity))])]), _vm._v(" "), _c('div', {
        staticClass: "w-flow",
        staticStyle: {
          "margin-top": "8px"
        }
      }, [(item.product_item_order_quantity > 1) ? _c('span', {
        staticClass: "price"
      }, [_c('small', [_vm._v("₦")]), _vm._v(_vm._s(item.product_item_price))]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (item.product_item_order_quantity > 1) ? _c('span', {
        staticClass: "price",
        attrs: {
          "id": 'qty_t' + index2
        }
      }, [_c('small', [_vm._v("₦")]), _vm._v(_vm._s((item.product_item_order_quantity * item.product_item_price).toFixed(2)))]) : _c('span', {
        staticClass: "price",
        attrs: {
          "id": 'qty_t' + index2
        }
      }, [_c('small', [_vm._v("₦")]), _vm._v(_vm._s(item.product_item_price))])]), _vm._v(" "), (item.can_remove) ? _c('div', {}, [_c('a', {
        staticClass: "mobi-off",
        staticStyle: {
          "float": "right",
          "font-size": "18px",
          "color": "#999999",
          "cursor": "pointer"
        },
        on: {
          "click": function($event) {
            _vm.removeFromCart(item._id, index, item)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-trash"
      })])]) : _vm._e()]), _vm._v(" "), _c('li', {
        staticClass: "cart-item-row-full"
      }, [_c('div', {
        staticStyle: {
          "float": "left"
        }
      }, [(group.selected_business_delivery_option && item.product_checked) ? _c('p', [(group.selected_business_delivery_option.has_product_delivery_fee) ? _c('span', _vm._l((group.selected_business_delivery_option.business_products_delivery_fees), function(pd_fee) {
        return _c('span', [(item.product_main_id == pd_fee.product_delivery_product) ? _c('span', [_vm._v("\r\n                                Shipping Fee: ₦" + _vm._s(pd_fee.product_delivery_fee) + "\r\n                                "), _vm._v(" "), _c('label', {
          staticStyle: {
            "display": "inline"
          }
        }, [_vm._v("Total: ₦" + _vm._s(item.calculated_product_delivery_fee))])]) : _vm._e()])
      })) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
        staticStyle: {
          "float": "right",
          "display": "none"
        }
      }, [_c('span', {
        staticStyle: {
          "font-size": "12px"
        }
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (item.chk),
          expression: "item.chk"
        }],
        attrs: {
          "type": "checkbox"
        },
        domProps: {
          "checked": Array.isArray(item.chk) ? _vm._i(item.chk, null) > -1 : (item.chk)
        },
        on: {
          "click": function($event) {
            _vm.toggleSingleDisplay(item.chk, index + 's_itm_d' + index2)
          },
          "__c": function($event) {
            var $$a = item.chk,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (item.chk = $$a.concat($$v))
              } else {
                $$i > -1 && (item.chk = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
              }
            } else {
              item.chk = $$c
            }
          }
        }
      }), _vm._v("Gift/Send this Product to a different location2233")]), _vm._v(" "), _c('div', {
        staticStyle: {
          "display": "none"
        },
        attrs: {
          "id": index + 's_itm_d' + index2
        }
      })]), _vm._v(" "), _c('div', {
        staticStyle: {
          "clear": "both"
        }
      }), _vm._v(" "), (group[4]) ? _c('div', {}, _vm._l((item.product_item_discounts), function(coupon) {
        return _c('p', {
          staticStyle: {
            "line-height": "1.0",
            "font-size": "10px"
          }
        }, [((((coupon.discount_coupon == 'C') && (coupon.discount_product == item.product_main_id)) || ((coupon.discount_coupon == 'C') && (coupon.discount_product_item == item.product_item_id)))) ? _c('span', [(item.product_checked) ? _c('span', [_c('input', {
          attrs: {
            "type": "checkbox"
          },
          domProps: {
            "value": coupon.discount_id + item.product_item_id
          },
          on: {
            "click": function($event) {
              _vm.set_coupons(index, index2, coupon, coupon.discount_percentage)
            }
          }
        })]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(" " + _vm._s(coupon.discount_coupon_code) + " ( " + _vm._s(coupon.discount_percentage) + "% Off)\r\n                          "), _c('br'), _c('span', {
          staticStyle: {
            "color": "#ff0000",
            "font-size": "12px"
          }
        }, [(item.product_checked) ? _c('span', [_vm._v("select")]) : _vm._e(), _vm._v(" coupon")])])]) : _vm._e()])
      })) : _vm._e()])])
    }), _vm._v(" "), (group.selected_delivery_state_locations.length == 0) ? _c('div', {
      staticStyle: {
        "clear": "both"
      }
    }, [(group.selected_business_delivery_option || group.delivery_general_set_option) ? _c('div', [(group.selected_business_delivery_option) ? _c('p', {
      staticStyle: {
        "font-size": "13px"
      }
    }, [_c('b', [_vm._v("Shipping: ")]), _vm._v(_vm._s(group.selected_business_delivery_option.business_delivery_option) + " - ₦" + _vm._s(group.selected_business_delivery_option.business_delivery_option_price))]) : _vm._e(), _vm._v(" "), (group.delivery_general_set_option && (group.delivery_general_set_option.city)) ? _c('p', {
      staticStyle: {
        "font-size": "13px"
      }
    }, [_c('b', [_vm._v("Shipping: ")]), _vm._v(_vm._s(group.delivery_general_set_option.city.city_name) + "-" + _vm._s(group.delivery_option))]) : _vm._e()]) : _c('div', [(group.business_min_delivery_fee != 0 && (group.business_max_delivery_fee.length != 0)) ? _c('div', [_c('p', {
      staticStyle: {
        "font-size": "13px"
      }
    }, [_c('b', [_vm._v("Shipping: ")]), _vm._v("₦" + _vm._s(group.business_min_delivery_fee) + " - ₦" + _vm._s(group.business_max_delivery_fee))])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (group.items_in_checkout > 0) ? _c('div', [_c('div', {
      staticStyle: {
        "width": "100%"
      }
    }, [_c('div', {
      staticStyle: {
        "width": "50%",
        "float": "left"
      }
    }, [(group.items_in_checkout > 0) ? _c('div', [(group[4]) ? _c('div', {
      staticClass: "coupons-sec"
    }, [_vm._m(1, true), _vm._v(" "), _vm._m(2, true), _vm._v(" "), _vm._l((group[4]), function(coupon) {
      return _c('p', [(((coupon.discount_type == 2) || (coupon.discount_type == 3))) ? _c('span', [_c('input', {
        attrs: {
          "type": "checkbox"
        },
        domProps: {
          "value": coupon.discount_id
        },
        on: {
          "click": function($event) {
            _vm.set_coupons(index, 0, coupon, coupon.discount_percentage)
          }
        }
      }), _vm._v(" " + _vm._s(coupon.discount_coupon_code) + " ( " + _vm._s(coupon.discount_percentage) + "% Off )")]) : _vm._e()])
    })], 2) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "delivery-sec",
      staticStyle: {
        "width": "50%",
        "float": "right"
      }
    }, [_c('div', [(group[2]) ? _c('div', {
      key: _vm.shipping_fee_key_options
    }, [(group[2].length != 0 && !group.delivery_option) ? _c('span', {
      staticStyle: {
        "color": "#ff0000",
        "font-size": "12px"
      }
    }, [_vm._v("Please select a delivery option"), _c('br')]) : _vm._e(), _vm._v(" "), (group.delivery_states.length == 1) ? _c('div', [_vm._v("\r\n                          Shipping State:" + _vm._s(group.delivery_states[0].state_name) + "\r\n                        ")]) : _c('div', [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (group.delivery_selected_state),
        expression: "group.delivery_selected_state"
      }],
      staticClass: "sp-form-select sp-select",
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          group.delivery_selected_state = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }, function($event) {
          _vm.getDeliveryLocations(index, group.delivery_selected_state)
        }]
      }
    }, [_c('option', {
      domProps: {
        "value": undefined
      }
    }, [_vm._v("Select")]), _vm._v(" "), _vm._l((group.delivery_states), function(state) {
      return _c('option', {
        domProps: {
          "value": state
        }
      }, [_vm._v(_vm._s(state.state_name))])
    })], 2)]), _vm._v(" "), _c('div', {
      attrs: {
        "id": index + 'BDLS'
      }
    }, [_c('div', {
      key: _vm.componentDeliveryLocationsKey
    }, [(group.selected_delivery_state_locations.length != 0) ? _c('div', [_c('div', {
      staticClass: "dropdown"
    }, [(group.selected_business_delivery_option) ? _c('button', {
      staticClass: "dropbtn"
    }, [(group.selected_business_delivery_option.has_product_delivery_fee) ? _c('span', [_vm._v("\r\n                                    " + _vm._s(group.selected_business_delivery_option.business_delivery_option) + " -  ₦" + _vm._s(group.selected_business_delivery_option.business_product_delivery_fee) + "▼\r\n                                  ")]) : _c('span', [_vm._v("\r\n                                    " + _vm._s(group.selected_business_delivery_option.business_delivery_option) + " -  ₦" + _vm._s(group.selected_business_delivery_option.business_delivery_option_price) + "▼\r\n                                  ")])]) : _c('button', {
      staticClass: "dropbtn"
    }, [_vm._v("Select Delivery Location ▼")]), _vm._v(" "), _c('div', {
      staticClass: "dropdown-content"
    }, _vm._l((group.selected_delivery_state_locations), function(option) {
      return _c('div', [(option.business_delivery_product == 0) ? _c('span', [_c('label', [((group.items_in_checkout > 0)) ? _c('span', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.sellpoint_delivery_fee),
          expression: "sellpoint_delivery_fee"
        }],
        attrs: {
          "type": "radio"
        },
        domProps: {
          "value": option.business_delivery_option_id,
          "checked": _vm._q(_vm.sellpoint_delivery_fee, option.business_delivery_option_id)
        },
        on: {
          "click": function($event) {
            _vm.calc_sellpoint_delivery_fee(index, option)
          },
          "__c": function($event) {
            _vm.sellpoint_delivery_fee = option.business_delivery_option_id
          }
        }
      })]) : _vm._e(), _vm._v(" "), _c('span', {
        staticStyle: {
          "font-size": "12px"
        }
      }, [_vm._v("\r\n                                          " + _vm._s(option.business_delivery_option) + " -  ₦" + _vm._s(option.business_delivery_option_price) + "\r\n                                        ")])])]) : _vm._e()])
    }))])]) : _vm._e()])]), _vm._v(" "), (!group[2] && (group[2].length != 0)) ? _c('div', [_c('p', {
      staticStyle: {
        "color": "#ff0000",
        "font-size": "12px"
      }
    }, [_vm._v("Free Delivery")])]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin-top": "1em"
      }
    }, [_c('p', {
      staticClass: "tiny-part",
      staticStyle: {
        "line-height": "0.4"
      }
    }, [_vm._v("Total Orders ₦" + _vm._s(group.total_order_amt.toFixed(2)))]), _vm._v(" "), (group[2]) ? _c('span', [_c('p', {
      key: _vm.shipping_fee_key,
      staticClass: "tiny-part",
      staticStyle: {
        "line-height": "0.4"
      }
    }, [_vm._v("Shipping Fee:  ₦" + _vm._s(group.total_delivery_charge))]), _vm._v(" "), _c('p', {
      key: _vm.total_orders_key,
      staticClass: "tiny-part",
      staticStyle: {
        "line-height": "0.4"
      }
    }, [_vm._v("Total: ₦" + _vm._s((group.total_order_amt + group.total_delivery_charge).toFixed(2)))])]) : _c('span', [_c('p', {
      staticClass: "tiny-part"
    }, [_c('b', [_vm._v("Shipping Details:")]), _vm._v(" " + _vm._s(group.delivery_option))])]), _vm._v(" "), (group[3]) ? _c('div', {
      staticClass: "row",
      staticStyle: {
        "display": "none"
      }
    }, [_vm._m(3, true), _vm._v(" "), (!group.payment_mode) ? _c('span', {
      staticStyle: {
        "color": "#ff0000",
        "font-size": "12px"
      }
    }, [_vm._v("Please select a payment option"), _c('br')]) : _vm._e(), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.payment_option),
        expression: "payment_option"
      }],
      attrs: {
        "type": "radio",
        "value": "pay_on_delivrey"
      },
      domProps: {
        "checked": _vm._q(_vm.payment_option, "pay_on_delivrey")
      },
      on: {
        "click": function($event) {
          _vm.setPaymentOption(index, 2)
        },
        "__c": function($event) {
          _vm.payment_option = "pay_on_delivrey"
        }
      }
    }), _c('label', [_vm._v("Pay On Delivery")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.payment_option),
        expression: "payment_option"
      }],
      attrs: {
        "type": "radio",
        "value": "pay_now"
      },
      domProps: {
        "checked": _vm._q(_vm.payment_option, "pay_now")
      },
      on: {
        "click": function($event) {
          _vm.setPaymentOption(index, 1)
        },
        "__c": function($event) {
          _vm.payment_option = "pay_now"
        }
      }
    }), _c('label', [_vm._v("Pay Now")])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    }), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "100%",
        "display": "none"
      }
    })]) : _vm._e()], 2)
  })), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "5em"
    }
  }, [_c('div', {
    staticClass: "c-cart-totals"
  }, [_c('div', {
    staticClass: "size-h3 margin-bottom"
  }, [_vm._v("Cart totals")]), _vm._v(" "), _c('div', {
    staticClass: "c-cart__section in-cart-page"
  }, [_c('div', {
    staticClass: "is-heading-color weight-is-medium"
  }, [_vm._v("Items : " + _vm._s(_vm.cart.length))])]), _vm._v(" "), _c('div', {
    staticClass: "c-cart__section in-cart-page"
  }, [_c('div', {
    staticClass: "is-heading-color weight-is-medium"
  }, [_vm._v("Subtotal: ₦" + _vm._s(_vm.total_order_amt.toFixed(2)))]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.total_order_amt == 0) ? _c('span', {
    staticStyle: {
      "clear": "both",
      "color": "#ff0000"
    }
  }, [_vm._v("select items to checkout")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "c-cart__section in-cart-page xs-is-wrapping",
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "is-heading-color weight-is-medium xs-margin-bottom"
  }, [_vm._v("State: ")]), _vm._v(" "), _c('div', {
    staticClass: "basis-200px"
  }, [_c('div', {
    staticClass: "w-form"
  }, [_c('form', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.order_delivery_main_location.state),
      expression: "order_delivery_main_location.state"
    }],
    staticClass: "form-select w-select",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.order_delivery_main_location.state = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.getCities(_vm.order_delivery_main_location.state)
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select...")]), _vm._v(" "), _vm._l((_vm.states), function(state) {
    return _c('option', {
      domProps: {
        "value": state
      }
    }, [_vm._v(_vm._s(state.name))])
  })], 2)])])])]), _vm._v(" "), (_vm.cities.length != 0) ? _c('div', {
    staticClass: "c-cart__section in-cart-page xs-is-wrapping",
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "is-heading-color weight-is-medium xs-margin-bottom"
  }, [_vm._v("Location: ")]), _vm._v(" "), _c('div', {
    staticClass: "basis-200px"
  }, [_c('div', {
    staticClass: "w-form"
  }, [_c('form', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.order_delivery_main_location.city),
      expression: "order_delivery_main_location.city"
    }],
    staticClass: "form-select w-select",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.order_delivery_main_location.city = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.setOrderLocations(_vm.order_delivery_main_location)
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select...")]), _vm._v(" "), _vm._l((_vm.cities), function(city) {
    return _c('option', {
      domProps: {
        "value": city
      }
    }, [_vm._v(_vm._s(city.city_name))])
  })], 2)])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "c-cart__section in-cart-page"
  }), _vm._v(" "), _c('div', {
    staticClass: "c-cart__section in-cart-page no-border-bottom"
  }, [_c('div', {
    staticClass: "is-heading-color weight-is-medium"
  }, [_vm._v("Total: ₦" + _vm._s((_vm.total_order_amt + _vm.total_delivery_fee).toFixed(2)))])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))])]), _vm._v(" "), _c('div', {
    staticClass: "mobile-fix-nav"
  }, [_c('div', {
    staticStyle: {
      "padding": "1em"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "background": "#ffa800",
      "width": "100vw",
      "padding": "0.8em"
    }
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer",
      "color": "#000000",
      "text-decoration": "none"
    },
    on: {
      "click": function($event) {
        _vm.process_orders()
      }
    }
  }, [_vm._v("Process Orders")])])])])])]) : _vm._e()]), _vm._v(" "), (this.$route.path == '/order') ? _c('div', {
    staticClass: "order-widget"
  }, [_c('div', {
    staticClass: "col-md-12 col-sm-12",
    staticStyle: {
      "background": "#ffffff"
    }
  }, [_c('h2', {
    staticStyle: {
      "padding-top": "2em",
      "font-size": "18px"
    },
    attrs: {
      "align": "center"
    }
  }, [_vm._v("Process your Order")]), _vm._v(" "), _vm._l((_vm.sorted_cart), function(group, index) {
    return _c('div', {
      staticStyle: {
        "margin-top": "1em",
        "margin-bottom": "6em"
      }
    }, [(index == (_vm.sorted_cart.length - 1)) ? _c('div', {
      staticClass: "row group-row"
    }, _vm._l((group[1]), function(item, index2) {
      return _c('ul', {}, [(index2 == (group[1].length - 1)) ? _c('div', [(item.active_order) ? _c('div', [_c('div', [_c('li', {
        staticClass: "col-xs-12"
      }, [_c('div', {}, [_c('a', {
        staticClass: "item-img cart-img",
        staticStyle: {
          "cursor": "pointer"
        },
        attrs: {
          "href": item.product_url
        }
      }, [((item.product_item_image && (item.product_item_image != ''))) ? _c('img', {
        staticClass: "sp-prd-img",
        attrs: {
          "src": _vm.img_product_url + item.product_item_image
        }
      }) : _c('img', {
        staticClass: "sp-prd-img",
        attrs: {
          "src": "/static/assets/images/dummy-image.png"
        }
      })])])]), _vm._v(" "), _c('li', {
        staticClass: "col-xs-12"
      }, [_c('div', {
        staticStyle: {
          "margin-top": "-1em"
        }
      }, [_c('li', [_c('h4', [_vm._v(_vm._s(item.product_name))]), _vm._v(" "), _c('label', {
        staticStyle: {
          "display": "inline"
        }
      }, [_vm._v("Price: ")]), _vm._v(" "), _c('span', {
        staticClass: "price"
      }, [_c('small', [_vm._v("₦")]), _vm._v(_vm._s(item.product_item_price))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('li', {
        staticStyle: {
          "margin-bottom": "5px"
        }
      }, [_c('label', {
        staticStyle: {
          "display": "inline"
        }
      }, [_vm._v("Qty: ")]), _vm._v(" "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (item.product_item_order_quantity),
          expression: "item.product_item_order_quantity"
        }],
        staticStyle: {
          "border": "solid #000000 1px",
          "max-width": "52px",
          "max-height": "32px"
        },
        attrs: {
          "type": "number"
        },
        domProps: {
          "value": (item.product_item_order_quantity)
        },
        on: {
          "change": function($event) {
            _vm.refreshCheckout(item, index, index2)
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            item.product_item_order_quantity = $event.target.value
          }
        }
      }), _vm._v(" "), _c('p', {
        staticStyle: {
          "color": "#f73676"
        },
        attrs: {
          "id": 'qty_c' + index2
        }
      }, [_vm._v(_vm._s(item.check_order_quantity))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('li', {
        attrs: {
          "id": 'qty_t' + index2
        }
      }, [_c('label', {
        staticStyle: {
          "display": "inline"
        }
      }, [_vm._v("Total: ")]), _vm._v(" "), _c('span', {
        staticClass: "price"
      }, [_c('small', [_vm._v("₦")]), _vm._v(_vm._s((item.product_item_order_quantity * item.product_item_price).toFixed(2)))])])]), _vm._v(" "), _c('div', [(item.product_checked) ? _c('a', {
        staticClass: "btn order-btn",
        staticStyle: {
          "margin-top": "3px",
          "float": "right"
        },
        attrs: {
          "href": "/"
        }
      }, [_vm._v("Cancel Order")]) : _c('button', {
        staticClass: "btn order-btn",
        on: {
          "click": function($event) {
            _vm.addToCheckout(item, index, index2)
          }
        }
      }, [_vm._v("Process Order")])])]), _vm._v(" "), _c('div', {
        staticClass: "clearfix"
      })]), _vm._v(" "), _c('div', {
        staticStyle: {
          "display": "none"
        },
        attrs: {
          "id": item.index2 + 'PRT_CART'
        }
      }, [(group.items_in_checkout > 0) ? _c('div', {
        staticClass: "col-md-4"
      }, [(group[4] && (group[4].length > 0)) ? _c('div', {}, [_vm._m(4, true), _vm._v(" "), _vm._m(5, true), _vm._v(" "), _vm._l((group[4]), function(coupon) {
        return _c('p', [(_vm.canUseCoupon(coupon)) ? _c('span', [((coupon.discount_type == 2) || (coupon.discount_type == 3)) ? _c('span', {
          staticStyle: {
            "color": "#ff0000",
            "font-size": "12px",
            "line-height": "0.8"
          }
        }, [_vm._v("Business Coupon")]) : _vm._e(), _vm._v(" "), ((coupon.discount_type == 4) || (coupon.discount_type == 5)) ? _c('span', {
          staticStyle: {
            "color": "#ff0000",
            "font-size": "12px",
            "line-height": "0.8"
          }
        }, [_vm._v("Product Coupon")]) : _vm._e(), _vm._v(" "), _c('br'), _c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (_vm.coupon_code),
            expression: "coupon_code"
          }],
          attrs: {
            "type": "checkbox"
          },
          domProps: {
            "value": coupon.discount_id,
            "checked": Array.isArray(_vm.coupon_code) ? _vm._i(_vm.coupon_code, coupon.discount_id) > -1 : (_vm.coupon_code)
          },
          on: {
            "click": function($event) {
              _vm.set_coupons(index, index2, coupon, coupon.discount_percentage)
            },
            "__c": function($event) {
              var $$a = _vm.coupon_code,
                $$el = $event.target,
                $$c = $$el.checked ? (true) : (false);
              if (Array.isArray($$a)) {
                var $$v = coupon.discount_id,
                  $$i = _vm._i($$a, $$v);
                if ($$el.checked) {
                  $$i < 0 && (_vm.coupon_code = $$a.concat($$v))
                } else {
                  $$i > -1 && (_vm.coupon_code = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
                }
              } else {
                _vm.coupon_code = $$c
              }
            }
          }
        }), _vm._v(" " + _vm._s(coupon.discount_coupon_code) + " ( " + _vm._s(coupon.discount_percentage) + "% Off )")]) : _vm._e()])
      })], 2) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "col-md-8"
      }, [_c('div', [(group[2]) ? _c('div', {
        key: _vm.shipping_fee_key_options
      }, [(group[2].length != 0 && !group.delivery_option) ? _c('span', {
        staticStyle: {
          "color": "#ff0000",
          "font-size": "12px"
        }
      }, [_vm._v("Please select a delivery option"), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.action_loading) ? _c('div', {
        staticClass: "loading-sm"
      }) : _vm._e(), _vm._v(" "), (group[2].length != 0) ? _c('div', [_c('div', {
        staticClass: "dropdown"
      }, [(group.selected_business_delivery_option) ? _c('button', {
        staticClass: "dropbtn",
        staticStyle: {
          "width": "18em",
          "text-align": "left"
        }
      }, [(group.selected_business_delivery_option.has_product_delivery_fee) ? _c('span', [_vm._v("\r\n                                  " + _vm._s(group.selected_business_delivery_option.business_delivery_option) + " -  ₦" + _vm._s(group.selected_business_delivery_option.business_product_delivery_fee) + "▼\r\n                                ")]) : _c('span', [_vm._v("\r\n                                  " + _vm._s(group.selected_business_delivery_option.business_delivery_option) + " -  ₦" + _vm._s(group.selected_business_delivery_option.business_delivery_option_price) + "▼\r\n                                ")])]) : _c('button', {
        staticClass: "dropbtn"
      }, [_vm._v("Select Delivery Location ▼")]), _vm._v(" "), _c('div', {
        staticClass: "dropdown-content"
      }, _vm._l((group[2]), function(option) {
        return _c('div', [(option.business_delivery_product == 0) ? _c('span', [_c('label', [((group.items_in_checkout > 0) && (group.products_without_delivery_details_checked.length > 0)) ? _c('span', [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (_vm.sellpoint_delivery_fee),
            expression: "sellpoint_delivery_fee"
          }],
          attrs: {
            "type": "radio"
          },
          domProps: {
            "value": option.business_delivery_option_id,
            "checked": _vm._q(_vm.sellpoint_delivery_fee, option.business_delivery_option_id)
          },
          on: {
            "click": function($event) {
              _vm.calc_sellpoint_delivery_fee(index, option)
            },
            "__c": function($event) {
              _vm.sellpoint_delivery_fee = option.business_delivery_option_id
            }
          }
        })]) : _vm._e(), _vm._v(" "), (option.has_product_delivery_fee) ? _c('span', [_vm._v("\r\n                                        " + _vm._s(option.business_delivery_option) + " -  ₦" + _vm._s(option.business_product_delivery_fee) + "\r\n                                      ")]) : _c('span', [_vm._v("\r\n                                        " + _vm._s(option.business_delivery_option) + " -  ₦" + _vm._s(option.business_delivery_option_price) + "\r\n                                      ")])])]) : _vm._e()])
      }))])]) : _c('div', [_c('p', {
        staticStyle: {
          "color": "#ff0000",
          "font-size": "12px"
        }
      }, [_vm._v("Free Delivery")])])]) : _vm._e()]), _vm._v(" "), _c('div', [(group[2]) ? _c('span', [_c('p', {
        key: _vm.shipping_fee_key,
        staticClass: "tiny-part"
      }, [_vm._v("Shipping Fee:  ₦" + _vm._s(group.total_delivery_charge))]), _vm._v(" "), _c('p', {
        key: _vm.total_orders_key,
        staticClass: "tiny-part"
      }, [_vm._v("Total: ₦" + _vm._s((group.total_order_amt + group.total_delivery_charge).toFixed(2)))])]) : _c('span', [_c('p', {
        staticClass: "tiny-part"
      }, [_c('b', [_vm._v("Shipping Details:")]), _vm._v(" " + _vm._s(group.delivery_option))])]), _vm._v(" "), (group[3]) ? _c('div', {
        staticStyle: {
          "display": "none"
        }
      }, [_vm._m(6, true), _vm._v(" "), (!group.payment_mode) ? _c('span', {
        staticStyle: {
          "color": "#ff0000",
          "font-size": "12px"
        }
      }, [_vm._v("Please select a payment option"), _c('br')]) : _vm._e(), _vm._v(" "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.payment_option),
          expression: "payment_option"
        }],
        attrs: {
          "type": "radio",
          "value": "pay_on_delivrey"
        },
        domProps: {
          "checked": _vm._q(_vm.payment_option, "pay_on_delivrey")
        },
        on: {
          "click": function($event) {
            _vm.setPaymentOption(index, 2)
          },
          "__c": function($event) {
            _vm.payment_option = "pay_on_delivrey"
          }
        }
      }), _c('label', [_vm._v("Pay On Delivery")]), _vm._v(" "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.payment_option),
          expression: "payment_option"
        }],
        attrs: {
          "type": "radio",
          "value": "pay_now"
        },
        domProps: {
          "checked": _vm._q(_vm.payment_option, "pay_now")
        },
        on: {
          "click": function($event) {
            _vm.setPaymentOption(index, 1)
          },
          "__c": function($event) {
            _vm.payment_option = "pay_now"
          }
        }
      }), _c('label', [_vm._v("Pay Now")])]) : _c('div', {
        staticStyle: {
          "display": "none"
        }
      }, [_vm._m(7, true)]), _vm._v(" "), (_vm.buy_now_order && (_vm.checked_out.length != 0)) ? _c('div', {
        staticClass: "text-align"
      }, [_c('p', {
        staticStyle: {
          "color": "#ff0000"
        }
      }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
        staticClass: "btn btn-primary",
        staticStyle: {
          "background": "#000000"
        },
        on: {
          "click": function($event) {
            _vm.process_orders()
          }
        }
      }, [_vm._v("Proceed")])]) : _vm._e()])])])]) : _vm._e()]) : _vm._e()])
    })) : _vm._e()])
  })], 2)]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cart-summ",
    staticStyle: {
      "text-align": "center",
      "width": "100%",
      "margin-bottom": "1em"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("Select Items to checkout and click *Process Orders* to continue.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Applied Business Coupons")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "color": "#ff0000",
      "font-size": "14px"
    }
  }, [_vm._v("Please select coupons "), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tiny-part"
  }, [_c('b', [_vm._v("Payment Mode")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Applied Coupons")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "color": "#ff0000",
      "font-size": "14px"
    }
  }, [_vm._v("Please select coupons"), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tiny-part"
  }, [_c('b', [_vm._v("Payment Mode")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tiny-part"
  }, [_vm._v("Payment Mode: "), _c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("Pay Now")])])
}]}

/***/ }),
/* 260 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pager"
  }, [_c('div', {
    staticClass: "container",
    staticStyle: {
      "border": "solid #e9e5e5",
      "border-radius": "3px",
      "background": "#ffffff"
    }
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "padding": "0 1em",
      "text-align": "left"
    }
  }, [_c('h5', [_vm._v(_vm._s(_vm.sellpoint.business_name) + "\r\n          "), _c('span', {
    staticStyle: {
      "float": "right",
      "font-size": "22px"
    }
  }, [(_vm.catvw) ? _c('a', {
    on: {
      "click": _vm.hide_cat
    }
  }, [_c('i', {
    staticClass: "fa fa-caret-down"
  })]) : _c('a', {
    on: {
      "click": _vm.show_cat
    }
  }, [_c('i', {
    staticClass: "fa fa-caret-down"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "p-cat",
    attrs: {
      "id": "cat-nav"
    }
  }, [_c('ul', _vm._l((_vm.sellpoint.business_categories), function(category) {
    return _c('li', [_c('a', {
      attrs: {
        "href": "#"
      }
    }, [_vm._v(_vm._s(category.business_category))])])
  }))])])]), _vm._v(" "), _c('div', {
    staticClass: "container",
    staticStyle: {
      "background": "#ffffff",
      "margin-bottom": "4em"
    }
  }, [_c('div', {}, _vm._l((_vm.products), function(product, index) {
    return _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticStyle: {
        "margin": "1em"
      }
    }, [_c('a', {
      staticStyle: {
        "text-decoration": "none",
        "color": "inherit"
      },
      attrs: {
        "href": '/' + _vm.sellpoint.business_username + '/' + product.product_url_name
      }
    }, [_c('div', {
      staticClass: "col-xs-3",
      staticStyle: {
        "height": "75px",
        "width": "25%",
        "padding": "0"
      }
    }, [(product.product_images[0]) ? _c('div', {
      staticStyle: {
        "height": "100%",
        "width": "80px",
        "background-position": "center",
        "background-size": "cover"
      },
      style: ({
        'background-image': 'url(' + product.product_images[0].product_image + ')'
      })
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-9",
      staticStyle: {
        "width": "75%"
      }
    }, [_c('div', {
      staticClass: "card-arm-line"
    }, [_c('p', [_vm._v(_vm._s(product.product_name)), _c('br'), _vm._v(" "), (product.product_items[0]) ? _c('span', {
      staticStyle: {
        "font-size": "12px"
      }
    }, [_vm._v("₦" + _vm._s(product.product_items[0].product_item_price) + " \r\n                      "), _c('del', [_vm._v("₦" + _vm._s(product.product_items[0].product_item_price))])]) : _vm._e(), _c('br'), _vm._v(" "), _vm._m(0, true)])])])])])])
  }))])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('ul', {
    staticStyle: {
      "display": "inline",
      "color": "#ffd900",
      "margin": "0",
      "padding": "0"
    }
  }, [_c('li', [_c('i', {
    staticClass: "fa fa-star"
  })]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-star"
  })]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-star"
  })]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-star"
  })])])])
}]}

/***/ }),
/* 261 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-wrap",
    attrs: {
      "id": "wrap"
    }
  }, [_c('component-header'), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pager home-bg"
  }, [_c('div', {}, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "margin-top": "8em",
      "text-align": "center"
    }
  }, [_c('h2', {
    staticClass: "hero-intro"
  }, [_vm._v("Stanel World")]), _vm._v(" "), _c('h3', {
    staticClass: "hero-text"
  }, [_vm._v("Get More Value")]), _vm._v(" "), _c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/assets/images/shopping-bag1.png",
      "width": "530",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "margin-top": "2em",
      "text-align": "center"
    }
  }, [_c('a', {
    staticClass: "btn sp-button-1 btn-clear",
    staticStyle: {
      "margin": "1em"
    },
    attrs: {
      "href": "/timeline"
    }
  }, [_vm._v("Welcome")])])])])])
}]}

/***/ }),
/* 262 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "wrap"
    }
  }, [_c('component-header'), _vm._v(" "), _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('section', {
    attrs: {
      "id": "banner"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('router-view')], 1)])]), _vm._v(" "), _c('component-footer')], 1)
},staticRenderFns: []}

/***/ }),
/* 263 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c("div")
},staticRenderFns: []}

/***/ }),
/* 264 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-wrap",
    attrs: {
      "id": "wrap"
    }
  }, [_c('component-header'), _vm._v(" "), _c('div', {
    staticClass: "pager"
  }, [_c('div', {
    staticClass: "container card-box card-box-full"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "login"
    }
  }, [_c('p', {
    staticClass: "text-muted"
  }, [_vm._v("Log into your account")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000",
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 col-xs-offset-5",
    staticStyle: {
      "text-align": "center"
    }
  }, [(_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e()]), _vm._v(" "), _c('form', {
    staticClass: "gw-form"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "sr-only",
    attrs: {
      "for": "my-email"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }],
    staticClass: "form-control input-group-lg",
    attrs: {
      "id": "my-email",
      "type": "text",
      "name": "Email",
      "title": "Enter Email",
      "placeholder": "Your Email"
    },
    domProps: {
      "value": (_vm.user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "sr-only",
    attrs: {
      "for": "my-password"
    }
  }, [_vm._v("Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.password),
      expression: "user.password"
    }],
    staticClass: "form-control input-group-lg",
    attrs: {
      "id": "my-password",
      "type": "password",
      "name": "password",
      "title": "Enter password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.user.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.password = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1",
    attrs: {
      "disabled": _vm.disable_btn
    },
    on: {
      "click": _vm.login
    }
  }, [_vm._v("Login")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(0)])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    staticStyle: {
      "color": "#777777"
    },
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Forgot Password?")]), _vm._v(" or "), _c('a', {
    staticStyle: {
      "color": "#888888"
    },
    attrs: {
      "href": "/register"
    }
  }, [_vm._v("Register?")])])
}]}

/***/ }),
/* 265 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "friend-list"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('h3', {
    staticStyle: {
      "color": "#ff5566",
      "padding": "1em"
    }
  }, [_vm._v("Top activity products")]), _vm._v(" "), _vm._l((_vm.products), function(product, index) {
    return _c('div', {
      key: index,
      staticClass: "col-md-4 col-sm-4 col-xs-6"
    }, [((product.product_items.length != 0)) ? _c('div', {
      staticStyle: {
        "min-height": "23em",
        "max-height": "22em"
      }
    }, [_c('a', {
      staticStyle: {
        "color": "inherit",
        "text-decoration": "none"
      },
      attrs: {
        "href": '/' + product.product_business_username + '/' + product.product_url_name
      }
    }, _vm._l((product.product_items), function(product_item, index2) {
      return _c('div', {
        key: index2,
        staticClass: "friend-card",
        staticStyle: {
          "min-height": "22em",
          "max-height": "22em",
          "border-bottom-color": "rgb(182, 176, 176)"
        }
      }, [(index2 == 0) ? _c('div', [_c('div', {
        staticStyle: {
          "height": "10em"
        }
      }, [_c('img', {
        staticClass: "sp-prd-img",
        attrs: {
          "src": product_item.product_item_image,
          "alt": "photo"
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "card-info"
      }, [_c('div', {
        staticClass: "friend-info"
      }, [_c('a', {
        staticClass: "pull-right text-green",
        staticStyle: {
          "font-size": "12px"
        },
        attrs: {
          "href": "#"
        }
      }, [_vm._v("@" + _vm._s(product.product_business_name))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h5', {
        staticStyle: {
          "height": "3em"
        }
      }, [_c('a', {
        staticClass: "profile-link",
        attrs: {
          "href": "#"
        }
      }, [_vm._v(_vm._s(product.product_name))])]), _vm._v(" "), _c('p', [_vm._v("₦" + _vm._s(product_item.product_item_price.toLocaleString('en', {
        useGrouping: true
      })))]), _vm._v(" "), _vm._m(0, true)])])]) : _vm._e()])
    }))]) : _vm._e()])
  })], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pull-right",
    staticStyle: {
      "margin-bottom": "1em"
    }
  }, [_c('a', {
    staticClass: "btn text-red",
    attrs: {
      "title": "Like"
    }
  }, [_c('i', {
    staticClass: "fa fa-heart-o",
    staticStyle: {
      "font-size": "14px"
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "btn text-red",
    attrs: {
      "title": "Add to Cart"
    }
  }, [_c('i', {
    staticClass: "fa fa-shopping-cart",
    staticStyle: {
      "font-size": "14px"
    }
  })])])
}]}

/***/ }),
/* 266 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "bottombar",
    staticStyle: {
      "margin-top": "15em"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('a', {
    staticClass: "col-xs-3",
    attrs: {
      "href": "/timeline"
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  }), _c('br'), _c('span', [_vm._v("Shops")])]), _vm._v(" "), _c('a', {
    staticClass: "col-xs-3",
    attrs: {
      "href": "/account"
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _c('br'), _c('span', [_vm._v("Search")])]), _vm._v(" "), _c('a', {
    staticClass: "col-xs-3",
    attrs: {
      "href": "/notifications"
    }
  }, [_c('i', {
    staticClass: "fa fa-bell"
  }), _c('br'), _c('span', [_vm._v("Notifications")])]), _vm._v(" "), _c('a', {
    staticClass: "col-xs-3",
    attrs: {
      "href": "/cart"
    }
  }, [_c('i', {
    staticClass: "fa fa-shopping-bag"
  }), _c('br'), _c('span', [_vm._v("Bag")])])])])])
}]}

/***/ }),
/* 267 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pager",
    attrs: {
      "id": "wrap"
    }
  }, [_c('component-header'), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "5em"
    }
  }, [(!_vm.setPanel) ? _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "banner-menu",
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "menu-links"
  }, [_c('ul', [_c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.setMenuComponent('profile')
      }
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "pull-left",
    staticStyle: {
      "padding": "1em"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.user.user_name))])])])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.setMenuComponent('orders')
      }
    }
  }, [_vm._m(2), _vm._v(" "), _vm._m(3)])]), _vm._v(" "), (!_vm.loading) ? _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.setBusinessComponent('sellpoints')
      }
    }
  }, [_vm._m(4), _vm._v(" "), _vm._m(5)])]) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.setComponent('manage-panel')
      }
    }
  }, [_vm._m(6), _vm._v(" "), _vm._m(7)])]) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.setMenuComponent('sidehustle')
      }
    }
  }, [_vm._m(8), _vm._v(" "), _vm._m(9)])]) : _vm._e(), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.setMenuComponent('settings')
      }
    }
  }, [_vm._m(10), _vm._v(" "), _vm._m(11)])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.setMenuComponent('settings')
      }
    }
  }, [_vm._m(12), _vm._v(" "), _vm._m(13)])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.setMenuComponent('settings')
      }
    }
  }, [_vm._m(14), _vm._v(" "), _vm._m(15)])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.setMenuComponent('settings')
      }
    }
  }, [_vm._m(16), _vm._v(" "), _vm._m(17)])])])])])]) : _vm._e(), _vm._v(" "), (_vm.setPanel) ? _c('div', {
    staticClass: "panel"
  }, [(_vm.menu_view.profile) ? _c('div', [_vm._v("\r\n              hi pro\r\n          ")]) : _vm._e()]) : _vm._e()])])]), _vm._v(" "), _c('component-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "loading-md"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pull-left"
  }, [_c('div', {
    staticClass: "avatar"
  }, [_c('img', {
    staticStyle: {
      "border-radius": "50%"
    },
    attrs: {
      "src": "/static/assets/images/dummy-image.png",
      "width": "50",
      "height": "50"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "ac_icon"
  }, [_c('i', {
    staticClass: "fa fa-shopping-cart"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "ac_subject"
  }, [_c('h4', [_vm._v("Orders")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("your orders from stores")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "ac_icon"
  }, [_c('i', {
    staticClass: "fa fa-briefcase"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "ac_subject"
  }, [_c('h4', [_vm._v("Sellpoints")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("your Businesses sellpoints")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "ac_icon"
  }, [_c('i', {
    staticClass: "fa fa-shopping-bag"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "ac_subject"
  }, [_c('h4', [_vm._v("Buypoints")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("your Buying Interests and settings")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "ac_icon"
  }, [_c('i', {
    staticClass: "fa fa-user"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "ac_subject"
  }, [_c('h4', [_vm._v("Sidehustle")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("your Agent/Sidehhustle Businesses")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "ac_icon"
  }, [_c('i', {
    staticClass: "fa fa-gear"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "ac_subject"
  }, [_c('h4', [_vm._v("Settings")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("limits, accounts, orders, payments")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "ac_icon"
  }, [_c('i', {
    staticClass: "fa fa-cloud"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "ac_subject"
  }, [_c('h4', [_vm._v("Storage")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("your cloud storage")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "ac_icon"
  }, [_c('i', {
    staticClass: "fa fa-question"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "ac_subject"
  }, [_c('h4', [_vm._v("Knowledge Center")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("Help, FAQs, terms, privacy")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "ac_icon"
  }, [_c('i', {
    staticClass: "fa fa-users"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "ac_subject"
  }, [_c('h4', [_vm._v("Invite a Friend")])])
}]}

/***/ }),
/* 268 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.open_request) ? _c('div', {}, [(_vm.loading) ? _c('div', [(_vm.loading) ? _c('div', {
    staticClass: "loading-md"
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "13px",
      "color": "#000000"
    }
  }, [_vm._v("Preparing and Checking your Sellpoint for previously added products and services")])]) : _c('form', {
    staticClass: "gw-form"
  }, [_c('h6', [_vm._v("Add a New Product Lookbook to your Gallery")]), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.showGalleryForm) ? _c('div', [_c('div', [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gallery.gallery_name),
      expression: "gallery.gallery_name"
    }],
    attrs: {
      "type": "text",
      "value": "",
      "placeholder": "What's the Name of your Lookbook"
    },
    domProps: {
      "value": (_vm.gallery.gallery_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.gallery.gallery_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Description")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gallery.gallery_description),
      expression: "gallery.gallery_description"
    }],
    attrs: {
      "placeholder": "What's this Lookbook all about"
    },
    domProps: {
      "value": (_vm.gallery.gallery_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.gallery.gallery_description = $event.target.value
      }
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('div', [(_vm.products.length > 0) ? _c('div', [_c('h6', {
    staticStyle: {
      "font-size": "16px",
      "margin-bottom": "1em"
    }
  }, [_vm._v("Do you want to add from your products?")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n                        " + _vm._s(this.selected_produts) + "\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "row sp-products-row"
  }, _vm._l((_vm.products), function(p, pdex) {
    return _c('div', {
      key: pdex,
      staticClass: "col-xs-4",
      staticStyle: {
        "padding": "5px",
        "margin": "1em",
        "width": "10%",
        "height": "6em"
      }
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "title": p.product_name
      },
      on: {
        "click": function($event) {
          _vm.setComponent('add-to-gallery-product', p)
        }
      }
    }, [(p.product_images[0]) ? _c('div', {
      staticClass: "box-color-cube"
    }, [_c('sup', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (p.product_checked),
        expression: "p.product_checked"
      }],
      attrs: {
        "type": "checkbox",
        "id": p.product_id + 'PRDC'
      },
      domProps: {
        "checked": Array.isArray(p.product_checked) ? _vm._i(p.product_checked, null) > -1 : (p.product_checked)
      },
      on: {
        "__c": function($event) {
          var $$a = p.product_checked,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (p.product_checked = $$a.concat($$v))
            } else {
              $$i > -1 && (p.product_checked = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            p.product_checked = $$c
          }
        }
      }
    })]), _vm._v(" "), _c('img', {
      staticClass: "product-select sp-prd-img",
      staticStyle: {
        "height": "5em",
        "width": "95%"
      },
      attrs: {
        "src": p.product_images[0].product_image,
        "id": p.product_id + 'PRD'
      }
    })]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
      staticStyle: {
        "font-size": "9px",
        "line-height": "1.2"
      }
    }, [_c('b', [_vm._v(_vm._s(p.product_name))])])])])
  }))]) : _vm._e(), _vm._v(" "), _c('div', [_c('hr'), _c('button', {
    staticClass: "btn",
    staticStyle: {
      "background": "#ffcc00"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('show-add-product-form', '')
      }
    }
  }, [_c('b', [(_vm.products.length > 0) ? _c('span', [_vm._v(" Or ")]) : _vm._e(), _vm._v(" Add New Product / Service")])])]), _vm._v(" "), (_vm.showProductForm) ? _c('div', {
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('h6', [_vm._v("Add Product / Service")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('button', {
    staticClass: "pull-right btn",
    staticStyle: {
      "background": "#cc6655",
      "color": "#ffffff"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.reset
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('form', {
    staticClass: "gw-form",
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "line-wrap"
  }, [_vm._v("Product")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.is_product_service),
      expression: "is_product_service"
    }],
    staticClass: "sp-radio-btn",
    staticStyle: {
      "height": "20px"
    },
    attrs: {
      "type": "radio",
      "value": "product"
    },
    domProps: {
      "checked": _vm._q(_vm.is_product_service, "product")
    },
    on: {
      "__c": function($event) {
        _vm.is_product_service = "product"
      }
    }
  }), _vm._v("\n                                           \n                                     "), _c('label', [_vm._v(" Service ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.is_product_service),
      expression: "is_product_service"
    }],
    staticClass: "sp-radio-btn",
    staticStyle: {
      "height": "20px"
    },
    attrs: {
      "type": "radio",
      "value": "service"
    },
    domProps: {
      "checked": _vm._q(_vm.is_product_service, "service")
    },
    on: {
      "__c": function($event) {
        _vm.is_product_service = "service"
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sp-form-descr"
  }, [_vm._v("is this a Product or Service?")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(4), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_name),
      expression: "product.product_name"
    }],
    attrs: {
      "type": "text",
      "value": "",
      "placeholder": "Name of Product / Service"
    },
    domProps: {
      "value": (_vm.product.product_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_name = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.sellpoint_categories.length > 0) ? _c('div', {
    staticClass: "form-group"
  }, [_vm._m(5), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_category),
      expression: "product.product_category"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "category-type-1"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.product.product_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.trackevent('category-type-1')
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "0",
      "disabled": _vm.category_type_1
    }
  }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.sellpoint_categories), function(category) {
    return _c('option', {
      key: category.business_category_id,
      attrs: {
        "disabled": _vm.category_type_1
      },
      domProps: {
        "value": category.business_category_id
      }
    }, [_vm._v(_vm._s(category.business_category))])
  })], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [(_vm.sellpoint_categories.length > 0) ? _c('span', [_c('b', [_vm._v("Or ")])]) : _vm._e(), _vm._v(" Select from Related Categories ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.main_category),
      expression: "main_category"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.main_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.getSubCategories(_vm.main_category)
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.categories), function(category) {
    return _c('option', {
      key: category.category_id,
      domProps: {
        "value": category
      }
    }, [_vm._v(_vm._s(category.category_name))])
  })], 2), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.sub_categories.length != 0) ? _c('label', [_vm._v(" Select a Category ")]) : _vm._e(), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_sub_category),
      expression: "product.product_sub_category"
    }],
    staticClass: "form-control category-type-2",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.product.product_sub_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.trackevent('category-type-2')
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "0",
      "disabled": _vm.category_type_2
    }
  }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.sub_categories), function(category) {
    return _c('option', {
      key: category.sub_category_id,
      attrs: {
        "disabled": _vm.category_type_2
      },
      domProps: {
        "value": category.sub_category_id
      }
    }, [_vm._v(_vm._s(category.sub_category_name))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(6), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_listed_category),
      expression: "product.product_listed_category"
    }],
    attrs: {
      "disabled": _vm.category_type_3,
      "type": "text",
      "placeholder": "",
      "id": "category-type-3"
    },
    domProps: {
      "value": (_vm.product.product_listed_category)
    },
    on: {
      "change": function($event) {
        _vm.trackevent('category-type-3')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_listed_category = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(" *Description")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_description),
      expression: "product.product_description"
    }],
    attrs: {
      "placeholder": "Provide details of your product/service"
    },
    domProps: {
      "value": (_vm.product.product_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_description = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(7), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_price),
      expression: "product.product_item_price"
    }],
    attrs: {
      "type": "number",
      "placeholder": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.product.product_item_price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_price = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.is_product_service == 'product') ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Weight(Kg)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_weight),
      expression: "product.product_item_weight"
    }],
    attrs: {
      "type": "number",
      "step": "any",
      "placeholder": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.product.product_item_weight)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_weight = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Quantity ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_quantity),
      expression: "product.product_item_quantity"
    }],
    attrs: {
      "type": "number",
      "placeholder": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.product.product_item_quantity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_quantity = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "upload-btn-wrapper",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('button', {
    staticClass: "upload-btn",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Add "), _c('span', {
    staticStyle: {
      "text-transform": "capitalize"
    }
  }, [_vm._v(_vm._s(_vm.is_product_service))]), _vm._v(" Image")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.onFileChange($event)
      }
    }
  }), _vm._v(" "), (_vm.file_info[0]) ? _c('span', [_c('b', [_vm._v("Added " + _vm._s(_vm.file_info[0].name))])]) : _vm._e(), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e()]), _vm._v(" "), _vm._m(8)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('p', {
    staticStyle: {
      "color": "#ee87a6"
    }
  }, [_vm._v(_vm._s(_vm.data_success_message)), _c('br'), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#ffcc00"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))])]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "pull-left btn",
    staticStyle: {
      "background": "#ff0055",
      "color": "#ffffff"
    },
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": _vm.addProduct
    }
  }, [_vm._v("Add Product")]), _vm._v(" "), _c('button', {
    staticClass: "pull-right btn",
    staticStyle: {
      "color": "#ffffff"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.reset
    }
  }, [_vm._v("Cancel")])])])]) : _vm._e(), _vm._v(" "), _c('div', [(_vm.canAddGallery) ? _c('div', {
    staticClass: "form-group"
  }, [_c('p', {
    staticStyle: {
      "color": "#ee87a6"
    }
  }, [_vm._v(_vm._s(_vm.data_success_message))]), _vm._v(" "), (_vm.addProductPost) ? _c('button', {
    staticClass: "btn",
    staticStyle: {
      "background": "#ff0055",
      "color": "#ffffff"
    },
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": _vm.addProductPostGallery
    }
  }, [_vm._v("Add Post to Lookbook")]) : _c('button', {
    staticClass: "btn",
    staticStyle: {
      "background": "#ff0055",
      "color": "#ffffff"
    },
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": _vm.addGallery
    }
  }, [_vm._v("Add Lookbook")]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e()]) : _vm._e()])])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "sp-form-descr"
  }, [_vm._v("(your product lookbook is a collection or group of products you want to keep together as posts)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Product lookbook Name "), _c('span', {
    staticClass: "sp-form-must"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_c('span', {
    staticClass: "sp-form-descr"
  }, [_vm._v("Select from your Products/Services to add to Lookbook")]), _vm._v(" (scroll to view all products)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "sp-form-descr"
  }, [_vm._v("(This would also be added to products in your sellpoint)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Name"), _c('span', {
    staticClass: "sp-form-must"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v(" Select from My Shop Categories"), _c('span', {
    staticClass: "sp-form-must"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('b', [_vm._v("Or ")]), _vm._v(" Enter a specific Category")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Price"), _c('span', {
    staticClass: "sp-form-must"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    staticClass: "sp-form-descr"
  }, [_vm._v("(You can always add more images or video on this post)")])])
}]}

/***/ }),
/* 269 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "wrap"
    }
  }, [_c('header', {
    staticClass: "site-header header-one home-page-one",
    staticStyle: {
      "margin-top": "3em"
    }
  }, [_c('nav', {
    staticClass: "navbar navbar-expand-lg navbar-light header-navigation stricky"
  }, [_c('div', {
    staticClass: "container clearfix"
  }, [_c('div', {
    staticClass: "clearfix"
  }, [_vm._m(0), _vm._v(" "), _c('span', {
    staticClass: "header-name"
  }, [_vm._v(_vm._s(_vm.sellpoint.business_name))])]), _vm._v(" "), (_vm.loggedIn) ? _c('div', {
    staticClass: "right-side-box"
  }, [(_vm.edit_mode) ? _c('a', {
    staticClass: "header-btn",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.mobileSideNavToggle('open')
      }
    }
  }, [_vm._v("Manage")]) : _c('a', {
    staticClass: "header-btn",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.mobileSideNavToggle('open')
      }
    }
  }, [_vm._v("Connect")])]) : _c('div', {
    staticClass: "right-side-box"
  }, [_c('a', {
    staticClass: "header-btn",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.mobileSideNavToggle('open')
      }
    }
  }, [_vm._v("Connect")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "page-wrapper"
  }, [(_vm.sellpoint.business_banner_image != _vm.default_banner_image) ? _c('section', {
    staticClass: "banner-style-one home-page-two",
    staticStyle: {
      "margin-top": "-2em",
      "height": "100vh"
    },
    style: ({
      backgroundImage: 'linear-gradient(rgba(0, 0, 0, 0.78), rgba(0, 0, 0, 0.48)), url(' + _vm.img_sellpoint_url + _vm.sellpoint.business_banner_image + ')'
    }),
    attrs: {
      "id": "banner"
    }
  }, [_c('div', {
    staticClass: "container gw-container"
  }, [(_vm.business_load_error_msg != '') ? _c('div', {
    staticClass: "row content-block"
  }, [_c('p', {
    staticStyle: {
      "color": "#ffc107",
      "margin": "1em"
    }
  }, [_vm._v(_vm._s(_vm.business_load_error_msg))])]) : _c('div', {
    staticClass: "row content-block"
  }, [_c('div', {
    staticClass: "col-sm-6 gw-large"
  }, [_c('div', {
    staticStyle: {
      "display": "block",
      "margin-top": "8em"
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.sellpoint.business_name))]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 gw-lookbook"
  }, [(_vm.edit_mode) ? _c('button', {
    staticClass: "btn btn-xs pull-right",
    staticStyle: {
      "background": "#f8ecf0",
      "color": "#161515",
      "margin-bottom": "1em"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('refresh-store', '')
      }
    }
  }, [_vm._v("Refresh Lookbook")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "addPanelView"
    }
  }, [(_vm.addPanel) ? _c('div', [_c('button', {
    staticClass: "btn",
    staticStyle: {
      "background": "#ff0055",
      "color": "#ffffff",
      "margin-bottom": "1em"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.reset
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.newLookbookForm) ? _c('div', [_c('add-lookbook')], 1) : _vm._e(), _vm._v(" "), (_vm.newProductLookbookForm) ? _c('div', [_c('add-product-lookbook')], 1) : _vm._e(), _vm._v(" "), (_vm.addNewPost) ? _c('div', {}, [_c('h6', [_vm._v("New Gallery Post")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))]), _vm._v(" "), _c('form', {
    staticClass: "gw-form"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(" *Caption")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.post.post_caption),
      expression: "post.post_caption"
    }],
    attrs: {
      "type": "text",
      "value": "",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.post.post_caption)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.post.post_caption = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(" *Details")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.post.post_details),
      expression: "post.post_details"
    }],
    domProps: {
      "value": (_vm.post.post_details)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.post.post_details = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "upload-btn-wrapper",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('button', {
    staticClass: "upload-btn",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Add Image")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.onFileChange($event)
      }
    }
  }), _vm._v(" "), (_vm.file_info[0]) ? _c('span', [_c('b', [_vm._v("Added " + _vm._s(_vm.file_info[0].name))])]) : _vm._e()])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#e4abbe"
    }
  }, [_vm._v(_vm._s(_vm.data_success_message))]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn",
    staticStyle: {
      "background": "#ff0055"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addPostToGallery
    }
  }, [_vm._v("Add")])])])]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', [(_vm.loading) ? _c('div', [_vm._m(3)]) : _c('div', [_c('div', {
    staticClass: "row",
    staticStyle: {
      "height": "60vh",
      "overflow": "scroll"
    }
  }, _vm._l((_vm.galleria), function(gallery, gndex) {
    return _c('div', {
      staticClass: "folder-main col-6 col-md-4"
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.getPostsInGallery(gallery)
        }
      }
    }, [_c('div', {
      staticClass: "folder-inner"
    }, [(gallery.gallery_posts_group_posts_media.length > 0) ? _c('div', {
      staticClass: "folder-inner-image"
    }, [(_vm.checkIfVideo(gallery.gallery_posts_group_posts_media[0].gallery_post_media)) ? _c('img', {
      staticClass: "sp-prd-img",
      attrs: {
        "src": "/static/assets/images/video-placeholder.png"
      }
    }) : _c('img', {
      staticClass: "sp-prd-img",
      attrs: {
        "src": gallery.gallery_posts_group_posts_media[0].gallery_post_media
      }
    })]) : _c('div', {
      staticClass: "folder-inner-image"
    }, [_c('img', {
      staticClass: "sp-prd-img",
      attrs: {
        "src": "/static/assets/images/dummy-image.png",
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "folder-inner-words"
    }, [_c('h5', [_c('a', {
      on: {
        "click": function($event) {
          _vm.getPostsInGallery(gallery)
        }
      }
    }, [_vm._v(_vm._s(gallery.gallery_posts_group_name))])])])])])])
  })), _vm._v(" "), (_vm.edit_mode && _vm.can_add_more_lookbook) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "display": "none"
    }
  }, [(_vm.edit_mode) ? _c('div', {
    staticClass: "folder-main col-6 col-md-4"
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.addComponent('add-new-lookbook', '')
      }
    }
  }, [_vm._m(4)])]) : _vm._e(), _vm._v(" "), (_vm.edit_mode && _vm.can_add_product_lookbook) ? _c('div', {
    staticClass: "folder-main col-6 col-md-4"
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.addComponent('add-new-product-lookbook', '')
      }
    }
  }, [_vm._m(5)])]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _vm._m(6)])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "sidenav",
    attrs: {
      "id": "mobileSideNav"
    }
  }, [_c('a', {
    staticClass: "closebtn",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.mobileSideNavToggle('close')
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('div', {
    staticClass: "container sidenav-links"
  }, [_c('ul', [_vm._m(7), _vm._v(" "), (_vm.loggedIn) ? _c('li', [_c('a', {
    attrs: {
      "href": "account"
    }
  }, [_vm._v("My Account")])]) : _c('li', [_c('a', {
    attrs: {
      "href": "login"
    }
  }, [_vm._v("Login")])]), _vm._v(" "), (_vm.loggedIn) ? _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": _vm.manageLookbook
    }
  }, [_vm._v("Go to Sellpoint")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "container sidenav-container"
  }, [_c('div', {
    staticStyle: {
      "margin-right": "2em"
    }
  }, [(_vm.addPanel) ? _c('div', {
    attrs: {
      "id": "addPanelView"
    }
  }, [(_vm.addPanel) ? _c('div', [_c('div', {
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_c('button', {
    staticClass: "btn",
    staticStyle: {
      "float": "right",
      "background": "#ff0055",
      "color": "#ffffff",
      "margin-bottom": "1em"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.reset
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), (_vm.newLookbookForm) ? _c('div', [_c('add-lookbook')], 1) : _vm._e(), _vm._v(" "), (_vm.newProductLookbookForm) ? _c('div', [_c('add-product-lookbook')], 1) : _vm._e(), _vm._v(" "), (_vm.addNewPost) ? _c('div', {}, [_c('h6', [_vm._v("Add a new Post to "), _c('b', [_vm._v(_vm._s(_vm.gallery.gallery_posts_group_name))])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))]), _vm._v(" "), _c('form', {
    staticClass: "gw-form"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(" *Caption")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.post.post_caption),
      expression: "post.post_caption"
    }],
    attrs: {
      "type": "text",
      "value": "",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.post.post_caption)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.post.post_caption = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(" *Details")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.post.post_details),
      expression: "post.post_details"
    }],
    domProps: {
      "value": (_vm.post.post_details)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.post.post_details = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "upload-btn-wrapper",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('button', {
    staticClass: "upload-btn",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Add Image")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.onFileChange($event)
      }
    }
  }), _vm._v(" "), (_vm.file_info[0]) ? _c('span', [_c('b', [_vm._v("Added " + _vm._s(_vm.file_info[0].name))])]) : _vm._e()])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#e4abbe"
    }
  }, [_vm._v(_vm._s(_vm.data_success_message))]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn",
    staticStyle: {
      "background": "#ff0055"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addPostToGallery
    }
  }, [_vm._v("Add")])])])]) : _vm._e()]) : _vm._e()]) : _c('div', [_c('div', {
    staticStyle: {
      "margin-right": "2em"
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.sellpoint.business_name))]), _vm._v(" "), _c('div', {
    staticClass: "sidenav-banner-img"
  }, [_c('img', {
    staticClass: "sp-prd-img",
    attrs: {
      "src": _vm.sellpoint.business_banner_image
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), (!_vm.edit_mode) ? _c('div', {
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('h5', [_vm._v("Contact Us")]), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "button-block"
  })]) : _vm._e(), _vm._v(" "), (_vm.edit_mode) ? _c('div', {}, [_c('p', [_vm._v("Welcome "), _c('b', [_vm._v(_vm._s(_vm.sellpoint.business_name))]), _vm._v(", here you can set up and manage your gallery with any of these actions below")]), _vm._v(" "), (_vm.edit_mode && _vm.can_add_more_lookbook) ? _c('div', {
    staticClass: "row"
  }, [(_vm.edit_mode) ? _c('div', {
    staticClass: "col-6 col-md-4"
  }, [_c('div', {
    staticClass: "gw-add-btn"
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer",
      "color": "inherit"
    },
    on: {
      "click": function($event) {
        _vm.addComponent('add-new-lookbook', '')
      }
    }
  }, [_c('h5', [_vm._v("Add New Lookbook")])])])]) : _vm._e(), _vm._v(" "), (_vm.edit_mode && _vm.can_add_product_lookbook) ? _c('div', {
    staticClass: "col-6 col-md-4"
  }, [_c('div', {
    staticClass: "gw-add-btn"
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer",
      "color": "inherit"
    },
    on: {
      "click": function($event) {
        _vm.addComponent('add-new-product-lookbook', '')
      }
    }
  }, [_c('h5', [_vm._v("Add Product Lookbook")])])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col",
    staticStyle: {
      "margin": "0",
      "padding": "0"
    }
  }, [(!(_vm.edit_mode && _vm.can_add_more_lookbook)) ? _c('div', {
    staticClass: "col-md-6 col-sm-12",
    staticStyle: {
      "margin": "0",
      "padding": "0"
    }
  }, [_c('div', {
    staticClass: "manage-action-block"
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer",
      "color": "inherit"
    },
    on: {
      "click": _vm.manageLookbook
    }
  }, [_c('h5', [_vm._v("You have reached the limit of your gallery")]), _vm._v(" "), _vm._m(9)])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-sm-12",
    staticStyle: {
      "margin": "0",
      "padding": "0"
    }
  }, [_c('div', {
    staticClass: "manage-action-block"
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer",
      "color": "inherit"
    },
    on: {
      "click": _vm.manageLookbook
    }
  }, [_c('h5', [_vm._v("Manage Your Gallery on Sellpoint")]), _vm._v(" "), _c('p', [_vm._v("Once clicked you would be directed to your Sellpoint account to further set-up your page")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    staticStyle: {
      "background": "#ff0055",
      "color": "#ffffff"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.manageLookbook
    }
  }, [_vm._v("Manage")])])])])])]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade modal-c p-modal",
    attrs: {
      "id": "quickviewModal",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [(_vm.place_order) ? _c('div', {
    staticClass: "modal-content"
  }, [_c('button', {
    staticClass: "pul-right close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.resetOptions
    }
  }, [_c('b', [_vm._v("close")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row row-20 mb-20 mb-xs-0"
  }, [(_vm.payment_successful) ? _c('div', {
    staticClass: "col-xs-12 mb-40"
  }, [_c('h3', {
    staticStyle: {
      "line-height": "1.6"
    }
  }, [_vm._v(_vm._s(this.payment_successful_message))])]) : _c('div', {
    staticClass: "col-xs-12 mb-40"
  }, [_c('h4', [_vm._v("Place Order For "), _c('b', [_vm._v(_vm._s(_vm.ordered_product.product_name) + "(₦" + _vm._s(_vm.ordered_product_item.product_item_price) + ")")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))]), _vm._v(" "), _c('div', {}, [_c('form', [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.payment_payer_name),
      expression: "payment_payer_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Name"
    },
    domProps: {
      "value": (_vm.payment_payer_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.payment_payer_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.payment_payer_email),
      expression: "payment_payer_email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.payment_payer_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.payment_payer_email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.payment_payer_phone),
      expression: "payment_payer_phone"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "placeholder": "Phone (format: 09088776655)"
    },
    domProps: {
      "value": (_vm.payment_payer_phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.payment_payer_phone = $event.target.value
      }
    }
  })]), _vm._v(" "), _vm._m(10), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "btn pull-left",
    staticStyle: {
      "cursor": "pointer",
      "border-radius": "2px",
      "background": "#ffc107",
      "color": "#000"
    },
    on: {
      "click": function($event) {
        _vm.processPayment()
      }
    }
  }, [_vm._v(" Proceed")])])])])])])]) : _c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "margin-top": "2em"
    }
  }, [(_vm.edit_mode) ? _c('button', {
    staticClass: "btn btn-xs pull-left",
    staticStyle: {
      "background": "#f8ecf0",
      "color": "#161515",
      "margin-bottom": "1em"
    },
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": _vm.manageLookbook
    }
  }, [_vm._v("ManageLookbook")]) : _vm._e(), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.edit_mode) ? _c('div', [(_vm.gallery.gallery_posts_group_posts_total < _vm.max_plan_lookbook_posts) ? _c('div', [_c('p', {
    staticStyle: {
      "color": "#ff0055"
    }
  }, [_vm._v("Add new Post to " + _vm._s(_vm.gallery.gallery_posts_group_name) + ", \r\n                                    "), (((_vm.gallery.gallery_posts_group_type == 2) && _vm.can_add_product_lookbook)) ? _c('a', {
    staticStyle: {
      "cursor": "pointer",
      "background": "#ffc107",
      "padding": "5px"
    },
    on: {
      "click": function($event) {
        _vm.addComponent('add-new-product-post', _vm.gallery)
      }
    }
  }, [_vm._v("Add")]) : _c('a', {
    staticStyle: {
      "cursor": "pointer",
      "background": "#ffc107",
      "padding": "5px"
    },
    on: {
      "click": function($event) {
        _vm.addComponent('add-new-post', _vm.gallery)
      }
    }
  }, [_vm._v("Add")])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('h2', {
    staticStyle: {
      "font-size": "28px"
    }
  }, [_vm._v(_vm._s(_vm.gallery_post.gallery_post_caption) + "\r\n                                                "), (_vm.gallery_post.gallery_post_product_items) ? _c('span', [_vm._v("(₦" + _vm._s(_vm.gallery_post.gallery_post_product_items[0].product_item_price) + ")")]) : _vm._e()]), _vm._v(" "), (_vm.gallery_post_set_image.gallery_post_media != '') ? _c('div', {
    staticClass: "image",
    staticStyle: {
      "height": "250px",
      "width": "100%"
    }
  }, [(_vm.checkIfVideo(_vm.gallery_post_set_image.gallery_post_media)) ? _c('img', {
    staticClass: "rounded",
    staticStyle: {
      "width": "100%",
      "height": "100%",
      "object-fit": "contain"
    },
    attrs: {
      "src": "/static/assets/images/video-placeholder.png",
      "alt": ""
    }
  }) : _c('img', {
    staticClass: "rounded",
    staticStyle: {
      "width": "100%",
      "height": "100%",
      "object-fit": "contain"
    },
    attrs: {
      "src": _vm.gallery_post_set_image.gallery_post_media,
      "alt": ""
    }
  }), _vm._v(" "), (_vm.gallery_post.gallery_post_media) ? _c('div', {
    staticClass: "image-overlay",
    staticStyle: {
      "top": "80px"
    }
  }, [(_vm.gallery_post.gallery_post_media.length > 1) ? _c('ul', {
    staticClass: "food-menu-list-num"
  }, _vm._l((_vm.gallery_post.gallery_post_media), function(img, imdex) {
    return _c('li', [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.showPostImage(img)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-circle-o"
    })])])
  })) : _vm._e()]) : _vm._e()]) : _c('div', [_c('img', {
    staticClass: "sp-prd-img",
    attrs: {
      "src": "/static/assets/images/dummy-image.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "content",
    staticStyle: {
      "top": "200px"
    }
  }, [_c('div', {
    staticClass: "content-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "content-right"
  }, [_c('p', [_vm._v(_vm._s(_vm.gallery_post.gallery_post_details))])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.gallery.gallery_posts_group_posts) ? _c('div', {
    staticClass: "col-xs-12 mb-40 pull-right"
  }, [(_vm.gallery.gallery_posts_group_posts.length > 1) ? _c('ol', {
    staticClass: "food-menu-list-num"
  }, _vm._l((_vm.gallery.gallery_posts_group_posts), function(post, prdex) {
    return _c('li', [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.showPost(post)
        }
      }
    }, [_vm._v(_vm._s(++prdex))])])
  })) : _vm._e()]) : _vm._e()])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "navbar-brand",
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/logo-sm.png",
      "alt": "Awesome Image"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Capture your moments "), _c('br'), _vm._v(" save and organise and "), _c('br'), _vm._v(" make your work roll out like a gallery.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "button-block"
  }, [_c('a', {
    staticClass: "banner-btn",
    attrs: {
      "href": "#"
    }
  }, [_c('span', [_vm._v("Contact Us")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin": "6em"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/loader.gif"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "folder-inner"
  }, [_c('div', {
    staticClass: "folder-inner-image",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('h2', {
    staticStyle: {
      "padding": "6px",
      "font-size": "24px",
      "color": "#ff0055"
    }
  }, [_vm._v("Add New Lookbook")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "folder-inner"
  }, [_c('div', {
    staticClass: "folder-inner-image",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('h2', {
    staticStyle: {
      "padding": "6px",
      "font-size": "24px",
      "color": "#ff0055"
    }
  }, [_vm._v("Add New Product Lookbook")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gw-mobile",
    staticStyle: {
      "display": "none"
    }
  }, [_c('p', [_vm._v("Capture your moments "), _c('br'), _vm._v(" save and organise and "), _c('br'), _vm._v(" make your work roll out like a gallery.")]), _vm._v(" "), _c('div', {
    staticClass: "button-block"
  }, [_c('a', {
    staticClass: "banner-btn",
    attrs: {
      "href": "#"
    }
  }, [_c('span', [_vm._v("Contact Us")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_vm._v("Home")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Capture your moments "), _c('br'), _vm._v(" save and organise and "), _c('br'), _vm._v(" make your work roll out like a gallery.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("To add more lookboks to your gallery, "), _c('a', {
    staticClass: "btn",
    staticStyle: {
      "background": "#ff0055",
      "color": "#ffffff"
    },
    attrs: {
      "href": "/"
    }
  }, [_vm._v("Upgrade your Account")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "checked": "true",
      "disabled": "disabled"
    }
  }), _vm._v(" By proceeding, you agree with the "), _c('u', [_c('a', {
    staticStyle: {
      "cursor": "pointer",
      "color": "#ff0055",
      "font-weight": "bold"
    },
    attrs: {
      "data-toggle": "modal",
      "data-backdrop": "false",
      "data-target": "#terms-modal",
      "href": "#"
    }
  }, [_vm._v("Terms and Conditions")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "pull-right close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_c('b', [_vm._v("close")])])
}]}

/***/ }),
/* 270 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "wrap"
    }
  }, [_c('component-header'), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "timeline"
  }, [_c('div', {
    staticClass: "timeline-cover sp-page-banner"
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "page-contents"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('left-sidebar')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('search-box'), _vm._v(" "), (!_vm.search_data != '') ? _c('div', [_vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.search_data != '') ? _c('h4', {
    staticClass: "grey"
  }, [_vm._v("Products found in " + _vm._s(_vm.search_data))]) : _vm._e(), _vm._v(" "), (_vm.products.length == 0) ? _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("no matching products")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "friend-list"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.products), function(product, index) {
    return _c('div', {
      staticClass: "col-md-4 col-sm-4 col-xs-6"
    }, [((product.product_items.length != 0)) ? _c('div', {
      staticStyle: {
        "min-height": "23em",
        "max-height": "22em"
      }
    }, [_c('a', {
      staticStyle: {
        "color": "inherit",
        "text-decoration": "none"
      },
      attrs: {
        "href": '/' + product.product_business_username + '/' + product.product_url_name
      }
    }, _vm._l((product.product_items), function(product_item, index2) {
      return _c('div', {
        staticClass: "friend-card",
        staticStyle: {
          "min-height": "22em",
          "max-height": "22em",
          "border-bottom-color": "rgb(182, 176, 176)"
        }
      }, [(index2 == 0) ? _c('div', [_c('div', {
        staticStyle: {
          "height": "10em"
        }
      }, [_c('img', {
        staticClass: "sp-prd-img",
        attrs: {
          "src": product_item.product_item_image,
          "alt": "photo"
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "card-info"
      }, [_c('div', {
        staticClass: "friend-info"
      }, [_c('a', {
        staticClass: "pull-right text-green",
        staticStyle: {
          "font-size": "12px"
        },
        attrs: {
          "href": "#"
        }
      }, [_vm._v("@" + _vm._s(product.product_business_name))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h5', {
        staticStyle: {
          "height": "3em"
        }
      }, [_c('a', {
        staticClass: "profile-link",
        attrs: {
          "href": "#"
        }
      }, [_vm._v(_vm._s(product.product_name))])]), _vm._v(" "), _c('p', [_vm._v("₦" + _vm._s(product_item.product_item_price.toLocaleString('en', {
        useGrouping: true
      })))]), _vm._v(" "), _vm._m(1, true)])])]) : _vm._e()])
    }))]) : _vm._e()])
  }))]), _vm._v(" "), _c('active-products')], 1)])])])]), _vm._v(" "), _c('component-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6 col-md-offset-2 col-sm-12 col-xs-12",
    staticStyle: {
      "padding": "5em"
    }
  }, [_c('div', {
    staticClass: "wn-loader"
  }), _vm._v(" "), _c('p', [_vm._v("loading...")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pull-right",
    staticStyle: {
      "margin-bottom": "1em"
    }
  }, [_c('a', {
    staticClass: "btn text-red",
    attrs: {
      "title": "Like"
    }
  }, [_c('i', {
    staticClass: "fa fa-heart-o",
    staticStyle: {
      "font-size": "14px"
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "btn text-red",
    attrs: {
      "title": "Add to Cart"
    }
  }, [_c('i', {
    staticClass: "fa fa-shopping-cart",
    staticStyle: {
      "font-size": "14px"
    }
  })])])
}]}

/***/ }),
/* 271 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('component-menu-bottom')], 1)
},staticRenderFns: []}

/***/ }),
/* 272 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('div', {
    staticStyle: {
      "background": "#ffffff",
      "width": "100%",
      "height": "3.2em",
      "top": "0",
      "position": "fixed",
      "z-index": "9999",
      "padding-top": "3px"
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "1px",
      "border-bottom": "1px solid #e7e7e7",
      "display": "inline",
      "text-align": "center"
    }
  }, [(_vm.navw) ? _c('a', {
    staticStyle: {
      "float": "left",
      "padding-left": "8px",
      "color": "#000000",
      "font-size": "24px",
      "font-weight": "500",
      "cursor": "pointer"
    },
    on: {
      "click": _vm.hide_nav
    }
  }, [_c('i', {
    staticClass: "fa fa-bars"
  })]) : _c('a', {
    staticStyle: {
      "float": "left",
      "padding-left": "8px",
      "color": "#000000",
      "font-size": "24px",
      "font-weight": "500",
      "cursor": "pointer"
    },
    on: {
      "click": _vm.show_nav
    }
  }, [_c('i', {
    staticClass: "fa fa-bars"
  })]), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticStyle: {
      "margin": "-0.8em 1em",
      "color": "#000000"
    }
  }, [_c('span', {
    staticStyle: {
      "text-transform": "uppercase",
      "text-align": "center"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/title-detail.png"
    }
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "height": "25px"
    },
    attrs: {
      "src": "/static/assets/images/logo-black.png"
    }
  })]), _vm._v(" "), _c('a', {
    staticStyle: {
      "float": "right",
      "color": "#000000",
      "font-size": "20px",
      "cursor": "pointer",
      "padding-top": "5px"
    },
    attrs: {
      "href": "/account"
    }
  }, [_c('i', {
    staticClass: "fa fa-user-o"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sidenav",
    attrs: {
      "id": "main-nav-bar"
    }
  }, [_c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "/timeline"
    }
  }, [_vm._v("Shop")])]), _vm._v(" "), _c('li', [_c('a', [_vm._v("Book Tickets")])]), _vm._v(" "), _c('li', [_c('a', [_vm._v("Events")])]), _vm._v(" "), _c('li', [_c('a', [_vm._v("Tour")])])])])
}]}

/***/ }),
/* 273 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.canAdd) ? _c('div', [(_vm.productMainView == 'cartactions') ? _c('button', {
    staticClass: "cta-btn cta-btn-sm",
    staticStyle: {
      "width": "50vw"
    },
    on: {
      "click": _vm.addToCart
    }
  }, [_vm._v(" Buy Now")]) : _c('button', {
    staticClass: "cta-btn",
    staticStyle: {
      "width": "50vw"
    },
    on: {
      "click": _vm.addToCart
    }
  }, [_vm._v(" Buy Now")])]) : _c('div', [_c('button', {
    staticClass: "cta-btn",
    staticStyle: {
      "width": "50vw",
      "text-align": "left",
      "padding-left": "5px",
      "font-size": "14px"
    },
    on: {
      "click": function($event) {
        _vm.redir(_vm.productMain.product_business_ownername)
      }
    }
  }, [_vm._v(" Continue Shopping")])])])
},staticRenderFns: []}

/***/ }),
/* 274 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-offset-2 col-md-8",
    staticStyle: {
      "margin-top": "4em"
    }
  }, [_c('cart-widget')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section is-dark is-header md-margin-top-24"
  }, [_c('div', {
    staticClass: "container margin-top"
  }, [_c('div', {
    staticClass: "col block-centered text-align-center lg-7 md-12"
  }, [_c('div', {
    staticClass: "padding-left padding-right margin-bottom low-text-contrast on-dark"
  }, [_vm._v("Process order "), _c('a', {
    staticClass: "on-dark",
    attrs: {
      "href": "/shops"
    }
  }, [_vm._v("or Continue shopping")])])])])])
}]}

/***/ }),
/* 275 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-top": "3.2em"
    },
    attrs: {
      "id": "wrap"
    }
  }, [(_vm.loading) ? _c('div', {
    staticClass: "section"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "container is-wide"
  }, [_c('div', {
    staticClass: "loading-md"
  })]) : _vm._e()]) : _c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {}, [(_vm.product_display_image.product_image != '' && _vm.product_display_image.product_image != 'error') ? _c('img', {
    staticClass: "pb_img",
    attrs: {
      "src": _vm.img_product_url + _vm.product_display_image.product_image,
      "alt": ""
    }
  }) : _c('img', {
    staticClass: "pb_img",
    attrs: {
      "src": "/static/assets/images/dummy-image.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), (_vm.product.product_images && (_vm.product.product_images.length > 1)) ? _c('div', {
    staticClass: "img-row",
    staticStyle: {
      "margin-top": "-4em"
    }
  }, _vm._l((_vm.product.product_images), function(img) {
    return _c('div', {
      staticClass: "img-column"
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('set-product-display-image', img)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.img_product_url + img.product_image,
        "alt": ""
      }
    })])])
  })) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col lg-6 md-12 margin-top max-width-690px"
  }, [_c('h1', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_vm._v(_vm._s(_vm.product.product_name))]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "sp-prd-attr-block",
    staticStyle: {
      "width": "100%",
      "margin-top": "2em"
    }
  }, [_c('div', {
    staticClass: "info-block col-xs-12"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "info-right col-xs-8",
    staticStyle: {
      "padding": "5px"
    }
  }, [(_vm.product_item.product_item_actual_price != 0) ? _c('p', {
    staticClass: "attr-intro-desc prd-price prd-discounted-price"
  }, [_c('del', [_c('small', [_vm._v("₦")]), _vm._v(_vm._s(_vm.product_item.product_item_actual_price))])]) : _c('p', {
    staticClass: "attr-intro-desc prd-price"
  }, [_c('small', [_vm._v("₦")]), _vm._v(_vm._s(_vm.product_item.product_item_price))])])]), _vm._v(" "), (_vm.product_item.product_item_actual_price != 0) ? _c('div', {
    staticClass: "info-block col-xs-12"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "info-right col-xs-8",
    staticStyle: {
      "padding": "5px"
    }
  }, [_c('p', {
    staticClass: "attr-intro-desc prd-discount-price"
  }, [_c('small', [_vm._v("₦")]), _vm._v(_vm._s(_vm.product_item.product_item_price))])])]) : _vm._e(), _vm._v(" "), (_vm.product.product_service == 'P') ? _c('div', {
    staticClass: "info-block col-xs-12"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "info-right col-xs-8",
    staticStyle: {
      "padding": "5px"
    }
  }, [_c('p', {
    staticClass: "attr-intro-desc"
  }, [_vm._v(_vm._s(_vm.product_item.product_item_weight) + " (Kg)")])])]) : _vm._e(), _vm._v(" "), (((_vm.product.product_set_groups != 0))) ? _c('div', {
    staticClass: "info-block col-xs-12"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "info-right col-xs-6",
    staticStyle: {
      "padding": "5px"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "inline"
    }
  }, _vm._l((_vm.product.product_item_groups), function(pg) {
    return _c('li', {
      staticClass: "prd-color-block listnone"
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('set-product-item-group', pg)
        }
      }
    }, [_c('div', {
      staticClass: "box-cube col-xs-2"
    }, [(pg.product_item_group_is_color_image == 'IMG') ? _c('div', {
      staticClass: "product-item-group"
    }, [_c('div', {
      staticClass: "product-item-group",
      attrs: {
        "id": pg.product_item_group_id + 'PRTGR'
      }
    }, [((pg.product_item_group_image && (pg.product_item_group_image != 'error'))) ? _c('img', {
      staticClass: "sp-prd-img",
      staticStyle: {
        "width": "50px",
        "object-fit": "contain"
      },
      attrs: {
        "src": pg.product_item_group_image
      }
    }) : _c('img', {
      staticClass: "sp-prd-img",
      staticStyle: {
        "object-fit": "contain"
      },
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })])]) : _vm._e(), _vm._v(" "), (pg.product_item_group_is_color_image == 'COL') ? _c('div', {}, [_c('div', {
      staticClass: "product-item-group box-color-cube",
      style: ({
        background: pg.product_item_group_color
      }),
      attrs: {
        "id": pg.product_item_group_id + 'PRTGR'
      }
    })]) : _vm._e()])])])
  })), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.data_cart_group_message) ? _c('p', {
    staticClass: "p-tiny-info",
    staticStyle: {
      "margin-top": "-1em",
      "padding-top": "1em",
      "float": "left",
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.data_cart_group_message))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (((_vm.product_item_group.product_items) && (_vm.product_item_group.product_items.length != 0))) ? _c('div', {
    staticClass: "info-block col-xs-12",
    staticStyle: {
      "clear": "both"
    }
  }, [(((_vm.product.product_set_items != 0) && (_vm.product.product_set_items_params_check != 0))) ? _c('div', [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "info-right col-xs-10"
  }, [_c('div', {
    staticClass: "prd-color-block",
    staticStyle: {
      "display": "inline"
    }
  }, _vm._l((_vm.product_item_group.product_items), function(pt) {
    return _c('div', {
      staticClass: "items-list-tiny col-xs-2",
      staticStyle: {
        "margin-left": "1em"
      }
    }, [_c('li', {
      staticClass: "product-item listnone",
      attrs: {
        "id": pt.product_item_id + 'PRT'
      }
    }, [(_vm.product.product_service == 'P') ? _c('a', {
      staticClass: "box-wrap",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('set-product-item', pt)
        }
      }
    }, [_vm._v(_vm._s(pt.product_item_size))]) : _vm._e()]), _vm._v(" "), _c('li', {
      staticClass: "product-item listnone",
      attrs: {
        "id": pt.product_item_id + 'PRT'
      }
    }, [(_vm.product.product_service == 'S') ? _c('a', {
      staticClass: "box-wrap",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('set-product-item', pt)
        }
      }
    }, [_vm._v(_vm._s(pt.product_item_service_tag))]) : _vm._e()])])
  })), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.data_cart_item_message) ? _c('p', {
    staticClass: "p-tiny-info",
    staticStyle: {
      "margin-top": "-0.1em",
      "float": "left"
    }
  }, [_vm._v(_vm._s(_vm.data_cart_item_message))]) : _vm._e()])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [(_vm.is_product_in_cart) ? _c('div', {
    staticStyle: {
      "border": "dotted 1px #96c5f5",
      "padding": "5px 2px"
    }
  }, [_c('p', [_vm._v("This Item is in your cart \r\n                    "), _c('button', {
    staticClass: "btn pull-right",
    staticStyle: {
      "width": "12em",
      "cursor": "pointer",
      "line-height": "1.8"
    },
    on: {
      "click": function($event) {
        _vm.redir('cart')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-shopping-cart"
  }), _vm._v(" View Cart")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]) : _c('div', [_c('div', [_c('div', {
    staticClass: "info-block col-xs-12"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "info-right col-xs-8"
  }, [_c('div', {}, [_c('a', {
    staticClass: "col-xs-3 qty-btn qty-btn-sm",
    staticStyle: {
      "cursor": "pointer",
      "text-decoration": "none"
    },
    on: {
      "click": function($event) {
        _vm.removeQuantity(_vm.product_item.product_item_order_quantity)
      }
    }
  }, [_vm._v("–")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product_item.product_item_order_quantity),
      expression: "product_item.product_item_order_quantity"
    }],
    key: _vm.product_item_quantity_key,
    staticClass: "col-xs-6 qty-input qty-input-sm",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.product_item.product_item_order_quantity)
    },
    on: {
      "change": function($event) {
        _vm.checkOrderQuantity(_vm.product_item.product_item_order_quantity)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product_item.product_item_order_quantity = $event.target.value
      }
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "col-xs-3 qty-btn qty-btn-sm",
    staticStyle: {
      "cursor": "pointer",
      "text-decoration": "none"
    },
    on: {
      "click": function($event) {
        _vm.addQuantity(_vm.product_item.product_item_order_quantity)
      }
    }
  }, [_vm._v("+")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.check_order_quantity))])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "fixed",
      "width": "100%",
      "bottom": "0",
      "margin": "0 -1.2em",
      "background": "#ffffff",
      "z-index": "10000"
    }
  }, [(_vm.product_item.product_item_quantity > 0) ? _c('ul', {
    staticStyle: {
      "clear": "both",
      "padding-left": "0"
    }
  }, [(_vm.data_cart_message) ? _c('p', {
    staticClass: "p-tiny-info"
  }, [_vm._v(_vm._s(_vm.data_cart_message))]) : _vm._e(), _vm._v(" "), (!_vm.product_is_ready_to_cart) ? _c('div', [_c('ul', {
    staticClass: "cart-wrap"
  }, [_c('li', {
    staticClass: "col-xs-6",
    staticStyle: {
      "padding": "0",
      "margin": "0"
    }
  }, [_c('button', {
    staticClass: "cta-btn",
    on: {
      "click": _vm.prep_set_product_is_ready_to_cart
    }
  }, [_vm._v(" Buy Now")])]), _vm._v(" "), _c('li', {
    staticClass: "col-xs-6",
    staticStyle: {
      "padding": "0",
      "margin": "0"
    }
  }, [_c('button', {
    staticClass: "cart-btn",
    on: {
      "click": _vm.prep_set_product_is_ready_to_cart
    }
  }, [_vm._v(" Add to Cart")])])])]) : _c('div', [_c('ul', {
    staticClass: "cart-wrap"
  }, [_c('li', {
    staticClass: "col-xs-6",
    staticStyle: {
      "padding": "0",
      "margin": "0"
    }
  }, [_c('product-cta-button', {
    attrs: {
      "productMain": _vm.product,
      "productItemGroup": _vm.product_item_group,
      "productItem": _vm.product_item
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "col-xs-6",
    staticStyle: {
      "padding": "0",
      "margin": "0"
    }
  }, [_c('add-to-cart-button', {
    attrs: {
      "productMain": _vm.product,
      "productItemGroup": _vm.product_item_group,
      "productItem": _vm.product_item
    }
  })], 1)])])]) : _c('ul', {
    staticClass: "col-xs-12 row"
  }, [_c('p', {
    staticStyle: {
      "text-align": "center",
      "color": "#ff0000"
    }
  }, [_vm._v("This Item is out of Stock")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "inner-info"
  }, [_c('div', {
    staticClass: "info-blocks"
  }, [(_vm.product.product_business_delivery_options.length > 0) ? _c('div', {
    staticClass: "info-block col-md-12 col-xs-12",
    staticStyle: {
      "border": "solid 1px #eeddcc",
      "padding": "1em",
      "background": "#fcf7f3"
    }
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "info-right-2 col-md-8 col-xs-12"
  }, [_c('div', {
    staticClass: "prd-delivery-list"
  }, _vm._l((_vm.product.product_business_delivery_options), function(delivery) {
    return _c('li', [_c('b', [_vm._v(_vm._s(delivery.business_delivery_option))]), _vm._v(" - ₦\r\n                          "), (delivery.business_products_delivery_fees.length > 0) ? _c('span', _vm._l((delivery.business_products_delivery_fees), function(fee, fdex) {
      return _c('span', [((fee.product_delivery_product == _vm.product.product_id)) ? _c('span', [_vm._v(_vm._s(fee.product_delivery_fee) + "\r\n                              ")]) : _vm._e()])
    })) : _c('span', [_vm._v("\r\n                            " + _vm._s(delivery.business_delivery_option_price) + "\r\n                          ")])])
  }))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])])])]), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 mshare",
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('ul', {}, [_c('li', [_vm._v("Share:")]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "share-btn",
    attrs: {
      "href": 'https://www.facebook.com/sharer/sharer.php?u=' + _vm.share_url,
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-facebook"
  })])]), _vm._v(" "), _vm._m(10), _vm._v(" "), _c('li', [_c('button', {
    staticClass: "share-btn",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "title": "Copy Link. Paste and Share Anywhere"
    },
    on: {
      "click": function($event) {
        _vm.copyLink()
      }
    }
  }, [_vm._v("Copy Link\r\n                        ")]), _vm._v(" "), (_vm.copied) ? _c('span', {
    staticStyle: {
      "background": "rgb(240, 227, 157)"
    }
  }, [_vm._v("Copied")]) : _vm._e()])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', [_c('div', {
    staticStyle: {
      "margin": "1em"
    }
  }, [_c('a', {
    staticClass: "col-xs-4",
    staticStyle: {
      "margin": "0",
      "padding": "0"
    },
    on: {
      "click": function($event) {
        _vm.setTabComponent('descr')
      }
    }
  }, [(_vm.tab_view.descr) ? _c('div', [_c('u', {
    staticStyle: {
      "border-bottom": "#061433 solid 1px"
    }
  }, [_vm._v("Description")])]) : _c('div', [_vm._v("Description")])]), _vm._v(" "), _c('a', {
    staticClass: "col-xs-4",
    staticStyle: {
      "margin": "0",
      "padding": "0"
    },
    on: {
      "click": function($event) {
        _vm.setTabComponent('info')
      }
    }
  }, [(_vm.tab_view.info) ? _c('div', [_c('u', {
    staticStyle: {
      "border-bottom": "#061433 solid 1px"
    }
  }, [_vm._v("More Details")])]) : _c('div', [_vm._v("More Details")])]), _vm._v(" "), _c('a', {
    staticClass: "col-xs-4",
    staticStyle: {
      "margin": "0",
      "padding": "0"
    },
    on: {
      "click": function($event) {
        _vm.setTabComponent('reviews')
      }
    }
  }, [(_vm.tab_view.reviews) ? _c('div', [_c('u', {
    staticStyle: {
      "border-bottom": "#061433 solid 1px"
    }
  }, [_vm._v("Reviews (2)")])]) : _c('div', [_vm._v("Reviews (2)")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "2em 1em"
    }
  }, [(_vm.tab_view.descr) ? _c('div', [_c('div', {
    staticClass: "w-richtext"
  }, [_c('p', {
    staticStyle: {
      "white-space": "pre-line"
    }
  }, [_vm._v(_vm._s(_vm.product.product_description) + " ")])])]) : _vm._e(), _vm._v(" "), (_vm.tab_view.info) ? _c('div', [_vm._m(11)]) : _vm._e(), _vm._v(" "), (_vm.tab_view.reviews) ? _c('div', [_c('p', [_vm._v("Reviews and Comments")])]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "section",
    staticStyle: {
      "margin-bottom": "5em"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(12), _vm._v(" "), _vm._l((_vm.related_products), function(product, rpdex) {
    return _c('div', {
      staticClass: "col-xs-6"
    }, [_c('div', {
      staticStyle: {
        "margin": "5px"
      }
    }, [_c('div', [_c('div', {}, [_c('a', {
      attrs: {
        "href": '/' + product.product_business_username + '/' + product.product_url_name
      }
    }, [(product.product_images[0]) ? _c('img', {
      staticClass: "pimage",
      attrs: {
        "src": product.product_images[0].product_image,
        "alt": ""
      }
    }) : _c('img', {
      staticClass: "pimage",
      attrs: {
        "src": "https://via.placeholder.com/1000x600.png?text=IMAGE 560w",
        "alt": ""
      }
    })])]), _vm._v(" "), _c('div', {}, [(product.product_category_name != 'error') ? _c('a', {
      staticStyle: {
        "font-size": "10px"
      },
      attrs: {
        "href": "'/'+product.product_business_ownername+'/'+product.product_url_name"
      }
    }, [_vm._v(_vm._s(product.product_category_name))]) : _vm._e()]), _vm._v(" "), _vm._m(13, true), _vm._v(" "), _c('a', {
      staticClass: "w-inline-block",
      attrs: {
        "href": '/' + product.product_business_username + '/' + product.product_url_name
      }
    }, [_c('div', {}, [_vm._v(_vm._s(product.product_name))])]), _vm._v(" "), (product.product_items[0]) ? _c('span', {
      staticStyle: {
        "font-size": "12px"
      }
    }, [_vm._v("₦" + _vm._s(product.product_items[0].product_item_price) + " \r\n                        "), _c('del', [_vm._v("₦" + _vm._s(product.product_items[0].product_item_price))])]) : _vm._e()])])])
  })], 2)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "float": "left",
      "margin-top": "-1em"
    }
  }, [_c('div', {
    staticStyle: {
      "color": "#ffd900"
    }
  }, [_c('div', {
    staticClass: "fa is-filled"
  }, [_vm._v("")]), _vm._v(" "), _c('div', {
    staticClass: "fa is-filled"
  }, [_vm._v("")]), _vm._v(" "), _c('div', {
    staticClass: "fa is-filled"
  }, [_vm._v("")]), _vm._v(" "), _c('div', {
    staticClass: "fa is-filled"
  }, [_vm._v("")]), _vm._v(" "), _c('div', {
    staticClass: "fa is-blank"
  }, [_vm._v("")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-left col-xs-2"
  }, [_c('p', {
    staticClass: "attr-intro-head"
  }, [_vm._v("Price: ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-left col-xs-2"
  }, [_c('p', {
    staticClass: "attr-intro-head"
  }, [_vm._v("Discount Price: ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-left col-xs-2"
  }, [_c('p', {
    staticClass: "attr-intro-head"
  }, [_vm._v("Weight: ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-left col-xs-6"
  }, [_c('p', {
    staticClass: "attr-intro-head"
  }, [_vm._v("Select: ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-left col-xs-2"
  }, [_c('p', {
    staticClass: "attr-intro-head"
  }, [_vm._v("Select: ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-left col-xs-2"
  }, [_c('p', {
    staticClass: "attr-intro-head"
  }, [_vm._v("Quantity:  ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('h6', [_vm._v("PRODUCT DELIVERY LOCATIONS")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-extrainfo",
    staticStyle: {
      "margin-top": "2em",
      "display": "none"
    }
  }, [_c('a', {
    staticClass: "c-extrainfo__text w-inline-block",
    attrs: {
      "href": "#"
    }
  }, [_c('div', {
    staticClass: "fa margin-right-small"
  }, [_vm._v("")]), _vm._v(" "), _c('div', {
    staticClass: "text-xsmall"
  }, [_vm._v("Store availability")])]), _vm._v(" "), _c('a', {
    staticClass: "c-extrainfo__text w-inline-block",
    attrs: {
      "href": "#"
    }
  }, [_c('div', {
    staticClass: "fa margin-right-small"
  }, [_vm._v("")]), _vm._v(" "), _c('div', {
    staticClass: "text-xsmall"
  }, [_vm._v("Delivery and return")])]), _vm._v(" "), _c('a', {
    staticClass: "c-extrainfo__text w-inline-block",
    attrs: {
      "href": "#"
    }
  }, [_c('div', {
    staticClass: "fa margin-right-small"
  }, [_vm._v("")]), _vm._v(" "), _c('div', {
    staticClass: "text-xsmall"
  }, [_vm._v("Ask a question")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('a', {
    staticClass: "share-btn",
    staticStyle: {
      "text-decoration": "none",
      "font-size": "14px"
    },
    attrs: {
      "href": "#"
    }
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-heart",
    staticStyle: {
      "color": "#ff0000"
    }
  })]), _vm._v(" Add to wishlist\r\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    staticClass: "share-btn",
    attrs: {
      "href": "'https://twitter.com/intent/tweet?source='+share_url+'&text='+share_text"
    }
  }, [_c('i', {
    staticClass: "fa fa-twitter"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w-layout-grid c-grid-info"
  }, [_c('p', [_vm._v("More Information")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h3', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_vm._v("Related products")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "color": "#ffd900"
    }
  }, [_c('div', {
    staticClass: "fa is-filled"
  }, [_vm._v("")]), _vm._v(" "), _c('div', {
    staticClass: "fa is-filled"
  }, [_vm._v("")]), _vm._v(" "), _c('div', {
    staticClass: "fa is-filled"
  }, [_vm._v("")]), _vm._v(" "), _c('div', {
    staticClass: "fa is-filled"
  }, [_vm._v("")]), _vm._v(" "), _c('div', {
    staticClass: "fa is-blank"
  }, [_vm._v("")])])
}]}

/***/ }),
/* 276 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pager"
  }, [_vm._m(0), _vm._v(" "), (_vm.show_all) ? _c('div', {
    staticClass: "section",
    staticStyle: {
      "margin": "0 1em"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "orders-panel",
    staticStyle: {
      "margin": "0 1em"
    }
  }, [_c('table', {
    staticClass: "table table-striped",
    staticStyle: {
      "width": "100%",
      "text-align": "left"
    }
  }, [_c('th', {
    staticClass: "tcol",
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("Date")]), _vm._v(" "), _c('th', {
    staticClass: "tcol",
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v("From")]), _vm._v(" "), _c('th', {
    staticClass: "tcol",
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("Total")]), _vm._v(" "), _c('th', {
    staticClass: "tcol",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("Status")]), _vm._v(" "), _vm._l((_vm.orders), function(order) {
    return _c('tr', [_c('td', {
      staticStyle: {
        "width": "20%"
      }
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "data-toggle": "modal",
        "data-backdrop": "false",
        "data-target": "#ordersModal"
      },
      on: {
        "click": function($event) {
          _vm.setOrder(order)
        }
      }
    }, [_c('span', {
      staticStyle: {
        "color": "#df4d4d",
        "font-size": "10px"
      }
    }, [_c('u', [_c('b', [_vm._v(_vm._s(order.order_no))])])]), _c('br'), _vm._v("\r\n                          " + _vm._s(order.order_date) + "\r\n                          "), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "p-tiny"
    }, [_vm._v("Tap to view")])])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "50%"
      }
    }, [_vm._v("\r\n                        " + _vm._s(order.order_business) + "\r\n                        "), _c('br'), _vm._v(" "), _vm._l((order.order_items), function(item) {
      return _c('div', {
        staticStyle: {
          "display": "inline"
        }
      }, [_c('img', {
        attrs: {
          "src": _vm.img_product_url + item.product_item_group_image,
          "height": "50",
          "width": "50"
        }
      })])
    })], 2), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "20%"
      }
    }, [_c('small', [_vm._v("₦")]), _vm._v(_vm._s(order.order_total.toFixed(2)))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_c('span', {
      style: ({
        color: order.order_payment_status_color
      })
    }, [_vm._v(_vm._s(order.order_payment_status))])])])
  })], 2)])])])]) : _vm._e(), _vm._v(" "), (_vm.show_single) ? _c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "col lg-12"
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer",
      "font-size": "28px",
      "font-weight": "bolder"
    },
    on: {
      "click": _vm.viewOrders
    }
  }, [_vm._v("X")])])])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "col lg-12"
  }, [_c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), (_vm.is_new) ? _c('h3', {
    staticClass: "text-align-center margin-bottom-double"
  }, [_vm._v("Thank you. Your order has been received.")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flexh-justify-center sm-flexv"
  }, [_c('div', {
    staticClass: "margin-left margin-right"
  }, [_c('span', {
    staticClass: "form-label margin-right-small"
  }, [_vm._v("Order number:")]), _vm._v(" " + _vm._s(_vm.order.order_no))]), _vm._v(" "), _c('div', {
    staticClass: "margin-left margin-right"
  }, [_c('span', {
    staticClass: "form-label margin-right-small"
  }, [_vm._v("Date:")]), _vm._v(" " + _vm._s(_vm.order.order_date))]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "margin-left margin-right"
  }, [_c('span', {
    staticClass: "form-label margin-right-small"
  }, [_vm._v("Status:")]), _vm._v(" "), _c('span', {
    style: ({
      color: _vm.order.order_payment_status_color
    })
  }, [_vm._v(_vm._s(_vm.order.order_payment_status))])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flexh-justify-center sm-flexv",
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('div', {
    staticClass: "margin-left margin-right-small"
  }, [_c('span', {
    staticClass: "form-label margin-right-small"
  }, [_vm._v("Order Amount:")]), _vm._v(" ₦" + _vm._s(_vm.order.order_items_total))]), _vm._v(" "), _c('div', {
    staticClass: "margin-left margin-right-small"
  }, [_c('span', {
    staticClass: "form-label margin-right-small"
  }, [_vm._v("Shipping:")]), _vm._v(" ₦" + _vm._s(_vm.order.order_shipping_total))]), _vm._v(" "), _c('div', {
    staticClass: "margin-left margin-right-small"
  }, [_c('span', {
    staticClass: "form-label margin-right-small"
  }, [_vm._v("Total:")]), _vm._v(" ₦" + _vm._s(_vm.order.order_total))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flexh-justify-center sm-flexv",
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('div', {
    staticClass: "margin-left margin-right-small"
  }, [_c('span', {
    staticClass: "form-label margin-right-small"
  }, [_vm._v("Delivery Location:")]), _vm._v(" " + _vm._s(_vm.order.order_delivery_city))]), _vm._v(" "), _c('div', {
    staticClass: "margin-left margin-right-small"
  }, [_c('span', {
    staticClass: "form-label margin-right-small"
  }, [_vm._v("Address:")]), _vm._v(" " + _vm._s(_vm.order.order_user_delivery_address))])])])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "col lg-12 position-relative"
  }, [_c('div', {
    staticClass: "c-shop-order__wrapper sm-overflow-scroll orders-panel"
  }, [_c('table', {
    staticClass: "table table-striped",
    staticStyle: {
      "width": "100%",
      "text-align": "left"
    }
  }, [_c('th', {
    staticClass: "tcol",
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("Order No")]), _vm._v(" "), _c('th', {
    staticClass: "tcol",
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v("Order")]), _vm._v(" "), _c('th', {
    staticClass: "tcol",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("Qty")]), _vm._v(" "), _c('th', {
    staticClass: "tcol",
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("Total")]), _vm._v(" "), _vm._l((_vm.order.order_items), function(item) {
    return _c('tr', [_c('td', {
      staticStyle: {
        "width": "20%",
        "font-size": "12px"
      }
    }, [_vm._v("\r\n                        " + _vm._s(item.order_item_no) + "\r\n                      ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "50%"
      }
    }, [_vm._v("\r\n                        " + _vm._s(item.product_name) + "\r\n                        "), _c('br'), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "inline"
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.img_product_url + item.product_item_group_image,
        "height": "50",
        "width": "50"
      }
    })])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_vm._v(_vm._s(item.order_item_quantity))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "20%"
      }
    }, [_c('small', [_vm._v("₦")]), _vm._v(_vm._s(item.order_item_total.toFixed(2)))])])
  })], 2)])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticStyle: {
      "margin-top": "1em",
      "text-align": "center",
      "font-size": "18px"
    }
  }, [_vm._v("Your Orders")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "margin-left margin-right"
  }, [_c('span', {
    staticClass: "form-label margin-right-small"
  }, [_vm._v("Payment method:")]), _vm._v(" Online Payment")])
}]}

/***/ }),
/* 277 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "wrap"
    }
  }, [_c('c-settings'), _vm._v(" "), _c('div', {
    staticClass: "page-wrapper",
    attrs: {
      "id": "topwrap"
    }
  }, [_c('component-header'), _vm._v(" "), (_vm.set_upgrade_plans) ? _c('section', {
    staticClass: "pricing-style-one",
    staticStyle: {
      "background": "#aa076b",
      "margin-top": "5em"
    },
    attrs: {
      "id": "pricing"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-top": "-5em"
    }
  }, [(!_vm.set_upgrade_plan_process) ? _c('div', {
    staticClass: "container"
  }, [(_vm.upgradable_plans.length == 0) ? _c('div', {
    staticClass: "block-title text-center"
  }, [_c('h2', {
    staticStyle: {
      "color": "#ffffff"
    }
  }, [_vm._v("Sorry, no plans to upgrade to.")])]) : _c('div', {
    staticClass: "block-title text-center"
  }, [_c('h2', {
    staticStyle: {
      "color": "#ffffff"
    }
  }, [_vm._v("Select a plan to upgrade")])]), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane show active  animated fadeInUp",
    attrs: {
      "role": "tabpanel"
    }
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.upgradable_plans), function(plan) {
    return _c('div', {
      staticClass: "col-lg-4 col-md-6 col-sm-12"
    }, [_c('div', {
      staticClass: "single-pricing-one basic-pack"
    }, [_c('div', {
      staticClass: "top-block"
    }, [((plan.product_items && plan.product_items.length > 0)) ? _c('span', {
      staticClass: "price"
    }, [_vm._v("₦" + _vm._s(plan.product_items[0].product_item_price))]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "pack-name"
    }, [_vm._v(_vm._s(plan.product_name))]), _vm._v(" "), _c('div', {
      staticClass: "line"
    })]), _vm._v(" "), (plan.product_url_name == 'plan1') ? _c('ul', {
      staticClass: "feature-lists"
    }, [_c('li', [_vm._v("Extra features")]), _vm._v(" "), _c('li', [_vm._v("Lifetime free support")]), _vm._v(" "), _c('li', [_vm._v("Upgrate options")]), _vm._v(" "), _c('li', [_vm._v("Full access")])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "bottom-block"
    }, [_c('p', {
      staticClass: "sp-form-descr"
    }, [_vm._v("Your Upgrade details would be calculated appropriately when you choose plan")]), _vm._v(" "), _c('a', {
      staticClass: "price-btn",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.upgrade_plan(plan)
        }
      }
    }, [_vm._v("Purchase")])])])])
  }))])])]) : _c('div', {
    staticClass: "container",
    staticStyle: {
      "margin-top": "10em"
    }
  }, [_vm._m(1), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._m(2)]) : _c('div', {
    staticClass: "row onboarding-wrap"
  }, [(_vm.setup_error_message != '') ? _c('div', {
    staticClass: "row onboarding-head"
  }, [_c('div', {
    staticClass: "col",
    staticStyle: {
      "margin": "5em",
      "text-align": "center"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#000000",
      "font-size": "18px"
    }
  }, [_vm._v(_vm._s(_vm.setup_error_message) + ".")])])]) : _c('div', [_c('div', {
    staticClass: "row onboarding-body"
  }, [_c('div', {
    staticClass: "col-12 col-sm-12 col-xs-12 col-md-6 offset-md-4 onboarding-center"
  }, [_c('div', [_c('h6', {
    staticStyle: {
      "text-decoration": "underline"
    }
  }, [_vm._v("Upgrade Plans")]), _vm._v(" "), (_vm.selected_plan && _vm.selected_plan.product_items) ? _c('h4', [_c('b', [_vm._v(_vm._s(_vm.selected_plan.product_name) + "(₦" + _vm._s(_vm.setCurrency(_vm.selected_plan_product_service_item.product_item_price)) + ")")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {}, [_c('div', [_vm._l((_vm.selected_plan.product_items_upgrade_details), function(details) {
    return _c('div', {}, [(_vm.selected_plan_product_service_item.product_item_id == details.subscription_new_product_item_id) ? _c('div', [_c('p', [_vm._v("Your last Subscription was on:"), _c('b', [_vm._v(_vm._s(details.subscription_subscribed_product_start_date))]), _vm._v(".")]), _vm._v(" "), _c('p', [_vm._v("You have "), _c('b', [_vm._v(_vm._s(details.subscription_subscribed_product_days_left))]), _vm._v(" days before your subscription expires.")]), _vm._v(" "), _c('p', [_vm._v("To upgrade to this plan, the total sum to pay is "), _c('b', [_vm._v(_vm._s(details.subscription_new_product_total_amount_to_pay))])])]) : _vm._e()])
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {}, [_c('form', {
    staticClass: "gw-form"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Subscription Duration: "), _c('b', [_vm._v(_vm._s(_vm.selected_plan_product_service_item.product_item_service_tag))])]), _c('br'), _vm._v(" "), _c('label', [_c('p', {
    staticClass: "sp-form-descr"
  }, [_c('b', [_vm._v("Total to pay: ₦" + _vm._s(_vm.setCurrency(_vm.selected_plan_product_service_item.product_item_price)))])])])]), _vm._v(" "), (_vm.selected_plan.product_items && (_vm.selected_plan.product_items.length > 1)) ? _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "gw-btn-cta-light",
    staticStyle: {
      "color": "#ffffff"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('display-product_service_items', '')
      }
    }
  }, [_vm._v("\r\n                                                                Change Subscription Duration\r\n                                                            ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none",
      "border": "#aa076b dashed",
      "margin-top": "6px",
      "padding": "5px"
    },
    attrs: {
      "id": "productServiceItems"
    }
  }, _vm._l((_vm.selected_plan.product_items), function(pt) {
    return _c('div', {
      staticClass: "radio-items"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.product_service_items_select),
        expression: "product_service_items_select"
      }],
      attrs: {
        "type": "radio",
        "id": pt.product_item_id
      },
      domProps: {
        "value": pt.product_item_id,
        "checked": _vm._q(_vm.product_service_items_select, pt.product_item_id)
      },
      on: {
        "click": function($event) {
          _vm.selectProductServiceItem(pt)
        },
        "__c": function($event) {
          _vm.product_service_items_select = pt.product_item_id
        }
      }
    }), _vm._v(_vm._s(pt.product_item_service_tag) + "\r\n                                                                ")])
  }))]) : _vm._e(), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))]), _vm._v(" "), (_vm.payment_successful) ? _c('div', {}, [_c('h3', {
    staticStyle: {
      "color": "#7c0b0b",
      "font-size": "16px"
    }
  }, [_vm._v(_vm._s(_vm.payment_successful_message))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "boarding-messages"
  }, [_c('p', {
    staticStyle: {
      "color": "#4617c7"
    }
  }, [_vm._v(_vm._s(_vm.data_boarding_message))])]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn pull-left gw-btn-cta-light",
    staticStyle: {
      "cursor": "pointer",
      "color": "#ffffff"
    },
    attrs: {
      "type": "button",
      "disabled": _vm.disable_btn
    },
    on: {
      "click": function($event) {
        _vm.proceedUpgradePlan()
      }
    }
  }, [_vm._v(" Proceed")]), _vm._v(" "), _c('button', {
    staticClass: "btn pull-right",
    staticStyle: {
      "background": "#f0de3d",
      "cursor": "pointer",
      "color": "#000000"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.reset
    }
  }, [_vm._v(" Cancel")])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })], 2)])])])])])])])]) : _c('section', {
    staticClass: "home-page-two gw-banner-plain",
    attrs: {
      "id": "banner"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._m(4)]) : _c('div', {
    staticClass: "row onboarding-wrap"
  }, [(_vm.setup_error_message != '') ? _c('div', {
    staticClass: "row onboarding-head"
  }, [_c('div', {
    staticClass: "col",
    staticStyle: {
      "margin": "5em",
      "text-align": "center"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#000000",
      "font-size": "18px"
    }
  }, [_vm._v(_vm._s(_vm.setup_error_message) + ".")])])]) : _c('div', [(!_vm.newBusinessForm) ? _c('div', {
    staticClass: "row onboarding-body"
  }, [_c('div', {
    staticClass: "col-6 onboarding-left"
  }, [_c('h6', [_vm._v("Purchase Plans")]), _vm._v(" "), _c('p', [_vm._v("You are about to purchase "), _c('b', [_vm._v(_vm._s(_vm.selected_plan.product_name))]), _vm._v(" plan, this would take few minutes and would lead you to creating and setting up \r\n                                        your "), _c('span', {
    staticClass: "sp-mention-inline"
  }, [_vm._v("Sellpoint")]), _vm._v(" account. We use Sellpoint to manage your acounts. \r\n                                        If you already have a Sellpoint account, you can Sign Up with your details.")]), _vm._v(" "), _c('p', [_c('u', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": _vm.toggleDisplayFeatures
    }
  }, [_vm._v("\r\n                                            See features of " + _vm._s(_vm.selected_plan.product_name) + " "), _c('i', {
    staticClass: "fa fa-caret-down",
    staticStyle: {
      "color": "#ff0055",
      "font-size": "18px"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "features-display",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "seeFeatures"
    }
  }, [_c('div', {
    staticClass: "feature-list"
  }, [(_vm.selected_plan.product_url_name == _vm.plan1.product_url_name) ? _c('ul', [_c('li', [_vm._v("cica1")])]) : _vm._e(), _vm._v(" "), (_vm.selected_plan.product_url_name == _vm.plan2.product_url_name) ? _c('ul', [_c('li', [_vm._v("cica2")])]) : _vm._e(), _vm._v(" "), (_vm.selected_plan.product_url_name == _vm.plan3.product_url_name) ? _c('ul', [_c('li', [_vm._v("cica3")])]) : _vm._e()])]), _vm._v(" "), _vm._m(5)]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-sm-12 col-xs-12 col-md-6 onboarding-right"
  }, [_c('div', [_c('h6', {
    staticClass: "gw-mobile",
    staticStyle: {
      "text-decoration": "underline"
    }
  }, [_vm._v("Purchase Plans")]), _vm._v(" "), (_vm.selected_plan && _vm.selected_plan.product_items) ? _c('h4', [_c('b', [_vm._v(_vm._s(_vm.selected_plan.product_name) + "(₦" + _vm._s(_vm.setCurrency(_vm.selected_plan_product_service_item.product_item_price)) + ")")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {}, [(!_vm.set_up_with_existing_account) ? _c('div', [_c('div', {}, [_c('div', {
    staticClass: "gw-mobile"
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('a', {
    staticClass: "btn gw-btn-cta-light pu",
    staticStyle: {
      "cursor": "pointer",
      "margin-bottom": "1em",
      "color": "#ffffff"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('setup-existing', '')
      }
    }
  }, [_vm._v("Sign Up with Sellpoint")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#aa076b",
      "font-size": "14px",
      "font-weight": "500"
    }
  }, [_vm._v("Or Create a Sellpoint account to proceed.")])]), _vm._v(" "), _c('div', {
    staticClass: "gw-not-mobile"
  }, [_c('p', {
    staticClass: "pull-left",
    staticStyle: {
      "color": "#aa076b"
    }
  }, [_vm._v("Create a Sellpoint account to proceed.")]), _vm._v(" "), _c('a', {
    staticClass: "btn gw-btn-cta-light pull-right",
    staticStyle: {
      "cursor": "pointer",
      "margin-bottom": "1em",
      "color": "#ffffff"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('setup-existing', '')
      }
    }
  }, [_vm._v(" Or Sign Up with Sellpoint")])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {}, [_c('form', {
    staticClass: "gw-form"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Full Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.payment_payer_name),
      expression: "payment_payer_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Your full name"
    },
    domProps: {
      "value": (_vm.payment_payer_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.payment_payer_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.payment_payer_email),
      expression: "payment_payer_email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.payment_payer_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.payment_payer_email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Phone")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.payment_payer_phone),
      expression: "payment_payer_phone"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "placeholder": "Phone (format: 09088776655)"
    },
    domProps: {
      "value": (_vm.payment_payer_phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.payment_payer_phone = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_password),
      expression: "user.user_password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.user.user_password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_password = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.selected_plan_product_service_item.product_item_service_tag) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Subscription Duration: "), _c('b', [_vm._v(_vm._s(_vm.selected_plan_product_service_item.product_item_service_tag))])]), _c('br'), _vm._v(" "), _c('label', [_c('p', {
    staticClass: "sp-form-descr"
  }, [_c('b', [_vm._v("Total to pay: ₦" + _vm._s(_vm.setCurrency(_vm.selected_plan_product_service_item.product_item_price)))])])])]) : _vm._e(), _vm._v(" "), (_vm.selected_plan.product_items && (_vm.selected_plan.product_items.length > 1)) ? _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "gw-btn-cta-light",
    staticStyle: {
      "color": "#ffffff"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('display-product_service_items', '')
      }
    }
  }, [_vm._v("\r\n                                                            Change Subscription Duration\r\n                                                        ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none",
      "border": "#aa076b dashed",
      "margin-top": "6px",
      "padding": "5px"
    },
    attrs: {
      "id": "productServiceItems"
    }
  }, _vm._l((_vm.selected_plan.product_items), function(pt) {
    return _c('div', {
      staticClass: "radio-items"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.product_service_items_select),
        expression: "product_service_items_select"
      }],
      attrs: {
        "type": "radio",
        "id": pt.product_item_id
      },
      domProps: {
        "value": pt.product_item_id,
        "checked": _vm._q(_vm.product_service_items_select, pt.product_item_id)
      },
      on: {
        "click": function($event) {
          _vm.selectProductServiceItem(pt)
        },
        "__c": function($event) {
          _vm.product_service_items_select = pt.product_item_id
        }
      }
    }), _vm._v(_vm._s(pt.product_item_service_tag) + "\r\n                                                            ")])
  }))]) : _vm._e(), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))]), _vm._v(" "), (_vm.payment_successful) ? _c('div', {}, [_c('h3', {
    staticStyle: {
      "color": "#7c0b0b",
      "font-size": "16px"
    }
  }, [_vm._v(_vm._s(_vm.payment_successful_message))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "boarding-messages"
  }, [_c('p', {
    staticStyle: {
      "color": "#4617c7"
    }
  }, [_vm._v(_vm._s(_vm.data_boarding_message))])]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn pull-left gw-btn-cta-light",
    staticStyle: {
      "cursor": "pointer",
      "color": "#ffffff"
    },
    attrs: {
      "type": "button",
      "disabled": _vm.disable_btn
    },
    on: {
      "click": function($event) {
        _vm.proceedNewAccount()
      }
    }
  }, [_vm._v(" Proceed")])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]) : _c('div', [_vm._m(7), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "2em"
    }
  }, [_c('form', {
    staticClass: "gw-form"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_email),
      expression: "user.user_email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.user.user_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_password),
      expression: "user.user_password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.user.user_password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Sellpoint Username or Handle")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_business),
      expression: "user.user_business"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Sellpoint Username/Handle"
    },
    domProps: {
      "value": (_vm.user.user_business)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_business = $event.target.value
      }
    }
  })]), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))]), _vm._v(" "), (_vm.payment_successful) ? _c('div', {}, [_c('h3', {
    staticStyle: {
      "color": "#7c0b0b",
      "font-size": "16px"
    }
  }, [_vm._v(_vm._s(_vm.payment_successful_message))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "boarding-messages"
  }, [_c('p', {
    staticStyle: {
      "color": "#4617c7"
    }
  }, [_vm._v(_vm._s(_vm.data_boarding_message))])]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn gw-btn-cta-light pull-left",
    staticStyle: {
      "cursor": "pointer",
      "border-radius": "2p",
      "color": "#ffffff"
    },
    attrs: {
      "type": "button",
      "disabled": _vm.disable_btn
    },
    on: {
      "click": function($event) {
        _vm.proceedWithAccount()
      }
    }
  }, [_vm._v(" Proceed")])])]), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('hr'), _vm._v(" "), _c('a', {
    staticClass: "gw-btn-cta-light pull-left",
    staticStyle: {
      "cursor": "pointer",
      "margin-bottom": "1em",
      "color": "#ffffff"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('not-setup-existing', '')
      }
    }
  }, [_vm._v(" Or Create a new account")])])])])])])]) : _c('div', {
    staticClass: "row onboarding-body"
  }, [_c('div', {
    staticClass: "col-6 onboarding-left"
  }, [_c('h6', [_vm._v("Purchase Plans")]), _vm._v(" "), _c('p', [_vm._v("You are about to purchase "), _c('b', [_vm._v(_vm._s(_vm.selected_plan.product_name))]), _vm._v(" plan, this would take few minutes and would lead you to creating and setting up \r\n                                        your "), _c('span', {
    staticClass: "sp-mention-inline"
  }, [_vm._v("Sellpoint")]), _vm._v(" account. We use Sellpoint to manage your acounts. \r\n                                        If you already have a Sellpoint account, you can Sign Up with your details.")]), _vm._v(" "), _c('p', [_c('u', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": _vm.toggleDisplayFeatures
    }
  }, [_vm._v("\r\n                                            See features of " + _vm._s(_vm.selected_plan.product_name) + " "), _c('i', {
    staticClass: "fa fa-caret-down",
    staticStyle: {
      "color": "#ff0055",
      "font-size": "18px"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "features-display",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "seeFeatures"
    }
  }, [_c('div', {
    staticClass: "feature-list"
  }, [(_vm.selected_plan.product_url_name == _vm.plan1.product_url_name) ? _c('ul', [_c('li', [_vm._v("cica1")])]) : _vm._e(), _vm._v(" "), (_vm.selected_plan.product_url_name == _vm.plan2.product_url_name) ? _c('ul', [_c('li', [_vm._v("cica2")])]) : _vm._e(), _vm._v(" "), (_vm.selected_plan.product_url_name == _vm.plan3.product_url_name) ? _c('ul', [_c('li', [_vm._v("cica3")])]) : _vm._e()])]), _vm._v(" "), _vm._m(9)]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-sm-12 col-xs-12 col-md-6 onboarding-right"
  }, [_vm._m(10), _vm._v(" "), _c('div', {}, [_c('div', [_c('div', {
    staticStyle: {
      "margin-bottom": "2em"
    }
  }, [_c('form', {
    staticClass: "gw-form"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(" *Business Name  ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business.business_name),
      expression: "business.business_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "value": "",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.business.business_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.business.business_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(" *Business Username "), (_vm.validate_user_name_error) ? _c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.validate_user_name_message))]) : _vm._e()]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business.business_user_name),
      expression: "business.business_user_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.business.business_user_name)
    },
    on: {
      "change": _vm.validateUserName,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.business.business_user_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Select Business Category Type")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business_category_type),
      expression: "business_category_type"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.business_category_type = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Products")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Services")])])]), _vm._v(" "), (_vm.business_category_type == 1) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Select a Product Category")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business.business_category),
      expression: "business.business_category"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.business.business_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.business_product_categories), function(category) {
    return _c('option', {
      domProps: {
        "value": category.category_id
      }
    }, [_vm._v(_vm._s(category.category_name))])
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.business_category_type == 2) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Select a Service Category")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business.business_category),
      expression: "business.business_category"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.business.business_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.business_service_categories), function(category) {
    return _c('option', {
      domProps: {
        "value": category.category_id
      }
    }, [_vm._v(_vm._s(category.category_name))])
  })], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "boarding-messages"
  }, [_c('p', {
    staticStyle: {
      "color": "#4617c7"
    }
  }, [_vm._v(_vm._s(_vm.data_boarding_message))])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn gw-btn-cta-light",
    staticStyle: {
      "color": "#ffffff"
    },
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": _vm.setUpNewAccountBusiness
    }
  }, [_vm._v("Create")])])])])])])])])])])]), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "container gw-mobile"
  }, [_vm._m(11)]) : _vm._e()]), _vm._v(" "), (!_vm.$route.query.upgrade) ? _c('section', {
    staticClass: "pricing-style-one gw-mtp",
    attrs: {
      "id": "pricing"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(12), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._m(13)]) : _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane show active  animated fadeInUp",
    attrs: {
      "role": "tabpanel",
      "id": "monthly"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-4 col-md-6 col-sm-12"
  }, [_c('div', {
    staticClass: "single-pricing-one basic-pack"
  }, [_c('div', {
    staticClass: "top-block"
  }, [((_vm.plan1.product_items && _vm.plan1.product_items.length > 0)) ? _c('span', {
    staticClass: "price"
  }, [_vm._v("₦" + _vm._s(_vm.plan1.product_items[0].product_item_price))]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "pack-name"
  }, [_vm._v(_vm._s(_vm.plan1.product_name))]), _vm._v(" "), _c('div', {
    staticClass: "line"
  })]), _vm._v(" "), _vm._m(14), _vm._v(" "), _c('div', {
    staticClass: "bottom-block"
  }, [_c('a', {
    staticClass: "price-btn",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.purchase_plan_2(_vm.plan1, 'n')
      }
    }
  }, [_vm._v("Purchase")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-6 col-sm-12"
  }, [_c('div', {
    staticClass: "single-pricing-one pro-pack"
  }, [_c('div', {
    staticClass: "top-block"
  }, [((_vm.plan2.product_items && _vm.plan2.product_items.length > 0)) ? _c('span', {
    staticClass: "price"
  }, [_vm._v("₦" + _vm._s(_vm.plan2.product_items[0].product_item_price) + "/mo")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "pack-name"
  }, [_vm._v(_vm._s(_vm.plan2.product_name))]), _vm._v(" "), _c('div', {
    staticClass: "line"
  })]), _vm._v(" "), _vm._m(15), _vm._v(" "), _c('div', {
    staticClass: "bottom-block"
  }, [_c('a', {
    staticClass: "price-btn",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.purchase_plan_2(_vm.plan2, 'n')
      }
    }
  }, [_vm._v("Purchase")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-6 col-sm-12"
  }, [_c('div', {
    staticClass: "single-pricing-one biz-pack"
  }, [_c('div', {
    staticClass: "top-block"
  }, [((_vm.plan3.product_items && _vm.plan3.product_items.length > 0)) ? _c('span', {
    staticClass: "price"
  }, [_vm._v("₦" + _vm._s(_vm.plan3.product_items[0].product_item_price) + "/mo")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "pack-name"
  }, [_vm._v(_vm._s(_vm.plan3.product_name))]), _vm._v(" "), _c('div', {
    staticClass: "line"
  })]), _vm._v(" "), _vm._m(16), _vm._v(" "), _c('div', {
    staticClass: "bottom-block"
  }, [_c('a', {
    staticClass: "price-btn",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.purchase_plan_2(_vm.plan3, 'n')
      }
    }
  }, [_vm._v("Purchase")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane animated fadeInUp",
    attrs: {
      "role": "tabpanel",
      "id": "yearly"
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('component-footer')], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-5 offset-sm-4"
  }, [_c('div', {
    staticClass: "loading-md"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-title text-center"
  }, [_c('h2', {
    staticStyle: {
      "color": "#ffffff"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-5 offset-sm-4"
  }, [_c('div', {
    staticClass: "loading-md"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "checked": "true",
      "disabled": "disabled"
    }
  }), _vm._v(" By proceeding, you agree with the "), _c('u', [_c('a', {
    staticStyle: {
      "cursor": "pointer",
      "color": "#ff0055",
      "font-weight": "bold"
    },
    attrs: {
      "data-toggle": "modal",
      "data-backdrop": "false",
      "data-target": "#terms-modal",
      "href": "#"
    }
  }, [_vm._v("Terms and Conditions")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-5 offset-sm-4"
  }, [_c('div', {
    staticClass: "loading-md"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "text-align": "left",
      "margin-top": "3em"
    }
  }, [_c('a', {
    staticClass: "btn gw-btn-cta-01",
    attrs: {
      "href": "#pricing"
    }
  }, [_vm._v("Checkout other plans")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "checked": "true",
      "disabled": "disabled"
    }
  }), _vm._v(" By proceeding, you agree with the "), _c('u', [_c('a', {
    staticStyle: {
      "cursor": "pointer",
      "color": "#ff0055",
      "font-weight": "bold"
    },
    attrs: {
      "data-toggle": "modal",
      "data-backdrop": "false",
      "data-target": "#terms-modal",
      "href": "#"
    }
  }, [_vm._v("Terms and Conditions")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('p', {
    staticClass: "pull-left",
    staticStyle: {
      "color": "#aa076b"
    }
  }, [_vm._v("Proceed with your Sellpoint Account ")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "checked": "true",
      "disabled": "disabled"
    }
  }), _vm._v(" By proceeding, you agree with the "), _c('u', [_c('a', {
    staticStyle: {
      "cursor": "pointer",
      "color": "#ff0055",
      "font-weight": "bold"
    },
    attrs: {
      "data-toggle": "modal",
      "data-backdrop": "false",
      "data-target": "#terms-modal",
      "href": "#"
    }
  }, [_vm._v("Terms and Conditions")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "text-align": "left",
      "margin-top": "3em"
    }
  }, [_c('a', {
    staticClass: "btn gw-btn-cta-01",
    attrs: {
      "href": "#pricing"
    }
  }, [_vm._v("Checkout other plans")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gw-mobile"
  }, [_c('h6', {
    staticClass: "gw-mobile",
    staticStyle: {
      "text-decoration": "underline"
    }
  }, [_vm._v("Setup New Sellpoint Account")]), _vm._v(" "), _c('p', {
    staticClass: "sp-form-descr"
  }, [_vm._v("Setup New Sellpoint Account......")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5 offset-sm-4",
    staticStyle: {
      "text-align": "center",
      "margin-top": "3em"
    }
  }, [_c('a', {
    staticClass: "btn gw-btn-cta-01",
    attrs: {
      "href": "#pricing"
    }
  }, [_vm._v("Checkout other plans")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-title text-center"
  }, [_c('h2', {
    staticStyle: {
      "color": "#aa076b"
    }
  }, [_vm._v("Choose from these plans")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-5 offset-sm-4"
  }, [_c('div', {
    staticClass: "loading-md"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "feature-lists"
  }, [_c('li', [_vm._v("Max. 2 lookbooks")]), _vm._v(" "), _c('li', [_vm._v("Max. of 5 posts per Lookbook")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "feature-lists"
  }, [_c('li', [_vm._v("Max. 10 Lookbooks")]), _vm._v(" "), _c('li', [_vm._v("Unlimited Posts per Lookbook")]), _vm._v(" "), _c('li', [_vm._v("Free .com.ng domain")]), _vm._v(" "), _c('li', [_vm._v("*Max Storage Space of 500mb")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "feature-lists"
  }, [_c('li', [_vm._v("Unlimited Lookbooks")]), _vm._v(" "), _c('li', [_vm._v("Unlimited Posts")]), _vm._v(" "), _c('li', [_vm._v("Free .com.ng domain\r\n                                            ")]), _c('li', [_vm._v("Online Store (Functionality)")]), _vm._v(" "), _c('li', [_vm._v("*Max Storage Space of 1Gb")])])
}]}

/***/ }),
/* 278 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.loggedIn) ? _c('div', {
    staticClass: "hidden-sm hidden-xs"
  }, [_c('div', {
    staticClass: "profile-card"
  }, [_c('img', {
    staticClass: "profile-photo",
    attrs: {
      "src": "http://placehold.it/300x300",
      "alt": "user"
    }
  }), _vm._v(" "), _c('h5', [_c('a', {
    staticClass: "text-white",
    attrs: {
      "href": "timeline"
    }
  }, [_vm._v(_vm._s(_vm.user.user_name))])]), _vm._v(" "), _vm._m(0), _c('br'), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _vm._m(2)]) : _vm._e(), _vm._v(" "), _vm._m(3)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "text-white",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-shopping-cart"
  }), _vm._v(" 62 shops")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "text-white",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "ion ion-android-person-add"
  }), _vm._v(" 1,500 friends")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "nav-news-feed"
  }, [_c('li', [_c('i', {
    staticClass: "icon ion-ios-paper"
  }), _c('div', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Tradefair Newsfeed")])])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "icon fa fa-shopping-cart"
  }), _c('div', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Shops Following")])])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "icon ion-ios-people-outline"
  }), _c('div', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Friends")])])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "icon ion-chatboxes"
  }), _c('div', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Discussions / Messages")])])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "icon ion-images"
  }), _c('div', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Orders")])])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "icon fa fa-bell"
  }), _c('div', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("No6ifications")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hidden-xs"
  }, [_c('div', {
    staticClass: "profile-card"
  }, [_c('p', [_vm._v("Do you dream of the day you will use naijabrandtradefair2019 and really make so much sales? Like the day you will stop struggling to pay bills because sales aren’t forth coming, Or maybe you want to be your own brand influencer but your visibility keeps diminishing day by day …")])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "sticky-feeds"
    }
  }, [_c('h4', {
    staticClass: "grey"
  }, [_vm._v("Ongoing Activities")]), _vm._v(" "), _c('div', {
    staticClass: "feed-item"
  }, [_c('div', {
    staticClass: "live-activity"
  }, [_c('p', [_c('img', {
    staticClass: "profile-photo-sm pull-left",
    attrs: {
      "src": "http://placehold.it/300x300",
      "alt": ""
    }
  }), _c('a', {
    staticClass: "profile-link",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Olu Jane Stores")]), _vm._v(" Commented on a product")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("5 mins ago")])])]), _vm._v(" "), _c('div', {
    staticClass: "feed-item"
  }, [_c('div', {
    staticClass: "live-activity"
  }, [_c('p', [_c('img', {
    staticClass: "profile-photo-sm pull-left",
    attrs: {
      "src": "http://placehold.it/300x300",
      "alt": ""
    }
  }), _c('a', {
    staticClass: "profile-link",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Lami Fashion Store")]), _vm._v(" Has posted a product")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("an hour ago")])])]), _vm._v(" "), _c('div', {
    staticClass: "feed-item"
  }, [_c('div', {
    staticClass: "live-activity"
  }, [_c('p', [_c('img', {
    staticClass: "profile-photo-sm pull-left",
    attrs: {
      "src": "http://placehold.it/300x300",
      "alt": ""
    }
  }), _c('a', {
    staticClass: "profile-link",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Trish Hairs")]), _vm._v(" Liked friend's product")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("4 hours ago")])])]), _vm._v(" "), _c('div', {
    staticClass: "feed-item"
  }, [_c('div', {
    staticClass: "live-activity"
  }, [_c('p', [_c('img', {
    staticClass: "profile-photo-sm pull-left",
    attrs: {
      "src": "http://placehold.it/300x300",
      "alt": ""
    }
  }), _c('a', {
    staticClass: "profile-link",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("LuluBeads Crafts")]), _vm._v(" has shared a product")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("a day ago")])])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "title"
  }, [_vm._v("Tradefair Talks")]), _vm._v(" "), _c('ul', {
    staticClass: "online-users list-inline"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#",
      "title": "Cynthia Belonwu"
    }
  }, [_c('img', {
    staticClass: "img-responsive profile-photo",
    attrs: {
      "src": "http://placehold.it/300x300",
      "alt": "user"
    }
  }), _c('span', {
    staticClass: "online-dot"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#",
      "title": "Jubril Sani"
    }
  }, [_c('img', {
    staticClass: "img-responsive profile-photo",
    attrs: {
      "src": "http://placehold.it/300x300",
      "alt": "user"
    }
  }), _c('span', {
    staticClass: "online-dot"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#",
      "title": "Sandra Oseni"
    }
  }, [_c('img', {
    staticClass: "img-responsive profile-photo",
    attrs: {
      "src": "http://placehold.it/300x300",
      "alt": "user"
    }
  }), _c('span', {
    staticClass: "online-dot"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#",
      "title": "Titilo Bass"
    }
  }, [_c('img', {
    staticClass: "img-responsive profile-photo",
    attrs: {
      "src": "http://placehold.it/300x300",
      "alt": "user"
    }
  }), _c('span', {
    staticClass: "online-dot"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#",
      "title": "Jayden Ajibade"
    }
  }, [_c('img', {
    staticClass: "img-responsive profile-photo",
    attrs: {
      "src": "http://placehold.it/300x300",
      "alt": "user"
    }
  }), _c('span', {
    staticClass: "online-dot"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#",
      "title": "Nonso Obi"
    }
  }, [_c('img', {
    staticClass: "img-responsive profile-photo",
    attrs: {
      "src": "http://placehold.it/300x300",
      "alt": "user"
    }
  }), _c('span', {
    staticClass: "online-dot"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#",
      "title": "Efiong Dun"
    }
  }, [_c('img', {
    staticClass: "img-responsive profile-photo",
    attrs: {
      "src": "http://placehold.it/300x300",
      "alt": "user"
    }
  }), _c('span', {
    staticClass: "online-dot"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#",
      "title": "Chika Nnabi"
    }
  }, [_c('img', {
    staticClass: "img-responsive profile-photo",
    attrs: {
      "src": "http://placehold.it/300x300",
      "alt": "user"
    }
  }), _c('span', {
    staticClass: "online-dot"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#",
      "title": "Bolaji Adewale"
    }
  }, [_c('img', {
    staticClass: "img-responsive profile-photo",
    attrs: {
      "src": "http://placehold.it/300x300",
      "alt": "user"
    }
  }), _c('span', {
    staticClass: "online-dot"
  })])])])])])])
}]}

/***/ }),
/* 279 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "create-post"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-9 col-sm-9"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('img', {
    staticClass: "profile-photo-md",
    attrs: {
      "src": "http://placehold.it/300x300",
      "alt": ""
    }
  }), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search_words),
      expression: "search_words"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "texts",
      "id": "exampleTextarea",
      "cols": "100",
      "rows": "1",
      "placeholder": "Search: enter name or handle or hashtag"
    },
    domProps: {
      "value": (_vm.search_words)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search_words = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    staticStyle: {
      "padding-left": "5em"
    }
  }, [_c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search_type),
      expression: "search_type"
    }],
    attrs: {
      "type": "radio",
      "value": "business",
      "id": "business"
    },
    domProps: {
      "checked": _vm._q(_vm.search_type, "business")
    },
    on: {
      "__c": function($event) {
        _vm.search_type = "business"
      }
    }
  }), _vm._v("Business\n                  ")]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search_type),
      expression: "search_type"
    }],
    attrs: {
      "type": "radio",
      "value": "product",
      "id": "product"
    },
    domProps: {
      "checked": _vm._q(_vm.search_type, "product")
    },
    on: {
      "__c": function($event) {
        _vm.search_type = "product"
      }
    }
  }), _vm._v("Product/Service\n                  ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-3"
  }, [_c('div', {
    staticClass: "tools"
  }, [_c('button', {
    staticClass: "btn btn-primary pull-right",
    on: {
      "click": _vm.search
    }
  }, [_vm._v("Search")])])])])])
},staticRenderFns: []}

/***/ }),
/* 280 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), (_vm.loggedIn) ? _c('div', {
    staticClass: "hidden-md hidden-lg"
  }, [_c('hr'), _vm._v(" "), _c('h3', [_vm._v("Your Profile")]), _vm._v(" "), _c('div', {
    staticClass: "profile-card"
  }, [_c('img', {
    staticClass: "profile-photo",
    attrs: {
      "src": "http://placehold.it/300x300",
      "alt": "user"
    }
  }), _vm._v(" "), _c('h5', [_c('a', {
    staticClass: "text-white",
    attrs: {
      "href": "timeline"
    }
  }, [_vm._v(_vm._s(_vm.user.user_name))])]), _vm._v(" "), _vm._m(1), _c('br'), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _vm._m(3)]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "suggestions",
    attrs: {
      "id": "sticky-sidebar"
    }
  }, [_c('h4', {
    staticClass: "grey"
  }, [_vm._v("Shops Followed")]), _vm._v(" "), _c('div', {
    staticClass: "follow-user"
  }, [_c('img', {
    staticClass: "profile-photo-sm pull-left",
    attrs: {
      "src": "http://placehold.it/300x300",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', [_c('h5', [_c('a', {
    attrs: {
      "href": "timeline#"
    }
  }, [_vm._v("Simi Shapers")])]), _vm._v(" "), _c('a', {
    staticClass: "text-green",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Follow Shop")])])]), _vm._v(" "), _c('div', {
    staticClass: "follow-user"
  }, [_c('img', {
    staticClass: "profile-photo-sm pull-left",
    attrs: {
      "src": "http://placehold.it/300x300",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', [_c('h5', [_c('a', {
    attrs: {
      "href": "timeline#"
    }
  }, [_vm._v("Chris Foodstore")])]), _vm._v(" "), _c('a', {
    staticClass: "text-green",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Follow Shop")])])]), _vm._v(" "), _c('div', {
    staticClass: "follow-user"
  }, [_c('img', {
    staticClass: "profile-photo-sm pull-left",
    attrs: {
      "src": "http://placehold.it/300x300",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', [_c('h5', [_c('a', {
    attrs: {
      "href": "timeline#"
    }
  }, [_vm._v("Olafumi Jewellries")])]), _vm._v(" "), _c('a', {
    staticClass: "text-green",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Follow Shop")])])]), _vm._v(" "), _c('div', {
    staticClass: "follow-user"
  }, [_c('img', {
    staticClass: "profile-photo-sm pull-left",
    attrs: {
      "src": "http://placehold.it/300x300",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', [_c('h5', [_c('a', {
    attrs: {
      "href": "timeline#"
    }
  }, [_vm._v("Trish Hairs")])]), _vm._v(" "), _c('a', {
    staticClass: "text-green",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Follow Shop")])])]), _vm._v(" "), _c('div', {
    staticClass: "follow-user"
  }, [_c('img', {
    staticClass: "profile-photo-sm pull-left",
    attrs: {
      "src": "http://placehold.it/300x300",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', [_c('h5', [_c('a', {
    attrs: {
      "href": "timeline#"
    }
  }, [_vm._v("Nina Organics")])]), _vm._v(" "), _c('a', {
    staticClass: "text-green",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Follow Shop")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "text-white",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-shopping-cart"
  }), _vm._v(" 62 shops")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "text-white",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "ion ion-android-person-add"
  }), _vm._v(" 1,500 friends")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "nav-news-feed"
  }, [_c('li', [_c('i', {
    staticClass: "icon ion-ios-paper"
  }), _c('div', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Tradefair Newsfeed")])])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "icon fa fa-shopping-cart"
  }), _c('div', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Shops Following")])])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "icon ion-ios-people-outline"
  }), _c('div', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Friends")])])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "icon ion-chatboxes"
  }), _c('div', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Discussions / Messages")])])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "icon ion-images"
  }), _c('div', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Orders")])])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "icon fa fa-bell"
  }), _c('div', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("No6ifications")])])])])
}]}

/***/ }),
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[110]);


// WEBPACK FOOTER //
// static/js/app.3aa635777d4b2bcceb63.js